(function() {
  'use strict';

  angular
    .module('inspinia', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'lbServices',
      'scDateTime',
      'ngFileUpload',
      'common.directives',
      'ngSanitize',
      'ngCsv',
      'google.places',
      'ngMap',
      '720kb.datepicker'
    ])

    .config(config);

    function config(LoopBackResourceProvider) {
      //console.log("API: PRODUCTION");
      LoopBackResourceProvider.setUrlBase('https://api.conapafa.com/api');
      //LoopBackResourceProvider.setUrlBase('http://54.174.148.162:3001/api');
      //LoopBackResourceProvider.setUrlBase('http://localhost:3001/api');
    }

})();

'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.worker.registers.register', {
      url: "/register/:id/:type",
      views: {
        registers:{
          templateUrl: "app/main/worker/registers/register/register.html"
        }
      },
      data: {
        pageTitle: 'Register Registers Worker'
      }
    });
  })
  .controller('RegisterRegistersWorkerController', function ($log, $window, $state, $stateParams, $timeout, $scope, RegisterPlate, AppUser, Brand, TypeCar, Color, Renovation, Upload, Setting) {

    $log.log('Register Registers Worker');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    // Variable stateparameter
    $log.log('stateparameter', $stateParams);

    // Variables Globales
    vm.createBlock = false;
    vm.errorFlag = false;
    vm.cylinders = [0,1,2,3,4,5,6,8,10,12];
    vm.doors = [0,1,2,3,4,5];
    vm.licenseTypes = [
      'Automovilista',
      'Chofer',
      'Motociclista',
      'Aprendiz',
      'Federal',
    ];
    vm.sugestions = [
      'Sin definir',
      'Para este Modelo queda restringido el tránsito por Carretera Federal',
      'PARA TRANSITO NACIONAL EXCEPTO ESTADOS FRONTERIZOS Y DE CONTROL AMBIENTAL'
    ];

    vm.typeRegister = '';
    vm.typeRegisterFlag = false;
    vm.typeRegisters = [
      'Vehículo',
      'Motocicleta'
    ];

    // Regresar a All Registers
    vm.cancel = function(){
      $state.go('^.all');
    };

    // Checar si es Veehiculo o Moto
    vm.typeRegisterCarOrMoto = function(){
      $log.log('vm.typeRegisterCarOrMoto()');
      $log.log('vm.typeRegister', vm.typeRegister);

      if(vm.typeRegister == 'Vehículo'){
        vm.typeRegisterFlag = false;
      }else if(vm.typeRegister == 'Motocicleta'){
        vm.typeRegisterFlag = true;
        vm.register.licenseType = 'Motociclista';
        vm.register.type = 'Motocicleta';
        vm.register.doors = '0';
      }

    };

    // Checar placa para Crear
    vm.checkCreate = function(){
      $log.log('vm.checkCreate()');
      $log.log('register checkCreate', vm.register);

      if(!vm.createBlock){
        vm.errorFlag = true;
        vm.createBlock = true;

        if(vm.register.fullName == '' || vm.register.lastNameFather == '' || vm.register.lastNameMother == '' ||
          vm.register.telephone == '' || vm.register.rfc == '' || vm.register.direction == '' ||
          vm.register.colony == '' || vm.register.postalCode == '' || vm.register.population == '' ||
          vm.register.municipality == '' || vm.register.state == '' || vm.register.credentialCard == '' ||
          vm.register.licenseNumber == '' || vm.register.brand == '' || vm.register.type == '' ||
          vm.register.line == '' || vm.register.model == '' || vm.register.color == '' ||
          vm.register.vin == '' || vm.register.plates == '' || vm.register.sugestion == '' ||
          vm.register.licenseType == '' || vm.typeRegister == ''){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
          vm.createBlock = false;
        }else if(vm.register.hasPolicy && vm.register.policyNumber == ''){
          sweetAlert("Oops...", "Te faltan poner el numero de poliza", "error");
          vm.createBlock = false;
        }else{
          $log.log('Crear Registro');

          if(vm.typeRegister == 'Vehículo'){
            vm.register.typeRegister = 'car';
          }else if(vm.typeRegister == 'Motocicleta'){
            vm.register.typeRegister = 'moto';
          }

          RegisterPlate.findOne({
              filter: {
                where: {
                  and:[
                    {plates: vm.register.plates},
                    {typeRegister: vm.register.typeRegister}
                  ]
                }
              }
            },
            function(registerFound){
              vm.registerFound = angular.copy(registerFound);
              $log.log("vm.registerFound",  vm.registerFound);
              sweetAlert("Oops...", "Este numero de placas ya esta dado de alta", "error");
              vm.createBlock = false;
            },
            function(err){
              $log.log(err);
              $log.log('Dar de alta nuevas placas');
              vm.create();
            });
        }
      }

    };

    // Crear Registro
    vm.create = function(){
      $log.log('vm.create()');
      $log.log('register create', vm.register);

      vm.register.createdById = vm.userLog.id;

      RegisterPlate.create(vm.register, function successSaveUser(datos){
        $log.log('created', datos);
        vm.pdfPrintNewCert();
      },function errorSaveProduct(err){
        $log.log(err);
      });

    };

    // PDF print
    vm.pdfPrint1 = function () {
      $log.log("vm.pdfPrint()");

      var item = vm.register;
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts:true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img2 = new Image;

      //Rutas de imágenes
      img2.crossOrigin = "";
      img2.src = "assets/images/conapafa/qrsat.jpg";

      // Texto
      // line(x1, y1, x2, y2, style) → {jsPDF}
      vm.marginAllY = vm.settings.marginY;

      // Cuadro 1 Titulo
      pdf.line(15, 130+vm.marginAllY, 15, 160+vm.marginAllY); // Vertical 1
      pdf.line(15, 130+vm.marginAllY, 20, 130+vm.marginAllY); // Horizontal 1
      pdf.line(15, 160+vm.marginAllY, 20, 160+vm.marginAllY); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 159+vm.marginAllY, 'DATOS DEL AFILIADO', null, 90);

      // Cuadro 2 Titulo
      pdf.line(15, 170+vm.marginAllY, 15, 192+vm.marginAllY); // Vertical 1
      pdf.line(15, 170+vm.marginAllY, 20, 170+vm.marginAllY); // Horizontal 1
      pdf.line(15, 192+vm.marginAllY, 20, 192+vm.marginAllY); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 187+vm.marginAllY, 'VEHICULO', null, 90);

      // Cuadro 3 Titulo
      pdf.line(15, 208+vm.marginAllY, 15, 232+vm.marginAllY); // Vertical 1
      pdf.line(15, 208+vm.marginAllY, 20, 208+vm.marginAllY); // Horizontal 1
      pdf.line(15, 232+vm.marginAllY, 20, 232+vm.marginAllY); // Horizontal 2
      pdf.text(19, 226+vm.marginAllY, 'REGISTRO', null, 90);

      // Primer Cuadro
      // Verticales
      pdf.line(20, 130+vm.marginAllY, 20, 160+vm.marginAllY); // Vertical 1 a
      pdf.line(20, 170+vm.marginAllY, 20, 192+vm.marginAllY); // Vertical 1 b

      pdf.line(63, 130+vm.marginAllY, 63, 138+vm.marginAllY); // Vertical 2 a
      pdf.line(63, 145+vm.marginAllY, 63, 160+vm.marginAllY); // Vertical 2 b
      pdf.line(63, 170+vm.marginAllY, 63, 192+vm.marginAllY); // Vertical 2 c

      pdf.line(106, 130+vm.marginAllY, 106, 160+vm.marginAllY); // Vertical 3 a
      pdf.line(106, 170+vm.marginAllY, 106, 177+vm.marginAllY); // Vertical 3 b

      pdf.line(94, 184+vm.marginAllY, 94, 192+vm.marginAllY); // Vertical 3 POLIZA

      pdf.line(130, 177+vm.marginAllY, 130, 192+vm.marginAllY); // Vertical 4 a

      pdf.line(162, 130+vm.marginAllY, 162, 177+vm.marginAllY); // Vertical 5 a

      pdf.line(200, 130+vm.marginAllY, 200, 192+vm.marginAllY); // Vertical 6 a

      // Horizontales
      pdf.line(20, 130+vm.marginAllY, 200, 130+vm.marginAllY); // Primera Horizontal
      pdf.line(20, 138+vm.marginAllY, 200, 138+vm.marginAllY); // 1 Horizontal
      pdf.line(20, 145+vm.marginAllY, 200, 145+vm.marginAllY); // 2 Horizontal
      pdf.line(20, 152+vm.marginAllY, 200, 152+vm.marginAllY); // 3 Horizontal
      pdf.line(20, 160+vm.marginAllY, 162, 160+vm.marginAllY); // 4 Horizontal
      pdf.line(20, 170+vm.marginAllY, 200, 170+vm.marginAllY); // 5 Horizontal
      pdf.line(20, 177+vm.marginAllY, 200, 177+vm.marginAllY); // 6 Horizontal
      pdf.line(20, 184+vm.marginAllY, 130, 184+vm.marginAllY); // 7 Horizontal
      pdf.line(20, 192+vm.marginAllY, 200, 192+vm.marginAllY); // Ultima Horizontal

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('ACREDITA AL TITULAR:', 21, 129+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('APELLIDO PATERNO', 21, 132+vm.marginAllY);
      pdf.text('APELLIDO MATERNO', 64, 132+vm.marginAllY);
      pdf.text('NOMBRE(S)', 107, 132+vm.marginAllY);
      pdf.text('TELEFONO', 163, 132+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.lastNameFather.toUpperCase(), 21, 136+vm.marginAllY);
      pdf.text(item.lastNameMother.toUpperCase(), 64, 136+vm.marginAllY);
      pdf.text(item.fullName.toUpperCase(), 107, 136+vm.marginAllY);
      pdf.text(item.telephone.toUpperCase(), 163, 136+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140+vm.marginAllY);
      pdf.text('COLONIA', 107, 140+vm.marginAllY);
      pdf.text('CODIGO POSTAL', 163, 140+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.direction.toUpperCase(), 21, 144+vm.marginAllY);
      pdf.text(item.colony.toUpperCase(), 107, 144+vm.marginAllY);
      pdf.text(item.postalCode.toUpperCase(), 163, 144+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('POBLACION', 21, 147+vm.marginAllY);
      pdf.text('MUNICIPIO', 64, 147+vm.marginAllY);
      pdf.text('ESTADO', 107, 147+vm.marginAllY);
      pdf.text('RFC', 163, 147+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.population.toUpperCase(), 21, 151+vm.marginAllY);
      pdf.text(item.municipality.toUpperCase(), 64, 151+vm.marginAllY);
      pdf.text(item.state.toUpperCase(), 107, 151+vm.marginAllY);
      pdf.text(item.rfc.toUpperCase(), 163, 151+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154+vm.marginAllY);
      pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154+vm.marginAllY);
      pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154+vm.marginAllY);
      pdf.setFontSize(5);
      pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154+vm.marginAllY);

      //Añade QR
      pdf.addImage(img2, 'JPG', 174, 155+vm.marginAllY, 14, 14);

      pdf.setFontSize(8);
      pdf.text(item.credentialCard.toUpperCase(), 21, 158+vm.marginAllY);
      pdf.text(item.licenseType.toUpperCase(), 64, 158+vm.marginAllY);
      pdf.text(item.licenseNumber.toUpperCase(), 107, 158+vm.marginAllY);

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('MARCA', 21, 172+vm.marginAllY);
      pdf.text('TIPO', 64, 172+vm.marginAllY);
      pdf.text('LINEA', 107, 172+vm.marginAllY);
      pdf.text('MODELO', 163, 172+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.brand.toUpperCase(), 21, 176+vm.marginAllY);
      pdf.text(item.type.toUpperCase(), 64, 176+vm.marginAllY);
      pdf.text(item.line.toUpperCase(), 107, 176+vm.marginAllY);
      pdf.text(item.model.toString(), 163, 176+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('COLOR', 21, 179+vm.marginAllY);
      pdf.text('NUMERO DE SERIE (VIN)', 64, 179+vm.marginAllY);
      pdf.text('NUMERO DE PLACAS', 131, 179+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.color.toUpperCase(), 21, 183+vm.marginAllY);
      pdf.text(item.vin.toUpperCase(), 64, 183+vm.marginAllY);

      pdf.setFontSize(28);
      pdf.text('MEC-', 135, 189+vm.marginAllY);
      pdf.text(item.plates.toUpperCase(), 161, 189+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('CILINDROS', 21, 186+vm.marginAllY);
      pdf.text('PUERTAS', 64, 186+vm.marginAllY);
      pdf.text('PÓLIZA', 96, 186+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.cylinders.toString(), 21, 190+vm.marginAllY);
      pdf.text(item.doors.toString(), 64, 190+vm.marginAllY);

      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
      }

      // Segundo cuadro
      // Verticales
      pdf.line(20, 208+vm.marginAllY, 20, 232+vm.marginAllY); // Vertical 1 a
      pdf.line(63, 208+vm.marginAllY, 63, 215+vm.marginAllY); // Vertical 2 a
      pdf.line(106, 208+vm.marginAllY, 106, 215+vm.marginAllY); // Vertical 3 a
      pdf.line(162, 208+vm.marginAllY, 162, 232+vm.marginAllY); // Vertical 4 a
      pdf.line(200, 208+vm.marginAllY, 200, 232+vm.marginAllY); // Vertical 5 a

      // Horizontales
      pdf.line(20, 208+vm.marginAllY, 200, 208+vm.marginAllY); // Primera Horizontal
      pdf.line(20, 215+vm.marginAllY, 162, 215+vm.marginAllY); // 1 Horizontal
      pdf.line(20, 232+vm.marginAllY, 200, 232+vm.marginAllY); // Ultima Horizontal

      pdf.setFontSize(9);
      pdf.setFontType("bold");
      pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202+vm.marginAllY);
      pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('LUGAR DE REGSITRO', 21, 210+vm.marginAllY);
      pdf.text('ESTADO DE REGISTRO', 64, 210+vm.marginAllY);
      pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210+vm.marginAllY);
      pdf.setFontSize(10);
      pdf.text('VIGENCIA', 172, 213+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214+vm.marginAllY);
      pdf.text(item.registerLocationState.toUpperCase(), 64, 214+vm.marginAllY);

      vm.dateRegister = new Date(item.dateRegister);
      vm.dateValidity = new Date(item.dateValidity);
      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth();
      vm.year1 = vm.dateRegister.getFullYear();
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

      vm.day2 = vm.dateValidity.getDate();
      vm.month2 = vm.dateValidity.getMonth();
      vm.year2 = vm.dateValidity.getFullYear();
      vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

      pdf.text(vm.dateRegisterFull, 110, 214+vm.marginAllY);

      pdf.setFontSize(16);
      pdf.text(vm.dateValidityrFull, 164, 222+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('SUGERENCIAS', 21, 217+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.sugestion.toUpperCase(), 21, 221+vm.marginAllY);
      pdf.text(item.obervations.toUpperCase(), 21, 225+vm.marginAllY);
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 21, 229+vm.marginAllY);
      }
      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      $state.go('^.all');
      window.open(pdf.output('bloburl'), '_blank');

    };

    vm.pdfPrintNewCert = function () {
      $log.log("vm.pdfPrintNewCert()");

      var item = vm.register;
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'letter',
        putOnlyUsedFonts: true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img2 = new Image;

      //Rutas de imágenes
      img2.crossOrigin = "";
      img2.src = "assets/images/conapafa/cert2.jpg";

      //Añade QR
      pdf.addImage(img2, 'JPG', 0, 0, 215.9, 279.4);

      pdf.setFontSize(13);
      pdf.setFontType("bold");
      pdf.setTextColor(0, 176, 240);
      vm.newDate = new Date();
      vm.newYear = ' ' + vm.newDate.getFullYear();
      pdf.text(vm.newYear, 49, 57.5);

      pdf.setFontSize(12);
      pdf.setFontType("bold");
      pdf.setTextColor(0, 0, 0);
      vm.fullName = item.fullName.toUpperCase() + ' ' + item.lastNameFather.toUpperCase() + ' ' + item.lastNameMother.toUpperCase();
      pdf.text(vm.fullName, 38, 143.5);

      pdf.setFontSize(8);
      pdf.setFontType("normal");
      pdf.text(item.telephone.toUpperCase(), 163, 143);

      vm.address = item.direction + ' COL. ' + item.colony + ', C.P. ' + item.postalCode + ', ' + item.population +
        ', ' + item.municipality + ', ' + item.state + '.';
      pdf.text(vm.address.toUpperCase(), 38, 149);

      pdf.text(item.credentialCard.toUpperCase(), 38, 154);
      pdf.text(item.rfc.toUpperCase(), 163, 153.5);

      pdf.text(item.licenseType.toUpperCase(), 70, 158.5);
      pdf.text(item.licenseNumber.toUpperCase(), 163, 158.5);

      pdf.text(item.brand.toUpperCase(), 45, 172);
      pdf.text(item.color.toUpperCase(), 130, 172);

      pdf.text(item.type.toUpperCase(), 45, 177);
      pdf.text(item.cylinders.toString(), 130, 177);

      pdf.text(item.line.toUpperCase(), 45, 182);
      pdf.text(item.doors.toString(), 130, 182);

      pdf.text(item.model.toString(), 45, 187);
      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
      }

      pdf.setFontSize(14);
      pdf.setFontType("bold");
      pdf.text(item.vin.toUpperCase(), 65, 193.5);

      pdf.setFontSize(18);
      pdf.setFontType("bold");
      vm.platesMec = 'MEC-' + item.plates.toUpperCase();
      pdf.text(vm.platesMec.toUpperCase(), 160.5, 193.5);

      pdf.setFontSize(8);
      pdf.setFontType("normal");

      pdf.text(item.registerLocationPlace.toUpperCase(), 60, 213);
      pdf.text(item.registerLocationState.toUpperCase(), 163, 213);

      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.dateRegister = new Date(item.dateRegister);
      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth() + 1;
      vm.year1 = vm.dateRegister.getFullYear();
      vm.hour = vm.dateRegister.getHours();
      vm.minutes = vm.dateRegister.getMinutes();
      vm.suffix = vm.hour >= 12 ? "PM":"AM";
      vm.hoursNew = ((vm.hour + 11) % 12 + 1) + ':' + vm.minutes + ' ' + vm.suffix;
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1-1].toUpperCase() + ' / ' + vm.year1 + ' - ' + vm.hoursNew;

      pdf.setFontSize(11);
      pdf.setFontType("bold");
      pdf.text(vm.dateRegisterFull.toUpperCase(), 70, 218);

      pdf.setFontType("normal");
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 19, 227);
      }else{
        //pdf.text(item.sugestion1.toUpperCase(), 18.5, 228);
      }

      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      $state.go('^.all');
      window.open(pdf.output('bloburl'), '_blank');

    };

    // Actualizar Registro
    vm.update = function(){
      vm.errorFlag = true;

      $log.log('register update', vm.register);

      if(vm.register.fullName == '' || vm.register.lastNameFather == '' || vm.register.lastNameMother == '' ||
        vm.register.telephone == '' || vm.register.rfc == '' || vm.register.direction == '' ||
        vm.register.colony == '' || vm.register.postalCode == '' || vm.register.population == '' ||
        vm.register.municipality == '' || vm.register.state == '' || vm.register.credentialCard == '' ||
        vm.register.licenseNumber == '' || vm.register.brand == '' || vm.register.type == '' ||
        vm.register.line == '' || vm.register.model == '' || vm.register.color == '' ||
        vm.register.vin == '' || vm.register.plates == '' || vm.register.sugestion == '' ||
        vm.register.licenseType == '' || vm.typeRegister == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else if(vm.register.hasPolicy && vm.register.policyNumber == ''){
        sweetAlert("Oops...", "Te faltan poner el numero de poliza", "error");
        vm.createBlock = false;
      }else{

        if(vm.typeRegister == 'Vehículo'){
          vm.register.typeRegister = 'car';
        }else if(vm.typeRegister == 'Motocicleta'){
          vm.register.typeRegister = 'moto';
        }

        RegisterPlate.prototype$patchAttributes(
            {id:  vm.register.id},
            vm.register, function (success){
                $log.log("Success", success);
                $state.go('^.all');
            }, function (err) {
                $log.log(err, 'error');
            });
      }

    };

    // Archivos en Container
    vm.createBlockUpload = false;
    vm.documentType = '';
    vm.sizeFile = 0;
    vm.fileToAdd = {
      name: '',
      dateUpload: new Date(),
      url: ''
    };

    vm.addFile = function (files) {
      $log.log('vm.addFile()');
      $log.log('files', files);

      vm.file = files[0];
      vm.fileKey =  lil.uuid();
      Upload.rename(vm.file, vm.fileKey);

      vm.sizeFile = vm.file.size/1000000;
      vm.fileToAdd = {
        name: vm.file.name,
        dateUpload: new Date(),
        url: vm.fileKey
      };

      $log.log('vm.file', vm.file);
      $log.log('vm.fileKey', vm.fileKey);
      $log.log('vm.fileToAdd', vm.fileToAdd);

    };

    vm.addFileToArray = function(){
      $log.log('vm.addFileToArray');
      $log.log('vm.file', vm.file);
      $log.log('vm.fileKey', vm.fileKey);
      $log.log('vm.fileToAdd', vm.fileToAdd);
      $log.log('vm.documentType', vm.documentType);
      vm.createBlockUpload = true;

      if(vm.documentType == ''){
        sweetAlert("Oops...", "Debes ponerle un nombre al documento", "error");
        vm.createBlockUpload = false;
      }else if(vm.fileToAdd.name == ''){
        sweetAlert("Oops...", "Debes adjuntar algun archivo", "error");
        vm.createBlockUpload = false;
      }else{
        $log.log('Subir el documento al server');
        vm.uploadFileToServer();
      }

    };

    vm.progressFile = 0;
    vm.uploadFileToServer = function () {
      $log.log('vm.uploadFileToServer()');

      vm.progressFile = 0;

      var file = vm.file;
      var fileKey =  vm.fileKey;
      vm.fileToUpload = file;
      vm.fileToUpload = Upload.upload({
        url: 'https://api.conapafa.com/api/Containers/container-conapafa/upload',
        //url: 'http://localhost:3001/api/Containers/container-buzonslagricola/upload',
        file: file,
        data: {
          key: fileKey,
          filename: fileKey
        }
      });

      vm.fileToUpload.then(function (response) {
        $timeout(function () {
          file.result = response.data;
        });
        $log.log('response', response);

        vm.fileToAdd.name = vm.documentType;
        vm.register.files.unshift(vm.fileToAdd);
        RegisterPlate.prototype$patchAttributes(
          {id:  vm.register.id},
          vm.register, function (success){
            $log.log(success, 'success');
            toastr.success('', 'Se subió el archivo al servidor');
            vm.createBlockUpload = false;
            vm.documentType = '';
            vm.fileToAdd = {
              name: '',
              dateUpload: new Date(),
              url: ''
            };
          }, function (err) {
            $log.log(err, 'error');
          });

      }, function (response) {
        if (response.status > 0)
          vm.errorMsg = response.status + ': ' + response.data;
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        $log.log('progress: ' + progressPercentage + '% '+ evt.config.file.name + '\n');
        vm.progressFile = progressPercentage;

        if(progressPercentage == 100){
          $log.log('progressPercentage == 100');
        }
      });
    };

    vm.deleteCheck = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteFile(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };

    vm.deleteFile = function (index){
      $log.log('vm.deletePond', index);
      vm.register.files.splice(index, 1);

      RegisterPlate.prototype$patchAttributes(
        {id:  vm.register.id},
        vm.register, function (success){
          $log.log("Success", success);
        }, function (err) {
          $log.log(err, 'error');
        });
    };

    // Crear Nuevo o Encontrar Registro
    vm.itemCreateUpdate = function(){

      if($stateParams.id === 'new'){
        $log.log("New register");
        vm.flag = true;
        // vm.register = {
        //   registerLocationState: vm.userLog.state,
        //   registerLocationPlace: vm.userLog.location,
        //   fullName: 'Ruben',
        //   lastNameFather: 'Lopez',
        //   lastNameMother: 'Flores',
        //   telephone: '6681620694',
        //   rfc: 'ASDC1568',
        //   direction: 'Delicias A',
        //   colony: 'Las Delicias',
        //   postalCode: '81277',
        //   population: 'Los Mochis',
        //   municipality: 'Ahome',
        //   state: 'Sinaloa',
        //   credentialCard: 'ASDFG16589',
        //   licenseType: 'Automovilista',
        //   licenseNumber: '91981981',
        //   brand: '',
        //   type: '',
        //   line: 'Linea',
        //   model: '2021',
        //   color: '',
        //   vin: '184197819',
        //   cylinders: '2',
        //   doors: '2',
        //   plates: '',
        //   sugestion: 'Tramitar verificación vehicular en guardia nacional',
        //   sugestion1: 'Sin definir',
        //   obervations: 'Con este registro su vehículo queda inscrito para una regularización futura',
        //   dateRegister: '',
        //   dateValidity: '',
        //   finalObservations: '',
        //   hasPolicy: false,
        //   policyNumber: ''
        // };

        vm.register = {
          registerLocationState: vm.userLog.state,
          registerLocationPlace: vm.userLog.location,
          fullName: '',
          lastNameFather: '',
          lastNameMother: '',
          telephone: '',
          rfc: '',
          direction: '',
          colony: '',
          postalCode: '',
          population: '',
          municipality: '',
          state: '',
          credentialCard: '',
          licenseType: '',
          licenseNumber: '',
          brand: '',
          type: '',
          line: '',
          model: '',
          color: '',
          vin: '',
          cylinders: '0',
          doors: '0',
          plates: '',
          sugestion: 'Tramitar verificación vehicular en guardia nacional',
          sugestion1: 'Sin definir',
          obervations: 'ESTE VEHÍCULO QUEDA INSCRITO PARA UNA REGULARIZACIÓN FUTURA',
          dateRegister: '',
          dateValidity: '',
          finalObservations: '',
          hasPolicy: false,
          policyNumber: '',
          files: []
        };

        vm.initialDate = '';
        // Seleccionar fecha para buscar
        vm.objInitialDate = new Date();
        vm.objInitialDateDay = vm.objInitialDate.getDate();
        vm.objInitialDateMonth = vm.objInitialDate.getMonth()+1;
        vm.objInitialDateYear = vm.objInitialDate.getFullYear();
        vm.initialDate = vm.objInitialDateDay + '-' + vm.objInitialDateMonth + '-' + vm.objInitialDateYear;
        vm.register.dateRegister = new Date(vm.objInitialDate);

        vm.dateValidity = new Date();
        vm.dateValidityYear = vm.dateValidity.getFullYear();
        vm.dateValidityMonth = vm.dateValidity.getMonth();
        vm.dateValidityDay = vm.dateValidity.getDate();
        vm.dateValidityC = new Date(vm.dateValidityYear + 1, vm.dateValidityMonth, vm.dateValidityDay);
        vm.register.dateValidity = vm.dateValidityC;

        vm.errorFlag = false;
        vm.flagUpdate = true;
      }
      else{
        $log.log("Update register");
        vm.flag = false;

        RegisterPlate.findOne({
            filter: {
              where: {
                id: $stateParams.id
              },
              include:[
                {
                  relation: 'appUser'
                },
                {
                  relation: 'renovations'
                }
              ]
            }
          },
          function(register){
            vm.register = angular.copy(register);
            $log.log("vm.register",  vm.register);

            vm.objInitialDate = new Date(vm.register.dateRegister);
            vm.objInitialDateDay = vm.objInitialDate.getDate();
            vm.objInitialDateMonth = vm.objInitialDate.getMonth()+1;
            vm.objInitialDateYear = vm.objInitialDate.getFullYear();
            vm.initialDate = vm.objInitialDateDay + '-' + vm.objInitialDateMonth + '-' + vm.objInitialDateYear;

            if($stateParams.type == 'see'){
              vm.flagUpdate = false;
            }else{
              vm.flagUpdate = true;
            }

            if(vm.register.typeRegister == 'car'){
              vm.typeRegister = 'Vehículo';
            }else if(vm.register.typeRegister == 'moto'){
              vm.typeRegister = 'Motocicleta';
            }

            if(vm.register.files == undefined){
              vm.register.files = [];
            }

            Renovation.find({
                filter: {
                  where: {
                    registerPlateId: $stateParams.id
                  },
                  order: "createdAt DESC",
                  include:[
                    {
                      relation: 'appUser'
                    },
                    {
                      relation: 'registerPlate'
                    }
                  ]
                }
              },
              function(renovations){
                vm.renovations = angular.copy(renovations);
                $log.log("vm.renovations", vm.renovations);
              },
              function(err){
                $log.log(err);
              });
          },
          function(err){
            $log.log(err);
          });

      }

    };

    // Buscar Marca Color, Tipo y Marca
    vm.infoStart = function(){

      $log.log('infoStart');

      Brand.find({
          filter: {
            where: {},
            order: 'name ASC'
          }
        },
        function(brands){
          vm.brands = angular.copy(brands);
          $log.log("vm.brands", vm.brands);

          TypeCar.find({
              filter: {
                where: {},
                order: 'name ASC'
              }
            },
            function(typeCars) {
              vm.typeCars = angular.copy(typeCars);
              $log.log("vm.typeCars", vm.typeCars);

              Color.find({
                  filter: {
                    where: {},
                    order: 'name ASC'
                  }
                },
                function(colors){
                  vm.colors = angular.copy(colors);
                  $log.log("vm.colors", vm.colors);

                  vm.itemCreateUpdate();
                },
                function(err){
                  $log.log(err);
                });
            },
            function(err){
              $log.log(err);
            });

        },
        function(err){
          $log.log(err);
        });

    };

    // Años para el select del Modelo del Carro
    vm.infoModelCar = function(){

      $log.log('infoStart2');

      vm.today = new Date();
      $log.log('vm.today.getFullYear()', vm.today.getFullYear());

      vm.todayYear = vm.today.getFullYear();
      vm.objDate = vm.today.getFullYear() - 1950;
      $log.log('vm.objDate', vm.objDate);

      vm.dates = [];
      for(var a=0; a<vm.objDate; a++){

        vm.dates.push(vm.todayYear-a);
        if(a==vm.objDate-1){
          $log.log('vm.dates', vm.dates);
          vm.infoStart();
        }
      }

    };

    //Detectar cambio de Fecha
    vm.changeInitialDate = function(){
      $log.log('vm.changeInitialDate');
      $log.log('vm.initialDate', vm.initialDate);
      vm.initialDateString = vm.initialDate.substr(3, 2) + '-' +
        vm.initialDate.substr(0, 2) + '-' +
        vm.initialDate.substr(6, 4);
      $log.log('vm.initialDateString', new Date(vm.initialDateString));

      vm.register.dateRegister = new Date(vm.initialDateString);

      vm.dateValidity = new Date(vm.register.dateRegister);
      vm.dateValidityYear = vm.dateValidity.getFullYear();
      vm.dateValidityMonth = vm.dateValidity.getMonth();
      vm.dateValidityDay = vm.dateValidity.getDate();
      vm.dateValidityC = new Date(vm.dateValidityYear + 1, vm.dateValidityMonth, vm.dateValidityDay);

      vm.register.dateValidity = vm.dateValidityC;
      $log.log('vm.register.dateRegister', vm.register.dateRegister);
      $log.log('vm.register.dateValidity', vm.register.dateValidity);

      vm.searchRegisterParameterFlag = false;
    };

    // Buscar Usuario Logeado
    vm.getAppUserData = function(){

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);
          vm.infoModelCar();

        },
        function(err){
          $log.log(err);
        });

      Setting.findOne({
          filter: {
            where: {
              name: 'configuration'
            }
          }
        },
        function(settings){
          vm.settings = angular.copy(settings);
          $log.log("vm.settings", vm.settings);
        },
        function(err){
          $log.log(err);
        });

    };

    vm.getAppUserData();

  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.worker.registers.all', {
      url: "/all",
      views: {
        registers:{
          templateUrl: "app/main/worker/registers/all/all.html"
        }
      },
      data: {
        pageTitle: 'All Registers Worker'
      }
    });
  })
  .controller('AllRegistersWorkerController', function ($log, $window, $state, $scope, RegisterPlate, AppUser, Setting) {

    $log.log('AllRegistersWorkerController');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    // Variables Globales
    vm.spinnerFlag = true;

    // Crear Nuevo Registro
    vm.create = function(){
      $log.log('create new user');
      $state.go('main.worker.registers.register', {id: 'new'});
    };

    // Ver el Registro
    vm.seeRegister = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.worker.registers.register', {id: vm.itemToGo, type: 'see'});
    };

    // Exportar Registros
    vm.months = ["Ene", "Feb", "Marzo", "Abril", "Mayo", "Jun", "Jul", "Ago", "Sept", "Oct", "Nov", "Dic"];
    vm.todayExcel = new Date();
    vm.objDateExcel = new Date(vm.todayExcel);
    vm.nameDateExcel = vm.objDateExcel.getDate() + ' - ' + vm.months[vm.objDateExcel.getMonth()] + ' - ' + vm.objDateExcel.getFullYear();

    vm.exportExcel = function(){
      $log.log("vm.exportExcel()");
      $log.log('downloadExcel');

      vm.nameExcel = 'Historial de Registro de Placas- ' + vm.nameDateExcel + '.xlsx';

      var num1 = 2;
      var n1 = num1.toString();
      vm.obj1 = 'A' + n1;
      vm.cell_address = vm.obj1;

      vm.arrayToExcel =[];

      if(vm.items.length == 0){
        sweetAlert("Oops...", "No tienes ningun registro de placas", "error");
      }else{
        for(var a=0; a<vm.items.length; a++){

          var obj = {
            'Estatus': '',
            'Fecha': '',
            'Placas': '',
            'Trabajador': angular.copy(vm.items[a].appUser.fullName),
            'Estado': angular.copy(vm.items[a].registerLocationState),
            'Lugar': angular.copy(vm.items[a].registerLocationPlace),
            'Nombre': '',
            'Telefono': angular.copy(vm.items[a].telephone),
            'Marca': angular.copy(vm.items[a].brand),
            'Linea': angular.copy(vm.items[a].line),
            'Modelo': angular.copy(vm.items[a].model),
            'Tipo': angular.copy(vm.items[a].type),
            'Vin': angular.copy(vm.items[a].vin),
            'Vigencia': ''
          };

          vm.arrayToExcel.push(angular.copy(obj));

          if(vm.items[a].status){
            vm.arrayToExcel[a]['Estatus'] = 'Normal';
          }else{
            vm.arrayToExcel[a]['Estatus'] = 'Baja';
          }

          vm.objDate1 = new Date(vm.items[a].createdAt);
          vm.nameDate1 = vm.objDate1.getDate() + ' - ' + vm.months[vm.objDate1.getMonth()] + ' - ' + vm.objDate1.getFullYear();
          vm.arrayToExcel[a]['Fecha'] = vm.nameDate1;

          vm.namePlates = 'MEC- ' + vm.items[a].plates;
          vm.arrayToExcel[a]['Placas'] = vm.namePlates;

          vm.nameFullName = vm.items[a].fullName + ' '+ vm.items[a].lastNameFather + ' '+ vm.items[a].lastNameMother;
          vm.arrayToExcel[a]['Nombre'] = vm.nameFullName;

          vm.objDate2 = new Date(vm.items[a].dateValidity);
          vm.nameDate2 = vm.objDate2.getDate() + ' - ' + vm.months[vm.objDate2.getMonth()] + ' - ' + vm.objDate2.getFullYear();
          vm.arrayToExcel[a]['Vigencia'] = vm.nameDate2;

          if(a==vm.items.length-1){

            var ws = XLSX.utils.json_to_sheet(vm.arrayToExcel, {origin: vm.cell_address});
            //XLSX.utils.sheet_add_json(ws, vm.arrayToExcel, {origin: vm.cell_address_2});
            var wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, ws, "Hoja_1");
            XLSX.writeFile(wb, vm.nameExcel);

          }

        }
      }

    };

    // Buscar los Registros
    vm.limit = 100;
    vm.limitSelect = '100';
    vm.limits = [
      '10',
      '100',
      '1000',
      'Todo'
    ];
    vm.paginationFor = 0;

    vm.today = new Date();
    vm.newFormatDate = new Date(2022, 0, 11, 23, 59, 59);

    vm.loadItems = function(skip) {

      vm.filterItems = {
        filter:{
          where: vm.where,
          skip: skip*vm.limit,
          limit: vm.limit,
          order: "createdAt DESC",
          include:[
            {
              relation: 'appUser'
            }
          ]
        }
      };

      vm.filterItemsQuantity = {
        where: vm.where
      };

      $log.log('filterItems', vm.filterItems);
      $log.log('filterItemsQuantity', vm.filterItemsQuantity);

      RegisterPlate.count(
        vm.filterItemsQuantity,
        function (quantityItems) {
          vm.quantityItems = quantityItems;
          $log.log('quantityItems', vm.quantityItems.count);
          vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
          vm.paginationOptions = [];

          if(vm.quantityItems.count != 0){
            if(vm.quantityItems.count % vm.limit != 0){
              vm.paginationFor =  vm.paginationFor + 1;
            }

            for(var n=0; n<vm.paginationFor; n++){
              vm.paginationOptions.push(n+1);
            }

            $log.log('vm.paginationOptions', vm.paginationOptions);
            vm.paginationOptions = vm.paginationOptions;
          }

          $log.log('vm.paginationFor', vm.paginationFor);
          $log.log('vm.paginationOptions', vm.paginationOptions);

          vm.paginationOptions = vm.paginationOptions;
          vm.paginationFor = vm.paginationFor;

        },
        function (err) {
          $log.log(err);
        });

      RegisterPlate.find(
        vm.filterItems,
        function (items) {
          vm.items = items;
          $log.log('vm.items', vm.items);
          vm.spinnerFlag = false;

          for(var a=0; a<vm.items.length; a++){

            //$log.log('a', a, vm.items[a].dateValidity);
            //$log.log('vm.today', vm.today);

            vm.items[a].dateValidity = new Date(vm.items[a].dateValidity);
            if(vm.items[a].dateValidity.getTime() > vm.today.getTime()){
              vm.items[a].isExpired = false;
            }else{
              vm.items[a].isExpired = true;
            }

            vm.items[a].dateRegister = new Date(vm.items[a].dateRegister);
            if(vm.items[a].dateRegister.getTime() < vm.newFormatDate.getTime()){
              vm.items[a].isNewFormat = false;
            }else{
              vm.items[a].isNewFormat = true;
            }

          }

        },
        function (err) {
          $log.log(err);
        });

    };

    // Pagination Seleccion
    vm.paginationOptions = [];
    vm.pageSelected = 1;

    vm.changeRight = function(){
      $log.log('vm.changeRight');

      if(vm.paginationOptions.length != 1){
        vm.pageSelected =  vm.pageSelected + 1;
        if(vm.paginationOptions.length < vm.pageSelected){
          vm.pageSelected = vm.paginationOptions.length;
        }

        $log.log('vm.pageSelected', vm.pageSelected);
        vm.loadItems(vm.pageSelected-1);
      }

    };

    vm.changeLeft = function(){
      $log.log('vm.changeLeft');

      if(vm.paginationOptions.length != 1){
        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected - 1;
          if(vm.pageSelected < 1){
            vm.pageSelected = 1;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }
      }
    };

    vm.changePage = function(pageIndex){
      $log.log('pageIndex', pageIndex);
      vm.pageSelected = pageIndex;
      vm.loadItems(pageIndex-1);
    };

    // Buscar Fecha inicio y fin de mes
    vm.getDatesMonth = function(){
      $log.log("vm.getDatesMonth");

      vm.today = new Date();
      vm.firstDayOfMonth = new Date();
      vm.lastDayOfMonth = new Date();
      vm.firstDayOfMonth.setHours(0, 0, 0);
      vm.lastDayOfMonth.setHours(23, 59, 59);

      vm.where = {
        and:[
          {
            createdAt:{gt: vm.firstDayOfMonth}
          },
          {
            createdAt:{lt: vm.lastDayOfMonth}
          },
          {
            createdById: vm.userLog.id
          }
        ]
      };

      $log.log("vm.where", vm.where);

      vm.loadItems(0);
    };

    // Buscar usuario logeado
    vm.getAppUserData = function(){

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.getDatesMonth();
        },
        function(err){
          $log.log(err);
        });

      Setting.findOne({
          filter: {
            where: {
              name: 'configuration'
            }
          }
        },
        function(settings){
          vm.settings = angular.copy(settings);
          $log.log("vm.settings", vm.settings);
        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

    // Print
    vm.pdfPrint = function (item) {
      $log.log("vm.pdfPrint()");
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts:true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img1 = new Image;

      //Rutas de imágenes
      img1.crossOrigin = "";
      img1.src = "assets/images/conapafa/all.png";

      //Añade toda la info al pdf
      pdf.addImage(img1, 'JPG', 18, 12, 182, 111);

      // Texto
      // line(x1, y1, x2, y2, style) → {jsPDF}

      // Cuadro 1 Titulo
      pdf.line(15, 130, 15, 160); // Vertical 1
      pdf.line(15, 130, 20, 130); // Horizontal 1
      pdf.line(15, 160, 20, 160); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 159, 'DATOS DEL AFILIADO', null, 90);

      // Cuadro 2 Titulo
      pdf.line(15, 170, 15, 192); // Vertical 1
      pdf.line(15, 170, 20, 170); // Horizontal 1
      pdf.line(15, 192, 20, 192); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 187, 'VEHICULO', null, 90);

      // Cuadro 3 Titulo
      pdf.line(15, 208, 15, 232); // Vertical 1
      pdf.line(15, 208, 20, 208); // Horizontal 1
      pdf.line(15, 232, 20, 232); // Horizontal 2
      pdf.text(19, 226, 'REGISTRO', null, 90);

      // Primer Cuadro
      // Verticales
      pdf.line(20, 130, 20, 160); // Vertical 1 a
      pdf.line(20, 170, 20, 192); // Vertical 1 b

      pdf.line(63, 130, 63, 138); // Vertical 2 a
      pdf.line(63, 145, 63, 160); // Vertical 2 b
      pdf.line(63, 170, 63, 192); // Vertical 2 c

      pdf.line(106, 130, 106, 160); // Vertical 3 a
      pdf.line(106, 170, 106, 177); // Vertical 3 b

      pdf.line(94, 184, 94, 192); // Vertical 3 POLIZA

      pdf.line(130, 177, 130, 192); // Vertical 4 a

      pdf.line(162, 130, 162, 177); // Vertical 5 a

      pdf.line(200, 130, 200, 192); // Vertical 6 a

      // Horizontales
      pdf.line(20, 130, 200, 130); // Primera Horizontal
      pdf.line(20, 138, 200, 138); // 1 Horizontal
      pdf.line(20, 145, 200, 145); // 2 Horizontal
      pdf.line(20, 152, 200, 152); // 3 Horizontal
      pdf.line(20, 160, 162, 160); // 4 Horizontal
      pdf.line(20, 170, 200, 170); // 5 Horizontal
      pdf.line(20, 177, 200, 177); // 6 Horizontal
      pdf.line(20, 184, 130, 184); // 7 Horizontal
      pdf.line(20, 192, 200, 192); // Ultima Horizontal

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('ACREDITA AL TITULAR:', 21, 129);

      pdf.setFontSize(6);
      pdf.text('APELLIDO PATERNO', 21, 132);
      pdf.text('APELLIDO MATERNO', 64, 132);
      pdf.text('NOMBRE(S)', 107, 132);
      pdf.text('TELEFONO', 163, 132);

      pdf.setFontSize(8);
      pdf.text(item.lastNameFather.toUpperCase(), 21, 136);
      pdf.text(item.lastNameMother.toUpperCase(), 64, 136);
      pdf.text(item.fullName.toUpperCase(), 107, 136);
      pdf.text(item.telephone.toUpperCase(), 163, 136);

      pdf.setFontSize(6);
      pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140);
      pdf.text('COLONIA', 107, 140);
      pdf.text('CODIGO POSTAL', 163, 140);

      pdf.setFontSize(8);
      pdf.text(item.direction.toUpperCase(), 21, 144);
      pdf.text(item.colony.toUpperCase(), 107, 144);
      pdf.text(item.postalCode.toUpperCase(), 163, 144);

      pdf.setFontSize(6);
      pdf.text('POBLACION', 21, 147);
      pdf.text('MUNICIPIO', 64, 147);
      pdf.text('ESTADO', 107, 147);
      pdf.text('RFC', 163, 147);

      pdf.setFontSize(8);
      pdf.text(item.population.toUpperCase(), 21, 151);
      pdf.text(item.municipality.toUpperCase(), 64, 151);
      pdf.text(item.state.toUpperCase(), 107, 151);
      pdf.text(item.rfc.toUpperCase(), 163, 151);

      pdf.setFontSize(6);
      pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154);
      pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154);
      pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154);
      pdf.setFontSize(5);
      pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154);

      pdf.setFontSize(8);
      pdf.text(item.credentialCard.toUpperCase(), 21, 158);
      pdf.text(item.licenseType.toUpperCase(), 64, 158);
      pdf.text(item.licenseNumber.toUpperCase(), 107, 158);

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169);

      pdf.setFontSize(6);
      pdf.text('MARCA', 21, 172);
      pdf.text('TIPO', 64, 172);
      pdf.text('LINEA', 107, 172);
      pdf.text('MODELO', 163, 172);

      pdf.setFontSize(8);
      pdf.text(item.brand.toUpperCase(), 21, 176);
      pdf.text(item.type.toUpperCase(), 64, 176);
      pdf.text(item.line.toUpperCase(), 107, 176);
      pdf.text(item.model.toUpperCase(), 163, 176);

      pdf.setFontSize(6);
      pdf.text('COLOR', 21, 179);
      pdf.text('NUMERO DE SERIE (VIN)', 64, 179);
      pdf.text('NUMERO DE PLACAS', 131, 179);

      pdf.setFontSize(8);
      pdf.text(item.color.toUpperCase(), 21, 183);
      pdf.text(item.vin.toUpperCase(), 64, 183);

      pdf.setFontSize(28);
      pdf.text('MEC-', 135, 189);
      pdf.text(item.plates.toUpperCase(), 161, 189);

      pdf.setFontSize(6);
      pdf.text('CILINDROS', 21, 186);
      pdf.text('PUERTAS', 64, 186);
      pdf.text('PÓLIZA', 88, 186);

      pdf.setFontSize(8);
      pdf.text(item.cylinders.toUpperCase(), 21, 190);
      pdf.text(item.doors.toUpperCase(), 64, 190);

      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190);
      }else{

      }

      // Segundo cuadro
      // Verticales
      pdf.line(20, 208, 20, 232); // Vertical 1 a
      pdf.line(63, 208, 63, 215); // Vertical 2 a
      pdf.line(106, 208, 106, 215); // Vertical 3 a
      pdf.line(162, 208, 162, 232); // Vertical 4 a
      pdf.line(200, 208, 200, 232); // Vertical 5 a

      // Horizontales
      pdf.line(20, 208, 200, 208); // Primera Horizontal
      pdf.line(20, 215, 162, 215); // 1 Horizontal
      pdf.line(20, 232, 200, 232); // Ultima Horizontal

      pdf.setFontSize(9);
      pdf.setFontType("bold");
      pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202);
      pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207);

      pdf.setFontSize(6);
      pdf.text('LUGAR DE REGSITRO', 21, 210);
      pdf.text('ESTADO DE REGISTRO', 64, 210);
      pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210);
      pdf.setFontSize(10);
      pdf.text('VIGENCIA', 172, 213);

      pdf.setFontSize(8);
      pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214);
      pdf.text(item.registerLocationState.toUpperCase(), 64, 214);

      vm.dateRegister = new Date(item.dateRegister);
      vm.dateValidity = new Date(item.dateValidity);
      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth();
      vm.year1 = vm.dateRegister.getFullYear();
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

      vm.day2 = vm.dateValidity.getDate();
      vm.month2 = vm.dateValidity.getMonth();
      vm.year2 = vm.dateValidity.getFullYear();
      vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

      pdf.text(vm.dateRegisterFull, 110, 214);

      pdf.setFontSize(16);
      pdf.text(vm.dateValidityrFull, 164, 222);

      pdf.setFontSize(6);
      pdf.text('SUGERENCIAS', 21, 217);

      pdf.setFontSize(8);
      pdf.text(item.sugestion.toUpperCase(), 21, 221);
      pdf.text(item.obervations.toUpperCase(), 21, 225);

      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 21, 229);
      }

      pdf.setFontSize(10);
      vm.widthPage = pdf.internal.pageSize.getWidth();
      vm.widthText1 = pdf.getTextWidth('ATENTAMENTE');
      vm.xText1 = (vm.widthPage - vm.widthText1 ) / 2;
      pdf.text('ATENTAMENTE', vm.xText1, 245);

      vm.widthText2 = pdf.getTextWidth('PROFR. MANUEL ESCALANTE COTA');
      vm.xText2 = (vm.widthPage - vm.widthText2 ) / 2;
      pdf.text('PROFR. MANUEL ESCALANTE COTA', vm.xText2, 268);

      pdf.setFontType("normal");
      vm.widthText3 = pdf.getTextWidth('PRESIDENTE DEL COMITÉ NACIONAL');
      vm.xText3 = (vm.widthPage - vm.widthText3 ) / 2;
      pdf.text('PRESIDENTE DEL COMITÉ NACIONAL', vm.xText3, 273);

      vm.widthText4 = pdf.getTextWidth('PRO-DEFENSA DEL PATRIMONIO FAMILIAR');
      vm.xText4 = (vm.widthPage - vm.widthText4 ) / 2;
      pdf.text('PRO-DEFENSA DEL PATRIMONIO FAMILIAR', vm.xText4, 278);

      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      window.open(pdf.output('bloburl'), '_blank');

    };

    vm.pdfPrint1 = function (item) {
      $log.log("vm.pdfPrint()");
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts:true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img2 = new Image;

      //Rutas de imágenes
      img2.crossOrigin = "";
      img2.src = "assets/images/conapafa/qrsat.jpg";

      // Texto
      // line(x1, y1, x2, y2, style) → {jsPDF}
      vm.marginAllY = vm.settings.marginY;

      // Cuadro 1 Titulo
      pdf.line(15, 130+vm.marginAllY, 15, 160+vm.marginAllY); // Vertical 1
      pdf.line(15, 130+vm.marginAllY, 20, 130+vm.marginAllY); // Horizontal 1
      pdf.line(15, 160+vm.marginAllY, 20, 160+vm.marginAllY); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 159+vm.marginAllY, 'DATOS DEL AFILIADO', null, 90);

      // Cuadro 2 Titulo
      pdf.line(15, 170+vm.marginAllY, 15, 192+vm.marginAllY); // Vertical 1
      pdf.line(15, 170+vm.marginAllY, 20, 170+vm.marginAllY); // Horizontal 1
      pdf.line(15, 192+vm.marginAllY, 20, 192+vm.marginAllY); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 187+vm.marginAllY, 'VEHICULO', null, 90);

      // Cuadro 3 Titulo
      pdf.line(15, 208+vm.marginAllY, 15, 232+vm.marginAllY); // Vertical 1
      pdf.line(15, 208+vm.marginAllY, 20, 208+vm.marginAllY); // Horizontal 1
      pdf.line(15, 232+vm.marginAllY, 20, 232+vm.marginAllY); // Horizontal 2
      pdf.text(19, 226+vm.marginAllY, 'REGISTRO', null, 90);

      // Primer Cuadro
      // Verticales
      pdf.line(20, 130+vm.marginAllY, 20, 160+vm.marginAllY); // Vertical 1 a
      pdf.line(20, 170+vm.marginAllY, 20, 192+vm.marginAllY); // Vertical 1 b

      pdf.line(63, 130+vm.marginAllY, 63, 138+vm.marginAllY); // Vertical 2 a
      pdf.line(63, 145+vm.marginAllY, 63, 160+vm.marginAllY); // Vertical 2 b
      pdf.line(63, 170+vm.marginAllY, 63, 192+vm.marginAllY); // Vertical 2 c

      pdf.line(106, 130+vm.marginAllY, 106, 160+vm.marginAllY); // Vertical 3 a
      pdf.line(106, 170+vm.marginAllY, 106, 177+vm.marginAllY); // Vertical 3 b

      pdf.line(94, 184+vm.marginAllY, 94, 192+vm.marginAllY); // Vertical 3 POLIZA

      pdf.line(130, 177+vm.marginAllY, 130, 192+vm.marginAllY); // Vertical 4 a

      pdf.line(162, 130+vm.marginAllY, 162, 177+vm.marginAllY); // Vertical 5 a

      pdf.line(200, 130+vm.marginAllY, 200, 192+vm.marginAllY); // Vertical 6 a

      // Horizontales
      pdf.line(20, 130+vm.marginAllY, 200, 130+vm.marginAllY); // Primera Horizontal
      pdf.line(20, 138+vm.marginAllY, 200, 138+vm.marginAllY); // 1 Horizontal
      pdf.line(20, 145+vm.marginAllY, 200, 145+vm.marginAllY); // 2 Horizontal
      pdf.line(20, 152+vm.marginAllY, 200, 152+vm.marginAllY); // 3 Horizontal
      pdf.line(20, 160+vm.marginAllY, 162, 160+vm.marginAllY); // 4 Horizontal
      pdf.line(20, 170+vm.marginAllY, 200, 170+vm.marginAllY); // 5 Horizontal
      pdf.line(20, 177+vm.marginAllY, 200, 177+vm.marginAllY); // 6 Horizontal
      pdf.line(20, 184+vm.marginAllY, 130, 184+vm.marginAllY); // 7 Horizontal
      pdf.line(20, 192+vm.marginAllY, 200, 192+vm.marginAllY); // Ultima Horizontal

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('ACREDITA AL TITULAR:', 21, 129+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('APELLIDO PATERNO', 21, 132+vm.marginAllY);
      pdf.text('APELLIDO MATERNO', 64, 132+vm.marginAllY);
      pdf.text('NOMBRE(S)', 107, 132+vm.marginAllY);
      pdf.text('TELEFONO', 163, 132+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.lastNameFather.toUpperCase(), 21, 136+vm.marginAllY);
      pdf.text(item.lastNameMother.toUpperCase(), 64, 136+vm.marginAllY);
      pdf.text(item.fullName.toUpperCase(), 107, 136+vm.marginAllY);
      pdf.text(item.telephone.toUpperCase(), 163, 136+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140+vm.marginAllY);
      pdf.text('COLONIA', 107, 140+vm.marginAllY);
      pdf.text('CODIGO POSTAL', 163, 140+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.direction.toUpperCase(), 21, 144+vm.marginAllY);
      pdf.text(item.colony.toUpperCase(), 107, 144+vm.marginAllY);
      pdf.text(item.postalCode.toUpperCase(), 163, 144+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('POBLACION', 21, 147+vm.marginAllY);
      pdf.text('MUNICIPIO', 64, 147+vm.marginAllY);
      pdf.text('ESTADO', 107, 147+vm.marginAllY);
      pdf.text('RFC', 163, 147+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.population.toUpperCase(), 21, 151+vm.marginAllY);
      pdf.text(item.municipality.toUpperCase(), 64, 151+vm.marginAllY);
      pdf.text(item.state.toUpperCase(), 107, 151+vm.marginAllY);
      pdf.text(item.rfc.toUpperCase(), 163, 151+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154+vm.marginAllY);
      pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154+vm.marginAllY);
      pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154+vm.marginAllY);
      pdf.setFontSize(5);
      pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154+vm.marginAllY);

      //Añade QR
      pdf.addImage(img2, 'JPG', 174, 155+vm.marginAllY, 14, 14);

      pdf.setFontSize(8);
      pdf.text(item.credentialCard.toUpperCase(), 21, 158+vm.marginAllY);
      pdf.text(item.licenseType.toUpperCase(), 64, 158+vm.marginAllY);
      pdf.text(item.licenseNumber.toUpperCase(), 107, 158+vm.marginAllY);

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('MARCA', 21, 172+vm.marginAllY);
      pdf.text('TIPO', 64, 172+vm.marginAllY);
      pdf.text('LINEA', 107, 172+vm.marginAllY);
      pdf.text('MODELO', 163, 172+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.brand.toUpperCase(), 21, 176+vm.marginAllY);
      pdf.text(item.type.toUpperCase(), 64, 176+vm.marginAllY);
      pdf.text(item.line.toUpperCase(), 107, 176+vm.marginAllY);
      pdf.text(item.model.toUpperCase(), 163, 176+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('COLOR', 21, 179+vm.marginAllY);
      pdf.text('NUMERO DE SERIE (VIN)', 64, 179+vm.marginAllY);
      pdf.text('NUMERO DE PLACAS', 131, 179+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.color.toUpperCase(), 21, 183+vm.marginAllY);
      pdf.text(item.vin.toUpperCase(), 64, 183+vm.marginAllY);

      pdf.setFontSize(28);
      pdf.text('MEC-', 135, 189+vm.marginAllY);
      pdf.text(item.plates.toUpperCase(), 161, 189+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('CILINDROS', 21, 186+vm.marginAllY);
      pdf.text('PUERTAS', 64, 186+vm.marginAllY);
      pdf.text('PÓLIZA', 96, 186+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.cylinders.toUpperCase(), 21, 190+vm.marginAllY);
      pdf.text(item.doors.toUpperCase(), 64, 190+vm.marginAllY);

      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
      }

      // Segundo cuadro
      // Verticales
      pdf.line(20, 208+vm.marginAllY, 20, 232+vm.marginAllY); // Vertical 1 a
      pdf.line(63, 208+vm.marginAllY, 63, 215+vm.marginAllY); // Vertical 2 a
      pdf.line(106, 208+vm.marginAllY, 106, 215+vm.marginAllY); // Vertical 3 a
      pdf.line(162, 208+vm.marginAllY, 162, 232+vm.marginAllY); // Vertical 4 a
      pdf.line(200, 208+vm.marginAllY, 200, 232+vm.marginAllY); // Vertical 5 a

      // Horizontales
      pdf.line(20, 208+vm.marginAllY, 200, 208+vm.marginAllY); // Primera Horizontal
      pdf.line(20, 215+vm.marginAllY, 162, 215+vm.marginAllY); // 1 Horizontal
      pdf.line(20, 232+vm.marginAllY, 200, 232+vm.marginAllY); // Ultima Horizontal

      pdf.setFontSize(9);
      pdf.setFontType("bold");
      pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202+vm.marginAllY);
      pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('LUGAR DE REGSITRO', 21, 210+vm.marginAllY);
      pdf.text('ESTADO DE REGISTRO', 64, 210+vm.marginAllY);
      pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210+vm.marginAllY);
      pdf.setFontSize(10);
      pdf.text('VIGENCIA', 172, 213+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214+vm.marginAllY);
      pdf.text(item.registerLocationState.toUpperCase(), 64, 214+vm.marginAllY);

      vm.dateRegister = new Date(item.dateRegister);
      vm.dateValidity = new Date(item.dateValidity);
      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth();
      vm.year1 = vm.dateRegister.getFullYear();
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

      vm.day2 = vm.dateValidity.getDate();
      vm.month2 = vm.dateValidity.getMonth();
      vm.year2 = vm.dateValidity.getFullYear();
      vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

      pdf.text(vm.dateRegisterFull, 110, 214+vm.marginAllY);

      pdf.setFontSize(16);
      pdf.text(vm.dateValidityrFull, 164, 222+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('SUGERENCIAS', 21, 217+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.sugestion.toUpperCase(), 21, 221+vm.marginAllY);
      pdf.text(item.obervations.toUpperCase(), 21, 225+vm.marginAllY);
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 21, 229+vm.marginAllY);
      }
      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      window.open(pdf.output('bloburl'), '_blank');

    };

    vm.pdfPrintNewCert = function (item) {
      $log.log("vm.pdfPrintNewCert()");
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'letter',
        putOnlyUsedFonts: true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img2 = new Image;

      //Rutas de imágenes
      img2.crossOrigin = "";
      img2.src = "assets/images/conapafa/cert2.jpg";

      //Añade QR
      pdf.addImage(img2, 'JPG', 0, 0, 215.9, 279.4);

      pdf.setFontSize(13);
      pdf.setFontType("bold");
      pdf.setTextColor(0, 176, 240);
      vm.newDate = new Date();
      vm.newYear = ' ' + vm.newDate.getFullYear();
      pdf.text(vm.newYear, 49, 57.5);

      pdf.setFontSize(12);
      pdf.setFontType("bold");
      pdf.setTextColor(0, 0, 0);
      vm.fullName = item.fullName.toUpperCase() + ' ' + item.lastNameFather.toUpperCase() + ' ' + item.lastNameMother.toUpperCase();
      pdf.text(vm.fullName, 38, 143.5);

      pdf.setFontSize(8);
      pdf.setFontType("normal");
      pdf.text(item.telephone.toUpperCase(), 163, 143);

      vm.address = item.direction + ' COL. ' + item.colony + ', C.P. ' + item.postalCode + ', ' + item.population +
        ', ' + item.municipality + ', ' + item.state + '.';
      pdf.text(vm.address.toUpperCase(), 38, 149);

      pdf.text(item.credentialCard.toUpperCase(), 38, 154);
      pdf.text(item.rfc.toUpperCase(), 163, 153.5);

      pdf.text(item.licenseType.toUpperCase(), 70, 158.5);
      pdf.text(item.licenseNumber.toUpperCase(), 163, 158.5);

      pdf.text(item.brand.toUpperCase(), 45, 172);
      pdf.text(item.color.toUpperCase(), 130, 172);

      pdf.text(item.type.toUpperCase(), 45, 177);
      pdf.text(item.cylinders.toUpperCase(), 130, 177);

      pdf.text(item.line.toUpperCase(), 45, 182);
      pdf.text(item.doors.toUpperCase(), 130, 182);

      pdf.text(item.model.toUpperCase(), 45, 187);
      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
      }

      pdf.setFontSize(14);
      pdf.setFontType("bold");
      pdf.text(item.vin.toUpperCase(), 65, 193.5);

      pdf.setFontSize(18);
      pdf.setFontType("bold");
      vm.platesMec = 'MEC-' + item.plates.toUpperCase();
      pdf.text(vm.platesMec.toUpperCase(), 160.5, 193.5);

      pdf.setFontSize(8);
      pdf.setFontType("normal");

      pdf.text(item.registerLocationPlace.toUpperCase(), 60, 213);
      pdf.text(item.registerLocationState.toUpperCase(), 163, 213);

      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.dateRegister = new Date(item.dateRegister);
      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth() + 1;
      vm.year1 = vm.dateRegister.getFullYear();
      vm.hour = vm.dateRegister.getHours();
      vm.minutes = vm.dateRegister.getMinutes();
      vm.suffix = vm.hour >= 12 ? "PM":"AM";
      vm.hoursNew = ((vm.hour + 11) % 12 + 1) + ':' + vm.minutes + ' ' + vm.suffix;
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1-1].toUpperCase() + ' / ' + vm.year1 + ' - ' + vm.hoursNew;

      pdf.setFontSize(11);
      pdf.setFontType("bold");
      pdf.text(vm.dateRegisterFull.toUpperCase(), 70, 218);

      pdf.setFontType("normal");
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 19, 227);
      }else{
        //pdf.text(item.sugestion1.toUpperCase(), 18.5, 228);
      }

      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      window.open(pdf.output('bloburl'), '_blank');

    };

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.vendors.vendor', {
      url: "/vendor/:id",
      views: {
        vendors:{
          templateUrl: "app/main/admin/vendors/vendor/vendor.html"
        }
      },
      data: {
        pageTitle: 'Vendor Vendors Admin'
      }
    });
  })
  .controller('VendorVendorsAdminController', function ($log, $window, $state, $stateParams, $timeout, $scope, Renovation, RegisterPlate, AppUser) {

    $log.log('Vendor Vendors Admin');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    // Variable stateparameter
    $log.log('stateparameter', $stateParams);

    vm.plates = '';
    vm.register = {};
    vm.registerFlag = false;
    vm.platesFlag = false;
    vm.flagHide = false;

    vm.searchPlates = function (plates, number){
      $log.log('searchPlates');

      if(plates == '' || plates == undefined){
        vm.platesFlag = false;
        if(number == 1){
          sweetAlert("Oops...", "El número de placa no puede estar en blanco", "error");
        }
      }else{

        vm.platesFlag = true;

        RegisterPlate.findOne({
            filter: {
              where:
                {
                  plates: plates
                }
            }
          },
          function(register){
            vm.register = angular.copy(register);

            $log.log("vm.register", vm.register);
            vm.registerFlag = true;

            vm.objInitialDate = new Date(vm.register.dateValidity);
            vm.objInitialDateDay = vm.objInitialDate.getDate();
            vm.objInitialDateMonth = vm.objInitialDate.getMonth()+1;
            vm.objInitialDateYear = vm.objInitialDate.getFullYear();
            vm.initialDate = vm.objInitialDateDay + '-' + vm.objInitialDateMonth + '-' + vm.objInitialDateYear;

            vm.dateValidity = new Date(vm.register.dateValidity);
            vm.dateValidityYear = vm.dateValidity.getFullYear();
            vm.dateValidityMonth = vm.dateValidity.getMonth();
            vm.dateValidityDay = vm.dateValidity.getDate();
            vm.dateValidityC = new Date(vm.dateValidityYear + 1, vm.dateValidityMonth, vm.dateValidityDay);

            vm.renovation = {
              date: new Date(vm.register.dateValidity),
              dateValidity: new Date(vm.dateValidityC),
              registerPlateId: vm.register.id,
              fullName: vm.register.fullName,
              lastNameFather: vm.register.lastNameFather,
              lastNameMother: vm.register.lastNameMother,
              telephone: vm.register.telephone,
              rfc: vm.register.rfc,
              direction: vm.register.direction,
              colony: vm.register.colony,
              postalCode: vm.register.postalCode,
              population: vm.register.population,
              municipality: vm.register.municipality,
              state: vm.register.state,
              credentialCard: vm.register.credentialCard,
              licenseType: vm.register.licenseType,
              licenseNumber: vm.register.licenseNumber,
              brand: vm.register.brand,
              type: vm.register.type,
              line: vm.register.line,
              model: vm.register.model,
              color: vm.register.color,
              vin: vm.register.vin,
              cylinders: vm.register.cylinders,
              doors: vm.register.doors,
              plates: vm.register.plates,
              sugestion: vm.register.sugestion,
              obervations: vm.register.obervations,
              dateRegisterOld: vm.register.dateRegister,
              dateValidityOld: vm.register.dateValidity,
              registerLocationState: vm.register.registerLocationState,
              registerLocationPlace: vm.register.registerLocationPlace
            };

          },
          function(err){
            $log.log(err);
            vm.registerFlag = false;
          });
      }

    };

    // Variables Globales
    vm.createBlock = false;
    vm.errorFlag = false;

    // Regresar a All Registers
    vm.cancel = function(){
      $state.go('^.all');
    };

    // Crear Registro
    vm.create = function(){
      $log.log('vm.create()');
      $log.log('renovation create', vm.renovation);

      vm.createBlock = true;
      vm.renovation.createdById = vm.userLog.id;

      Renovation.create(vm.renovation, function successSaveUser(datos){
        $log.log('created', datos);

        vm.register.dateValidity = vm.renovation.dateValidity;

        RegisterPlate.prototype$patchAttributes(
          {id:  vm.register.id},
          vm.register, function (success){
            $log.log("Success", success);
            $state.go('^.all');
          }, function (err) {
            $log.log(err, 'error');
          });

      },function errorSaveProduct(err){
        $log.log(err);
      });

    };

    // Crear Nuevo o Encontrar Registro
    vm.itemCreateUpdate = function(){

      if($stateParams.id === 'new'){
        $log.log("New register");
        vm.flag = true;

        vm.renovation = {
          date: new Date(),
          dateValidity: new Date()
        };

      }
      else{
        $log.log("Update register");
        vm.flag = false;

        Renovation.findOne({
            filter: {
              where: {
                id: $stateParams.id
              },
              include:[
                {
                  relation: 'appUser'
                },
                {
                  relation: 'registerPlate'
                }
              ]
            }
          },
          function(renovation){
            vm.renovation = angular.copy(renovation);
            $log.log("vm.renovation",  vm.renovation);

            vm.flagHide = true;
            vm.platesFlag = true;
            vm.registerFlag = true;
            vm.register = vm.renovation.plate;
          },
          function(err){
            $log.log(err);
          });

      }

    };

    //Detectar cambio de Fecha
    vm.changeInitialDate = function(){
      $log.log('vm.changeInitialDate');
      $log.log('vm.initialDate', vm.initialDate);
      vm.initialDateString = vm.initialDate.substr(3, 2) + '-' +
        vm.initialDate.substr(0, 2) + '-' +
        vm.initialDate.substr(6, 4);
      $log.log('vm.initialDateString', new Date(vm.initialDateString));

      vm.renovation.date = new Date(vm.initialDateString);

      vm.dateValidity = new Date(vm.renovation.date);
      vm.dateValidityYear = vm.dateValidity.getFullYear();
      vm.dateValidityMonth = vm.dateValidity.getMonth();
      vm.dateValidityDay = vm.dateValidity.getDate();
      vm.dateValidityC = new Date(vm.dateValidityYear + 1, vm.dateValidityMonth, vm.dateValidityDay);

      vm.renovation.dateValidity = vm.dateValidityC;
      $log.log('vm.renovation.date', vm.renovation.date);
      $log.log('vm.renovation.dateValidity', vm.renovation.dateValidity);
    };

    // Buscar Usuario Logeado
    vm.getAppUserData = function(){

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);
          vm.itemCreateUpdate();
        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.vendors.all', {
      url: "/all",
      views: {
        vendors:{
          templateUrl: "app/main/admin/vendors/all/all.html"
        }
      },
      data: {
        pageTitle: 'Vendors All'
      }
    });
  })
  .controller('VendorsAllController',
    function ($log, $window, $state, $scope, RegisterPlate, AppUser, Brand, Color, TypeCar, Setting) {

    $log.log('Vendors All');

      // Subir la pantalla
      function scrollWin() {$window.scrollTo(0, 0);}
      scrollWin();

      var vm = this;

      // Variables Globales
      vm.spinnerFlag = true;

      // Filtrador de Registros
      vm.stateOption = 'Todos';
      vm.placeOption = 'Todos';
      vm.states = [
        'Todos',
        'Sinaloa',
        'Sonora'
      ];
      vm.statesBlockOption = 'Todos';
      vm.statesBlocks = [
        'Todos',
        'Activo',
        'Baja'
      ];
      vm.places = [
        'Todos'
      ];
      vm.userOption = {
        fullName: 'Todos'
      };
      vm.brandOption = {
        name: 'Todos'
      };
      vm.typeCarOption = {
        name: 'Todos'
      };

      // Crear Nuevo Registro
      vm.create = function(){
        $log.log('create new user');
        $state.go('main.admin.vendors.vendor', {id: 'new'});
      };

      // Editar Registro
      vm.editModule = function(index){
        $log.log('editModule');
        $log.log('index', index);
        vm.itemToGo = vm.items[index].id;
        $state.go('main.admin.vendors.vendor', {id: vm.itemToGo, type: 'update'});
      };

      // Dar de Baja Registro
      vm.banModule = function(index){
        $log.log("Item to Delete");
        swal({
            title: "¿Quieres dar de baja el registro?",
            text: "",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Sí",
            cancelButtonText: "No!",
            closeOnConfirm: false,
            closeOnCancel: false },
          function(isConfirm){
            if (isConfirm) {
              swal("Baja de Registro", "", "");
              vm.banOk(index);
            } else {
              swal("Cancelado", "", "");
            }
          });
      };
      vm.banOk = function(index){
        $log.log('index', index);
        vm.items[index].status = false;
        vm.items[index].banDate = new Date();

        RegisterPlate.prototype$patchAttributes(
          {id:  vm.items[index].id},
          vm.items[index], function (success){
            $log.log("Success", success);
          }, function (err) {
            $log.log(err, 'error');
          });

      };

      // Eliminar Registro
      vm.deleteModule = function(index){
        $log.log("Item to Delete");
        swal({
            title: "Estas seguro?",
            text: "Si lo elmininas no hay manera de volver a recuperarlo",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Sí",
            cancelButtonText: "No!",
            closeOnConfirm: false,
            closeOnCancel: false },
          function(isConfirm){
            if (isConfirm) {
              swal("Eliminado", "", "");
              vm.deleteOk(index);
            } else {
              swal("Cancelado", "", "");
            }
          });
      };
      vm.deleteOk = function(index){
        $log.log('index', index);
        vm.itemToDelete = vm.items[index].id;

        RegisterPlate.deleteById({id: vm.itemToDelete},
          function(itemDeleted){
            vm.itemDeleted = itemDeleted;
            $log.log("ItemDeleted", vm.itemDeleted);

            vm.items.splice(index, 1);

            if(vm.items.length == 0){
              vm.paginationFor = 0;
            }
          },
          function(err){
            $log.log(err);
          });
      };

      // Ver el Registro
      vm.seeRegister = function(index){
        $log.log('editModule');
        $log.log('index', index);
        vm.itemToGo = vm.items[index].id;
        $state.go('main.admin.vendors.vendor', {id: vm.itemToGo, type: 'see'});
      };

      // Exportar Registros
      vm.months = ["Ene", "Feb", "Marzo", "Abril", "Mayo", "Jun", "Jul", "Ago", "Sept", "Oct", "Nov", "Dic"];
      vm.todayExcel = new Date();
      vm.objDateExcel = new Date(vm.todayExcel);
      vm.nameDateExcel = vm.objDateExcel.getDate() + ' - ' + vm.months[vm.objDateExcel.getMonth()] + ' - ' + vm.objDateExcel.getFullYear();

      vm.exportExcel = function(){
        $log.log("vm.exportExcel()");
        $log.log('downloadExcel');

        vm.nameExcel = 'Historial de Registro de Placas- ' + vm.nameDateExcel + '.xlsx';

        var num1 = 2;
        var n1 = num1.toString();
        vm.obj1 = 'A' + n1;
        vm.cell_address = vm.obj1;

        vm.arrayToExcel =[];

        if(vm.items.length == 0){
          sweetAlert("Oops...", "No tienes ningun registro de placas", "error");
        }else{
          for(var a=0; a<vm.items.length; a++){

            var obj = {
              'Estatus': '',
              'Fecha': '',
              'Placas': '',
              'Trabajador Conapafa': angular.copy(vm.items[a].appUser.fullName),
              'Estado Conapafa': angular.copy(vm.items[a].registerLocationState),
              'Lugar Conapafa': angular.copy(vm.items[a].registerLocationPlace),
              'Nombre': '',
              'Calle y Numero': vm.items[a].direction,
              'Colonia': vm.items[a].colony,
              'Codigo Postal': vm.items[a].postalCode,
              'Poblacion': vm.items[a].population,
              'Municipio': vm.items[a].municipality,
              'Estado': vm.items[a].state,
              'Telefono': angular.copy(vm.items[a].telephone),
              'Marca': angular.copy(vm.items[a].brand),
              'Linea': angular.copy(vm.items[a].line),
              'Modelo': angular.copy(vm.items[a].model),
              'Tipo': angular.copy(vm.items[a].type),
              'Color': angular.copy(vm.items[a].color),
              'Vin': angular.copy(vm.items[a].vin),
              'Vigencia': '',
              'Poliza': '',
              'Fecha Baja': '',
              'Observaciones': angular.copy(vm.items[a].finalObservations)
            };

            vm.arrayToExcel.push(angular.copy(obj));

            if(vm.items[a].status){
              vm.arrayToExcel[a]['Estatus'] = 'Activo';
              vm.arrayToExcel[a]['Fecha Baja'] = '-';
            }else{
              vm.arrayToExcel[a]['Estatus'] = 'Baja';
              vm.objDate2 = new Date(vm.items[a].banDate);
              vm.nameDate2 = vm.objDate2.getDate() + ' - ' + vm.months[vm.objDate2.getMonth()] + ' - ' + vm.objDate2.getFullYear();
              vm.arrayToExcel[a]['Fecha Baja'] = vm.nameDate2;

            }

            vm.objDate1 = new Date(vm.items[a].createdAt);
            vm.nameDate1 = vm.objDate1.getDate() + ' - ' + vm.months[vm.objDate1.getMonth()] + ' - ' + vm.objDate1.getFullYear();
            vm.arrayToExcel[a]['Fecha'] = vm.nameDate1;

            vm.namePlates = 'MEC- ' + vm.items[a].plates;
            vm.arrayToExcel[a]['Placas'] = vm.namePlates;

            vm.nameFullName = vm.items[a].fullName + ' '+ vm.items[a].lastNameFather + ' '+ vm.items[a].lastNameMother;
            vm.arrayToExcel[a]['Nombre'] = vm.nameFullName;

            vm.objDate2 = new Date(vm.items[a].dateValidity);
            vm.nameDate2 = vm.objDate2.getDate() + ' - ' + vm.months[vm.objDate2.getMonth()] + ' - ' + vm.objDate2.getFullYear();
            vm.arrayToExcel[a]['Vigencia'] = vm.nameDate2;

            if(vm.items[a].hasPolicy && vm.items[a].registerLocationPlace == 'Los Mochis Matriz'){
              vm.objPolicyExcel = 'MOCH 2-' + vm.items[a].policyNumber;
              vm.arrayToExcel[a]['Poliza'] = vm.objPolicyExcel;
            }else if(vm.items[a].hasPolicy){
              vm.objPolicyExcel = 'LM-' + vm.items[a].policyNumber;
              vm.arrayToExcel[a]['Poliza'] = vm.objPolicyExcel;
            }

            if(a==vm.items.length-1){

              var ws = XLSX.utils.json_to_sheet(vm.arrayToExcel, {origin: vm.cell_address});
              //XLSX.utils.sheet_add_json(ws, vm.arrayToExcel, {origin: vm.cell_address_2});
              var wb = XLSX.utils.book_new();

              XLSX.utils.book_append_sheet(wb, ws, "Hoja_1");
              XLSX.writeFile(wb, vm.nameExcel);

            }

          }
        }

      };

      // Para detectar cambios de fechas
      vm.getDatesFilter = function(){
        $log.log('vm.getDatesFilter()');

        $log.log("day1", document.getElementById("day1").value);
        vm.filterDate1 = document.getElementById("day1").value;
        vm.filterYear1 = vm.filterDate1.substr(0, 4);
        $log.log("vm.filterYear1", vm.filterYear1);
        vm.filterMonth1 = vm.filterDate1.substr(5, 2);
        $log.log("vm.filterMonth1", vm.filterMonth1);
        vm.filterDay1 = vm.filterDate1.substr(8, 2);
        $log.log("vm.filterDay1", vm.filterDay1);
        vm.newDate1 = new Date(vm.filterYear1, vm.filterMonth1-1, vm.filterDay1, 0, 0, 0)
        $log.log("vm.newDate1", vm.newDate1);

        $log.log("day2", document.getElementById("day2").value);
        vm.filterDate2 = document.getElementById("day2").value;
        vm.filterYear2 = vm.filterDate2.substr(0, 4);
        $log.log("vm.filterYear2", vm.filterYear2);
        vm.filterMonth2 = vm.filterDate2.substr(5, 2);
        $log.log("vm.filterMonth2", vm.filterMonth2);
        vm.filterDay2 = vm.filterDate2.substr(8, 2);
        $log.log("vm.filterDay2", vm.filterDay2);
        vm.newDate2 = new Date(vm.filterYear2, vm.filterMonth2-1, vm.filterDay2, 23, 59, 59)
        $log.log("vm.newDate2", vm.newDate2);

        if(vm.newDate1.getTime() > vm.newDate2.getTime()){
          sweetAlert("Oops...", "La fecha final tiene que ser mayor a la inicial", "error");
        }else{
          vm.filterWhereRegisters();
        }

      };

      // Cambiar Estado
      vm.changeState = function(){
        $log.log('vm.changeState()');
        $log.log('vm.stateOption', vm.stateOption);

        if(vm.stateOption == 'Todos'){
          vm.filterWhereRegisters();
        }else{
          if(vm.stateOption == 'Sinaloa'){
            vm.places = [
              'Todos',
              'Los Mochis Matriz',
              'Los Mochis Gaxiola',
              'Mochicahui',
              'El Carrizo',
              'Juan Jose Ríos',
              'Ruiz Cortines',
              'Leyva Solano',
              'Sinaloa de Leyva',
              'Guasave',
              'Guamuchil',
              'Culiacán',
              'Mazatlán'
            ];
          }else if(vm.stateOption == 'Sonora'){
            vm.places = [
              'Todos',
              'Hermosillo'
            ];
          }
          vm.filterWhereRegisters();
        }

      };

      // Cambiar Lugar
      vm.changePlace = function(){
        $log.log('vm.changePlace()');
        $log.log('vm.placeOption', vm.placeOption);
        vm.filterWhereRegisters();
      };

      // Definir el Where
      vm.filterWhereRegisters = function(){
        $log.log('vm.filterWhereRegisters()');

        if(vm.stateOption == 'Todos' && vm.placeOption == 'Todos' && vm.statesBlockOption == 'Todos' &&
          vm.userOption.fullName == 'Todos' && vm.brandOption.name == 'Todos' && vm.typeCarOption.name == 'Todos'){
          vm.where = {
            and:[
              {createdAt:{gt: vm.newDate1}},
              {createdAt:{lt: vm.newDate2}},
              {typePlate: 'plateVendor'}
            ]
          };
        }else{
          vm.where = {
            and:[
              {createdAt:{gt: vm.newDate1}},
              {createdAt:{lt: vm.newDate2}},
              {typePlate: 'plateVendor'}
            ]
          };
          if(vm.stateOption != 'Todos'){
            vm.where.and.push({registerLocationState: vm.stateOption});
          }
          if(vm.statesBlockOption != 'Todos'){
            if(vm.statesBlockOption == 'Activo'){
              vm.where.and.push({status: true});
            }else{
              vm.where.and.push({status: false});
            }
          }
          if(vm.placeOption != 'Todos'){
            vm.where.and.push({registerLocationPlace: vm.placeOption});
          }
          if(vm.userOption.fullName != 'Todos'){
            vm.where.and.push({createdById: vm.userOption.id});
          }
          if(vm.brandOption.name != 'Todos'){
            vm.where.and.push({brand: vm.brandOption.name});
          }
          if(vm.typeCarOption.name != 'Todos'){
            vm.where.and.push({type: vm.typeCarOption.name});
          }
        }

        if(vm.itemsText != ''){
          $log.log('vm.itemsText', vm.itemsText);

          vm.searchInputString = angular.copy(vm.itemsText);
          var stringsArray = vm.searchInputString.split(" ");

          vm.where.and.unshift({
            or:[]
          });

          for(var a = 0; a < stringsArray.length; a++){
            var word = stringsArray[a];

            for (var x = 0; x < vm.searchLikes.length; x++) {
              var objects = {};

              objects[vm.searchLikes[x]] = {
                like: word,
                options: 'i'
              };
              vm.where.and[0].or.push(angular.copy(objects));
            }

            if(a == stringsArray.length-1){
              $log.log('vm.where', vm.where);
              vm.loadItems(0);
            }
          }
        }else{
          $log.log('vm.where', vm.where);
          vm.loadItems(0);
        }

      };

      // Buscador
      vm.itemsText = '';
      vm.searchLikes = [
        "plates",
        "fullName",
        "lastNameFather",
        "lastNameMother",
        "vin"
      ];

      // Buscar los Registros
      vm.limit = 100;
      vm.limitSelect = '100';
      vm.limits = [
        '10',
        '100',
        '1000',
        'Todo'
      ];
      vm.paginationFor = 0;

      vm.today = new Date();
      vm.newFormatDate = new Date(2022, 0, 11, 23, 59, 59);

      vm.changeLimit = function(){
        $log.log('vm.changeLimit()');

        if(vm.limitSelect == '10'){
          vm.limit = 10;
        }else if(vm.limitSelect == '100'){
          vm.limit = 100;
        }else if(vm.limitSelect == '1000'){
          vm.limit = 1000;
        }else if(vm.limitSelect == 'Todo'){
          vm.limit = 999999999;
        }
        vm.loadItems(0);

      };

      vm.loadItems = function(skip) {
        $log.log('vm.loadItems');

        $log.log('vm.where', vm.where);
        $log.log('skip', skip);
        $log.log('vm.limit', vm.limit);

        vm.filterItems = {
          filter:{
            where: vm.where,
            skip: skip*vm.limit,
            limit: vm.limit,
            order: "createdAt DESC",
            include:[
              {
                relation: 'appUser'
              }
            ]
          }
        };

        vm.filterItemsQuantity = {
          where: vm.where
        };

        $log.log('filterItems', vm.filterItems);
        $log.log('filterItemsQuantity', vm.filterItemsQuantity);

        RegisterPlate.count(
          vm.filterItemsQuantity,
          function (quantityItems) {
            vm.quantityItems = quantityItems;
            $log.log('quantityItems', vm.quantityItems.count);
            vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
            vm.paginationOptions = [];

            if(vm.quantityItems.count != 0){
              if(vm.quantityItems.count % vm.limit != 0){
                vm.paginationFor =  vm.paginationFor + 1;
              }

              for(var n=0; n<vm.paginationFor; n++){
                vm.paginationOptions.push(n+1);
              }

              $log.log('vm.paginationOptions', vm.paginationOptions);
              vm.paginationOptions = vm.paginationOptions;
            }

            $log.log('vm.paginationFor', vm.paginationFor);
            $log.log('vm.paginationOptions', vm.paginationOptions);

            vm.paginationOptions = vm.paginationOptions;
            vm.paginationFor = vm.paginationFor;

          },
          function (err) {
            $log.log(err);
          });

        RegisterPlate.find(
          vm.filterItems,
          function (items) {
            vm.items = items;
            $log.log('vm.items', vm.items);
            vm.spinnerFlag = false;

            for(var a=0; a<vm.items.length; a++){

              //$log.log('a', a, vm.items[a].dateValidity);
              //$log.log('vm.today', vm.today);

              vm.items[a].dateValidity = new Date(vm.items[a].dateValidity);
              if(vm.items[a].dateValidity.getTime() > vm.today.getTime()){
                vm.items[a].isExpired = false;
              }else{
                vm.items[a].isExpired = true;
              }

              vm.items[a].dateRegister = new Date(vm.items[a].dateRegister);
              if(vm.items[a].dateRegister.getTime() < vm.newFormatDate.getTime()){
                vm.items[a].isNewFormat = false;
              }else{
                vm.items[a].isNewFormat = true;
              }

            }

          },
          function (err) {
            $log.log(err);
          });

      };

      // Pagination Seleccion
      vm.paginationOptions = [];
      vm.pageSelected = 1;

      vm.changeRight = function(){
        $log.log('vm.changeRight');

        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected + 1;
          if(vm.paginationOptions.length < vm.pageSelected){
            vm.pageSelected = vm.paginationOptions.length;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }

      };

      vm.changeLeft = function(){
        $log.log('vm.changeLeft');

        if(vm.paginationOptions.length != 1){
          if(vm.paginationOptions.length != 1){
            vm.pageSelected =  vm.pageSelected - 1;
            if(vm.pageSelected < 1){
              vm.pageSelected = 1;
            }

            $log.log('vm.pageSelected', vm.pageSelected);
            vm.loadItems(vm.pageSelected-1);
          }
        }
      };

      vm.changePage = function(){
        $log.log('vm.changePage');
        $log.log('vm.pageSelected', vm.pageSelected);

        if(vm.pageSelected == null){
          vm.pageSelected = 1;
          vm.loadItems(0);
        }else{
          vm.loadItems(vm.pageSelected-1);
        }
      };

      // Buscar Fecha inicio y fin de mes
      vm.getDatesMonth = function(){
        $log.log("vm.getDatesMonth");

        vm.today = new Date();

        if(vm.userLog.fullEdit){
          vm.firstDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth(), 1);
          vm.lastDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth()+1, 0);
        }else{
          vm.firstDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate());
          vm.lastDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate());
        }

        vm.newDate1 = vm.firstDayOfMonth;
        vm.newDate2 = vm.lastDayOfMonth;
        vm.day1 = vm.firstDayOfMonth.getDate() + ' ' + vm.months[vm.firstDayOfMonth.getMonth()] + ' ' + vm.firstDayOfMonth.getFullYear();
        vm.day2 = vm.lastDayOfMonth.getDate() + ' ' + vm.months[vm.lastDayOfMonth.getMonth()] + ' ' + vm.lastDayOfMonth.getFullYear();

        $log.log("vm.today", vm.today);
        $log.log("vm.firstDayOfMonth", vm.firstDayOfMonth);
        $log.log("vm.lastDayOfMonth", vm.lastDayOfMonth);

        vm.firstDayOfMonth = new Date(vm.firstDayOfMonth);
        vm.lastDayOfMonth = new Date(vm.lastDayOfMonth);

        vm.firstDayOfMonth.setHours(0, 0, 0);
        vm.lastDayOfMonth.setHours(23, 59, 59);

        vm.month1Temp = vm.firstDayOfMonth.getMonth() + 1;

        if(vm.month1Temp<10 && vm.firstDayOfMonth.getDate()<10){
          vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-0' + vm.month1Temp + '-0' + vm.firstDayOfMonth.getDate();
        }else if(vm.month1Temp<10){
          vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-0' + vm.month1Temp + '-' + vm.firstDayOfMonth.getDate();
        }else if(vm.firstDayOfMonth.getDate()<10){
          vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-' + vm.month1Temp + '-0' + vm.firstDayOfMonth.getDate();
        }else{
          vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-' + vm.month1Temp + '-' + vm.firstDayOfMonth.getDate();
        }

        $log.log("vm.dayOF1", vm.dayOF1);
        document.getElementById("day1").value = vm.dayOF1;

        vm.month2Temp = vm.lastDayOfMonth.getMonth() + 1;

        if(vm.month2Temp<10 && vm.lastDayOfMonth.getDate()<10){
          vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-0' + vm.month2Temp + '-0' + vm.lastDayOfMonth.getDate();
        }else if(vm.month2Temp<10){
          vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-0' + vm.month2Temp + '-' + vm.lastDayOfMonth.getDate();
        }else if(vm.lastDayOfMonth.getDate()<10){
          vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-' + vm.month2Temp + '-0' + vm.lastDayOfMonth.getDate();
        }else{
          vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-' + vm.month2Temp + '-' + vm.lastDayOfMonth.getDate();
        }

        $log.log("vm.dayOF2", vm.dayOF2);
        document.getElementById("day2").value = vm.dayOF2;

        vm.where = {
          and:[
            {createdAt:{gt: vm.newDate1}},
            {createdAt:{lt: vm.newDate2}},
            {typePlate: 'plateVendor'}
          ]
        };

        $log.log("vm.where", vm.where);

        vm.loadItems(0);
      };

      // Buscar Marcas, Tipo, Color
      vm.getInfoToStart = function(){
        $log.log("vm.getInfoToStart()");

        AppUser.find({
            filter: {
              where: {},
              order: 'fullName ASC'
            }
          },
          function(users){
            vm.users = angular.copy(users);
            $log.log("vm.users",  vm.users);
            vm.users.unshift({
              fullName: 'Todos'
            });
            $log.log("vm.users",  vm.users);
          },
          function(err){
            $log.log(err);
          });

        Brand.find({
            filter: {
              where: {},
              order: 'name ASC'
            }
          },
          function(brands){
            vm.brands = angular.copy(brands);
            $log.log("vm.brands",  vm.brands);
            vm.brands.unshift({
              name: 'Todos'
            });
            $log.log("vm.brands",  vm.brands);
          },
          function(err){
            $log.log(err);
          });

        TypeCar.find({
            filter: {
              where: {},
              order: 'name ASC'
            }
          },
          function(typeCars){
            vm.typeCars = angular.copy(typeCars);
            $log.log("vm.typeCars",  vm.typeCars);
            vm.typeCars.unshift({
              name: 'Todos'
            });
            $log.log("vm.typeCars",  vm.typeCars);
          },
          function(err){
            $log.log(err);
          });

        vm.getDatesMonth();

      };

      // Buscar usuario logeado
      vm.fullEditFlag = false;
      vm.getAppUserData = function(){

        AppUser.findOne({
            filter: {
              where: {
                id: AppUser.getCurrentId()
              }
            }
          },
          function(userLog){
            vm.userLog = angular.copy(userLog);
            $log.log("vm.userLog", vm.userLog);

            if(vm.userLog.fullEdit){
              vm.fullEditFlag = true;
            }else{
              vm.fullEditFlag = false;
            }

            vm.getInfoToStart();
          },
          function(err){
            $log.log(err);
          });

        Setting.findOne({
            filter: {
              where: {
                name: 'configuration'
              }
            }
          },
          function(settings){
            vm.settings = angular.copy(settings);
            $log.log("vm.settings", vm.settings);
          },
          function(err){
            $log.log(err);
          });

      };

      vm.getAppUserData();

      // Print
      vm.pdfPrint = function (item) {
        $log.log("vm.pdfPrint()");
        $log.log("item", item);

        //Genera el pdf
        var pdf = new jsPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'a4',
          putOnlyUsedFonts:true,
          floatPrecision: 16 // or "smart", default is 16
        });

        //Imágenes
        var img1 = new Image;
        var img2 = new Image;

        //Rutas de imágenes
        img1.crossOrigin = "";
        img2.crossOrigin = "";
        img1.src = "assets/images/conapafa/all.png";
        img2.src = "assets/images/conapafa/qrsat.jpg";

        //Añade toda la info al pdf
        pdf.addImage(img1, 'JPG', 18, 12, 182, 111);

        // Texto
        // line(x1, y1, x2, y2, style) → {jsPDF}

        // Cuadro 1 Titulo
        pdf.line(15, 130, 15, 160); // Vertical 1
        pdf.line(15, 130, 20, 130); // Horizontal 1
        pdf.line(15, 160, 20, 160); // Horizontal 2
        pdf.setFontSize(7);
        pdf.setFontType("bold");
        pdf.text(19, 159, 'DATOS DEL AFILIADO', null, 90);

        // Cuadro 2 Titulo
        pdf.line(15, 170, 15, 192); // Vertical 1
        pdf.line(15, 170, 20, 170); // Horizontal 1
        pdf.line(15, 192, 20, 192); // Horizontal 2
        pdf.setFontSize(7);
        pdf.setFontType("bold");
        pdf.text(19, 187, 'VEHICULO', null, 90);

        // Cuadro 3 Titulo
        pdf.line(15, 208, 15, 232); // Vertical 1
        pdf.line(15, 208, 20, 208); // Horizontal 1
        pdf.line(15, 232, 20, 232); // Horizontal 2
        pdf.text(19, 226, 'REGISTRO', null, 90);

        // Primer Cuadro
        // Verticales
        pdf.line(20, 130, 20, 160); // Vertical 1 a
        pdf.line(20, 170, 20, 192); // Vertical 1 b

        pdf.line(63, 130, 63, 138); // Vertical 2 a
        pdf.line(63, 145, 63, 160); // Vertical 2 b
        pdf.line(63, 170, 63, 192); // Vertical 2 c

        pdf.line(106, 130, 106, 160); // Vertical 3 a
        pdf.line(106, 170, 106, 177); // Vertical 3 b

        pdf.line(94, 184, 94, 192); // Vertical 3 POLIZA

        pdf.line(130, 177, 130, 192); // Vertical 4 a

        pdf.line(162, 130, 162, 177); // Vertical 5 a

        pdf.line(200, 130, 200, 192); // Vertical 6 a

        // Horizontales
        pdf.line(20, 130, 200, 130); // Primera Horizontal
        pdf.line(20, 138, 200, 138); // 1 Horizontal
        pdf.line(20, 145, 200, 145); // 2 Horizontal
        pdf.line(20, 152, 200, 152); // 3 Horizontal
        pdf.line(20, 160, 162, 160); // 4 Horizontal
        pdf.line(20, 170, 200, 170); // 5 Horizontal
        pdf.line(20, 177, 200, 177); // 6 Horizontal
        pdf.line(20, 184, 130, 184); // 7 Horizontal
        pdf.line(20, 192, 200, 192); // Ultima Horizontal

        pdf.setFontSize(10);
        pdf.setFontType("bold");
        pdf.text('ACREDITA AL TITULAR:', 21, 129);

        pdf.setFontSize(6);
        pdf.text('APELLIDO PATERNO', 21, 132);
        pdf.text('APELLIDO MATERNO', 64, 132);
        pdf.text('NOMBRE(S)', 107, 132);
        pdf.text('TELEFONO', 163, 132);

        pdf.setFontSize(8);
        pdf.text(item.lastNameFather.toUpperCase(), 21, 136);
        pdf.text(item.lastNameMother.toUpperCase(), 64, 136);
        pdf.text(item.fullName.toUpperCase(), 107, 136);
        pdf.text(item.telephone.toUpperCase(), 163, 136);

        pdf.setFontSize(6);
        pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140);
        pdf.text('COLONIA', 107, 140);
        pdf.text('CODIGO POSTAL', 163, 140);

        pdf.setFontSize(8);
        pdf.text(item.direction.toUpperCase(), 21, 144);
        pdf.text(item.colony.toUpperCase(), 107, 144);
        pdf.text(item.postalCode.toUpperCase(), 163, 144);

        pdf.setFontSize(6);
        pdf.text('POBLACION', 21, 147);
        pdf.text('MUNICIPIO', 64, 147);
        pdf.text('ESTADO', 107, 147);
        pdf.text('RFC', 163, 147);

        pdf.setFontSize(8);
        pdf.text(item.population.toUpperCase(), 21, 151);
        pdf.text(item.municipality.toUpperCase(), 64, 151);
        pdf.text(item.state.toUpperCase(), 107, 151);
        pdf.text(item.rfc.toUpperCase(), 163, 151);

        pdf.setFontSize(6);
        pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154);
        pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154);
        pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154);
        pdf.setFontSize(5);
        pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154);

        //Añade QR
        pdf.addImage(img2, 'JPG', 174, 155, 14, 14);

        pdf.setFontSize(8);
        pdf.text(item.credentialCard.toUpperCase(), 21, 158);
        pdf.text(item.licenseType.toUpperCase(), 64, 158);
        pdf.text(item.licenseNumber.toUpperCase(), 107, 158);

        pdf.setFontSize(10);
        pdf.setFontType("bold");
        pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169);

        pdf.setFontSize(6);
        pdf.text('MARCA', 21, 172);
        pdf.text('TIPO', 64, 172);
        pdf.text('LINEA', 107, 172);
        pdf.text('MODELO', 163, 172);

        pdf.setFontSize(8);
        pdf.text(item.brand.toUpperCase(), 21, 176);
        pdf.text(item.type.toUpperCase(), 64, 176);
        pdf.text(item.line.toUpperCase(), 107, 176);
        pdf.text(item.model.toUpperCase(), 163, 176);

        pdf.setFontSize(6);
        pdf.text('COLOR', 21, 179);
        pdf.text('NUMERO DE SERIE (VIN)', 64, 179);
        pdf.text('NUMERO DE PLACAS', 131, 179);

        pdf.setFontSize(8);
        pdf.text(item.color.toUpperCase(), 21, 183);
        pdf.text(item.vin.toUpperCase(), 64, 183);

        pdf.setFontSize(28);
        pdf.text('MEC-', 135, 189);
        pdf.text(item.plates.toUpperCase(), 161, 189);

        pdf.setFontSize(6);
        pdf.text('CILINDROS', 21, 186);
        pdf.text('PUERTAS', 64, 186);
        pdf.text('PÓLIZA', 96, 186);

        pdf.setFontSize(8);
        pdf.text(item.cylinders.toUpperCase(), 21, 190);
        pdf.text(item.doors.toUpperCase(), 64, 190);

        if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
          vm.objPolicy = 'MOCH 2-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 96, 190);
        }else if(item.hasPolicy){
          vm.objPolicy = 'LM-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 96, 190);
        }else{

        }

        // Segundo cuadro
        // Verticales
        pdf.line(20, 208, 20, 232); // Vertical 1 a
        pdf.line(63, 208, 63, 215); // Vertical 2 a
        pdf.line(106, 208, 106, 215); // Vertical 3 a
        pdf.line(162, 208, 162, 232); // Vertical 4 a
        pdf.line(200, 208, 200, 232); // Vertical 5 a

        // Horizontales
        pdf.line(20, 208, 200, 208); // Primera Horizontal
        pdf.line(20, 215, 162, 215); // 1 Horizontal
        pdf.line(20, 232, 200, 232); // Ultima Horizontal

        pdf.setFontSize(9);
        pdf.setFontType("bold");
        pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202);
        pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207);

        pdf.setFontSize(6);
        pdf.text('LUGAR DE REGSITRO', 21, 210);
        pdf.text('ESTADO DE REGISTRO', 64, 210);
        pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210);
        pdf.setFontSize(10);
        pdf.text('VIGENCIA', 172, 213);

        pdf.setFontSize(8);
        pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214);
        pdf.text(item.registerLocationState.toUpperCase(), 64, 214);

        vm.dateRegister = new Date(item.dateRegister);
        vm.dateValidity = new Date(item.dateValidity);
        vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

        vm.day1 = vm.dateRegister.getDate();
        vm.month1 = vm.dateRegister.getMonth();
        vm.year1 = vm.dateRegister.getFullYear();
        vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

        vm.day2 = vm.dateValidity.getDate();
        vm.month2 = vm.dateValidity.getMonth();
        vm.year2 = vm.dateValidity.getFullYear();
        vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

        pdf.text(vm.dateRegisterFull, 110, 214);

        pdf.setFontSize(16);
        pdf.text(vm.dateValidityrFull, 164, 222);

        pdf.setFontSize(6);
        pdf.text('SUGERENCIAS', 21, 217);

        pdf.setFontSize(8);
        pdf.text(item.sugestion.toUpperCase(), 21, 221);
        pdf.text(item.obervations.toUpperCase(), 21, 225);
        if(item.sugestion1 != 'Sin definir'){
          pdf.text(item.sugestion1.toUpperCase(), 21, 229);
        }
        pdf.setFontSize(10);
        vm.widthPage = pdf.internal.pageSize.getWidth();
        vm.widthText1 = pdf.getTextWidth('ATENTAMENTE');
        vm.xText1 = (vm.widthPage - vm.widthText1 ) / 2;
        pdf.text('ATENTAMENTE', vm.xText1, 245);

        vm.widthText2 = pdf.getTextWidth('PROFR. MANUEL ESCALANTE COTA');
        vm.xText2 = (vm.widthPage - vm.widthText2 ) / 2;
        pdf.text('PROFR. MANUEL ESCALANTE COTA', vm.xText2, 268);

        pdf.setFontType("normal");
        vm.widthText3 = pdf.getTextWidth('PRESIDENTE DEL COMITÉ NACIONAL');
        vm.xText3 = (vm.widthPage - vm.widthText3 ) / 2;
        pdf.text('PRESIDENTE DEL COMITÉ NACIONAL', vm.xText3, 273);

        vm.widthText4 = pdf.getTextWidth('PRO-DEFENSA DEL PATRIMONIO FAMILIAR');
        vm.xText4 = (vm.widthPage - vm.widthText4 ) / 2;
        pdf.text('PRO-DEFENSA DEL PATRIMONIO FAMILIAR', vm.xText4, 278);

        // // Print
        // pdf.autoPrint({variant: 'non-conform'});
        // //This is a key for printing
        // pdf.output('dataurlnewwindow');

        window.open(pdf.output('bloburl'), '_blank');

      };

      vm.pdfPrint1 = function (item) {
        $log.log("vm.pdfPrint()");
        $log.log("item", item);

        //Genera el pdf
        var pdf = new jsPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'a4',
          putOnlyUsedFonts:true,
          floatPrecision: 16 // or "smart", default is 16
        });

        //Imágenes
        var img2 = new Image;

        //Rutas de imágenes
        img2.crossOrigin = "";
        img2.src = "assets/images/conapafa/qrsat.jpg";

        // Texto
        // line(x1, y1, x2, y2, style) → {jsPDF}
        vm.marginAllY = vm.settings.marginY;

        // Cuadro 1 Titulo
        pdf.line(15, 130+vm.marginAllY, 15, 160+vm.marginAllY); // Vertical 1
        pdf.line(15, 130+vm.marginAllY, 20, 130+vm.marginAllY); // Horizontal 1
        pdf.line(15, 160+vm.marginAllY, 20, 160+vm.marginAllY); // Horizontal 2
        pdf.setFontSize(7);
        pdf.setFontType("bold");
        pdf.text(19, 159+vm.marginAllY, 'DATOS DEL AFILIADO', null, 90);

        // Cuadro 2 Titulo
        pdf.line(15, 170+vm.marginAllY, 15, 192+vm.marginAllY); // Vertical 1
        pdf.line(15, 170+vm.marginAllY, 20, 170+vm.marginAllY); // Horizontal 1
        pdf.line(15, 192+vm.marginAllY, 20, 192+vm.marginAllY); // Horizontal 2
        pdf.setFontSize(7);
        pdf.setFontType("bold");
        pdf.text(19, 187+vm.marginAllY, 'VEHICULO', null, 90);

        // Cuadro 3 Titulo
        pdf.line(15, 208+vm.marginAllY, 15, 232+vm.marginAllY); // Vertical 1
        pdf.line(15, 208+vm.marginAllY, 20, 208+vm.marginAllY); // Horizontal 1
        pdf.line(15, 232+vm.marginAllY, 20, 232+vm.marginAllY); // Horizontal 2
        pdf.text(19, 226+vm.marginAllY, 'REGISTRO', null, 90);

        // Primer Cuadro
        // Verticales
        pdf.line(20, 130+vm.marginAllY, 20, 160+vm.marginAllY); // Vertical 1 a
        pdf.line(20, 170+vm.marginAllY, 20, 192+vm.marginAllY); // Vertical 1 b

        pdf.line(63, 130+vm.marginAllY, 63, 138+vm.marginAllY); // Vertical 2 a
        pdf.line(63, 145+vm.marginAllY, 63, 160+vm.marginAllY); // Vertical 2 b
        pdf.line(63, 170+vm.marginAllY, 63, 192+vm.marginAllY); // Vertical 2 c

        pdf.line(106, 130+vm.marginAllY, 106, 160+vm.marginAllY); // Vertical 3 a
        pdf.line(106, 170+vm.marginAllY, 106, 177+vm.marginAllY); // Vertical 3 b

        pdf.line(94, 184+vm.marginAllY, 94, 192+vm.marginAllY); // Vertical 3 POLIZA

        pdf.line(130, 177+vm.marginAllY, 130, 192+vm.marginAllY); // Vertical 4 a

        pdf.line(162, 130+vm.marginAllY, 162, 177+vm.marginAllY); // Vertical 5 a

        pdf.line(200, 130+vm.marginAllY, 200, 192+vm.marginAllY); // Vertical 6 a

        // Horizontales
        pdf.line(20, 130+vm.marginAllY, 200, 130+vm.marginAllY); // Primera Horizontal
        pdf.line(20, 138+vm.marginAllY, 200, 138+vm.marginAllY); // 1 Horizontal
        pdf.line(20, 145+vm.marginAllY, 200, 145+vm.marginAllY); // 2 Horizontal
        pdf.line(20, 152+vm.marginAllY, 200, 152+vm.marginAllY); // 3 Horizontal
        pdf.line(20, 160+vm.marginAllY, 162, 160+vm.marginAllY); // 4 Horizontal
        pdf.line(20, 170+vm.marginAllY, 200, 170+vm.marginAllY); // 5 Horizontal
        pdf.line(20, 177+vm.marginAllY, 200, 177+vm.marginAllY); // 6 Horizontal
        pdf.line(20, 184+vm.marginAllY, 130, 184+vm.marginAllY); // 7 Horizontal
        pdf.line(20, 192+vm.marginAllY, 200, 192+vm.marginAllY); // Ultima Horizontal

        pdf.setFontSize(10);
        pdf.setFontType("bold");
        pdf.text('ACREDITA AL TITULAR:', 21, 129+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('APELLIDO PATERNO', 21, 132+vm.marginAllY);
        pdf.text('APELLIDO MATERNO', 64, 132+vm.marginAllY);
        pdf.text('NOMBRE(S)', 107, 132+vm.marginAllY);
        pdf.text('TELEFONO', 163, 132+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.lastNameFather.toUpperCase(), 21, 136+vm.marginAllY);
        pdf.text(item.lastNameMother.toUpperCase(), 64, 136+vm.marginAllY);
        pdf.text(item.fullName.toUpperCase(), 107, 136+vm.marginAllY);
        pdf.text(item.telephone.toUpperCase(), 163, 136+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140+vm.marginAllY);
        pdf.text('COLONIA', 107, 140+vm.marginAllY);
        pdf.text('CODIGO POSTAL', 163, 140+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.direction.toUpperCase(), 21, 144+vm.marginAllY);
        pdf.text(item.colony.toUpperCase(), 107, 144+vm.marginAllY);
        pdf.text(item.postalCode.toUpperCase(), 163, 144+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('POBLACION', 21, 147+vm.marginAllY);
        pdf.text('MUNICIPIO', 64, 147+vm.marginAllY);
        pdf.text('ESTADO', 107, 147+vm.marginAllY);
        pdf.text('RFC', 163, 147+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.population.toUpperCase(), 21, 151+vm.marginAllY);
        pdf.text(item.municipality.toUpperCase(), 64, 151+vm.marginAllY);
        pdf.text(item.state.toUpperCase(), 107, 151+vm.marginAllY);
        pdf.text(item.rfc.toUpperCase(), 163, 151+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154+vm.marginAllY);
        pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154+vm.marginAllY);
        pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154+vm.marginAllY);
        pdf.setFontSize(5);
        pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154+vm.marginAllY);

        //Añade QR
        pdf.addImage(img2, 'JPG', 174, 155+vm.marginAllY, 14, 14);

        pdf.setFontSize(8);
        pdf.text(item.credentialCard.toUpperCase(), 21, 158+vm.marginAllY);
        pdf.text(item.licenseType.toUpperCase(), 64, 158+vm.marginAllY);
        pdf.text(item.licenseNumber.toUpperCase(), 107, 158+vm.marginAllY);

        pdf.setFontSize(10);
        pdf.setFontType("bold");
        pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('MARCA', 21, 172+vm.marginAllY);
        pdf.text('TIPO', 64, 172+vm.marginAllY);
        pdf.text('LINEA', 107, 172+vm.marginAllY);
        pdf.text('MODELO', 163, 172+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.brand.toUpperCase(), 21, 176+vm.marginAllY);
        pdf.text(item.type.toUpperCase(), 64, 176+vm.marginAllY);
        pdf.text(item.line.toUpperCase(), 107, 176+vm.marginAllY);
        pdf.text(item.model.toUpperCase(), 163, 176+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('COLOR', 21, 179+vm.marginAllY);
        pdf.text('NUMERO DE SERIE (VIN)', 64, 179+vm.marginAllY);
        pdf.text('NUMERO DE PLACAS', 131, 179+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.color.toUpperCase(), 21, 183+vm.marginAllY);
        pdf.text(item.vin.toUpperCase(), 64, 183+vm.marginAllY);

        pdf.setFontSize(28);
        pdf.text('MEC-', 135, 189+vm.marginAllY);
        pdf.text(item.plates.toUpperCase(), 161, 189+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('CILINDROS', 21, 186+vm.marginAllY);
        pdf.text('PUERTAS', 64, 186+vm.marginAllY);
        pdf.text('PÓLIZA', 96, 186+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.cylinders.toUpperCase(), 21, 190+vm.marginAllY);
        pdf.text(item.doors.toUpperCase(), 64, 190+vm.marginAllY);

        if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
          vm.objPolicy = 'MOCH 2-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
        }else if(item.hasPolicy){
          vm.objPolicy = 'LM-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
        }

        // Segundo cuadro
        // Verticales
        pdf.line(20, 208+vm.marginAllY, 20, 232+vm.marginAllY); // Vertical 1 a
        pdf.line(63, 208+vm.marginAllY, 63, 215+vm.marginAllY); // Vertical 2 a
        pdf.line(106, 208+vm.marginAllY, 106, 215+vm.marginAllY); // Vertical 3 a
        pdf.line(162, 208+vm.marginAllY, 162, 232+vm.marginAllY); // Vertical 4 a
        pdf.line(200, 208+vm.marginAllY, 200, 232+vm.marginAllY); // Vertical 5 a

        // Horizontales
        pdf.line(20, 208+vm.marginAllY, 200, 208+vm.marginAllY); // Primera Horizontal
        pdf.line(20, 215+vm.marginAllY, 162, 215+vm.marginAllY); // 1 Horizontal
        pdf.line(20, 232+vm.marginAllY, 200, 232+vm.marginAllY); // Ultima Horizontal

        pdf.setFontSize(9);
        pdf.setFontType("bold");
        pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202+vm.marginAllY);
        pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('LUGAR DE REGSITRO', 21, 210+vm.marginAllY);
        pdf.text('ESTADO DE REGISTRO', 64, 210+vm.marginAllY);
        pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210+vm.marginAllY);
        pdf.setFontSize(10);
        pdf.text('VIGENCIA', 172, 213+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214+vm.marginAllY);
        pdf.text(item.registerLocationState.toUpperCase(), 64, 214+vm.marginAllY);

        vm.dateRegister = new Date(item.dateRegister);
        vm.dateValidity = new Date(item.dateValidity);
        vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

        vm.day1 = vm.dateRegister.getDate();
        vm.month1 = vm.dateRegister.getMonth();
        vm.year1 = vm.dateRegister.getFullYear();
        vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

        vm.day2 = vm.dateValidity.getDate();
        vm.month2 = vm.dateValidity.getMonth();
        vm.year2 = vm.dateValidity.getFullYear();
        vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

        pdf.text(vm.dateRegisterFull, 110, 214+vm.marginAllY);

        pdf.setFontSize(16);
        pdf.text(vm.dateValidityrFull, 164, 222+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('SUGERENCIAS', 21, 217+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.sugestion.toUpperCase(), 21, 221+vm.marginAllY);
        pdf.text(item.obervations.toUpperCase(), 21, 225+vm.marginAllY);
        if(item.sugestion1 != 'Sin definir'){
          pdf.text(item.sugestion1.toUpperCase(), 21, 229+vm.marginAllY);
        }
        // // Print
        // pdf.autoPrint({variant: 'non-conform'});
        // //This is a key for printing
        // pdf.output('dataurlnewwindow');

        window.open(pdf.output('bloburl'), '_blank');

      };

      vm.pdfPrintNewCert = function (item) {
        $log.log("vm.pdfPrintNewCert()");
        $log.log("item", item);

        //Genera el pdf
        var pdf = new jsPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'letter',
          putOnlyUsedFonts: true,
          floatPrecision: 16 // or "smart", default is 16
        });

        //Imágenes
        var img2 = new Image;

        //Rutas de imágenes
        img2.crossOrigin = "";
        img2.src = "assets/images/conapafa/cert2.jpg";

        //Añade QR
        pdf.addImage(img2, 'JPG', 0, 0, 215.9, 279.4);

        pdf.setFontSize(13);
        pdf.setFontType("bold");
        pdf.setTextColor(0, 176, 240);
        vm.newDate = new Date();
        vm.newYear = ' ' + vm.newDate.getFullYear();
        pdf.text(vm.newYear, 49, 57.5);

        pdf.setFontSize(12);
        pdf.setFontType("bold");
        pdf.setTextColor(0, 0, 0);
        vm.fullName = item.fullName.toUpperCase() + ' ' + item.lastNameFather.toUpperCase() + ' ' + item.lastNameMother.toUpperCase();
        pdf.text(vm.fullName, 38, 143.5);

        pdf.setFontSize(8);
        pdf.setFontType("normal");
        pdf.text(item.telephone.toUpperCase(), 163, 143);

        vm.address = item.direction + ' COL. ' + item.colony + ', C.P. ' + item.postalCode + ', ' + item.population +
          ', ' + item.municipality + ', ' + item.state + '.';
        pdf.text(vm.address.toUpperCase(), 38, 149);

        pdf.text(item.credentialCard.toUpperCase(), 38, 154);
        pdf.text(item.rfc.toUpperCase(), 163, 153.5);

        pdf.text(item.licenseType.toUpperCase(), 70, 158.5);
        pdf.text(item.licenseNumber.toUpperCase(), 163, 158.5);

        pdf.text(item.brand.toUpperCase(), 45, 172);
        pdf.text(item.color.toUpperCase(), 130, 172);

        pdf.text(item.type.toUpperCase(), 45, 177);
        pdf.text(item.cylinders.toUpperCase(), 130, 177);

        pdf.text(item.line.toUpperCase(), 45, 182);
        pdf.text(item.doors.toUpperCase(), 130, 182);

        pdf.text(item.model.toUpperCase(), 45, 187);
        if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
          vm.objPolicy = 'MOCH 2-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
        }else if(item.hasPolicy){
          vm.objPolicy = 'LM-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
        }

        pdf.setFontSize(14);
        pdf.setFontType("bold");
        pdf.text(item.vin.toUpperCase(), 65, 193.5);

        pdf.setFontSize(18);
        pdf.setFontType("bold");
        vm.platesMec = 'MEC-' + item.plates.toUpperCase();
        pdf.text(vm.platesMec.toUpperCase(), 160.5, 193.5);

        pdf.setFontSize(8);
        pdf.setFontType("normal");

        pdf.text(item.registerLocationPlace.toUpperCase(), 60, 213);
        pdf.text(item.registerLocationState.toUpperCase(), 163, 213);

        vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        vm.dateRegister = new Date(item.dateRegister);
        vm.day1 = vm.dateRegister.getDate();
        vm.month1 = vm.dateRegister.getMonth() + 1;
        vm.year1 = vm.dateRegister.getFullYear();
        vm.hour = vm.dateRegister.getHours();
        vm.minutes = vm.dateRegister.getMinutes();
        vm.suffix = vm.hour >= 12 ? "PM":"AM";
        vm.hoursNew = ((vm.hour + 11) % 12 + 1) + ':' + vm.minutes + ' ' + vm.suffix;
        vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1-1].toUpperCase() + ' / ' + vm.year1 + ' - ' + vm.hoursNew;

        pdf.setFontSize(11);
        pdf.setFontType("bold");
        pdf.text(vm.dateRegisterFull.toUpperCase(), 70, 218);

        pdf.setFontType("normal");
        if(item.sugestion1 != 'Sin definir'){
          pdf.text(item.sugestion1.toUpperCase(), 19, 227);
        }else{
          //pdf.text(item.sugestion1.toUpperCase(), 18.5, 228);
        }

        // // Print
        // pdf.autoPrint({variant: 'non-conform'});
        // //This is a key for printing
        // pdf.output('dataurlnewwindow');

        window.open(pdf.output('bloburl'), '_blank');

      };

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.users.all', {
      url: "/all",
      views: {
        users:{
          templateUrl: "app/main/admin/users/all/all.html"
        }
      },
      data: {
        pageTitle: 'Users All'
      }
    });
  })
  .controller('UsersAllController', function ($log, $window, $state, $scope, AppUser) {

    $log.log('Users All');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;
    vm.spinnerFlag = true;

    // Titulo
    vm.title = 'Usuarios Conapafa';
    vm.titleButtonCreate = 'Añadir usuario';

    vm.create = function(){
      $log.log('create new user');
      $state.go('main.admin.users.user', {id: 'new'});
    };

    // Buscador
    vm.itemsText = '';
    vm.withText = false;
    vm.searchLikes = [
      "fullName"
    ];

    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
        $log.log('enterFunction', keyEvent);
        vm.searchText(vm.itemsText);
      }
    };

    vm.searchText = function(text) {
      $log.log('text', text);
      vm.itemsText = text;

      if(vm.itemsText == ''){
        $log.log('nothing');
        vm.withText = false;
        vm.loadItems(0);
      }else{
        $log.log('text text');
        vm.withText = true;
        vm.loadItems(0);
      }
    };

    // Lista
    vm.editModule = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.admin.users.user', {id: vm.itemToGo});
    };

    vm.deleteModule = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteOk(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };

    vm.deleteOk = function(index){
      $log.log('index', index);
      vm.itemToDelete = vm.items[index].id;

      AppUser.deleteById({id: vm.itemToDelete},
        function(itemDeleted){
          vm.itemDeleted = itemDeleted;
          $log.log("ItemDeleted", vm.itemDeleted);

          vm.items.splice(index, 1);

          if(vm.items.length == 0){
            vm.paginationFor = 0;
          }
        },
        function(err){
          $log.log(err);
        });
    };

    vm.limit = 50;
    vm.paginationFor = 0;

    vm.loadItems = function(skip) {

      vm.filterItems = {
        filter:{
          where: {
            role: 'Trabajador'
          },
          skip: skip*vm.limit,
          limit: vm.limit,
          order: "fullName ASC"
        }
      };

      vm.filterItemsQuantity = {
        where:{
          role: 'Trabajador'
        }
      };

      if(vm.withText){
        $log.log('vm.itemsText', vm.itemsText);

        vm.searchInputString = angular.copy(vm.itemsText);
        var stringsArray = vm.searchInputString.split(" ");

        vm.filterItems.filter.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        vm.filterItemsQuantity.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        for(var a = 0; a < stringsArray.length; a++){
          var word = stringsArray[a];

          for (var x = 0; x < vm.searchLikes.length; x++) {
            var objects = {};

            objects[vm.searchLikes[x]] = {
              like: word,
              options: 'i'
            };

            vm.filterItems.filter.where.and[0].or.push(angular.copy(objects));
            vm.filterItemsQuantity.where.and[0].or.push(angular.copy(objects));
          }
        }
      }

      $log.log('filterItems', vm.filterItems);
      $log.log('filterItemsQuantity', vm.filterItemsQuantity);

      AppUser.count(
        vm.filterItemsQuantity,
        function (quantityItems) {
          vm.quantityItems = quantityItems;
          $log.log('quantityItems', vm.quantityItems.count);
          vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
          vm.paginationOptions = [];

          if(vm.quantityItems.count != 0){
            if(vm.quantityItems.count % vm.limit != 0){
              vm.paginationFor =  vm.paginationFor + 1;
            }

            for(var n=0; n<vm.paginationFor; n++){
              vm.paginationOptions.push(n+1);
            }

            $log.log('vm.paginationOptions', vm.paginationOptions);
            vm.paginationOptions = vm.paginationOptions;
          }

          $log.log('vm.paginationFor', vm.paginationFor);
          $log.log('vm.paginationOptions', vm.paginationOptions);

          vm.paginationOptions = vm.paginationOptions;
          vm.paginationFor = vm.paginationFor;

        },
        function (err) {
          $log.log(err);
        });

      AppUser.find(
        vm.filterItems,
        function (items) {
          vm.items = items;
          $log.log('vm.items', vm.items);
          vm.spinnerFlag = false;
        },
        function (err) {
          $log.log(err);
        });

    };

    // Pagination Seleccion
    vm.paginationOptions = [];
    vm.pageSelected = 1;

    vm.changeRight = function(){
      $log.log('vm.changeRight');

      if(vm.paginationOptions.length != 1){
        vm.pageSelected =  vm.pageSelected + 1;
        if(vm.paginationOptions.length < vm.pageSelected){
          vm.pageSelected = vm.paginationOptions.length;
        }

        $log.log('vm.pageSelected', vm.pageSelected);
        vm.loadItems(vm.pageSelected-1);
      }

    };

    vm.changeLeft = function(){
      $log.log('vm.changeLeft');

      if(vm.paginationOptions.length != 1){
        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected - 1;
          if(vm.pageSelected < 1){
            vm.pageSelected = 1;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }
      }
    };

    vm.changePage = function(pageIndex){
      $log.log('pageIndex', pageIndex);
      vm.pageSelected = pageIndex;
      vm.loadItems(pageIndex-1);
    };


    // Buscar compañia

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.loadItems(0);

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();


  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.users.user', {
      url: "/user/:id",
      views: {
        users:{
          templateUrl: "app/main/admin/users/user/user.html"
        }
      },
      data: {
        pageTitle: 'User Users Admin'
      }
    });
  })
  .controller('UserUsersAdminController', function ($log, $window, $state, $stateParams, $timeout, $scope, AppUser, UserRole) {

    $log.log('User Users Admin');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    // Regresar a All Users
    vm.cancel = function(){
      $state.go('^.all');
    };

    // stateparameter
    $log.log('stateparameter', $stateParams);

    // Variables Generales
    vm.errorFlag = false;
    vm.createBlock = false;
    vm.states = [
      'Sinaloa',
      'Sonora'
    ];

    vm.roles = [
      'Admin General',
      'Operador'
    ];

    vm.stateFlag = false;

    // Crear Usuario
    vm.create = function(){
      vm.errorFlag = true;
      vm.createBlock = true;
      $log.log('user create', vm.user);

      if(vm.user.fullName == '' || vm.user.username == '' || vm.user.password == ''||
        vm.user.state == '' || vm.user.location == '' || vm.user.role == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
        vm.createBlock = false;
      }else{

        vm.user.isAdmin = false;

          AppUser.create(vm.user, function successSaveUser(datos){
              $log.log('created', datos);
              $state.go('^.all');
          },function errorSaveProduct(err){
              $log.log(err);
          });
      }

    };

    // Actualizar Usuario
    vm.update = function(){
      vm.errorFlag = true;
      vm.createBlock = true;

      if(vm.flagg.changePassword){
        vm.user.password = vm.newPassword;
      }

      $log.log('user update', vm.user);

      if(vm.user.fullName == '' || vm.user.username == '' || vm.user.password == ''||
        vm.user.state == '' || vm.user.location == '' || vm.user.role == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
        vm.createBlock = false;
      }else{

        vm.user.isAdmin = false;

        AppUser.prototype$patchAttributes(
            {id:  vm.user.id},
            vm.user, function (success){
                $log.log("Success", success);
                $state.go('^.all');
            }, function (err) {
                $log.log(err, 'error');
            });
      }

    };

    // Convertir a Admin
    vm.changeToAdmin = function(){

      vm.errorFlag = true;
      vm.createBlock = true;

      if(vm.flagg.changePassword){
        vm.user.password = vm.newPassword;
      }

      $log.log('user update', vm.user);

      if(vm.user.fullName == '' || vm.user.username == '' || vm.user.password == ''||
        vm.user.state == '' || vm.user.location == '' || vm.user.role == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
        vm.createBlock = false;
      }else{

        vm.user.isAdmin = false;
        vm.user.role = 'Admin General';

        AppUser.prototype$patchAttributes(
          {id:  vm.user.id},
          vm.user, function (success){
            $log.log("Success", success);
            $state.go('^.all');
          }, function (err) {
            $log.log(err, 'error');
          });
      }


    };

    // Se selecciona el role para el User
    vm.selectState = function() {
      $log.log('selectState');
      vm.user.location = '';

      if(vm.user.state == ''){

      }else{
        vm.stateFlag = true;

        if(vm.user.state == 'Sinaloa'){
          vm.locations = [
            'Los Mochis Matriz',
            'Los Mochis Gaxiola',
            'Mochicahui',
            'El Carrizo',
            'Juan Jose Ríos',
            'Ruiz Cortines',
            'Leyva Solano',
            'Sinaloa de Leyva',
            'Guasave',
            'Guamuchil',
            'Culiacán',
            'Mazatlán'
          ];
        }else if(vm.user.state == 'Sonora'){
          vm.locations = [
            'Hermosillo'
          ];
        }
      }
    };

    vm.itemCreateUpdate = function(){

      // Depende de la $stateParams.id nos indica si vamos a crear una nueva PurchaseRequest
      // o vamos a actualizar una ya creada
      if($stateParams.id === 'new'){
        $log.log("New user");
        vm.flag = true;
        vm.user = {
          fullName: '',
          username: '',
          state: '',
          location: '',
          role: 'Trabajador'
        };
      }
      else{
        $log.log("Update user");
        vm.flag = false;
        vm.flagg = {};
        vm.flagg.changePassword = false;
        vm.newPassword = "";

        vm.stateFlag = true;

        AppUser.findOne({
            filter: {
              where:
                {
                  id: $stateParams.id
                }
            }
          },
          function(user){
            vm.user = angular.copy(user);

            $log.log("vm.user",  vm.user);

            if(vm.user.state == 'Sinaloa'){
              vm.locations = [
                'Los Mochis Matriz',
                'Los Mochis Gaxiola',
                'Mochicahui',
                'El Carrizo',
                'Juan Jose Ríos',
                'Ruiz Cortines',
                'Leyva Solano',
                'Sinaloa de Leyva',
                'Guasave',
                'Guamuchil',
                'Culiacán',
                'Mazatlán'
              ];
            }else if(vm.user.state == 'Sonora'){
              vm.locations = [
                'Hermosillo'
              ];
            }
          },
          function(err){
            $log.log(err);
          });

      }

    };



    // Buscar usuario logeado
    vm.getAppUserData = function(){
      $log.log("vm.getAppUserData()");

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.itemCreateUpdate();
        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.typeCars.typeCar', {
      url: "/typeCar/:id",
      views: {
        typeCars:{
          templateUrl: "app/main/admin/types/type/type.html"
        }
      },
      data: {
        pageTitle: 'TypeCars TypeCar'
      }
    });
  })
  .controller('TypeCarsTypeCarController', function ($log, $window, $state, $stateParams, $timeout, $scope, AppUser, TypeCar) {

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    $log.log('TypeCars TypeCar');
    $log.log('stateparameter', $stateParams);

    // <title-model data-config="vm.configTitle"></title-model>
    // Directiva Título

    vm.addItemDirective = function(){
      $log.log('addItemDirective');
      $state.go('main.admin.modules.module', {id: 'new'});
    };

    vm.configTitle = {
      'title': "Detalle del tipo de carro",
      'icon': "fa-car",
      'iconButton': "fa-plus",
      'buttonName': "Añadir módulo",
      'addButton': false,
      'style': {
          "background-typeCar" : "#313639",
          "typeCar": "#fff"
      },
      'styleHover': {
          "background-typeCar" : "#313639",
          "typeCar": "#fff"
      }
    };

    vm.createBlock = false;

    vm.cancel = function(){
      $state.go('^.all');
    };

    // Se crea una nueva User
    // Antes de crearla se hace un chequeo para que todó lo necesario
    // este definido sino sale una modal que te lo recuerda
    vm.create = function(){
      vm.errorFlag = true;
      $log.log('typeCar create', vm.typeCar);

      if(vm.typeCar.fullName == ""){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{

          TypeCar.create(vm.typeCar, function successSaveUser(datos){
              $log.log('created', datos);
              $state.go('^.all');
          },function errorSaveProduct(err){
              $log.log(err);
          })
      }

    };

    // Se actualiza una User
    // Antes de crearla se hace un chequeo para que todó lo necesario
    // este definido sino sale una modal que te lo recuerda
    vm.update = function(){
      vm.errorFlag = true;

      $log.log('typeCar update', vm.typeCar);

      if(vm.typeCar.name == ""){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{

        TypeCar.prototype$patchAttributes(
            {id:  vm.typeCar.id},
            vm.typeCar, function (success){
                $log.log("Success", success);
                $state.go('^.all');
            }, function (err) {
                $log.log(err, 'error');
            });
      }

    };

    // Cuando le das enter a un input se ejecuta dicha dunción
    // el numero 13 indica el enter
    // ng-keypress="vm.enterFunction($event)"
    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
          if(vm.flag){
              $log.log('Create');
              vm.create();
          }else{
              $log.log('Update');
              vm.update();
          }
      }
    };

    vm.itemCreateUpdate = function(){

      // Depende de la $stateParams.id nos indica si vamos a crear una nueva PurchaseRequest
      // o vamos a actualizar una ya creada
      if($stateParams.id === 'new'){
        $log.log("New typeCar");
        vm.flag = true;
        vm.typeCar = {};
        vm.typeCar.name = '';
        vm.errorFlag = false;
      }
      else{
        $log.log("Update typeCar");
        vm.flag = false;

        TypeCar.findOne({
            filter: {
              where:
                {
                  id: $stateParams.id
                }
            }
          },
          function(typeCar){
            vm.typeCar = angular.copy(typeCar);

            $log.log("vm.typeCar",  vm.typeCar);
          },
          function(err){
            $log.log(err);
          });

      }

    };

    // Usuario Logeado
    vm.getAppUserData = function(){
      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.itemCreateUpdate();

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.typeCars.all', {
      url: "/all",
      views: {
        typeCars:{
          templateUrl: "app/main/admin/types/all/all.html"
        }
      },
      data: {
        pageTitle: 'TypeCars All'
      }
    });
  })
  .controller('TypeCarsAllController', function ($log, $window, $state, $scope, AppUser, TypeCar) {

    $log.log('TypeCars All');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;
    vm.spinnerFlag = true;

    // Titulo
    vm.title = 'Tipo de Carro';
    vm.titleButtonCreate = 'Añadir tipo';

    vm.create = function(){
      $log.log('create new user');
      $state.go('main.admin.typeCars.typeCar', {id: 'new'});
    };

    // Buscador
    vm.itemsText = '';
    vm.withText = false;
    vm.searchLikes = [
      "name"
    ];

    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
        $log.log('enterFunction', keyEvent);
        vm.searchText(vm.itemsText);
      }
    };

    vm.searchText = function(text) {
      $log.log('text', text);
      vm.itemsText = text;

      if(vm.itemsText == ''){
        $log.log('nothing');
        vm.withText = false;
        vm.loadItems(0);
      }else{
        $log.log('text text');
        vm.withText = true;
        vm.loadItems(0);
      }
    };

    // Lista

    vm.editModule = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.admin.typeCars.typeCar', {id: vm.itemToGo});
    };

    vm.deleteModule = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonTypeCar: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteOk(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };

    vm.deleteOk = function(index){
      $log.log('index', index);
      vm.itemToDelete = vm.items[index].id;

      TypeCar.deleteById({id: vm.itemToDelete},
        function(itemDeleted){
          vm.itemDeleted = itemDeleted;
          $log.log("ItemDeleted", vm.itemDeleted);

          vm.items.splice(index, 1);

          if(vm.items.length == 0){
            vm.paginationFor = 0;
          }
        },
        function(err){
          $log.log(err);
        });
    };

    vm.limit = 50;
    vm.paginationFor = 0;

    vm.loadItems = function(skip) {

      vm.filterItems = {
        filter:{
          where: {},
          skip: skip*vm.limit,
          limit: vm.limit,
          order: "name ASC"
        }
      };

      vm.filterItemsQuantity = {
        where:{}
      };

      if(vm.withText){
        $log.log('vm.itemsText', vm.itemsText);

        vm.searchInputString = angular.copy(vm.itemsText);
        var stringsArray = vm.searchInputString.split(" ");

        vm.filterItems.filter.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        vm.filterItemsQuantity.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        for(var a = 0; a < stringsArray.length; a++){
          var word = stringsArray[a];

          for (var x = 0; x < vm.searchLikes.length; x++) {
            var objects = {};

            objects[vm.searchLikes[x]] = {
              like: word,
              options: 'i'
            };

            vm.filterItems.filter.where.and[0].or.push(angular.copy(objects));
            vm.filterItemsQuantity.where.and[0].or.push(angular.copy(objects));
          }
        }
      }

      $log.log('filterItems', vm.filterItems);
      $log.log('filterItemsQuantity', vm.filterItemsQuantity);

      TypeCar.count(
        vm.filterItemsQuantity,
        function (quantityItems) {
          vm.quantityItems = quantityItems;
          $log.log('quantityItems', vm.quantityItems.count);
          vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
          vm.paginationOptions = [];

          if(vm.quantityItems.count != 0){
            if(vm.quantityItems.count % vm.limit != 0){
              vm.paginationFor =  vm.paginationFor + 1;
            }

            for(var n=0; n<vm.paginationFor; n++){
              vm.paginationOptions.push(n+1);
            }

            $log.log('vm.paginationOptions', vm.paginationOptions);
            vm.paginationOptions = vm.paginationOptions;
          }

          $log.log('vm.paginationFor', vm.paginationFor);
          $log.log('vm.paginationOptions', vm.paginationOptions);

          vm.paginationOptions = vm.paginationOptions;
          vm.paginationFor = vm.paginationFor;

        },
        function (err) {
          $log.log(err);
        });

      TypeCar.find(
        vm.filterItems,
        function (items) {
          vm.items = items;
          $log.log('vm.items', vm.items);
          vm.spinnerFlag = false;
        },
        function (err) {
          $log.log(err);
        });

    };

    // Pagination Seleccion
    vm.paginationOptions = [];
    vm.pageSelected = 1;

    vm.changeRight = function(){
      $log.log('vm.changeRight');

      if(vm.paginationOptions.length != 1){
        vm.pageSelected =  vm.pageSelected + 1;
        if(vm.paginationOptions.length < vm.pageSelected){
          vm.pageSelected = vm.paginationOptions.length;
        }

        $log.log('vm.pageSelected', vm.pageSelected);
        vm.loadItems(vm.pageSelected-1);
      }

    };

    vm.changeLeft = function(){
      $log.log('vm.changeLeft');

      if(vm.paginationOptions.length != 1){
        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected - 1;
          if(vm.pageSelected < 1){
            vm.pageSelected = 1;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }
      }
    };

    vm.changePage = function(pageIndex){
      $log.log('pageIndex', pageIndex);
      vm.pageSelected = pageIndex;
      vm.loadItems(pageIndex-1);
    };


    // Buscar compañia

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.loadItems(0);

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();


  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.roles.role', {
      url: "/role/:id",
      views: {
        roles:{
          templateUrl: "app/main/admin/roles/role/role.html"
        }
      },
      data: {
        pageTitle: 'Roles Role'
      }
    });
  })
  .controller('RolesRoleController', function ($log, $window, $state, $stateParams, $timeout, $scope, UserRole, AppUser) {

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    $log.log('Role');
    $log.log('stateparameter', $stateParams);

    // <title-model data-config="vm.configTitle"></title-model>
    // Directiva Título

    vm.addItemDirective = function(){
      $log.log('addItemDirective');
      $state.go('main.admin.modules.module', {id: 'new'});
    };

    vm.configTitle = {
      'title': "Detalle del Rol",
      'icon': "fa-user",
      'iconButton': "fa-plus",
      'buttonName': "Añadir módulo",
      'addButton': false,
      'style': {
          "background-color" : "#313639",
          "color": "#fff"
      },
      'styleHover': {
          "background-color" : "#313639",
          "color": "#fff"
      }
    };

    vm.createBlock = false;

    vm.cancel = function(){
      $state.go('^.all');
    };

    // Se crea una nueva User
    // Antes de crearla se hace un chequeo para que todó lo necesario
    // este definido sino sale una modal que te lo recuerda
    vm.create = function(){
      vm.errorFlag = true;
      $log.log('role create', vm.role);

      if(vm.role.name == undefined || vm.role.name == ""){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{

        UserRole.create(vm.role, function successSaveUser(datos){
          $log.log('created', datos);
          $state.go('^.all');
        },function errorSaveProduct(err){
          $log.log(err);
        })
      }

    };

    // Se actualiza una User
    // Antes de crearla se hace un chequeo para que todó lo necesario
    // este definido sino sale una modal que te lo recuerda
    vm.update = function(){
      vm.errorFlag = true;

      $log.log('role update', vm.role);

      if(vm.role.name == undefined || vm.role.name == ""){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{

        UserRole.prototype$patchAttributes(
          {id:  vm.role.id},
          vm.role, function (success){
            $log.log("Success", success);
            $state.go('^.all');
          }, function (err) {
            $log.log(err, 'error');
          });
      }

    };

    // Cuando le das enter a un input se ejecuta dicha dunción
    // el numero 13 indica el enter
    // ng-keypress="vm.enterFunction($event)"
    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
          if(vm.flag){
              $log.log('Create');
              vm.create();
          }else{
              $log.log('Update');
              vm.update();
          }
      }
    };

    vm.itemCreateUpdate = function(){

      // Depende de la $stateParams.id nos indica si vamos a crear una nueva PurchaseRequest
      // o vamos a actualizar una ya creada
      if($stateParams.id === 'new'){
        $log.log("New role");
        vm.flag = true;
        vm.role = {};

        vm.errorFlag = false;
      }
      else{
        $log.log("Update role");
        vm.flag = false;

        UserRole.findOne({
            filter: {
              where:
                {
                  id: $stateParams.id
                }
            }
          },
          function(role){
            vm.role = angular.copy(role);

            $log.log("vm.role",  vm.role);
          },
          function(err){
            $log.log(err);
          });

      }

    };

    // Buscar compañia
    //
    //

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.itemCreateUpdate();

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.roles.all', {
      url: "/all",
      views: {
        roles:{
          templateUrl: "app/main/admin/roles/all/all.html"
        }
      },
      data: {
        pageTitle: 'Roles All'
      }
    });
  })
  .controller('RolesAllController', function ($log, $window, $state, $scope, UserRole, AppUser) {

    $log.log('Roles All');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;
    vm.spinnerFlag = true;

    // Titulo
    vm.title = 'Roles para Usuarios';
    vm.titleButtonCreate = 'Añadir rol';

    vm.create = function(){
      $log.log('create new user');
      $state.go('main.admin.roles.role', {id: 'new'});
    };

    // Buscador
    vm.itemsText = '';
    vm.withText = false;
    vm.searchLikes = [
      "name"
    ];

    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
        $log.log('enterFunction', keyEvent);
        vm.searchText(vm.itemsText);
      }
    };

    vm.searchText = function(text) {
      $log.log('text', text);
      vm.itemsText = text;

      if(vm.itemsText == ''){
        $log.log('nothing');
        vm.withText = false;
        vm.loadItems(0);
      }else{
        $log.log('text text');
        vm.withText = true;
        vm.loadItems(0);
      }
    };

    // Lista

    vm.editModule = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.admin.roles.role', {id: vm.itemToGo});
    };

    vm.deleteModule = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteOk(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };

    vm.deleteOk = function(index){
      $log.log('index', index);
      vm.itemToDelete = vm.items[index].id;

      UserRole.deleteById({id: vm.itemToDelete},
        function(itemDeleted){
          vm.itemDeleted = itemDeleted;
          $log.log("ItemDeleted", vm.itemDeleted);

          vm.items.splice(index, 1);

          if(vm.items.length == 0){
            vm.paginationFor = 0;
          }
        },
        function(err){
          $log.log(err);
        });
    };

    vm.limit = 50;
    vm.paginationFor = 0;

    vm.loadItems = function(skip) {

      vm.filterItems = {
        filter:{
          where: {},
          skip: skip*vm.limit,
          limit: vm.limit,
          order: "name ASC"
        }
      };

      vm.filterItemsQuantity = {
        where:{}
      };

      if(vm.withText){
        $log.log('vm.itemsText', vm.itemsText);

        vm.searchInputString = angular.copy(vm.itemsText);
        var stringsArray = vm.searchInputString.split(" ");

        vm.filterItems.filter.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        vm.filterItemsQuantity.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        for(var a = 0; a < stringsArray.length; a++){
          var word = stringsArray[a];

          for (var x = 0; x < vm.searchLikes.length; x++) {
            var objects = {};

            objects[vm.searchLikes[x]] = {
              like: word,
              options: 'i'
            };

            vm.filterItems.filter.where.and[0].or.push(angular.copy(objects));
            vm.filterItemsQuantity.where.and[0].or.push(angular.copy(objects));
          }
        }
      }

      $log.log('filterItems', vm.filterItems);
      $log.log('filterItemsQuantity', vm.filterItemsQuantity);

      UserRole.count(
        vm.filterItemsQuantity,
        function (quantityItems) {
          vm.quantityItems = quantityItems;
          $log.log('quantityItems', vm.quantityItems.count);
          vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
          vm.paginationOptions = [];

          if(vm.quantityItems.count != 0){
            if(vm.quantityItems.count % vm.limit != 0){
              vm.paginationFor =  vm.paginationFor + 1;
            }

            for(var n=0; n<vm.paginationFor; n++){
              vm.paginationOptions.push(n+1);
            }

            $log.log('vm.paginationOptions', vm.paginationOptions);
            vm.paginationOptions = vm.paginationOptions;
          }

          $log.log('vm.paginationFor', vm.paginationFor);
          $log.log('vm.paginationOptions', vm.paginationOptions);

          vm.paginationOptions = vm.paginationOptions;
          vm.paginationFor = vm.paginationFor;

        },
        function (err) {
          $log.log(err);
        });

      UserRole.find(
        vm.filterItems,
        function (items) {
          vm.items = items;
          $log.log('vm.items', vm.items);
          vm.spinnerFlag = false;
        },
        function (err) {
          $log.log(err);
        });

    };

    // Pagination Seleccion
    vm.paginationOptions = [];
    vm.pageSelected = 1;

    vm.changeRight = function(){
      $log.log('vm.changeRight');

      if(vm.paginationOptions.length != 1){
        vm.pageSelected =  vm.pageSelected + 1;
        if(vm.paginationOptions.length < vm.pageSelected){
          vm.pageSelected = vm.paginationOptions.length;
        }

        $log.log('vm.pageSelected', vm.pageSelected);
        vm.loadItems(vm.pageSelected-1);
      }

    };

    vm.changeLeft = function(){
      $log.log('vm.changeLeft');

      if(vm.paginationOptions.length != 1){
        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected - 1;
          if(vm.pageSelected < 1){
            vm.pageSelected = 1;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }
      }
    };

    vm.changePage = function(pageIndex){
      $log.log('pageIndex', pageIndex);
      vm.pageSelected = pageIndex;
      vm.loadItems(pageIndex-1);
    };

    // Buscar compañia

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.loadItems(0);

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.registers.all', {
      url: "/all",
      views: {
        registers:{
          templateUrl: "app/main/admin/registers/all/all.html"
        }
      },
      data: {
        pageTitle: 'Registers All'
      }
    });
  })
  .controller('RegistersAllController',
    function ($log, $window, $state, $scope, RegisterPlate, AppUser, Brand, Color, TypeCar, Setting) {

    $log.log('Registers All');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    // Variables Globales
    vm.spinnerFlag = true;

    // Filtrador de Registros
    vm.stateOption = 'Todos';
    vm.placeOption = 'Todos';
    vm.states = [
      'Todos',
      'Sinaloa',
      'Sonora'
    ];
    vm.statesBlockOption = 'Todos';
    vm.statesBlocks = [
      'Todos',
      'Activo',
      'Baja'
    ];
    vm.places = [
      'Todos'
    ];
    vm.userOption = {
      fullName: 'Todos'
    };
    vm.brandOption = {
      name: 'Todos'
    };
    vm.typeCarOption = {
      name: 'Todos'
    };

    // Para detectar cambios de fechas
    vm.getDatesFilter = function(){
      $log.log('vm.getDatesFilter()');

      $log.log("day1", document.getElementById("day1").value);
      vm.filterDate1 = document.getElementById("day1").value;
      vm.filterYear1 = vm.filterDate1.substr(0, 4);
      $log.log("vm.filterYear1", vm.filterYear1);
      vm.filterMonth1 = vm.filterDate1.substr(5, 2);
      $log.log("vm.filterMonth1", vm.filterMonth1);
      vm.filterDay1 = vm.filterDate1.substr(8, 2);
      $log.log("vm.filterDay1", vm.filterDay1);
      vm.newDate1 = new Date(vm.filterYear1, vm.filterMonth1-1, vm.filterDay1, 0, 0, 0)
      $log.log("vm.newDate1", vm.newDate1);

      $log.log("day2", document.getElementById("day2").value);
      vm.filterDate2 = document.getElementById("day2").value;
      vm.filterYear2 = vm.filterDate2.substr(0, 4);
      $log.log("vm.filterYear2", vm.filterYear2);
      vm.filterMonth2 = vm.filterDate2.substr(5, 2);
      $log.log("vm.filterMonth2", vm.filterMonth2);
      vm.filterDay2 = vm.filterDate2.substr(8, 2);
      $log.log("vm.filterDay2", vm.filterDay2);
      vm.newDate2 = new Date(vm.filterYear2, vm.filterMonth2-1, vm.filterDay2, 23, 59, 59)
      $log.log("vm.newDate2", vm.newDate2);

      if(vm.newDate1.getTime() > vm.newDate2.getTime()){
        sweetAlert("Oops...", "La fecha final tiene que ser mayor a la inicial", "error");
      }else{
        vm.filterWhereRegisters();
      }

    };

    // Cambiar Estado
    vm.changeState = function(){
      $log.log('vm.changeState()');
      $log.log('vm.stateOption', vm.stateOption);

      if(vm.stateOption == 'Todos'){
        vm.filterWhereRegisters();
      }else{
        if(vm.stateOption == 'Sinaloa'){
          vm.places = [
            'Todos',
            'Los Mochis Matriz',
            'Los Mochis Gaxiola',
            'Mochicahui',
            'El Carrizo',
            'Juan Jose Ríos',
            'Ruiz Cortines',
            'Leyva Solano',
            'Sinaloa de Leyva',
            'Guasave',
            'Guamuchil',
            'Culiacán',
            'Mazatlán'
          ];
        }else if(vm.stateOption == 'Sonora'){
          vm.places = [
            'Todos',
            'Hermosillo'
          ];
        }
        vm.filterWhereRegisters();
      }

    };

    // Cambiar Lugar
    vm.changePlace = function(){
      $log.log('vm.changePlace()');
      $log.log('vm.placeOption', vm.placeOption);
      vm.filterWhereRegisters();
    };

    // Definir el Where
    vm.filterWhereRegisters = function(){
      $log.log('vm.filterWhereRegisters()');

      if(vm.stateOption == 'Todos' && vm.placeOption == 'Todos' && vm.statesBlockOption == 'Todos' &&
        vm.userOption.fullName == 'Todos' && vm.brandOption.name == 'Todos' && vm.typeCarOption.name == 'Todos'){
        vm.where = {
          and:[
            {
              createdAt:{gt: vm.newDate1}
            },
            {
              createdAt:{lt: vm.newDate2}
            }
          ]
        };
      }else{
        vm.where = {
          and:[
            {
              createdAt:{gt: vm.firstDayOfMonth}
            },
            {
              createdAt:{lt: vm.lastDayOfMonth}
            }
          ]
        };
        if(vm.stateOption != 'Todos'){
          vm.where.and.push({registerLocationState: vm.stateOption});
        }
        if(vm.statesBlockOption != 'Todos'){
          if(vm.statesBlockOption == 'Activo'){
            vm.where.and.push({status: true});
          }else{
            vm.where.and.push({status: false});
          }
        }
        if(vm.placeOption != 'Todos'){
          vm.where.and.push({registerLocationPlace: vm.placeOption});
        }
        if(vm.userOption.fullName != 'Todos'){
          vm.where.and.push({createdById: vm.userOption.id});
        }
        if(vm.brandOption.name != 'Todos'){
          vm.where.and.push({brand: vm.brandOption.name});
        }
        if(vm.typeCarOption.name != 'Todos'){
          vm.where.and.push({type: vm.typeCarOption.name});
        }
      }

      if(vm.itemsText != ''){
        $log.log('vm.itemsText', vm.itemsText);

        vm.searchInputString = angular.copy(vm.itemsText);
        var stringsArray = vm.searchInputString.split(" ");

        vm.where.and.unshift({
          or:[]
        });

        for(var a = 0; a < stringsArray.length; a++){
          var word = stringsArray[a];

          for (var x = 0; x < vm.searchLikes.length; x++) {
            var objects = {};

            objects[vm.searchLikes[x]] = {
              like: word,
              options: 'i'
            };
            vm.where.and[0].or.push(angular.copy(objects));
          }

          if(a == stringsArray.length-1){
            $log.log('vm.where', vm.where);
            vm.loadItems(0);
          }
        }
      }else{
        $log.log('vm.where', vm.where);
        vm.loadItems(0);
      }

    };

    // Crear Nuevo Registro
    vm.create = function(){
      $log.log('create new user');
      $state.go('main.admin.registers.register', {id: 'new'});
    };

    // Editar Registro
    vm.editModule = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.admin.registers.register', {id: vm.itemToGo, type: 'update'});
    };

    // Dar de Baja Registro
    vm.banModule = function(index){
      $log.log("Item to Delete");
      swal({
          title: "¿Quieres dar de baja el registro?",
          text: "",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Baja de Registro", "", "");
            vm.banOk(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };
    vm.banOk = function(index){
      $log.log('index', index);
      vm.items[index].status = false;
      vm.items[index].banDate = new Date();

      RegisterPlate.prototype$patchAttributes(
        {id:  vm.items[index].id},
        vm.items[index], function (success){
          $log.log("Success", success);
        }, function (err) {
          $log.log(err, 'error');
        });

    };

    // Eliminar Registro
    vm.deleteModule = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteOk(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };
    vm.deleteOk = function(index){
      $log.log('index', index);
      vm.itemToDelete = vm.items[index].id;

      RegisterPlate.deleteById({id: vm.itemToDelete},
        function(itemDeleted){
          vm.itemDeleted = itemDeleted;
          $log.log("ItemDeleted", vm.itemDeleted);

          vm.items.splice(index, 1);

          if(vm.items.length == 0){
            vm.paginationFor = 0;
          }
        },
        function(err){
          $log.log(err);
        });
    };

    // Ver el Registro
    vm.seeRegister = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.admin.registers.register', {id: vm.itemToGo, type: 'see'});
    };

    // Exportar Registros
    vm.months = ["Ene", "Feb", "Marzo", "Abril", "Mayo", "Jun", "Jul", "Ago", "Sept", "Oct", "Nov", "Dic"];
    vm.todayExcel = new Date();
    vm.objDateExcel = new Date(vm.todayExcel);
    vm.nameDateExcel = vm.objDateExcel.getDate() + ' - ' + vm.months[vm.objDateExcel.getMonth()] + ' - ' + vm.objDateExcel.getFullYear();

    vm.exportExcel = function(){
      $log.log("vm.exportExcel()");
      $log.log('downloadExcel');

      vm.nameExcel = 'Historial de Registro de Placas- ' + vm.nameDateExcel + '.xlsx';

      var num1 = 2;
      var n1 = num1.toString();
      vm.obj1 = 'A' + n1;
      vm.cell_address = vm.obj1;

      vm.arrayToExcel =[];

      if(vm.items.length == 0){
        sweetAlert("Oops...", "No tienes ningun registro de placas", "error");
      }else{
        for(var a=0; a<vm.items.length; a++){

          var obj = {
            'Estatus': '',
            'Fecha': '',
            'Placas': '',
            'Trabajador Conapafa': angular.copy(vm.items[a].appUser.fullName),
            'Estado Conapafa': angular.copy(vm.items[a].registerLocationState),
            'Lugar Conapafa': angular.copy(vm.items[a].registerLocationPlace),
            'Nombre': '',
            'Calle y Numero': vm.items[a].direction,
            'Colonia': vm.items[a].colony,
            'Codigo Postal': vm.items[a].postalCode,
            'Poblacion': vm.items[a].population,
            'Municipio': vm.items[a].municipality,
            'Estado': vm.items[a].state,
            'Telefono': angular.copy(vm.items[a].telephone),
            'Marca': angular.copy(vm.items[a].brand),
            'Linea': angular.copy(vm.items[a].line),
            'Modelo': angular.copy(vm.items[a].model),
            'Tipo': angular.copy(vm.items[a].type),
            'Color': angular.copy(vm.items[a].color),
            'Vin': angular.copy(vm.items[a].vin),
            'Vigencia': '',
            'Poliza': '',
            'Fecha Baja': '',
            'Observaciones': angular.copy(vm.items[a].finalObservations)
          };

          vm.arrayToExcel.push(angular.copy(obj));

          if(vm.items[a].status){
            vm.arrayToExcel[a]['Estatus'] = 'Activo';
            vm.arrayToExcel[a]['Fecha Baja'] = '-';
          }else{
            vm.arrayToExcel[a]['Estatus'] = 'Baja';
            vm.objDate2 = new Date(vm.items[a].banDate);
            vm.nameDate2 = vm.objDate2.getDate() + ' - ' + vm.months[vm.objDate2.getMonth()] + ' - ' + vm.objDate2.getFullYear();
            vm.arrayToExcel[a]['Fecha Baja'] = vm.nameDate2;

          }

          vm.objDate1 = new Date(vm.items[a].createdAt);
          vm.nameDate1 = vm.objDate1.getDate() + ' - ' + vm.months[vm.objDate1.getMonth()] + ' - ' + vm.objDate1.getFullYear();
          vm.arrayToExcel[a]['Fecha'] = vm.nameDate1;

          vm.namePlates = 'MEC- ' + vm.items[a].plates;
          vm.arrayToExcel[a]['Placas'] = vm.namePlates;

          vm.nameFullName = vm.items[a].fullName + ' '+ vm.items[a].lastNameFather + ' '+ vm.items[a].lastNameMother;
          vm.arrayToExcel[a]['Nombre'] = vm.nameFullName;

          vm.objDate2 = new Date(vm.items[a].dateValidity);
          vm.nameDate2 = vm.objDate2.getDate() + ' - ' + vm.months[vm.objDate2.getMonth()] + ' - ' + vm.objDate2.getFullYear();
          vm.arrayToExcel[a]['Vigencia'] = vm.nameDate2;

          if(vm.items[a].hasPolicy && vm.items[a].registerLocationPlace == 'Los Mochis Matriz'){
            vm.objPolicyExcel = 'MOCH 2-' + vm.items[a].policyNumber;
            vm.arrayToExcel[a]['Poliza'] = vm.objPolicyExcel;
          }else if(vm.items[a].hasPolicy){
            vm.objPolicyExcel = 'LM-' + vm.items[a].policyNumber;
            vm.arrayToExcel[a]['Poliza'] = vm.objPolicyExcel;
          }

          if(a==vm.items.length-1){

            var ws = XLSX.utils.json_to_sheet(vm.arrayToExcel, {origin: vm.cell_address});
            //XLSX.utils.sheet_add_json(ws, vm.arrayToExcel, {origin: vm.cell_address_2});
            var wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, ws, "Hoja_1");
            XLSX.writeFile(wb, vm.nameExcel);

          }

        }
      }

    };

    // Buscador
    vm.itemsText = '';
    vm.searchLikes = [
      "plates",
      "fullName",
      "lastNameFather",
      "lastNameMother",
      "vin"
    ];

    // Buscar los Registros
    vm.limit = 100;
    vm.limitSelect = '100';
    vm.limits = [
      '10',
      '100',
      '1000',
      'Todo'
    ];
    vm.paginationFor = 0;

    vm.today = new Date();
    vm.newFormatDate = new Date(2022, 0, 11, 23, 59, 59);

    vm.changeLimit = function(){
      $log.log('vm.changeLimit()');

      if(vm.limitSelect == '10'){
        vm.limit = 10;
      }else if(vm.limitSelect == '100'){
        vm.limit = 100;
      }else if(vm.limitSelect == '1000'){
        vm.limit = 1000;
      }else if(vm.limitSelect == 'Todo'){
        vm.limit = 999999999;
      }
      vm.loadItems(0);

    };

    vm.loadItems = function(skip) {
      $log.log('vm.loadItems');

      $log.log('vm.where', vm.where);
      $log.log('skip', skip);
      $log.log('vm.limit', vm.limit);

      vm.filterItems = {
        filter:{
          where: vm.where,
          skip: skip*vm.limit,
          limit: vm.limit,
          order: "createdAt DESC",
          include:[
            {
              relation: 'appUser'
            }
          ]
        }
      };

      vm.filterItemsQuantity = {
        where: vm.where
      };

      $log.log('filterItems', vm.filterItems);
      $log.log('filterItemsQuantity', vm.filterItemsQuantity);

      RegisterPlate.count(
        vm.filterItemsQuantity,
        function (quantityItems) {
          vm.quantityItems = quantityItems;
          $log.log('quantityItems', vm.quantityItems.count);
          vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
          vm.paginationOptions = [];

          if(vm.quantityItems.count != 0){
            if(vm.quantityItems.count % vm.limit != 0){
              vm.paginationFor =  vm.paginationFor + 1;
            }

            for(var n=0; n<vm.paginationFor; n++){
              vm.paginationOptions.push(n+1);
            }

            $log.log('vm.paginationOptions', vm.paginationOptions);
            vm.paginationOptions = vm.paginationOptions;
          }

          $log.log('vm.paginationFor', vm.paginationFor);
          $log.log('vm.paginationOptions', vm.paginationOptions);

          vm.paginationOptions = vm.paginationOptions;
          vm.paginationFor = vm.paginationFor;

        },
        function (err) {
          $log.log(err);
        });

      RegisterPlate.find(
        vm.filterItems,
        function (items) {
          vm.items = items;
          $log.log('vm.items', vm.items);
          vm.spinnerFlag = false;

          for(var a=0; a<vm.items.length; a++){

            //$log.log('a', a, vm.items[a].dateValidity);
            //$log.log('vm.today', vm.today);

            vm.items[a].dateValidity = new Date(vm.items[a].dateValidity);
            if(vm.items[a].dateValidity.getTime() > vm.today.getTime()){
              vm.items[a].isExpired = false;
            }else{
              vm.items[a].isExpired = true;
            }

            vm.items[a].dateRegister = new Date(vm.items[a].dateRegister);
            if(vm.items[a].dateRegister.getTime() < vm.newFormatDate.getTime()){
              vm.items[a].isNewFormat = false;
            }else{
              vm.items[a].isNewFormat = true;
            }

          }

        },
        function (err) {
          $log.log(err);
        });

    };

    // Pagination Seleccion
    vm.paginationOptions = [];
    vm.pageSelected = 1;

    vm.changeRight = function(){
      $log.log('vm.changeRight');

      if(vm.paginationOptions.length != 1){
        vm.pageSelected =  vm.pageSelected + 1;
        if(vm.paginationOptions.length < vm.pageSelected){
          vm.pageSelected = vm.paginationOptions.length;
        }

        $log.log('vm.pageSelected', vm.pageSelected);
        vm.loadItems(vm.pageSelected-1);
      }

    };

    vm.changeLeft = function(){
      $log.log('vm.changeLeft');

      if(vm.paginationOptions.length != 1){
        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected - 1;
          if(vm.pageSelected < 1){
            vm.pageSelected = 1;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }
      }
    };

    vm.changePage = function(){
      $log.log('vm.changePage');
      $log.log('vm.pageSelected', vm.pageSelected);

      if(vm.pageSelected == null){
        vm.pageSelected = 1;
        vm.loadItems(0);
      }else{
        vm.loadItems(vm.pageSelected-1);
      }
    };

    // Buscar Fecha inicio y fin de mes
    vm.getDatesMonth = function(){
      $log.log("vm.getDatesMonth");

      vm.today = new Date();

      if(vm.userLog.fullEdit){
        vm.firstDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth(), 1);
        vm.lastDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth()+1, 0);
      }else{
        vm.firstDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate());
        vm.lastDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate());
      }

      vm.newDate1 = vm.firstDayOfMonth;
      vm.newDate2 = vm.lastDayOfMonth;
      vm.day1 = vm.firstDayOfMonth.getDate() + ' ' + vm.months[vm.firstDayOfMonth.getMonth()] + ' ' + vm.firstDayOfMonth.getFullYear();
      vm.day2 = vm.lastDayOfMonth.getDate() + ' ' + vm.months[vm.lastDayOfMonth.getMonth()] + ' ' + vm.lastDayOfMonth.getFullYear();

      $log.log("vm.today", vm.today);
      $log.log("vm.firstDayOfMonth", vm.firstDayOfMonth);
      $log.log("vm.lastDayOfMonth", vm.lastDayOfMonth);

      vm.firstDayOfMonth = new Date(vm.firstDayOfMonth);
      vm.lastDayOfMonth = new Date(vm.lastDayOfMonth);

      vm.firstDayOfMonth.setHours(0, 0, 0);
      vm.lastDayOfMonth.setHours(23, 59, 59);

      vm.month1Temp = vm.firstDayOfMonth.getMonth() + 1;

      if(vm.month1Temp<10 && vm.firstDayOfMonth.getDate()<10){
        vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-0' + vm.month1Temp + '-0' + vm.firstDayOfMonth.getDate();
      }else if(vm.month1Temp<10){
        vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-0' + vm.month1Temp + '-' + vm.firstDayOfMonth.getDate();
      }else if(vm.firstDayOfMonth.getDate()<10){
        vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-' + vm.month1Temp + '-0' + vm.firstDayOfMonth.getDate();
      }else{
        vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-' + vm.month1Temp + '-' + vm.firstDayOfMonth.getDate();
      }

      $log.log("vm.dayOF1", vm.dayOF1);
      document.getElementById("day1").value = vm.dayOF1;

      vm.month2Temp = vm.lastDayOfMonth.getMonth() + 1;

      if(vm.month2Temp<10 && vm.lastDayOfMonth.getDate()<10){
        vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-0' + vm.month2Temp + '-0' + vm.lastDayOfMonth.getDate();
      }else if(vm.month2Temp<10){
        vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-0' + vm.month2Temp + '-' + vm.lastDayOfMonth.getDate();
      }else if(vm.lastDayOfMonth.getDate()<10){
        vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-' + vm.month2Temp + '-0' + vm.lastDayOfMonth.getDate();
      }else{
        vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-' + vm.month2Temp + '-' + vm.lastDayOfMonth.getDate();
      }

      $log.log("vm.dayOF2", vm.dayOF2);
      document.getElementById("day2").value = vm.dayOF2;

      vm.where = {
        and:[
          {
            createdAt:{gt: vm.newDate1}
          },
          {
            createdAt:{lt: vm.newDate2}
          }
        ]
      };

      $log.log("vm.where", vm.where);

      vm.loadItems(0);
    };

    // Buscar Marcas, Tipo, Color
    vm.getInfoToStart = function(){
      $log.log("vm.getInfoToStart()");

      AppUser.find({
          filter: {
            where: {},
            order: 'fullName ASC'
          }
        },
        function(users){
          vm.users = angular.copy(users);
          $log.log("vm.users",  vm.users);
          vm.users.unshift({
            fullName: 'Todos'
          });
          $log.log("vm.users",  vm.users);
        },
        function(err){
          $log.log(err);
        });

      Brand.find({
          filter: {
            where: {},
            order: 'name ASC'
          }
        },
        function(brands){
          vm.brands = angular.copy(brands);
          $log.log("vm.brands",  vm.brands);
          vm.brands.unshift({
            name: 'Todos'
          });
          $log.log("vm.brands",  vm.brands);
        },
        function(err){
          $log.log(err);
        });

      TypeCar.find({
          filter: {
            where: {},
            order: 'name ASC'
          }
        },
        function(typeCars){
          vm.typeCars = angular.copy(typeCars);
          $log.log("vm.typeCars",  vm.typeCars);
          vm.typeCars.unshift({
            name: 'Todos'
          });
          $log.log("vm.typeCars",  vm.typeCars);
        },
        function(err){
          $log.log(err);
        });

      vm.getDatesMonth();

    };

    // Buscar usuario logeado
    vm.fullEditFlag = false;
    vm.getAppUserData = function(){

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          if(vm.userLog.fullEdit){
            vm.fullEditFlag = true;
          }else{
            vm.fullEditFlag = false;
          }

          vm.getInfoToStart();
        },
        function(err){
          $log.log(err);
        });

      Setting.findOne({
          filter: {
            where: {
              name: 'configuration'
            }
          }
        },
        function(settings){
          vm.settings = angular.copy(settings);
          $log.log("vm.settings", vm.settings);
        },
        function(err){
          $log.log(err);
        });

    };

    vm.getAppUserData();

    // Print
    vm.pdfPrint = function (item) {
      $log.log("vm.pdfPrint()");
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts:true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img1 = new Image;
      var img2 = new Image;

      //Rutas de imágenes
      img1.crossOrigin = "";
      img2.crossOrigin = "";
      img1.src = "assets/images/conapafa/all.png";
      img2.src = "assets/images/conapafa/qrsat.jpg";

      //Añade toda la info al pdf
      pdf.addImage(img1, 'JPG', 18, 12, 182, 111);

      // Texto
      // line(x1, y1, x2, y2, style) → {jsPDF}

      // Cuadro 1 Titulo
      pdf.line(15, 130, 15, 160); // Vertical 1
      pdf.line(15, 130, 20, 130); // Horizontal 1
      pdf.line(15, 160, 20, 160); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 159, 'DATOS DEL AFILIADO', null, 90);

      // Cuadro 2 Titulo
      pdf.line(15, 170, 15, 192); // Vertical 1
      pdf.line(15, 170, 20, 170); // Horizontal 1
      pdf.line(15, 192, 20, 192); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 187, 'VEHICULO', null, 90);

      // Cuadro 3 Titulo
      pdf.line(15, 208, 15, 232); // Vertical 1
      pdf.line(15, 208, 20, 208); // Horizontal 1
      pdf.line(15, 232, 20, 232); // Horizontal 2
      pdf.text(19, 226, 'REGISTRO', null, 90);

      // Primer Cuadro
      // Verticales
      pdf.line(20, 130, 20, 160); // Vertical 1 a
      pdf.line(20, 170, 20, 192); // Vertical 1 b

      pdf.line(63, 130, 63, 138); // Vertical 2 a
      pdf.line(63, 145, 63, 160); // Vertical 2 b
      pdf.line(63, 170, 63, 192); // Vertical 2 c

      pdf.line(106, 130, 106, 160); // Vertical 3 a
      pdf.line(106, 170, 106, 177); // Vertical 3 b

      pdf.line(94, 184, 94, 192); // Vertical 3 POLIZA

      pdf.line(130, 177, 130, 192); // Vertical 4 a

      pdf.line(162, 130, 162, 177); // Vertical 5 a

      pdf.line(200, 130, 200, 192); // Vertical 6 a

      // Horizontales
      pdf.line(20, 130, 200, 130); // Primera Horizontal
      pdf.line(20, 138, 200, 138); // 1 Horizontal
      pdf.line(20, 145, 200, 145); // 2 Horizontal
      pdf.line(20, 152, 200, 152); // 3 Horizontal
      pdf.line(20, 160, 162, 160); // 4 Horizontal
      pdf.line(20, 170, 200, 170); // 5 Horizontal
      pdf.line(20, 177, 200, 177); // 6 Horizontal
      pdf.line(20, 184, 130, 184); // 7 Horizontal
      pdf.line(20, 192, 200, 192); // Ultima Horizontal

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('ACREDITA AL TITULAR:', 21, 129);

      pdf.setFontSize(6);
      pdf.text('APELLIDO PATERNO', 21, 132);
      pdf.text('APELLIDO MATERNO', 64, 132);
      pdf.text('NOMBRE(S)', 107, 132);
      pdf.text('TELEFONO', 163, 132);

      pdf.setFontSize(8);
      pdf.text(item.lastNameFather.toUpperCase(), 21, 136);
      pdf.text(item.lastNameMother.toUpperCase(), 64, 136);
      pdf.text(item.fullName.toUpperCase(), 107, 136);
      pdf.text(item.telephone.toUpperCase(), 163, 136);

      pdf.setFontSize(6);
      pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140);
      pdf.text('COLONIA', 107, 140);
      pdf.text('CODIGO POSTAL', 163, 140);

      pdf.setFontSize(8);
      pdf.text(item.direction.toUpperCase(), 21, 144);
      pdf.text(item.colony.toUpperCase(), 107, 144);
      pdf.text(item.postalCode.toUpperCase(), 163, 144);

      pdf.setFontSize(6);
      pdf.text('POBLACION', 21, 147);
      pdf.text('MUNICIPIO', 64, 147);
      pdf.text('ESTADO', 107, 147);
      pdf.text('RFC', 163, 147);

      pdf.setFontSize(8);
      pdf.text(item.population.toUpperCase(), 21, 151);
      pdf.text(item.municipality.toUpperCase(), 64, 151);
      pdf.text(item.state.toUpperCase(), 107, 151);
      pdf.text(item.rfc.toUpperCase(), 163, 151);

      pdf.setFontSize(6);
      pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154);
      pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154);
      pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154);
      pdf.setFontSize(5);
      pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154);

      //Añade QR
      pdf.addImage(img2, 'JPG', 174, 155, 14, 14);

      pdf.setFontSize(8);
      pdf.text(item.credentialCard.toUpperCase(), 21, 158);
      pdf.text(item.licenseType.toUpperCase(), 64, 158);
      pdf.text(item.licenseNumber.toUpperCase(), 107, 158);

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169);

      pdf.setFontSize(6);
      pdf.text('MARCA', 21, 172);
      pdf.text('TIPO', 64, 172);
      pdf.text('LINEA', 107, 172);
      pdf.text('MODELO', 163, 172);

      pdf.setFontSize(8);
      pdf.text(item.brand.toUpperCase(), 21, 176);
      pdf.text(item.type.toUpperCase(), 64, 176);
      pdf.text(item.line.toUpperCase(), 107, 176);
      pdf.text(item.model.toUpperCase(), 163, 176);

      pdf.setFontSize(6);
      pdf.text('COLOR', 21, 179);
      pdf.text('NUMERO DE SERIE (VIN)', 64, 179);
      pdf.text('NUMERO DE PLACAS', 131, 179);

      pdf.setFontSize(8);
      pdf.text(item.color.toUpperCase(), 21, 183);
      pdf.text(item.vin.toUpperCase(), 64, 183);

      pdf.setFontSize(28);
      pdf.text('MEC-', 135, 189);
      pdf.text(item.plates.toUpperCase(), 161, 189);

      pdf.setFontSize(6);
      pdf.text('CILINDROS', 21, 186);
      pdf.text('PUERTAS', 64, 186);
      pdf.text('PÓLIZA', 96, 186);

      pdf.setFontSize(8);
      pdf.text(item.cylinders.toUpperCase(), 21, 190);
      pdf.text(item.doors.toUpperCase(), 64, 190);

      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190);
      }else{

      }

      // Segundo cuadro
      // Verticales
      pdf.line(20, 208, 20, 232); // Vertical 1 a
      pdf.line(63, 208, 63, 215); // Vertical 2 a
      pdf.line(106, 208, 106, 215); // Vertical 3 a
      pdf.line(162, 208, 162, 232); // Vertical 4 a
      pdf.line(200, 208, 200, 232); // Vertical 5 a

      // Horizontales
      pdf.line(20, 208, 200, 208); // Primera Horizontal
      pdf.line(20, 215, 162, 215); // 1 Horizontal
      pdf.line(20, 232, 200, 232); // Ultima Horizontal

      pdf.setFontSize(9);
      pdf.setFontType("bold");
      pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202);
      pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207);

      pdf.setFontSize(6);
      pdf.text('LUGAR DE REGSITRO', 21, 210);
      pdf.text('ESTADO DE REGISTRO', 64, 210);
      pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210);
      pdf.setFontSize(10);
      pdf.text('VIGENCIA', 172, 213);

      pdf.setFontSize(8);
      pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214);
      pdf.text(item.registerLocationState.toUpperCase(), 64, 214);

      vm.dateRegister = new Date(item.dateRegister);
      vm.dateValidity = new Date(item.dateValidity);
      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth();
      vm.year1 = vm.dateRegister.getFullYear();
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

      vm.day2 = vm.dateValidity.getDate();
      vm.month2 = vm.dateValidity.getMonth();
      vm.year2 = vm.dateValidity.getFullYear();
      vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

      pdf.text(vm.dateRegisterFull, 110, 214);

      pdf.setFontSize(16);
      pdf.text(vm.dateValidityrFull, 164, 222);

      pdf.setFontSize(6);
      pdf.text('SUGERENCIAS', 21, 217);

      pdf.setFontSize(8);
      pdf.text(item.sugestion.toUpperCase(), 21, 221);
      pdf.text(item.obervations.toUpperCase(), 21, 225);
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 21, 229);
      }
      pdf.setFontSize(10);
      vm.widthPage = pdf.internal.pageSize.getWidth();
      vm.widthText1 = pdf.getTextWidth('ATENTAMENTE');
      vm.xText1 = (vm.widthPage - vm.widthText1 ) / 2;
      pdf.text('ATENTAMENTE', vm.xText1, 245);

      vm.widthText2 = pdf.getTextWidth('PROFR. MANUEL ESCALANTE COTA');
      vm.xText2 = (vm.widthPage - vm.widthText2 ) / 2;
      pdf.text('PROFR. MANUEL ESCALANTE COTA', vm.xText2, 268);

      pdf.setFontType("normal");
      vm.widthText3 = pdf.getTextWidth('PRESIDENTE DEL COMITÉ NACIONAL');
      vm.xText3 = (vm.widthPage - vm.widthText3 ) / 2;
      pdf.text('PRESIDENTE DEL COMITÉ NACIONAL', vm.xText3, 273);

      vm.widthText4 = pdf.getTextWidth('PRO-DEFENSA DEL PATRIMONIO FAMILIAR');
      vm.xText4 = (vm.widthPage - vm.widthText4 ) / 2;
      pdf.text('PRO-DEFENSA DEL PATRIMONIO FAMILIAR', vm.xText4, 278);

      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      window.open(pdf.output('bloburl'), '_blank');

    };

    vm.pdfPrint1 = function (item) {
      $log.log("vm.pdfPrint()");
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts:true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img2 = new Image;

      //Rutas de imágenes
      img2.crossOrigin = "";
      img2.src = "assets/images/conapafa/qrsat.jpg";

      // Texto
      // line(x1, y1, x2, y2, style) → {jsPDF}
      vm.marginAllY = vm.settings.marginY;

      // Cuadro 1 Titulo
      pdf.line(15, 130+vm.marginAllY, 15, 160+vm.marginAllY); // Vertical 1
      pdf.line(15, 130+vm.marginAllY, 20, 130+vm.marginAllY); // Horizontal 1
      pdf.line(15, 160+vm.marginAllY, 20, 160+vm.marginAllY); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 159+vm.marginAllY, 'DATOS DEL AFILIADO', null, 90);

      // Cuadro 2 Titulo
      pdf.line(15, 170+vm.marginAllY, 15, 192+vm.marginAllY); // Vertical 1
      pdf.line(15, 170+vm.marginAllY, 20, 170+vm.marginAllY); // Horizontal 1
      pdf.line(15, 192+vm.marginAllY, 20, 192+vm.marginAllY); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 187+vm.marginAllY, 'VEHICULO', null, 90);

      // Cuadro 3 Titulo
      pdf.line(15, 208+vm.marginAllY, 15, 232+vm.marginAllY); // Vertical 1
      pdf.line(15, 208+vm.marginAllY, 20, 208+vm.marginAllY); // Horizontal 1
      pdf.line(15, 232+vm.marginAllY, 20, 232+vm.marginAllY); // Horizontal 2
      pdf.text(19, 226+vm.marginAllY, 'REGISTRO', null, 90);

      // Primer Cuadro
      // Verticales
      pdf.line(20, 130+vm.marginAllY, 20, 160+vm.marginAllY); // Vertical 1 a
      pdf.line(20, 170+vm.marginAllY, 20, 192+vm.marginAllY); // Vertical 1 b

      pdf.line(63, 130+vm.marginAllY, 63, 138+vm.marginAllY); // Vertical 2 a
      pdf.line(63, 145+vm.marginAllY, 63, 160+vm.marginAllY); // Vertical 2 b
      pdf.line(63, 170+vm.marginAllY, 63, 192+vm.marginAllY); // Vertical 2 c

      pdf.line(106, 130+vm.marginAllY, 106, 160+vm.marginAllY); // Vertical 3 a
      pdf.line(106, 170+vm.marginAllY, 106, 177+vm.marginAllY); // Vertical 3 b

      pdf.line(94, 184+vm.marginAllY, 94, 192+vm.marginAllY); // Vertical 3 POLIZA

      pdf.line(130, 177+vm.marginAllY, 130, 192+vm.marginAllY); // Vertical 4 a

      pdf.line(162, 130+vm.marginAllY, 162, 177+vm.marginAllY); // Vertical 5 a

      pdf.line(200, 130+vm.marginAllY, 200, 192+vm.marginAllY); // Vertical 6 a

      // Horizontales
      pdf.line(20, 130+vm.marginAllY, 200, 130+vm.marginAllY); // Primera Horizontal
      pdf.line(20, 138+vm.marginAllY, 200, 138+vm.marginAllY); // 1 Horizontal
      pdf.line(20, 145+vm.marginAllY, 200, 145+vm.marginAllY); // 2 Horizontal
      pdf.line(20, 152+vm.marginAllY, 200, 152+vm.marginAllY); // 3 Horizontal
      pdf.line(20, 160+vm.marginAllY, 162, 160+vm.marginAllY); // 4 Horizontal
      pdf.line(20, 170+vm.marginAllY, 200, 170+vm.marginAllY); // 5 Horizontal
      pdf.line(20, 177+vm.marginAllY, 200, 177+vm.marginAllY); // 6 Horizontal
      pdf.line(20, 184+vm.marginAllY, 130, 184+vm.marginAllY); // 7 Horizontal
      pdf.line(20, 192+vm.marginAllY, 200, 192+vm.marginAllY); // Ultima Horizontal

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('ACREDITA AL TITULAR:', 21, 129+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('APELLIDO PATERNO', 21, 132+vm.marginAllY);
      pdf.text('APELLIDO MATERNO', 64, 132+vm.marginAllY);
      pdf.text('NOMBRE(S)', 107, 132+vm.marginAllY);
      pdf.text('TELEFONO', 163, 132+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.lastNameFather.toUpperCase(), 21, 136+vm.marginAllY);
      pdf.text(item.lastNameMother.toUpperCase(), 64, 136+vm.marginAllY);
      pdf.text(item.fullName.toUpperCase(), 107, 136+vm.marginAllY);
      pdf.text(item.telephone.toUpperCase(), 163, 136+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140+vm.marginAllY);
      pdf.text('COLONIA', 107, 140+vm.marginAllY);
      pdf.text('CODIGO POSTAL', 163, 140+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.direction.toUpperCase(), 21, 144+vm.marginAllY);
      pdf.text(item.colony.toUpperCase(), 107, 144+vm.marginAllY);
      pdf.text(item.postalCode.toUpperCase(), 163, 144+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('POBLACION', 21, 147+vm.marginAllY);
      pdf.text('MUNICIPIO', 64, 147+vm.marginAllY);
      pdf.text('ESTADO', 107, 147+vm.marginAllY);
      pdf.text('RFC', 163, 147+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.population.toUpperCase(), 21, 151+vm.marginAllY);
      pdf.text(item.municipality.toUpperCase(), 64, 151+vm.marginAllY);
      pdf.text(item.state.toUpperCase(), 107, 151+vm.marginAllY);
      pdf.text(item.rfc.toUpperCase(), 163, 151+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154+vm.marginAllY);
      pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154+vm.marginAllY);
      pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154+vm.marginAllY);
      pdf.setFontSize(5);
      pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154+vm.marginAllY);

      //Añade QR
      pdf.addImage(img2, 'JPG', 174, 155+vm.marginAllY, 14, 14);

      pdf.setFontSize(8);
      pdf.text(item.credentialCard.toUpperCase(), 21, 158+vm.marginAllY);
      pdf.text(item.licenseType.toUpperCase(), 64, 158+vm.marginAllY);
      pdf.text(item.licenseNumber.toUpperCase(), 107, 158+vm.marginAllY);

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('MARCA', 21, 172+vm.marginAllY);
      pdf.text('TIPO', 64, 172+vm.marginAllY);
      pdf.text('LINEA', 107, 172+vm.marginAllY);
      pdf.text('MODELO', 163, 172+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.brand.toUpperCase(), 21, 176+vm.marginAllY);
      pdf.text(item.type.toUpperCase(), 64, 176+vm.marginAllY);
      pdf.text(item.line.toUpperCase(), 107, 176+vm.marginAllY);
      pdf.text(item.model.toUpperCase(), 163, 176+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('COLOR', 21, 179+vm.marginAllY);
      pdf.text('NUMERO DE SERIE (VIN)', 64, 179+vm.marginAllY);
      pdf.text('NUMERO DE PLACAS', 131, 179+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.color.toUpperCase(), 21, 183+vm.marginAllY);
      pdf.text(item.vin.toUpperCase(), 64, 183+vm.marginAllY);

      pdf.setFontSize(28);
      pdf.text('MEC-', 135, 189+vm.marginAllY);
      pdf.text(item.plates.toUpperCase(), 161, 189+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('CILINDROS', 21, 186+vm.marginAllY);
      pdf.text('PUERTAS', 64, 186+vm.marginAllY);
      pdf.text('PÓLIZA', 96, 186+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.cylinders.toUpperCase(), 21, 190+vm.marginAllY);
      pdf.text(item.doors.toUpperCase(), 64, 190+vm.marginAllY);

      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
      }

      // Segundo cuadro
      // Verticales
      pdf.line(20, 208+vm.marginAllY, 20, 232+vm.marginAllY); // Vertical 1 a
      pdf.line(63, 208+vm.marginAllY, 63, 215+vm.marginAllY); // Vertical 2 a
      pdf.line(106, 208+vm.marginAllY, 106, 215+vm.marginAllY); // Vertical 3 a
      pdf.line(162, 208+vm.marginAllY, 162, 232+vm.marginAllY); // Vertical 4 a
      pdf.line(200, 208+vm.marginAllY, 200, 232+vm.marginAllY); // Vertical 5 a

      // Horizontales
      pdf.line(20, 208+vm.marginAllY, 200, 208+vm.marginAllY); // Primera Horizontal
      pdf.line(20, 215+vm.marginAllY, 162, 215+vm.marginAllY); // 1 Horizontal
      pdf.line(20, 232+vm.marginAllY, 200, 232+vm.marginAllY); // Ultima Horizontal

      pdf.setFontSize(9);
      pdf.setFontType("bold");
      pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202+vm.marginAllY);
      pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('LUGAR DE REGSITRO', 21, 210+vm.marginAllY);
      pdf.text('ESTADO DE REGISTRO', 64, 210+vm.marginAllY);
      pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210+vm.marginAllY);
      pdf.setFontSize(10);
      pdf.text('VIGENCIA', 172, 213+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214+vm.marginAllY);
      pdf.text(item.registerLocationState.toUpperCase(), 64, 214+vm.marginAllY);

      vm.dateRegister = new Date(item.dateRegister);
      vm.dateValidity = new Date(item.dateValidity);
      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth();
      vm.year1 = vm.dateRegister.getFullYear();
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

      vm.day2 = vm.dateValidity.getDate();
      vm.month2 = vm.dateValidity.getMonth();
      vm.year2 = vm.dateValidity.getFullYear();
      vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

      pdf.text(vm.dateRegisterFull, 110, 214+vm.marginAllY);

      pdf.setFontSize(16);
      pdf.text(vm.dateValidityrFull, 164, 222+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('SUGERENCIAS', 21, 217+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.sugestion.toUpperCase(), 21, 221+vm.marginAllY);
      pdf.text(item.obervations.toUpperCase(), 21, 225+vm.marginAllY);
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 21, 229+vm.marginAllY);
      }
      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      window.open(pdf.output('bloburl'), '_blank');

    };

    vm.pdfPrintNewCert = function (item) {
      $log.log("vm.pdfPrintNewCert()");
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'letter',
        putOnlyUsedFonts: true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img2 = new Image;

      //Rutas de imágenes
      img2.crossOrigin = "";
      img2.src = "assets/images/conapafa/cert2.jpg";

      //Añade QR
      pdf.addImage(img2, 'JPG', 0, 0, 215.9, 279.4);

      pdf.setFontSize(13);
      pdf.setFontType("bold");
      pdf.setTextColor(0, 176, 240);
      vm.newDate = new Date();
      vm.newYear = ' ' + vm.newDate.getFullYear();
      pdf.text(vm.newYear, 49, 57.5);

      pdf.setFontSize(12);
      pdf.setFontType("bold");
      pdf.setTextColor(0, 0, 0);
      vm.fullName = item.fullName.toUpperCase() + ' ' + item.lastNameFather.toUpperCase() + ' ' + item.lastNameMother.toUpperCase();
      pdf.text(vm.fullName, 38, 143.5);

      pdf.setFontSize(8);
      pdf.setFontType("normal");
      pdf.text(item.telephone.toUpperCase(), 163, 143);

      vm.address = item.direction + ' COL. ' + item.colony + ', C.P. ' + item.postalCode + ', ' + item.population +
                    ', ' + item.municipality + ', ' + item.state + '.';
      pdf.text(vm.address.toUpperCase(), 38, 149);

      pdf.text(item.credentialCard.toUpperCase(), 38, 154);
      pdf.text(item.rfc.toUpperCase(), 163, 153.5);

      pdf.text(item.licenseType.toUpperCase(), 70, 158.5);
      pdf.text(item.licenseNumber.toUpperCase(), 163, 158.5);

      pdf.text(item.brand.toUpperCase(), 45, 172);
      pdf.text(item.color.toUpperCase(), 130, 172);

      pdf.text(item.type.toUpperCase(), 45, 177);
      pdf.text(item.cylinders.toUpperCase(), 130, 177);

      pdf.text(item.line.toUpperCase(), 45, 182);
      pdf.text(item.doors.toUpperCase(), 130, 182);

      pdf.text(item.model.toUpperCase(), 45, 187);
      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
      }

      pdf.setFontSize(14);
      pdf.setFontType("bold");
      pdf.text(item.vin.toUpperCase(), 65, 193.5);

      pdf.setFontSize(18);
      pdf.setFontType("bold");
      vm.platesMec = 'MEC-' + item.plates.toUpperCase();
      pdf.text(vm.platesMec.toUpperCase(), 160.5, 193.5);

      pdf.setFontSize(8);
      pdf.setFontType("normal");

      pdf.text(item.registerLocationPlace.toUpperCase(), 60, 213);
      pdf.text(item.registerLocationState.toUpperCase(), 163, 213);

      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.dateRegister = new Date(item.dateRegister);
      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth() + 1;
      vm.year1 = vm.dateRegister.getFullYear();
      vm.hour = vm.dateRegister.getHours();
      vm.minutes = vm.dateRegister.getMinutes();
      vm.suffix = vm.hour >= 12 ? "PM":"AM";
      vm.hoursNew = ((vm.hour + 11) % 12 + 1) + ':' + vm.minutes + ' ' + vm.suffix;
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1-1].toUpperCase() + ' / ' + vm.year1 + ' - ' + vm.hoursNew;

      pdf.setFontSize(11);
      pdf.setFontType("bold");
      pdf.text(vm.dateRegisterFull.toUpperCase(), 70, 218);

      pdf.setFontType("normal");
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 19, 227);
      }else{
        //pdf.text(item.sugestion1.toUpperCase(), 18.5, 228);
      }

      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      window.open(pdf.output('bloburl'), '_blank');

    };

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.registers.register', {
      url: "/register/:id/:type",
      views: {
        registers:{
          templateUrl: "app/main/admin/registers/register/register.html"
        }
      },
      data: {
        pageTitle: 'Register Registers Admin'
      }
    });
  })
  .controller('RegisterRegistersAdminController',
    function ($log, $window, $state, $stateParams, $timeout, $scope, RegisterPlate, AppUser, Brand, TypeCar, Color, Renovation, Upload, Setting) {

    $log.log('Register Registers Admin');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    // Variable stateparameter
    $log.log('stateparameter', $stateParams);

    // Variables Globales
    vm.createBlock = false;
    vm.errorFlag = false;
    vm.blockMEC = false;
    vm.cylinders = [0,1,2,3,4,5,6,8,10,12];
    vm.doors = [0,1,2,3,4,5];
    vm.licenseTypes = [
      'Automovilista',
      'Chofer',
      'Motociclista',
      'Aprendiz',
      'Federal',
    ];
    vm.sugestions = [
      'Sin definir',
      'Para este Modelo queda restringido el tránsito por Carretera Federal',
      'PARA TRANSITO NACIONAL EXCEPTO ESTADOS FRONTERIZOS Y DE CONTROL AMBIENTAL'
    ];

    vm.typeRegister = '';
    vm.typeRegisterFlag = false;
    vm.typeRegisters = [
      'Vehículo',
      'Motocicleta'
    ];

    // Regresar a All Registers
    vm.cancel = function(){
      $state.go('^.all');
    };

    // Checar si es Vehiculo o Moto
    vm.typeRegisterCarOrMoto = function(){
      $log.log('vm.typeRegisterCarOrMoto()');
      $log.log('vm.typeRegister', vm.typeRegister);

      if(vm.typeRegister == 'Vehículo'){
        vm.typeRegisterFlag = false;
      }else if(vm.typeRegister == 'Motocicleta'){
        vm.typeRegisterFlag = true;
        vm.register.licenseType = 'Motociclista';
        vm.register.type = 'Motocicleta';
        vm.register.doors = '0';
      }

    };

    // Checar placa para Crear
    vm.checkCreate = function(){
      $log.log('vm.checkCreate()');
      $log.log('register checkCreate', vm.register);

      vm.errorFlag = true;
      vm.createBlock = true;

      if(vm.register.fullName == '' || vm.register.lastNameFather == '' || vm.register.lastNameMother == '' ||
        vm.register.telephone == '' || vm.register.rfc == '' || vm.register.direction == '' ||
        vm.register.colony == '' || vm.register.postalCode == '' || vm.register.population == '' ||
        vm.register.municipality == '' || vm.register.state == '' || vm.register.credentialCard == '' ||
        vm.register.licenseNumber == '' || vm.register.brand == '' || vm.register.type == '' ||
        vm.register.line == '' || vm.register.model == '' || vm.register.color == '' ||
        vm.register.vin == '' || vm.register.plates == '' || vm.register.sugestion == '' ||
        vm.register.licenseType == '' || vm.typeRegister == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
        vm.createBlock = false;
      }else if(vm.register.hasPolicy && vm.register.policyNumber == ''){
        sweetAlert("Oops...", "Te faltan poner el numero de poliza", "error");
        vm.createBlock = false;
      }else{
        $log.log('Crear Registro');

        if(vm.typeRegister == 'Vehículo'){
          vm.register.typeRegister = 'car';
        }else if(vm.typeRegister == 'Motocicleta'){
          vm.register.typeRegister = 'moto';
        }

        RegisterPlate.findOne({
            filter: {
              where: {
                and:[
                  {plates: vm.register.plates},
                  {typeRegister: vm.register.typeRegister}
                ]
              }
            }
          },
          function(registerFound){
            vm.registerFound = angular.copy(registerFound);
            $log.log("vm.registerFound",  vm.registerFound);
            sweetAlert("Oops...", "Este numero de placas ya esta dado de alta", "error");
            vm.createBlock = false;
          },
          function(err){
            $log.log(err);
            $log.log('Dar de alta nuevas placas');
            vm.create();
          });

      }

    };

    // Crear Registro
    vm.create = function(){
      $log.log('vm.create()');
      $log.log('register create', vm.register);

      vm.register.createdById = vm.userLog.id;

      RegisterPlate.create(vm.register, function successSaveUser(datos){
        $log.log('created', datos);
        vm.pdfPrintNewCert();
      },function errorSaveProduct(err){
        $log.log(err);
      });

    };

    // PDF print
    vm.pdfPrint1 = function () {
      $log.log("vm.pdfPrint()");

      var item = vm.register;
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts:true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img2 = new Image;

      //Rutas de imágenes
      img2.crossOrigin = "";
      img2.src = "assets/images/conapafa/qrsat.jpg";

      // Texto
      // line(x1, y1, x2, y2, style) → {jsPDF}
      vm.marginAllY = vm.settings.marginY;

      // Cuadro 1 Titulo
      pdf.line(15, 130+vm.marginAllY, 15, 160+vm.marginAllY); // Vertical 1
      pdf.line(15, 130+vm.marginAllY, 20, 130+vm.marginAllY); // Horizontal 1
      pdf.line(15, 160+vm.marginAllY, 20, 160+vm.marginAllY); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 159+vm.marginAllY, 'DATOS DEL AFILIADO', null, 90);

      // Cuadro 2 Titulo
      pdf.line(15, 170+vm.marginAllY, 15, 192+vm.marginAllY); // Vertical 1
      pdf.line(15, 170+vm.marginAllY, 20, 170+vm.marginAllY); // Horizontal 1
      pdf.line(15, 192+vm.marginAllY, 20, 192+vm.marginAllY); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 187+vm.marginAllY, 'VEHICULO', null, 90);

      // Cuadro 3 Titulo
      pdf.line(15, 208+vm.marginAllY, 15, 232+vm.marginAllY); // Vertical 1
      pdf.line(15, 208+vm.marginAllY, 20, 208+vm.marginAllY); // Horizontal 1
      pdf.line(15, 232+vm.marginAllY, 20, 232+vm.marginAllY); // Horizontal 2
      pdf.text(19, 226+vm.marginAllY, 'REGISTRO', null, 90);

      // Primer Cuadro
      // Verticales
      pdf.line(20, 130+vm.marginAllY, 20, 160+vm.marginAllY); // Vertical 1 a
      pdf.line(20, 170+vm.marginAllY, 20, 192+vm.marginAllY); // Vertical 1 b

      pdf.line(63, 130+vm.marginAllY, 63, 138+vm.marginAllY); // Vertical 2 a
      pdf.line(63, 145+vm.marginAllY, 63, 160+vm.marginAllY); // Vertical 2 b
      pdf.line(63, 170+vm.marginAllY, 63, 192+vm.marginAllY); // Vertical 2 c

      pdf.line(106, 130+vm.marginAllY, 106, 160+vm.marginAllY); // Vertical 3 a
      pdf.line(106, 170+vm.marginAllY, 106, 177+vm.marginAllY); // Vertical 3 b

      pdf.line(94, 184+vm.marginAllY, 94, 192+vm.marginAllY); // Vertical 3 POLIZA

      pdf.line(130, 177+vm.marginAllY, 130, 192+vm.marginAllY); // Vertical 4 a

      pdf.line(162, 130+vm.marginAllY, 162, 177+vm.marginAllY); // Vertical 5 a

      pdf.line(200, 130+vm.marginAllY, 200, 192+vm.marginAllY); // Vertical 6 a

      // Horizontales
      pdf.line(20, 130+vm.marginAllY, 200, 130+vm.marginAllY); // Primera Horizontal
      pdf.line(20, 138+vm.marginAllY, 200, 138+vm.marginAllY); // 1 Horizontal
      pdf.line(20, 145+vm.marginAllY, 200, 145+vm.marginAllY); // 2 Horizontal
      pdf.line(20, 152+vm.marginAllY, 200, 152+vm.marginAllY); // 3 Horizontal
      pdf.line(20, 160+vm.marginAllY, 162, 160+vm.marginAllY); // 4 Horizontal
      pdf.line(20, 170+vm.marginAllY, 200, 170+vm.marginAllY); // 5 Horizontal
      pdf.line(20, 177+vm.marginAllY, 200, 177+vm.marginAllY); // 6 Horizontal
      pdf.line(20, 184+vm.marginAllY, 130, 184+vm.marginAllY); // 7 Horizontal
      pdf.line(20, 192+vm.marginAllY, 200, 192+vm.marginAllY); // Ultima Horizontal

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('ACREDITA AL TITULAR:', 21, 129+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('APELLIDO PATERNO', 21, 132+vm.marginAllY);
      pdf.text('APELLIDO MATERNO', 64, 132+vm.marginAllY);
      pdf.text('NOMBRE(S)', 107, 132+vm.marginAllY);
      pdf.text('TELEFONO', 163, 132+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.lastNameFather.toUpperCase(), 21, 136+vm.marginAllY);
      pdf.text(item.lastNameMother.toUpperCase(), 64, 136+vm.marginAllY);
      pdf.text(item.fullName.toUpperCase(), 107, 136+vm.marginAllY);
      pdf.text(item.telephone.toUpperCase(), 163, 136+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140+vm.marginAllY);
      pdf.text('COLONIA', 107, 140+vm.marginAllY);
      pdf.text('CODIGO POSTAL', 163, 140+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.direction.toUpperCase(), 21, 144+vm.marginAllY);
      pdf.text(item.colony.toUpperCase(), 107, 144+vm.marginAllY);
      pdf.text(item.postalCode.toUpperCase(), 163, 144+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('POBLACION', 21, 147+vm.marginAllY);
      pdf.text('MUNICIPIO', 64, 147+vm.marginAllY);
      pdf.text('ESTADO', 107, 147+vm.marginAllY);
      pdf.text('RFC', 163, 147+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.population.toUpperCase(), 21, 151+vm.marginAllY);
      pdf.text(item.municipality.toUpperCase(), 64, 151+vm.marginAllY);
      pdf.text(item.state.toUpperCase(), 107, 151+vm.marginAllY);
      pdf.text(item.rfc.toUpperCase(), 163, 151+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154+vm.marginAllY);
      pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154+vm.marginAllY);
      pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154+vm.marginAllY);
      pdf.setFontSize(5);
      pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154+vm.marginAllY);

      //Añade QR
      pdf.addImage(img2, 'JPG', 174, 155+vm.marginAllY, 14, 14);

      pdf.setFontSize(8);
      pdf.text(item.credentialCard.toUpperCase(), 21, 158+vm.marginAllY);
      pdf.text(item.licenseType.toUpperCase(), 64, 158+vm.marginAllY);
      pdf.text(item.licenseNumber.toUpperCase(), 107, 158+vm.marginAllY);

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('MARCA', 21, 172+vm.marginAllY);
      pdf.text('TIPO', 64, 172+vm.marginAllY);
      pdf.text('LINEA', 107, 172+vm.marginAllY);
      pdf.text('MODELO', 163, 172+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.brand.toUpperCase(), 21, 176+vm.marginAllY);
      pdf.text(item.type.toUpperCase(), 64, 176+vm.marginAllY);
      pdf.text(item.line.toUpperCase(), 107, 176+vm.marginAllY);
      pdf.text(item.model.toString(), 163, 176+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('COLOR', 21, 179+vm.marginAllY);
      pdf.text('NUMERO DE SERIE (VIN)', 64, 179+vm.marginAllY);
      pdf.text('NUMERO DE PLACAS', 131, 179+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.color.toUpperCase(), 21, 183+vm.marginAllY);
      pdf.text(item.vin.toUpperCase(), 64, 183+vm.marginAllY);

      pdf.setFontSize(28);
      pdf.text('MEC-', 135, 189+vm.marginAllY);
      pdf.text(item.plates.toUpperCase(), 161, 189+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('CILINDROS', 21, 186+vm.marginAllY);
      pdf.text('PUERTAS', 64, 186+vm.marginAllY);
      pdf.text('PÓLIZA', 96, 186+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.cylinders.toString(), 21, 190+vm.marginAllY);
      pdf.text(item.doors.toString(), 64, 190+vm.marginAllY);

      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
      }

      // Segundo cuadro
      // Verticales
      pdf.line(20, 208+vm.marginAllY, 20, 232+vm.marginAllY); // Vertical 1 a
      pdf.line(63, 208+vm.marginAllY, 63, 215+vm.marginAllY); // Vertical 2 a
      pdf.line(106, 208+vm.marginAllY, 106, 215+vm.marginAllY); // Vertical 3 a
      pdf.line(162, 208+vm.marginAllY, 162, 232+vm.marginAllY); // Vertical 4 a
      pdf.line(200, 208+vm.marginAllY, 200, 232+vm.marginAllY); // Vertical 5 a

      // Horizontales
      pdf.line(20, 208+vm.marginAllY, 200, 208+vm.marginAllY); // Primera Horizontal
      pdf.line(20, 215+vm.marginAllY, 162, 215+vm.marginAllY); // 1 Horizontal
      pdf.line(20, 232+vm.marginAllY, 200, 232+vm.marginAllY); // Ultima Horizontal

      pdf.setFontSize(9);
      pdf.setFontType("bold");
      pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202+vm.marginAllY);
      pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('LUGAR DE REGSITRO', 21, 210+vm.marginAllY);
      pdf.text('ESTADO DE REGISTRO', 64, 210+vm.marginAllY);
      pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210+vm.marginAllY);
      pdf.setFontSize(10);
      pdf.text('VIGENCIA', 172, 213+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214+vm.marginAllY);
      pdf.text(item.registerLocationState.toUpperCase(), 64, 214+vm.marginAllY);

      vm.dateRegister = new Date(item.dateRegister);
      vm.dateValidity = new Date(item.dateValidity);
      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth();
      vm.year1 = vm.dateRegister.getFullYear();
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

      vm.day2 = vm.dateValidity.getDate();
      vm.month2 = vm.dateValidity.getMonth();
      vm.year2 = vm.dateValidity.getFullYear();
      vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

      pdf.text(vm.dateRegisterFull, 110, 214+vm.marginAllY);

      pdf.setFontSize(16);
      pdf.text(vm.dateValidityrFull, 164, 222+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('SUGERENCIAS', 21, 217+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.sugestion.toUpperCase(), 21, 221+vm.marginAllY);
      pdf.text(item.obervations.toUpperCase(), 21, 225+vm.marginAllY);
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 21, 229+vm.marginAllY);
      }
      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      $state.go('^.all');
      window.open(pdf.output('bloburl'), '_blank');

    };

    vm.pdfPrintNewCert = function () {
      $log.log("vm.pdfPrintNewCert()");

      var item = vm.register;
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'letter',
        putOnlyUsedFonts: true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img2 = new Image;

      //Rutas de imágenes
      img2.crossOrigin = "";
      img2.src = "assets/images/conapafa/cert2.jpg";

      //Añade QR
      pdf.addImage(img2, 'JPG', 0, 0, 215.9, 279.4);

      pdf.setFontSize(13);
      pdf.setFontType("bold");
      pdf.setTextColor(0, 176, 240);
      vm.newDate = new Date();
      vm.newYear = ' ' + vm.newDate.getFullYear();
      pdf.text(vm.newYear, 49, 57.5);

      pdf.setFontSize(12);
      pdf.setFontType("bold");
      pdf.setTextColor(0, 0, 0);
      vm.fullName = item.fullName.toUpperCase() + ' ' + item.lastNameFather.toUpperCase() + ' ' + item.lastNameMother.toUpperCase();
      pdf.text(vm.fullName, 38, 143.5);

      pdf.setFontSize(8);
      pdf.setFontType("normal");
      pdf.text(item.telephone.toUpperCase(), 163, 143);

      vm.address = item.direction + ' COL. ' + item.colony + ', C.P. ' + item.postalCode + ', ' + item.population +
        ', ' + item.municipality + ', ' + item.state + '.';
      pdf.text(vm.address.toUpperCase(), 38, 149);

      pdf.text(item.credentialCard.toUpperCase(), 38, 154);
      pdf.text(item.rfc.toUpperCase(), 163, 153.5);

      pdf.text(item.licenseType.toUpperCase(), 70, 158.5);
      pdf.text(item.licenseNumber.toUpperCase(), 163, 158.5);

      pdf.text(item.brand.toUpperCase(), 45, 172);
      pdf.text(item.color.toUpperCase(), 130, 172);

      pdf.text(item.type.toUpperCase(), 45, 177);
      pdf.text(item.cylinders.toString(), 130, 177);

      pdf.text(item.line.toUpperCase(), 45, 182);
      pdf.text(item.doors.toString(), 130, 182);

      pdf.text(item.model.toString(), 45, 187);
      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
      }

      pdf.setFontSize(14);
      pdf.setFontType("bold");
      pdf.text(item.vin.toUpperCase(), 65, 193.5);

      pdf.setFontSize(18);
      pdf.setFontType("bold");
      vm.platesMec = 'MEC-' + item.plates.toUpperCase();
      pdf.text(vm.platesMec.toUpperCase(), 160.5, 193.5);

      pdf.setFontSize(8);
      pdf.setFontType("normal");

      pdf.text(item.registerLocationPlace.toUpperCase(), 60, 213);
      pdf.text(item.registerLocationState.toUpperCase(), 163, 213);

      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.dateRegister = new Date(item.dateRegister);
      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth() + 1;
      vm.year1 = vm.dateRegister.getFullYear();
      vm.hour = vm.dateRegister.getHours();
      vm.minutes = vm.dateRegister.getMinutes();
      vm.suffix = vm.hour >= 12 ? "PM":"AM";
      vm.hoursNew = ((vm.hour + 11) % 12 + 1) + ':' + vm.minutes + ' ' + vm.suffix;
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1-1].toUpperCase() + ' / ' + vm.year1 + ' - ' + vm.hoursNew;

      pdf.setFontSize(11);
      pdf.setFontType("bold");
      pdf.text(vm.dateRegisterFull.toUpperCase(), 70, 218);

      pdf.setFontType("normal");
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 19, 227);
      }else{
        //pdf.text(item.sugestion1.toUpperCase(), 18.5, 228);
      }

      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      $state.go('^.all');
      window.open(pdf.output('bloburl'), '_blank');

    };

    // Actualizar Registro
    vm.update = function(){
      vm.errorFlag = true;

      $log.log('register update', vm.register);

      if(vm.register.fullName == '' || vm.register.lastNameFather == '' || vm.register.lastNameMother == '' ||
        vm.register.telephone == '' || vm.register.rfc == '' || vm.register.direction == '' ||
        vm.register.colony == '' || vm.register.postalCode == '' || vm.register.population == '' ||
        vm.register.municipality == '' || vm.register.state == '' || vm.register.credentialCard == '' ||
        vm.register.licenseNumber == '' || vm.register.brand == '' || vm.register.type == '' ||
        vm.register.line == '' || vm.register.model == '' || vm.register.color == '' ||
        vm.register.vin == '' || vm.register.plates == '' || vm.register.sugestion == '' ||
        vm.register.licenseType == '' || vm.typeRegister == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else if(vm.register.hasPolicy && vm.register.policyNumber == ''){
        sweetAlert("Oops...", "Te faltan poner el numero de poliza", "error");
        vm.createBlock = false;
      }else{

        if(vm.typeRegister == 'Vehículo'){
          vm.register.typeRegister = 'car';
        }else if(vm.typeRegister == 'Motocicleta'){
          vm.register.typeRegister = 'moto';
        }

        //vm.register.createdById = vm.userLog.id;

        RegisterPlate.prototype$patchAttributes(
            {id:  vm.register.id},
            vm.register, function (success){
                $log.log("Success", success);
                $state.go('^.all');
            }, function (err) {
                $log.log(err, 'error');
            });
      }

    };

    // Archivos en Container
    vm.createBlockUpload = false;
    vm.documentType = '';
    vm.fileToAdd = {
      name: '',
      dateUpload: new Date(),
      url: ''
    };

    vm.addFile = function (files) {
      $log.log('vm.addFile()');
      $log.log('files', files);

      vm.file = files[0];
      vm.fileKey =  lil.uuid();
      Upload.rename(vm.file, vm.fileKey);

      vm.fileToAdd = {
        name: vm.file.name,
        dateUpload: new Date(),
        url: vm.fileKey
      };

      vm.sizeFile = vm.file.size/1000000;

      $log.log('vm.file', vm.file);
      $log.log('vm.fileKey', vm.fileKey);
      $log.log('vm.fileToAdd', vm.fileToAdd);

    };

    vm.addFileToArray = function(){
      $log.log('vm.addFileToArray');
      $log.log('vm.file', vm.file);
      $log.log('vm.fileKey', vm.fileKey);
      $log.log('vm.fileToAdd', vm.fileToAdd);
      $log.log('vm.documentType', vm.documentType);

      if(!vm.createBlockUpload){
        vm.createBlockUpload = true;

        if(vm.documentType == ''){
          sweetAlert("Oops...", "Debes ponerle un nombre al documento", "error");
          vm.createBlockUpload = false;
        }else if(vm.fileToAdd.name == ''){
          sweetAlert("Oops...", "Debes adjuntar algun archivo", "error");
          vm.createBlockUpload = false;
        }else{
          $log.log('Subir el documento al server');
          vm.uploadFileToServer();
        }
      }

    };

    vm.progressFile = 0;
    vm.uploadFileToServer = function () {
      $log.log('vm.uploadFileToServer()');

      vm.progressFile = 0;

      var file = vm.file;
      var fileKey =  vm.fileKey;

      vm.fileToUpload = file;
      vm.fileToUpload = Upload.upload({
        url: 'https://api.conapafa.com/api/Containers/container-conapafa/upload',
        //url: 'http://localhost:3001/api/Containers/container-buzonslagricola/upload',
        file: file,
        data: {
          key: fileKey,
          filename: fileKey
        }
      });

      vm.fileToUpload.then(function (response) {
        $timeout(function () {
          file.result = response.data;
        });
        $log.log('response', response);

        vm.fileToAdd.name = vm.documentType;
        vm.register.files.unshift(vm.fileToAdd);
        RegisterPlate.prototype$patchAttributes(
          {id:  vm.register.id},
          vm.register, function (success){
            $log.log(success, 'success');
            toastr.success('', 'Se subió el archivo al servidor');
            vm.createBlockUpload = false;
            vm.documentType = '';
            vm.fileToAdd = {
              name: '',
              dateUpload: new Date(),
              url: ''
            };
          }, function (err) {
            $log.log(err, 'error');
          });

      }, function (response) {
        if (response.status > 0)
          vm.errorMsg = response.status + ': ' + response.data;
          $log.log('err: ', vm.errorMsg);
          $log.log('err response: ', response);
          toastr.error('', 'Error');
          vm.createBlockUpload = false;
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        $log.log('progress: ' + progressPercentage + '% '+ evt.config.file.name + '\n');
        vm.progressFile = progressPercentage;
        if(progressPercentage == 100){
          $log.log('progressPercentage == 100');
        }
      });
    };

    vm.deleteCheck = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteFile(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };

    vm.deleteFile = function (index){
      $log.log('vm.deletePond', index);
      vm.register.files.splice(index, 1);

      RegisterPlate.prototype$patchAttributes(
        {id:  vm.register.id},
        vm.register, function (success){
          $log.log("Success", success);
        }, function (err) {
          $log.log(err, 'error');
        });
    };

    // Crear Nuevo o Encontrar Registro
    vm.itemCreateUpdate = function(){

      if($stateParams.id === 'new'){
        $log.log("New register");
        vm.flag = true;

        /*vm.register = {
          registerLocationState: vm.userLog.state,
          registerLocationPlace: vm.userLog.location,
          fullName: 'Ruben',
          lastNameFather: 'Lopez',
          lastNameMother: 'Flores',
          telephone: '6681620694',
          rfc: 'ASDC1568',
          direction: 'Delicias A',
          colony: 'Las Delicias',
          postalCode: '81277',
          population: 'Los Mochis',
          municipality: 'Ahome',
          state: 'Sinaloa',
          credentialCard: 'ASDFG16589',
          licenseType: 'Automovilista',
          licenseNumber: '91981981',
          brand: '',
          type: '',
          line: 'Linea',
          model: '2021',
          color: '',
          vin: '184197819',
          cylinders: '2',
          doors: '2',
          plates: '',
          sugestion: 'Tramitar verificación vehicular en guardia nacional',
          sugestion1: 'Sin definir',
          obervations: 'Con este registro su vehículo queda inscrito para una regularización futura',
          dateRegister: '',
          dateValidity: '',
          finalObservations: '',
          hasPolicy: false,
          policyNumber: '',
          files: [],
          typePlate: 'plateNormal'
        };*/

        vm.register = {
          registerLocationState: vm.userLog.state,
          registerLocationPlace: vm.userLog.location,
          fullName: '',
          lastNameFather: '',
          lastNameMother: '',
          telephone: '',
          rfc: '',
          direction: '',
          colony: '',
          postalCode: '',
          population: '',
          municipality: '',
          state: '',
          credentialCard: '',
          licenseType: '',
          licenseNumber: '',
          brand: '',
          type: '',
          line: '',
          model: '',
          color: '',
          vin: '',
          cylinders: '0',
          doors: '0',
          plates: '',
          sugestion: 'Tramitar verificación vehicular en guardia nacional',
          sugestion1: 'Sin definir',
          obervations: 'ESTE VEHÍCULO QUEDA INSCRITO PARA UNA REGULARIZACIÓN FUTURA',
          dateRegister: '',
          dateValidity: '',
          finalObservations: '',
          hasPolicy: false,
          policyNumber: '',
          files: [],
          typePlate: 'plateNormal'
        };

        vm.initialDate = '';
        // Seleccionar fecha para buscar
        vm.objInitialDate = new Date();
        vm.objInitialDateDay = vm.objInitialDate.getDate();
        vm.objInitialDateMonth = vm.objInitialDate.getMonth()+1;
        vm.objInitialDateYear = vm.objInitialDate.getFullYear();
        vm.initialDate = vm.objInitialDateDay + '-' + vm.objInitialDateMonth + '-' + vm.objInitialDateYear;
        vm.register.dateRegister = new Date(vm.objInitialDate);

        vm.dateValidity = new Date();
        vm.dateValidityYear = vm.dateValidity.getFullYear();
        vm.dateValidityMonth = vm.dateValidity.getMonth();
        vm.dateValidityDay = vm.dateValidity.getDate();
        vm.dateValidityC = new Date(vm.dateValidityYear + 1, vm.dateValidityMonth, vm.dateValidityDay);
        vm.register.dateValidity = vm.dateValidityC;

        vm.errorFlag = false;
        vm.flagUpdate = true;
      }
      else{
        $log.log("Update register");
        vm.flag = false;

        if($stateParams.type == 'see'){
          vm.flagUpdate = false;
          vm.blockMEC = true;
        }else{
          vm.flagUpdate = true;

          if(vm.userLog.fullEdit){
            vm.blockMEC = false;
          }else{
            vm.blockMEC = true;
          }
        }

        RegisterPlate.findOne({
            filter: {
              where: {
                id: $stateParams.id
              },
              include:[
                {
                  relation: 'appUser'
                },
                {
                  relation: 'renovations'
                }
              ]
            }
          },
          function(register){
            vm.register = angular.copy(register);
            $log.log("vm.register",  vm.register);

            vm.objInitialDate = new Date(vm.register.dateRegister);
            vm.objInitialDateDay = vm.objInitialDate.getDate();
            vm.objInitialDateMonth = vm.objInitialDate.getMonth()+1;
            vm.objInitialDateYear = vm.objInitialDate.getFullYear();
            vm.initialDate = vm.objInitialDateDay + '-' + vm.objInitialDateMonth + '-' + vm.objInitialDateYear;

            if(vm.register.typeRegister == 'car'){
              vm.typeRegister = 'Vehículo';
            }else if(vm.register.typeRegister == 'moto'){
              vm.typeRegister = 'Motocicleta';
            }

            if(vm.register.files == undefined){
              vm.register.files = [];
            }

            Renovation.find({
                filter: {
                  where: {
                    registerPlateId: $stateParams.id
                  },
                  order: "createdAt DESC",
                  include:[
                    {
                      relation: 'appUser'
                    },
                    {
                      relation: 'registerPlate'
                    }
                  ]
                }
              },
              function(renovations){
                vm.renovations = angular.copy(renovations);
                $log.log("vm.renovations", vm.renovations);
              },
              function(err){
                $log.log(err);
              });
          },
          function(err){
            $log.log(err);
          });

      }

    };

    // Buscar Marca Color, Tipo y Marca
    vm.infoStart = function(){

      $log.log('infoStart');

      Brand.find({
          filter: {
            where: {},
            order: 'name ASC'
          }
        },
        function(brands){
          vm.brands = angular.copy(brands);
          $log.log("vm.brands", vm.brands);

          TypeCar.find({
              filter: {
                where: {},
                order: 'name ASC'
              }
            },
            function(typeCars) {
              vm.typeCars = angular.copy(typeCars);
              $log.log("vm.typeCars", vm.typeCars);

              Color.find({
                  filter: {
                    where: {},
                    order: 'name ASC'
                  }
                },
                function(colors){
                  vm.colors = angular.copy(colors);
                  $log.log("vm.colors", vm.colors);

                  vm.itemCreateUpdate();

                },
                function(err){
                  $log.log(err);
                });
            },
            function(err){
              $log.log(err);
            });

        },
        function(err){
          $log.log(err);
        });

    };

    // Años para el select del Modelo del Carro
    vm.infoModelCar = function(){

      $log.log('infoStart2');

      vm.today = new Date();
      $log.log('vm.today.getFullYear()', vm.today.getFullYear());

      vm.todayYear = vm.today.getFullYear();
      vm.objDate = vm.today.getFullYear() - 1950;
      $log.log('vm.objDate', vm.objDate);

      vm.dates = [];
      for(var a=0; a<vm.objDate; a++){

        vm.dates.push(vm.todayYear-a);
        if(a==vm.objDate-1){
          $log.log('vm.dates', vm.dates);
          vm.infoStart();
        }
      }

    };

    //Detectar cambio de Fecha
    vm.changeInitialDate = function(){
      $log.log('vm.changeInitialDate');
      $log.log('vm.initialDate', vm.initialDate);
      vm.initialDateString = vm.initialDate.substr(3, 2) + '-' +
        vm.initialDate.substr(0, 2) + '-' +
        vm.initialDate.substr(6, 4);
      $log.log('vm.initialDateString', new Date(vm.initialDateString));

      vm.register.dateRegister = new Date(vm.initialDateString);

      vm.dateValidity = new Date(vm.register.dateRegister);
      vm.dateValidityYear = vm.dateValidity.getFullYear();
      vm.dateValidityMonth = vm.dateValidity.getMonth();
      vm.dateValidityDay = vm.dateValidity.getDate();
      vm.dateValidityC = new Date(vm.dateValidityYear + 1, vm.dateValidityMonth, vm.dateValidityDay);

      vm.register.dateValidity = vm.dateValidityC;
      $log.log('vm.register.dateRegister', vm.register.dateRegister);
      $log.log('vm.register.dateValidity', vm.register.dateValidity);

      vm.searchRegisterParameterFlag = false;
    };

    // Buscar Usuario Logeado
    vm.fullEditFlag = false;
    vm.getAppUserData = function(){

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          if(vm.userLog.fullEdit){
            vm.fullEditFlag = true;
          }else{
            vm.fullEditFlag = false;
          }

          vm.infoModelCar();
        },
        function(err){
          $log.log(err);
        });

      Setting.findOne({
          filter: {
            where: {
              name: 'configuration'
            }
          }
        },
        function(settings){
          vm.settings = angular.copy(settings);
          $log.log("vm.settings", vm.settings);
        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.renovations.renovation', {
      url: "/renovation/:id",
      views: {
        renovations:{
          templateUrl: "app/main/admin/renovations/renovation/renovation.html"
        }
      },
      data: {
        pageTitle: 'Renovation Renovations Admin'
      }
    });
  })
  .controller('RenovationRenovationsAdminController',
    function ($log, $window, $state, $stateParams, $timeout, $scope, RegisterPlate, AppUser, Brand, TypeCar, Color, Renovation, Upload, Setting) {

    $log.log('Renovation Renovations Admin');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    // Variable stateparameter
    $log.log('stateparameter', $stateParams);

    // Variables Globales
    vm.createBlock = false;
    vm.errorFlag = false;
    vm.blockMEC = false;
    vm.cylinders = [0,1,2,3,4,5,6,8,10,12];
    vm.doors = [0,1,2,3,4,5];
    vm.licenseTypes = [
      'Automovilista',
      'Chofer',
      'Motociclista',
      'Aprendiz',
      'Federal',
    ];
    vm.sugestions = [
      'Sin definir',
      'Para este Modelo queda restringido el tránsito por Carretera Federal',
      'PARA TRANSITO NACIONAL EXCEPTO ESTADOS FRONTERIZOS Y DE CONTROL AMBIENTAL'
    ];

    vm.typeRegister = '';
    vm.typeRegisterFlag = false;
    vm.typeRegisters = [
      'Vehículo',
      'Motocicleta'
    ];

    // Regresar a All Registers
    vm.cancel = function(){
      $state.go('^.all');
    };

    // Checar si es Vehiculo o Moto
    vm.typeRegisterCarOrMoto = function(){
      $log.log('vm.typeRegisterCarOrMoto()');
      $log.log('vm.typeRegister', vm.typeRegister);

      if(vm.typeRegister == 'Vehículo'){
        vm.typeRegisterFlag = false;
      }else if(vm.typeRegister == 'Motocicleta'){
        vm.typeRegisterFlag = true;
        vm.register.licenseType = 'Motociclista';
        vm.register.type = 'Motocicleta';
        vm.register.doors = '0';
      }

    };

    // Checar placa para Crear
    vm.checkCreate = function(){
      $log.log('vm.checkCreate()');
      $log.log('register checkCreate', vm.register);

      vm.errorFlag = true;
      vm.createBlock = true;

      if(vm.register.fullName == '' || vm.register.lastNameFather == '' || vm.register.lastNameMother == '' ||
        vm.register.telephone == '' || vm.register.rfc == '' || vm.register.direction == '' ||
        vm.register.colony == '' || vm.register.postalCode == '' || vm.register.population == '' ||
        vm.register.municipality == '' || vm.register.state == '' || vm.register.credentialCard == '' ||
        vm.register.licenseNumber == '' || vm.register.brand == '' || vm.register.type == '' ||
        vm.register.line == '' || vm.register.model == '' || vm.register.color == '' ||
        vm.register.vin == '' || vm.register.plates == '' || vm.register.sugestion == '' ||
        vm.register.licenseType == '' || vm.typeRegister == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
        vm.createBlock = false;
      }else if(vm.register.hasPolicy && vm.register.policyNumber == ''){
        sweetAlert("Oops...", "Te faltan poner el numero de poliza", "error");
        vm.createBlock = false;
      }else{
        $log.log('Crear Registro');

        if(vm.typeRegister == 'Vehículo'){
          vm.register.typeRegister = 'car';
        }else if(vm.typeRegister == 'Motocicleta'){
          vm.register.typeRegister = 'moto';
        }

        RegisterPlate.findOne({
            filter: {
              where: {
                and:[
                  {plates: vm.register.plates},
                  {typeRegister: vm.register.typeRegister}
                ]
              }
            }
          },
          function(registerFound){
            vm.registerFound = angular.copy(registerFound);
            $log.log("vm.registerFound",  vm.registerFound);
            sweetAlert("Oops...", "Este numero de placas ya esta dado de alta", "error");
            vm.createBlock = false;
          },
          function(err){
            $log.log(err);
            $log.log('Dar de alta nuevas placas');
            vm.create();
          });

      }

    };

    // Crear Registro
    vm.create = function(){
      $log.log('vm.create()');
      $log.log('register create', vm.register);

      vm.register.createdById = vm.userLog.id;

      RegisterPlate.create(vm.register, function successSaveUser(datos){
        $log.log('created', datos);
        vm.pdfPrintNewCert();
      },function errorSaveProduct(err){
        $log.log(err);
      });

    };

    // PDF print
    vm.pdfPrint1 = function () {
      $log.log("vm.pdfPrint()");

      var item = vm.register;
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts:true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img2 = new Image;

      //Rutas de imágenes
      img2.crossOrigin = "";
      img2.src = "assets/images/conapafa/qrsat.jpg";

      // Texto
      // line(x1, y1, x2, y2, style) → {jsPDF}
      vm.marginAllY = vm.settings.marginY;

      // Cuadro 1 Titulo
      pdf.line(15, 130+vm.marginAllY, 15, 160+vm.marginAllY); // Vertical 1
      pdf.line(15, 130+vm.marginAllY, 20, 130+vm.marginAllY); // Horizontal 1
      pdf.line(15, 160+vm.marginAllY, 20, 160+vm.marginAllY); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 159+vm.marginAllY, 'DATOS DEL AFILIADO', null, 90);

      // Cuadro 2 Titulo
      pdf.line(15, 170+vm.marginAllY, 15, 192+vm.marginAllY); // Vertical 1
      pdf.line(15, 170+vm.marginAllY, 20, 170+vm.marginAllY); // Horizontal 1
      pdf.line(15, 192+vm.marginAllY, 20, 192+vm.marginAllY); // Horizontal 2
      pdf.setFontSize(7);
      pdf.setFontType("bold");
      pdf.text(19, 187+vm.marginAllY, 'VEHICULO', null, 90);

      // Cuadro 3 Titulo
      pdf.line(15, 208+vm.marginAllY, 15, 232+vm.marginAllY); // Vertical 1
      pdf.line(15, 208+vm.marginAllY, 20, 208+vm.marginAllY); // Horizontal 1
      pdf.line(15, 232+vm.marginAllY, 20, 232+vm.marginAllY); // Horizontal 2
      pdf.text(19, 226+vm.marginAllY, 'REGISTRO', null, 90);

      // Primer Cuadro
      // Verticales
      pdf.line(20, 130+vm.marginAllY, 20, 160+vm.marginAllY); // Vertical 1 a
      pdf.line(20, 170+vm.marginAllY, 20, 192+vm.marginAllY); // Vertical 1 b

      pdf.line(63, 130+vm.marginAllY, 63, 138+vm.marginAllY); // Vertical 2 a
      pdf.line(63, 145+vm.marginAllY, 63, 160+vm.marginAllY); // Vertical 2 b
      pdf.line(63, 170+vm.marginAllY, 63, 192+vm.marginAllY); // Vertical 2 c

      pdf.line(106, 130+vm.marginAllY, 106, 160+vm.marginAllY); // Vertical 3 a
      pdf.line(106, 170+vm.marginAllY, 106, 177+vm.marginAllY); // Vertical 3 b

      pdf.line(94, 184+vm.marginAllY, 94, 192+vm.marginAllY); // Vertical 3 POLIZA

      pdf.line(130, 177+vm.marginAllY, 130, 192+vm.marginAllY); // Vertical 4 a

      pdf.line(162, 130+vm.marginAllY, 162, 177+vm.marginAllY); // Vertical 5 a

      pdf.line(200, 130+vm.marginAllY, 200, 192+vm.marginAllY); // Vertical 6 a

      // Horizontales
      pdf.line(20, 130+vm.marginAllY, 200, 130+vm.marginAllY); // Primera Horizontal
      pdf.line(20, 138+vm.marginAllY, 200, 138+vm.marginAllY); // 1 Horizontal
      pdf.line(20, 145+vm.marginAllY, 200, 145+vm.marginAllY); // 2 Horizontal
      pdf.line(20, 152+vm.marginAllY, 200, 152+vm.marginAllY); // 3 Horizontal
      pdf.line(20, 160+vm.marginAllY, 162, 160+vm.marginAllY); // 4 Horizontal
      pdf.line(20, 170+vm.marginAllY, 200, 170+vm.marginAllY); // 5 Horizontal
      pdf.line(20, 177+vm.marginAllY, 200, 177+vm.marginAllY); // 6 Horizontal
      pdf.line(20, 184+vm.marginAllY, 130, 184+vm.marginAllY); // 7 Horizontal
      pdf.line(20, 192+vm.marginAllY, 200, 192+vm.marginAllY); // Ultima Horizontal

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('ACREDITA AL TITULAR:', 21, 129+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('APELLIDO PATERNO', 21, 132+vm.marginAllY);
      pdf.text('APELLIDO MATERNO', 64, 132+vm.marginAllY);
      pdf.text('NOMBRE(S)', 107, 132+vm.marginAllY);
      pdf.text('TELEFONO', 163, 132+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.lastNameFather.toUpperCase(), 21, 136+vm.marginAllY);
      pdf.text(item.lastNameMother.toUpperCase(), 64, 136+vm.marginAllY);
      pdf.text(item.fullName.toUpperCase(), 107, 136+vm.marginAllY);
      pdf.text(item.telephone.toUpperCase(), 163, 136+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140+vm.marginAllY);
      pdf.text('COLONIA', 107, 140+vm.marginAllY);
      pdf.text('CODIGO POSTAL', 163, 140+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.direction.toUpperCase(), 21, 144+vm.marginAllY);
      pdf.text(item.colony.toUpperCase(), 107, 144+vm.marginAllY);
      pdf.text(item.postalCode.toUpperCase(), 163, 144+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('POBLACION', 21, 147+vm.marginAllY);
      pdf.text('MUNICIPIO', 64, 147+vm.marginAllY);
      pdf.text('ESTADO', 107, 147+vm.marginAllY);
      pdf.text('RFC', 163, 147+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.population.toUpperCase(), 21, 151+vm.marginAllY);
      pdf.text(item.municipality.toUpperCase(), 64, 151+vm.marginAllY);
      pdf.text(item.state.toUpperCase(), 107, 151+vm.marginAllY);
      pdf.text(item.rfc.toUpperCase(), 163, 151+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154+vm.marginAllY);
      pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154+vm.marginAllY);
      pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154+vm.marginAllY);
      pdf.setFontSize(5);
      pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154+vm.marginAllY);

      //Añade QR
      pdf.addImage(img2, 'JPG', 174, 155+vm.marginAllY, 14, 14);

      pdf.setFontSize(8);
      pdf.text(item.credentialCard.toUpperCase(), 21, 158+vm.marginAllY);
      pdf.text(item.licenseType.toUpperCase(), 64, 158+vm.marginAllY);
      pdf.text(item.licenseNumber.toUpperCase(), 107, 158+vm.marginAllY);

      pdf.setFontSize(10);
      pdf.setFontType("bold");
      pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('MARCA', 21, 172+vm.marginAllY);
      pdf.text('TIPO', 64, 172+vm.marginAllY);
      pdf.text('LINEA', 107, 172+vm.marginAllY);
      pdf.text('MODELO', 163, 172+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.brand.toUpperCase(), 21, 176+vm.marginAllY);
      pdf.text(item.type.toUpperCase(), 64, 176+vm.marginAllY);
      pdf.text(item.line.toUpperCase(), 107, 176+vm.marginAllY);
      pdf.text(item.model.toString(), 163, 176+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('COLOR', 21, 179+vm.marginAllY);
      pdf.text('NUMERO DE SERIE (VIN)', 64, 179+vm.marginAllY);
      pdf.text('NUMERO DE PLACAS', 131, 179+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.color.toUpperCase(), 21, 183+vm.marginAllY);
      pdf.text(item.vin.toUpperCase(), 64, 183+vm.marginAllY);

      pdf.setFontSize(28);
      pdf.text('MEC-', 135, 189+vm.marginAllY);
      pdf.text(item.plates.toUpperCase(), 161, 189+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('CILINDROS', 21, 186+vm.marginAllY);
      pdf.text('PUERTAS', 64, 186+vm.marginAllY);
      pdf.text('PÓLIZA', 96, 186+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.cylinders.toString(), 21, 190+vm.marginAllY);
      pdf.text(item.doors.toString(), 64, 190+vm.marginAllY);

      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
      }

      // Segundo cuadro
      // Verticales
      pdf.line(20, 208+vm.marginAllY, 20, 232+vm.marginAllY); // Vertical 1 a
      pdf.line(63, 208+vm.marginAllY, 63, 215+vm.marginAllY); // Vertical 2 a
      pdf.line(106, 208+vm.marginAllY, 106, 215+vm.marginAllY); // Vertical 3 a
      pdf.line(162, 208+vm.marginAllY, 162, 232+vm.marginAllY); // Vertical 4 a
      pdf.line(200, 208+vm.marginAllY, 200, 232+vm.marginAllY); // Vertical 5 a

      // Horizontales
      pdf.line(20, 208+vm.marginAllY, 200, 208+vm.marginAllY); // Primera Horizontal
      pdf.line(20, 215+vm.marginAllY, 162, 215+vm.marginAllY); // 1 Horizontal
      pdf.line(20, 232+vm.marginAllY, 200, 232+vm.marginAllY); // Ultima Horizontal

      pdf.setFontSize(9);
      pdf.setFontType("bold");
      pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202+vm.marginAllY);
      pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('LUGAR DE REGSITRO', 21, 210+vm.marginAllY);
      pdf.text('ESTADO DE REGISTRO', 64, 210+vm.marginAllY);
      pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210+vm.marginAllY);
      pdf.setFontSize(10);
      pdf.text('VIGENCIA', 172, 213+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214+vm.marginAllY);
      pdf.text(item.registerLocationState.toUpperCase(), 64, 214+vm.marginAllY);

      vm.dateRegister = new Date(item.dateRegister);
      vm.dateValidity = new Date(item.dateValidity);
      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth();
      vm.year1 = vm.dateRegister.getFullYear();
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

      vm.day2 = vm.dateValidity.getDate();
      vm.month2 = vm.dateValidity.getMonth();
      vm.year2 = vm.dateValidity.getFullYear();
      vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

      pdf.text(vm.dateRegisterFull, 110, 214+vm.marginAllY);

      pdf.setFontSize(16);
      pdf.text(vm.dateValidityrFull, 164, 222+vm.marginAllY);

      pdf.setFontSize(6);
      pdf.text('SUGERENCIAS', 21, 217+vm.marginAllY);

      pdf.setFontSize(8);
      pdf.text(item.sugestion.toUpperCase(), 21, 221+vm.marginAllY);
      pdf.text(item.obervations.toUpperCase(), 21, 225+vm.marginAllY);
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 21, 229+vm.marginAllY);
      }
      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      $state.go('^.all');
      window.open(pdf.output('bloburl'), '_blank');

    };

    vm.pdfPrintNewCert = function () {
      $log.log("vm.pdfPrintNewCert()");

      var item = vm.register;
      $log.log("item", item);

      //Genera el pdf
      var pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'letter',
        putOnlyUsedFonts: true,
        floatPrecision: 16 // or "smart", default is 16
      });

      //Imágenes
      var img2 = new Image;

      //Rutas de imágenes
      img2.crossOrigin = "";
      img2.src = "assets/images/conapafa/cert2.jpg";

      //Añade QR
      pdf.addImage(img2, 'JPG', 0, 0, 215.9, 279.4);

      pdf.setFontSize(13);
      pdf.setFontType("bold");
      pdf.setTextColor(0, 176, 240);
      vm.newDate = new Date();
      vm.newYear = ' ' + vm.newDate.getFullYear();
      pdf.text(vm.newYear, 49, 57.5);

      pdf.setFontSize(12);
      pdf.setFontType("bold");
      pdf.setTextColor(0, 0, 0);
      vm.fullName = item.fullName.toUpperCase() + ' ' + item.lastNameFather.toUpperCase() + ' ' + item.lastNameMother.toUpperCase();
      pdf.text(vm.fullName, 38, 143.5);

      pdf.setFontSize(8);
      pdf.setFontType("normal");
      pdf.text(item.telephone.toUpperCase(), 163, 143);

      vm.address = item.direction + ' COL. ' + item.colony + ', C.P. ' + item.postalCode + ', ' + item.population +
        ', ' + item.municipality + ', ' + item.state + '.';
      pdf.text(vm.address.toUpperCase(), 38, 149);

      pdf.text(item.credentialCard.toUpperCase(), 38, 154);
      pdf.text(item.rfc.toUpperCase(), 163, 153.5);

      pdf.text(item.licenseType.toUpperCase(), 70, 158.5);
      pdf.text(item.licenseNumber.toUpperCase(), 163, 158.5);

      pdf.text(item.brand.toUpperCase(), 45, 172);
      pdf.text(item.color.toUpperCase(), 130, 172);

      pdf.text(item.type.toUpperCase(), 45, 177);
      pdf.text(item.cylinders.toString(), 130, 177);

      pdf.text(item.line.toUpperCase(), 45, 182);
      pdf.text(item.doors.toString(), 130, 182);

      pdf.text(item.model.toString(), 45, 187);
      if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
        vm.objPolicy = 'MOCH 2-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
      }else if(item.hasPolicy){
        vm.objPolicy = 'LM-' + item.policyNumber;
        pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
      }

      pdf.setFontSize(14);
      pdf.setFontType("bold");
      pdf.text(item.vin.toUpperCase(), 65, 193.5);

      pdf.setFontSize(18);
      pdf.setFontType("bold");
      vm.platesMec = 'MEC-' + item.plates.toUpperCase();
      pdf.text(vm.platesMec.toUpperCase(), 160.5, 193.5);

      pdf.setFontSize(8);
      pdf.setFontType("normal");

      pdf.text(item.registerLocationPlace.toUpperCase(), 60, 213);
      pdf.text(item.registerLocationState.toUpperCase(), 163, 213);

      vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      vm.dateRegister = new Date(item.dateRegister);
      vm.day1 = vm.dateRegister.getDate();
      vm.month1 = vm.dateRegister.getMonth() + 1;
      vm.year1 = vm.dateRegister.getFullYear();
      vm.hour = vm.dateRegister.getHours();
      vm.minutes = vm.dateRegister.getMinutes();
      vm.suffix = vm.hour >= 12 ? "PM":"AM";
      vm.hoursNew = ((vm.hour + 11) % 12 + 1) + ':' + vm.minutes + ' ' + vm.suffix;
      vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1-1].toUpperCase() + ' / ' + vm.year1 + ' - ' + vm.hoursNew;

      pdf.setFontSize(11);
      pdf.setFontType("bold");
      pdf.text(vm.dateRegisterFull.toUpperCase(), 70, 218);

      pdf.setFontType("normal");
      if(item.sugestion1 != 'Sin definir'){
        pdf.text(item.sugestion1.toUpperCase(), 19, 227);
      }else{
        //pdf.text(item.sugestion1.toUpperCase(), 18.5, 228);
      }

      // // Print
      // pdf.autoPrint({variant: 'non-conform'});
      // //This is a key for printing
      // pdf.output('dataurlnewwindow');

      $state.go('^.all');
      window.open(pdf.output('bloburl'), '_blank');

    };

    // Actualizar Registro
    vm.update = function(){
      vm.errorFlag = true;

      $log.log('register update', vm.register);

      if(vm.register.fullName == '' || vm.register.lastNameFather == '' || vm.register.lastNameMother == '' ||
        vm.register.telephone == '' || vm.register.rfc == '' || vm.register.direction == '' ||
        vm.register.colony == '' || vm.register.postalCode == '' || vm.register.population == '' ||
        vm.register.municipality == '' || vm.register.state == '' || vm.register.credentialCard == '' ||
        vm.register.licenseNumber == '' || vm.register.brand == '' || vm.register.type == '' ||
        vm.register.line == '' || vm.register.model == '' || vm.register.color == '' ||
        vm.register.vin == '' || vm.register.plates == '' || vm.register.sugestion == '' ||
        vm.register.licenseType == '' || vm.typeRegister == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else if(vm.register.hasPolicy && vm.register.policyNumber == ''){
        sweetAlert("Oops...", "Te faltan poner el numero de poliza", "error");
        vm.createBlock = false;
      }else{

        if(vm.typeRegister == 'Vehículo'){
          vm.register.typeRegister = 'car';
        }else if(vm.typeRegister == 'Motocicleta'){
          vm.register.typeRegister = 'moto';
        }

        //vm.register.createdById = vm.userLog.id;

        RegisterPlate.prototype$patchAttributes(
          {id:  vm.register.id},
          vm.register, function (success){
            $log.log("Success", success);
            $state.go('^.all');
          }, function (err) {
            $log.log(err, 'error');
          });
      }

    };

    // Archivos en Container
    vm.createBlockUpload = false;
    vm.documentType = '';
    vm.fileToAdd = {
      name: '',
      dateUpload: new Date(),
      url: ''
    };

    vm.addFile = function (files) {
      $log.log('vm.addFile()');
      $log.log('files', files);

      vm.file = files[0];
      vm.fileKey =  lil.uuid();
      Upload.rename(vm.file, vm.fileKey);

      vm.fileToAdd = {
        name: vm.file.name,
        dateUpload: new Date(),
        url: vm.fileKey
      };

      vm.sizeFile = vm.file.size/1000000;

      $log.log('vm.file', vm.file);
      $log.log('vm.fileKey', vm.fileKey);
      $log.log('vm.fileToAdd', vm.fileToAdd);

    };

    vm.addFileToArray = function(){
      $log.log('vm.addFileToArray');
      $log.log('vm.file', vm.file);
      $log.log('vm.fileKey', vm.fileKey);
      $log.log('vm.fileToAdd', vm.fileToAdd);
      $log.log('vm.documentType', vm.documentType);

      if(!vm.createBlockUpload){
        vm.createBlockUpload = true;

        if(vm.documentType == ''){
          sweetAlert("Oops...", "Debes ponerle un nombre al documento", "error");
          vm.createBlockUpload = false;
        }else if(vm.fileToAdd.name == ''){
          sweetAlert("Oops...", "Debes adjuntar algun archivo", "error");
          vm.createBlockUpload = false;
        }else{
          $log.log('Subir el documento al server');
          vm.uploadFileToServer();
        }
      }

    };

    vm.progressFile = 0;
    vm.uploadFileToServer = function () {
      $log.log('vm.uploadFileToServer()');

      vm.progressFile = 0;

      var file = vm.file;
      var fileKey =  vm.fileKey;

      vm.fileToUpload = file;
      vm.fileToUpload = Upload.upload({
        url: 'https://api.conapafa.com/api/Containers/container-conapafa/upload',
        //url: 'http://localhost:3001/api/Containers/container-buzonslagricola/upload',
        file: file,
        data: {
          key: fileKey,
          filename: fileKey
        }
      });

      vm.fileToUpload.then(function (response) {
        $timeout(function () {
          file.result = response.data;
        });
        $log.log('response', response);

        vm.fileToAdd.name = vm.documentType;
        vm.register.files.unshift(vm.fileToAdd);
        RegisterPlate.prototype$patchAttributes(
          {id:  vm.register.id},
          vm.register, function (success){
            $log.log(success, 'success');
            toastr.success('', 'Se subió el archivo al servidor');
            vm.createBlockUpload = false;
            vm.documentType = '';
            vm.fileToAdd = {
              name: '',
              dateUpload: new Date(),
              url: ''
            };
          }, function (err) {
            $log.log(err, 'error');
          });

      }, function (response) {
        if (response.status > 0)
          vm.errorMsg = response.status + ': ' + response.data;
        $log.log('err: ', vm.errorMsg);
        $log.log('err response: ', response);
        toastr.error('', 'Error');
        vm.createBlockUpload = false;
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        $log.log('progress: ' + progressPercentage + '% '+ evt.config.file.name + '\n');
        vm.progressFile = progressPercentage;
        if(progressPercentage == 100){
          $log.log('progressPercentage == 100');
        }
      });
    };

    vm.deleteCheck = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteFile(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };

    vm.deleteFile = function (index){
      $log.log('vm.deletePond', index);
      vm.register.files.splice(index, 1);

      RegisterPlate.prototype$patchAttributes(
        {id:  vm.register.id},
        vm.register, function (success){
          $log.log("Success", success);
        }, function (err) {
          $log.log(err, 'error');
        });
    };

    // Crear Nuevo o Encontrar Registro
    vm.itemCreateUpdate = function(){

      if($stateParams.id === 'new'){
        $log.log("New register");
        vm.flag = true;

        /*vm.register = {
          registerLocationState: vm.userLog.state,
          registerLocationPlace: vm.userLog.location,
          fullName: 'Ruben',
          lastNameFather: 'Lopez',
          lastNameMother: 'Flores',
          telephone: '6681620694',
          rfc: 'ASDC1568',
          direction: 'Delicias A',
          colony: 'Las Delicias',
          postalCode: '81277',
          population: 'Los Mochis',
          municipality: 'Ahome',
          state: 'Sinaloa',
          credentialCard: 'ASDFG16589',
          licenseType: 'Automovilista',
          licenseNumber: '91981981',
          brand: '',
          type: '',
          line: 'Linea',
          model: '2021',
          color: '',
          vin: '184197819',
          cylinders: '2',
          doors: '2',
          plates: '',
          sugestion: 'Tramitar verificación vehicular en guardia nacional',
          sugestion1: 'Sin definir',
          obervations: 'Con este registro su vehículo queda inscrito para una regularización futura',
          dateRegister: '',
          dateValidity: '',
          finalObservations: '',
          hasPolicy: false,
          policyNumber: '',
          files: [],
          typePlate: 'plateA'
        };*/

        vm.register = {
          registerLocationState: vm.userLog.state,
          registerLocationPlace: vm.userLog.location,
          fullName: '',
          lastNameFather: '',
          lastNameMother: '',
          telephone: '',
          rfc: '',
          direction: '',
          colony: '',
          postalCode: '',
          population: '',
          municipality: '',
          state: '',
          credentialCard: '',
          licenseType: '',
          licenseNumber: '',
          brand: '',
          type: '',
          line: '',
          model: '',
          color: '',
          vin: '',
          cylinders: '0',
          doors: '0',
          plates: '',
          sugestion: 'Tramitar verificación vehicular en guardia nacional',
          sugestion1: 'Sin definir',
          obervations: 'ESTE VEHÍCULO QUEDA INSCRITO PARA UNA REGULARIZACIÓN FUTURA',
          dateRegister: '',
          dateValidity: '',
          finalObservations: '',
          hasPolicy: false,
          policyNumber: '',
          files: [],
          typePlate: 'plateA'
        };

        vm.initialDate = '';
        // Seleccionar fecha para buscar
        vm.objInitialDate = new Date();
        vm.objInitialDateDay = vm.objInitialDate.getDate();
        vm.objInitialDateMonth = vm.objInitialDate.getMonth()+1;
        vm.objInitialDateYear = vm.objInitialDate.getFullYear();
        vm.initialDate = vm.objInitialDateDay + '-' + vm.objInitialDateMonth + '-' + vm.objInitialDateYear;
        vm.register.dateRegister = new Date(vm.objInitialDate);

        vm.dateValidity = new Date();
        vm.dateValidityYear = vm.dateValidity.getFullYear();
        vm.dateValidityMonth = vm.dateValidity.getMonth();
        vm.dateValidityDay = vm.dateValidity.getDate();
        vm.dateValidityC = new Date(vm.dateValidityYear + 1, vm.dateValidityMonth, vm.dateValidityDay);
        vm.register.dateValidity = vm.dateValidityC;

        vm.errorFlag = false;
        vm.flagUpdate = true;
      }
      else{
        $log.log("Update register");
        vm.flag = false;

        if($stateParams.type == 'see'){
          vm.flagUpdate = false;
          vm.blockMEC = true;
        }else{
          vm.flagUpdate = true;

          if(vm.userLog.fullEdit){
            vm.blockMEC = false;
          }else{
            vm.blockMEC = true;
          }
        }

        RegisterPlate.findOne({
            filter: {
              where: {
                id: $stateParams.id
              },
              include:[
                {
                  relation: 'appUser'
                },
                {
                  relation: 'renovations'
                }
              ]
            }
          },
          function(register){
            vm.register = angular.copy(register);
            $log.log("vm.register",  vm.register);

            vm.objInitialDate = new Date(vm.register.dateRegister);
            vm.objInitialDateDay = vm.objInitialDate.getDate();
            vm.objInitialDateMonth = vm.objInitialDate.getMonth()+1;
            vm.objInitialDateYear = vm.objInitialDate.getFullYear();
            vm.initialDate = vm.objInitialDateDay + '-' + vm.objInitialDateMonth + '-' + vm.objInitialDateYear;

            if(vm.register.typeRegister == 'car'){
              vm.typeRegister = 'Vehículo';
            }else if(vm.register.typeRegister == 'moto'){
              vm.typeRegister = 'Motocicleta';
            }

            if(vm.register.files == undefined){
              vm.register.files = [];
            }

            Renovation.find({
                filter: {
                  where: {
                    registerPlateId: $stateParams.id
                  },
                  order: "createdAt DESC",
                  include:[
                    {
                      relation: 'appUser'
                    },
                    {
                      relation: 'registerPlate'
                    }
                  ]
                }
              },
              function(renovations){
                vm.renovations = angular.copy(renovations);
                $log.log("vm.renovations", vm.renovations);
              },
              function(err){
                $log.log(err);
              });
          },
          function(err){
            $log.log(err);
          });

      }

    };

    // Buscar Marca Color, Tipo y Marca
    vm.infoStart = function(){

      $log.log('infoStart');

      Brand.find({
          filter: {
            where: {},
            order: 'name ASC'
          }
        },
        function(brands){
          vm.brands = angular.copy(brands);
          $log.log("vm.brands", vm.brands);

          TypeCar.find({
              filter: {
                where: {},
                order: 'name ASC'
              }
            },
            function(typeCars) {
              vm.typeCars = angular.copy(typeCars);
              $log.log("vm.typeCars", vm.typeCars);

              Color.find({
                  filter: {
                    where: {},
                    order: 'name ASC'
                  }
                },
                function(colors){
                  vm.colors = angular.copy(colors);
                  $log.log("vm.colors", vm.colors);

                  vm.itemCreateUpdate();

                },
                function(err){
                  $log.log(err);
                });
            },
            function(err){
              $log.log(err);
            });

        },
        function(err){
          $log.log(err);
        });

    };

    // Años para el select del Modelo del Carro
    vm.infoModelCar = function(){

      $log.log('infoStart2');

      vm.today = new Date();
      $log.log('vm.today.getFullYear()', vm.today.getFullYear());

      vm.todayYear = vm.today.getFullYear();
      vm.objDate = vm.today.getFullYear() - 1950;
      $log.log('vm.objDate', vm.objDate);

      vm.dates = [];
      for(var a=0; a<vm.objDate; a++){

        vm.dates.push(vm.todayYear-a);
        if(a==vm.objDate-1){
          $log.log('vm.dates', vm.dates);
          vm.infoStart();
        }
      }

    };

    //Detectar cambio de Fecha
    vm.changeInitialDate = function(){
      $log.log('vm.changeInitialDate');
      $log.log('vm.initialDate', vm.initialDate);
      vm.initialDateString = vm.initialDate.substr(3, 2) + '-' +
        vm.initialDate.substr(0, 2) + '-' +
        vm.initialDate.substr(6, 4);
      $log.log('vm.initialDateString', new Date(vm.initialDateString));

      vm.register.dateRegister = new Date(vm.initialDateString);

      vm.dateValidity = new Date(vm.register.dateRegister);
      vm.dateValidityYear = vm.dateValidity.getFullYear();
      vm.dateValidityMonth = vm.dateValidity.getMonth();
      vm.dateValidityDay = vm.dateValidity.getDate();
      vm.dateValidityC = new Date(vm.dateValidityYear + 1, vm.dateValidityMonth, vm.dateValidityDay);

      vm.register.dateValidity = vm.dateValidityC;
      $log.log('vm.register.dateRegister', vm.register.dateRegister);
      $log.log('vm.register.dateValidity', vm.register.dateValidity);

      vm.searchRegisterParameterFlag = false;
    };

    // Buscar Usuario Logeado
    vm.fullEditFlag = false;
    vm.getAppUserData = function(){

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          if(vm.userLog.fullEdit){
            vm.fullEditFlag = true;
          }else{
            vm.fullEditFlag = false;
          }

          vm.infoModelCar();
        },
        function(err){
          $log.log(err);
        });

      Setting.findOne({
          filter: {
            where: {
              name: 'configuration'
            }
          }
        },
        function(settings){
          vm.settings = angular.copy(settings);
          $log.log("vm.settings", vm.settings);
        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.renovations.all', {
      url: "/all",
      views: {
        renovations:{
          templateUrl: "app/main/admin/renovations/all/all.html"
        }
      },
      data: {
        pageTitle: 'Renovations All'
      }
    });
  })
  .controller('RenovationsAllController',
    function ($log, $window, $state, $scope, RegisterPlate, AppUser, Brand, Color, TypeCar, Setting) {

    $log.log('Renovations All');

      // Subir la pantalla
      function scrollWin() {$window.scrollTo(0, 0);}
      scrollWin();

      var vm = this;

      // Variables Globales
      vm.spinnerFlag = true;

      // Filtrador de Registros
      vm.stateOption = 'Todos';
      vm.placeOption = 'Todos';
      vm.states = [
        'Todos',
        'Sinaloa',
        'Sonora'
      ];
      vm.statesBlockOption = 'Todos';
      vm.statesBlocks = [
        'Todos',
        'Activo',
        'Baja'
      ];
      vm.places = [
        'Todos'
      ];
      vm.userOption = {
        fullName: 'Todos'
      };
      vm.brandOption = {
        name: 'Todos'
      };
      vm.typeCarOption = {
        name: 'Todos'
      };

      // Crear Nuevo Registro
      vm.create = function(){
        $log.log('create new user');
        $state.go('main.admin.renovations.renovation', {id: 'new'});
      };

      // Editar Registro
      vm.editModule = function(index){
        $log.log('editModule');
        $log.log('index', index);
        vm.itemToGo = vm.items[index].id;
        $state.go('main.admin.renovations.renovation', {id: vm.itemToGo, type: 'update'});
      };

      // Dar de Baja Registro
      vm.banModule = function(index){
        $log.log("Item to Delete");
        swal({
            title: "¿Quieres dar de baja el registro?",
            text: "",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Sí",
            cancelButtonText: "No!",
            closeOnConfirm: false,
            closeOnCancel: false },
          function(isConfirm){
            if (isConfirm) {
              swal("Baja de Registro", "", "");
              vm.banOk(index);
            } else {
              swal("Cancelado", "", "");
            }
          });
      };
      vm.banOk = function(index){
        $log.log('index', index);
        vm.items[index].status = false;
        vm.items[index].banDate = new Date();

        RegisterPlate.prototype$patchAttributes(
          {id:  vm.items[index].id},
          vm.items[index], function (success){
            $log.log("Success", success);
          }, function (err) {
            $log.log(err, 'error');
          });

      };

      // Eliminar Registro
      vm.deleteModule = function(index){
        $log.log("Item to Delete");
        swal({
            title: "Estas seguro?",
            text: "Si lo elmininas no hay manera de volver a recuperarlo",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Sí",
            cancelButtonText: "No!",
            closeOnConfirm: false,
            closeOnCancel: false },
          function(isConfirm){
            if (isConfirm) {
              swal("Eliminado", "", "");
              vm.deleteOk(index);
            } else {
              swal("Cancelado", "", "");
            }
          });
      };
      vm.deleteOk = function(index){
        $log.log('index', index);
        vm.itemToDelete = vm.items[index].id;

        RegisterPlate.deleteById({id: vm.itemToDelete},
          function(itemDeleted){
            vm.itemDeleted = itemDeleted;
            $log.log("ItemDeleted", vm.itemDeleted);

            vm.items.splice(index, 1);

            if(vm.items.length == 0){
              vm.paginationFor = 0;
            }
          },
          function(err){
            $log.log(err);
          });
      };

      // Ver el Registro
      vm.seeRegister = function(index){
        $log.log('editModule');
        $log.log('index', index);
        vm.itemToGo = vm.items[index].id;
        $state.go('main.admin.renovations.renovation', {id: vm.itemToGo, type: 'see'});
      };

      // Exportar Registros EXCEL
      vm.months = ["Ene", "Feb", "Marzo", "Abril", "Mayo", "Jun", "Jul", "Ago", "Sept", "Oct", "Nov", "Dic"];
      vm.todayExcel = new Date();
      vm.objDateExcel = new Date(vm.todayExcel);
      vm.nameDateExcel = vm.objDateExcel.getDate() + ' - ' + vm.months[vm.objDateExcel.getMonth()] + ' - ' + vm.objDateExcel.getFullYear();

      vm.exportExcel = function(){
        $log.log("vm.exportExcel()");
        $log.log('downloadExcel');

        vm.nameExcel = 'Historial de Registro de Placas- ' + vm.nameDateExcel + '.xlsx';

        var num1 = 2;
        var n1 = num1.toString();
        vm.obj1 = 'A' + n1;
        vm.cell_address = vm.obj1;

        vm.arrayToExcel =[];

        if(vm.items.length == 0){
          sweetAlert("Oops...", "No tienes ningun registro de placas", "error");
        }else{
          for(var a=0; a<vm.items.length; a++){

            var obj = {
              'Estatus': '',
              'Fecha': '',
              'Placas': '',
              'Trabajador Conapafa': angular.copy(vm.items[a].appUser.fullName),
              'Estado Conapafa': angular.copy(vm.items[a].registerLocationState),
              'Lugar Conapafa': angular.copy(vm.items[a].registerLocationPlace),
              'Nombre': '',
              'Calle y Numero': vm.items[a].direction,
              'Colonia': vm.items[a].colony,
              'Codigo Postal': vm.items[a].postalCode,
              'Poblacion': vm.items[a].population,
              'Municipio': vm.items[a].municipality,
              'Estado': vm.items[a].state,
              'Telefono': angular.copy(vm.items[a].telephone),
              'Marca': angular.copy(vm.items[a].brand),
              'Linea': angular.copy(vm.items[a].line),
              'Modelo': angular.copy(vm.items[a].model),
              'Tipo': angular.copy(vm.items[a].type),
              'Color': angular.copy(vm.items[a].color),
              'Vin': angular.copy(vm.items[a].vin),
              'Vigencia': '',
              'Poliza': '',
              'Fecha Baja': '',
              'Observaciones': angular.copy(vm.items[a].finalObservations)
            };

            vm.arrayToExcel.push(angular.copy(obj));

            if(vm.items[a].status){
              vm.arrayToExcel[a]['Estatus'] = 'Activo';
              vm.arrayToExcel[a]['Fecha Baja'] = '-';
            }else{
              vm.arrayToExcel[a]['Estatus'] = 'Baja';
              vm.objDate2 = new Date(vm.items[a].banDate);
              vm.nameDate2 = vm.objDate2.getDate() + ' - ' + vm.months[vm.objDate2.getMonth()] + ' - ' + vm.objDate2.getFullYear();
              vm.arrayToExcel[a]['Fecha Baja'] = vm.nameDate2;

            }

            vm.objDate1 = new Date(vm.items[a].createdAt);
            vm.nameDate1 = vm.objDate1.getDate() + ' - ' + vm.months[vm.objDate1.getMonth()] + ' - ' + vm.objDate1.getFullYear();
            vm.arrayToExcel[a]['Fecha'] = vm.nameDate1;

            vm.namePlates = 'MEC- ' + vm.items[a].plates;
            vm.arrayToExcel[a]['Placas'] = vm.namePlates;

            vm.nameFullName = vm.items[a].fullName + ' '+ vm.items[a].lastNameFather + ' '+ vm.items[a].lastNameMother;
            vm.arrayToExcel[a]['Nombre'] = vm.nameFullName;

            vm.objDate2 = new Date(vm.items[a].dateValidity);
            vm.nameDate2 = vm.objDate2.getDate() + ' - ' + vm.months[vm.objDate2.getMonth()] + ' - ' + vm.objDate2.getFullYear();
            vm.arrayToExcel[a]['Vigencia'] = vm.nameDate2;

            if(vm.items[a].hasPolicy && vm.items[a].registerLocationPlace == 'Los Mochis Matriz'){
              vm.objPolicyExcel = 'MOCH 2-' + vm.items[a].policyNumber;
              vm.arrayToExcel[a]['Poliza'] = vm.objPolicyExcel;
            }else if(vm.items[a].hasPolicy){
              vm.objPolicyExcel = 'LM-' + vm.items[a].policyNumber;
              vm.arrayToExcel[a]['Poliza'] = vm.objPolicyExcel;
            }

            if(a==vm.items.length-1){

              var ws = XLSX.utils.json_to_sheet(vm.arrayToExcel, {origin: vm.cell_address});
              //XLSX.utils.sheet_add_json(ws, vm.arrayToExcel, {origin: vm.cell_address_2});
              var wb = XLSX.utils.book_new();

              XLSX.utils.book_append_sheet(wb, ws, "Hoja_1");
              XLSX.writeFile(wb, vm.nameExcel);

            }

          }
        }

      };

      // Para detectar cambios de fechas
      vm.getDatesFilter = function(){
        $log.log('vm.getDatesFilter()');

        $log.log("day1", document.getElementById("day1").value);
        vm.filterDate1 = document.getElementById("day1").value;
        vm.filterYear1 = vm.filterDate1.substr(0, 4);
        $log.log("vm.filterYear1", vm.filterYear1);
        vm.filterMonth1 = vm.filterDate1.substr(5, 2);
        $log.log("vm.filterMonth1", vm.filterMonth1);
        vm.filterDay1 = vm.filterDate1.substr(8, 2);
        $log.log("vm.filterDay1", vm.filterDay1);
        vm.newDate1 = new Date(vm.filterYear1, vm.filterMonth1-1, vm.filterDay1, 0, 0, 0)
        $log.log("vm.newDate1", vm.newDate1);

        $log.log("day2", document.getElementById("day2").value);
        vm.filterDate2 = document.getElementById("day2").value;
        vm.filterYear2 = vm.filterDate2.substr(0, 4);
        $log.log("vm.filterYear2", vm.filterYear2);
        vm.filterMonth2 = vm.filterDate2.substr(5, 2);
        $log.log("vm.filterMonth2", vm.filterMonth2);
        vm.filterDay2 = vm.filterDate2.substr(8, 2);
        $log.log("vm.filterDay2", vm.filterDay2);
        vm.newDate2 = new Date(vm.filterYear2, vm.filterMonth2-1, vm.filterDay2, 23, 59, 59)
        $log.log("vm.newDate2", vm.newDate2);

        if(vm.newDate1.getTime() > vm.newDate2.getTime()){
          sweetAlert("Oops...", "La fecha final tiene que ser mayor a la inicial", "error");
        }else{
          vm.filterWhereRegisters();
        }

      };

      // Cambiar Estado
      vm.changeState = function(){
        $log.log('vm.changeState()');
        $log.log('vm.stateOption', vm.stateOption);

        if(vm.stateOption == 'Todos'){
          vm.filterWhereRegisters();
        }else{
          if(vm.stateOption == 'Sinaloa'){
            vm.places = [
              'Todos',
              'Los Mochis Matriz',
              'Los Mochis Gaxiola',
              'Mochicahui',
              'El Carrizo',
              'Juan Jose Ríos',
              'Ruiz Cortines',
              'Leyva Solano',
              'Sinaloa de Leyva',
              'Guasave',
              'Guamuchil',
              'Culiacán',
              'Mazatlán'
            ];
          }else if(vm.stateOption == 'Sonora'){
            vm.places = [
              'Todos',
              'Hermosillo'
            ];
          }
          vm.filterWhereRegisters();
        }

      };

      // Cambiar Lugar
      vm.changePlace = function(){
        $log.log('vm.changePlace()');
        $log.log('vm.placeOption', vm.placeOption);
        vm.filterWhereRegisters();
      };

      // Definir el Where
      vm.filterWhereRegisters = function(){
        $log.log('vm.filterWhereRegisters()');

        if(vm.stateOption == 'Todos' && vm.placeOption == 'Todos' && vm.statesBlockOption == 'Todos' &&
          vm.userOption.fullName == 'Todos' && vm.brandOption.name == 'Todos' && vm.typeCarOption.name == 'Todos'){
          vm.where = {
            and:[
              {createdAt:{gt: vm.newDate1}},
              {createdAt:{lt: vm.newDate2}},
              {typePlate: 'plateA'}
            ]
          };
        }else{
          vm.where = {
            and:[
              {createdAt:{gt: vm.newDate1}},
              {createdAt:{lt: vm.newDate2}},
              {typePlate: 'plateA'}
            ]
          };
          if(vm.stateOption != 'Todos'){
            vm.where.and.push({registerLocationState: vm.stateOption});
          }
          if(vm.statesBlockOption != 'Todos'){
            if(vm.statesBlockOption == 'Activo'){
              vm.where.and.push({status: true});
            }else{
              vm.where.and.push({status: false});
            }
          }
          if(vm.placeOption != 'Todos'){
            vm.where.and.push({registerLocationPlace: vm.placeOption});
          }
          if(vm.userOption.fullName != 'Todos'){
            vm.where.and.push({createdById: vm.userOption.id});
          }
          if(vm.brandOption.name != 'Todos'){
            vm.where.and.push({brand: vm.brandOption.name});
          }
          if(vm.typeCarOption.name != 'Todos'){
            vm.where.and.push({type: vm.typeCarOption.name});
          }
        }

        if(vm.itemsText != ''){
          $log.log('vm.itemsText', vm.itemsText);

          vm.searchInputString = angular.copy(vm.itemsText);
          var stringsArray = vm.searchInputString.split(" ");

          vm.where.and.unshift({
            or:[]
          });

          for(var a = 0; a < stringsArray.length; a++){
            var word = stringsArray[a];

            for (var x = 0; x < vm.searchLikes.length; x++) {
              var objects = {};

              objects[vm.searchLikes[x]] = {
                like: word,
                options: 'i'
              };
              vm.where.and[0].or.push(angular.copy(objects));
            }

            if(a == stringsArray.length-1){
              $log.log('vm.where', vm.where);
              vm.loadItems(0);
            }
          }
        }else{
          $log.log('vm.where', vm.where);
          vm.loadItems(0);
        }

      };

      // Buscador
      vm.itemsText = '';
      vm.searchLikes = [
        "plates",
        "fullName",
        "lastNameFather",
        "lastNameMother",
        "vin"
      ];

      // Buscar los Registros
      vm.limit = 100;
      vm.limitSelect = '100';
      vm.limits = [
        '10',
        '100',
        '1000',
        'Todo'
      ];
      vm.paginationFor = 0;

      vm.today = new Date();
      vm.newFormatDate = new Date(2022, 0, 11, 23, 59, 59);

      vm.changeLimit = function(){
        $log.log('vm.changeLimit()');

        if(vm.limitSelect == '10'){
          vm.limit = 10;
        }else if(vm.limitSelect == '100'){
          vm.limit = 100;
        }else if(vm.limitSelect == '1000'){
          vm.limit = 1000;
        }else if(vm.limitSelect == 'Todo'){
          vm.limit = 999999999;
        }
        vm.loadItems(0);

      };

      vm.loadItems = function(skip) {
        $log.log('vm.loadItems');

        $log.log('vm.where', vm.where);
        $log.log('skip', skip);
        $log.log('vm.limit', vm.limit);

        vm.filterItems = {
          filter:{
            where: vm.where,
            skip: skip*vm.limit,
            limit: vm.limit,
            order: "createdAt DESC",
            include:[
              {
                relation: 'appUser'
              }
            ]
          }
        };

        vm.filterItemsQuantity = {
          where: vm.where
        };

        $log.log('filterItems', vm.filterItems);
        $log.log('filterItemsQuantity', vm.filterItemsQuantity);

        RegisterPlate.count(
          vm.filterItemsQuantity,
          function (quantityItems) {
            vm.quantityItems = quantityItems;
            $log.log('quantityItems', vm.quantityItems.count);
            vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
            vm.paginationOptions = [];

            if(vm.quantityItems.count != 0){
              if(vm.quantityItems.count % vm.limit != 0){
                vm.paginationFor =  vm.paginationFor + 1;
              }

              for(var n=0; n<vm.paginationFor; n++){
                vm.paginationOptions.push(n+1);
              }

              $log.log('vm.paginationOptions', vm.paginationOptions);
              vm.paginationOptions = vm.paginationOptions;
            }

            $log.log('vm.paginationFor', vm.paginationFor);
            $log.log('vm.paginationOptions', vm.paginationOptions);

            vm.paginationOptions = vm.paginationOptions;
            vm.paginationFor = vm.paginationFor;

          },
          function (err) {
            $log.log(err);
          });

        RegisterPlate.find(
          vm.filterItems,
          function (items) {
            vm.items = items;
            $log.log('vm.items', vm.items);
            vm.spinnerFlag = false;

            for(var a=0; a<vm.items.length; a++){

              //$log.log('a', a, vm.items[a].dateValidity);
              //$log.log('vm.today', vm.today);

              vm.items[a].dateValidity = new Date(vm.items[a].dateValidity);
              if(vm.items[a].dateValidity.getTime() > vm.today.getTime()){
                vm.items[a].isExpired = false;
              }else{
                vm.items[a].isExpired = true;
              }

              vm.items[a].dateRegister = new Date(vm.items[a].dateRegister);
              if(vm.items[a].dateRegister.getTime() < vm.newFormatDate.getTime()){
                vm.items[a].isNewFormat = false;
              }else{
                vm.items[a].isNewFormat = true;
              }

            }

          },
          function (err) {
            $log.log(err);
          });

      };

      // Pagination Seleccion
      vm.paginationOptions = [];
      vm.pageSelected = 1;

      vm.changeRight = function(){
        $log.log('vm.changeRight');

        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected + 1;
          if(vm.paginationOptions.length < vm.pageSelected){
            vm.pageSelected = vm.paginationOptions.length;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }

      };

      vm.changeLeft = function(){
        $log.log('vm.changeLeft');

        if(vm.paginationOptions.length != 1){
          if(vm.paginationOptions.length != 1){
            vm.pageSelected =  vm.pageSelected - 1;
            if(vm.pageSelected < 1){
              vm.pageSelected = 1;
            }

            $log.log('vm.pageSelected', vm.pageSelected);
            vm.loadItems(vm.pageSelected-1);
          }
        }
      };

      vm.changePage = function(){
        $log.log('vm.changePage');
        $log.log('vm.pageSelected', vm.pageSelected);

        if(vm.pageSelected == null){
          vm.pageSelected = 1;
          vm.loadItems(0);
        }else{
          vm.loadItems(vm.pageSelected-1);
        }
      };

      // Buscar Fecha inicio y fin de mes
      vm.getDatesMonth = function(){
        $log.log("vm.getDatesMonth");

        vm.today = new Date();

        if(vm.userLog.fullEdit){
          vm.firstDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth(), 1);
          vm.lastDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth()+1, 0);
        }else{
          vm.firstDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate());
          vm.lastDayOfMonth = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate());
        }

        vm.newDate1 = vm.firstDayOfMonth;
        vm.newDate2 = vm.lastDayOfMonth;
        vm.day1 = vm.firstDayOfMonth.getDate() + ' ' + vm.months[vm.firstDayOfMonth.getMonth()] + ' ' + vm.firstDayOfMonth.getFullYear();
        vm.day2 = vm.lastDayOfMonth.getDate() + ' ' + vm.months[vm.lastDayOfMonth.getMonth()] + ' ' + vm.lastDayOfMonth.getFullYear();

        $log.log("vm.today", vm.today);
        $log.log("vm.firstDayOfMonth", vm.firstDayOfMonth);
        $log.log("vm.lastDayOfMonth", vm.lastDayOfMonth);

        vm.firstDayOfMonth = new Date(vm.firstDayOfMonth);
        vm.lastDayOfMonth = new Date(vm.lastDayOfMonth);

        vm.firstDayOfMonth.setHours(0, 0, 0);
        vm.lastDayOfMonth.setHours(23, 59, 59);

        vm.month1Temp = vm.firstDayOfMonth.getMonth() + 1;

        if(vm.month1Temp<10 && vm.firstDayOfMonth.getDate()<10){
          vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-0' + vm.month1Temp + '-0' + vm.firstDayOfMonth.getDate();
        }else if(vm.month1Temp<10){
          vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-0' + vm.month1Temp + '-' + vm.firstDayOfMonth.getDate();
        }else if(vm.firstDayOfMonth.getDate()<10){
          vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-' + vm.month1Temp + '-0' + vm.firstDayOfMonth.getDate();
        }else{
          vm.dayOF1 = vm.firstDayOfMonth.getFullYear() + '-' + vm.month1Temp + '-' + vm.firstDayOfMonth.getDate();
        }

        $log.log("vm.dayOF1", vm.dayOF1);
        document.getElementById("day1").value = vm.dayOF1;

        vm.month2Temp = vm.lastDayOfMonth.getMonth() + 1;

        if(vm.month2Temp<10 && vm.lastDayOfMonth.getDate()<10){
          vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-0' + vm.month2Temp + '-0' + vm.lastDayOfMonth.getDate();
        }else if(vm.month2Temp<10){
          vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-0' + vm.month2Temp + '-' + vm.lastDayOfMonth.getDate();
        }else if(vm.lastDayOfMonth.getDate()<10){
          vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-' + vm.month2Temp + '-0' + vm.lastDayOfMonth.getDate();
        }else{
          vm.dayOF2 = vm.lastDayOfMonth.getFullYear() + '-' + vm.month2Temp + '-' + vm.lastDayOfMonth.getDate();
        }

        $log.log("vm.dayOF2", vm.dayOF2);
        document.getElementById("day2").value = vm.dayOF2;

        vm.where = {
          and:[
            {createdAt:{gt: vm.newDate1}},
            {createdAt:{lt: vm.newDate2}},
            {typePlate: 'plateAB'}
          ]
        };

        $log.log("vm.where", vm.where);

        vm.loadItems(0);
      };

      // Buscar Marcas, Tipo, Color
      vm.getInfoToStart = function(){
        $log.log("vm.getInfoToStart()");

        AppUser.find({
            filter: {
              where: {},
              order: 'fullName ASC'
            }
          },
          function(users){
            vm.users = angular.copy(users);
            $log.log("vm.users",  vm.users);
            vm.users.unshift({
              fullName: 'Todos'
            });
            $log.log("vm.users",  vm.users);
          },
          function(err){
            $log.log(err);
          });

        Brand.find({
            filter: {
              where: {},
              order: 'name ASC'
            }
          },
          function(brands){
            vm.brands = angular.copy(brands);
            $log.log("vm.brands",  vm.brands);
            vm.brands.unshift({
              name: 'Todos'
            });
            $log.log("vm.brands",  vm.brands);
          },
          function(err){
            $log.log(err);
          });

        TypeCar.find({
            filter: {
              where: {},
              order: 'name ASC'
            }
          },
          function(typeCars){
            vm.typeCars = angular.copy(typeCars);
            $log.log("vm.typeCars",  vm.typeCars);
            vm.typeCars.unshift({
              name: 'Todos'
            });
            $log.log("vm.typeCars",  vm.typeCars);
          },
          function(err){
            $log.log(err);
          });

        vm.getDatesMonth();

      };

      // Buscar usuario logeado
      vm.fullEditFlag = false;
      vm.getAppUserData = function(){

        AppUser.findOne({
            filter: {
              where: {
                id: AppUser.getCurrentId()
              }
            }
          },
          function(userLog){
            vm.userLog = angular.copy(userLog);
            $log.log("vm.userLog", vm.userLog);

            if(vm.userLog.fullEdit){
              vm.fullEditFlag = true;
            }else{
              vm.fullEditFlag = false;
            }

            vm.getInfoToStart();
          },
          function(err){
            $log.log(err);
          });

        Setting.findOne({
            filter: {
              where: {
                name: 'configuration'
              }
            }
          },
          function(settings){
            vm.settings = angular.copy(settings);
            $log.log("vm.settings", vm.settings);
          },
          function(err){
            $log.log(err);
          });

      };

      vm.getAppUserData();

      // Print
      vm.pdfPrint = function (item) {
        $log.log("vm.pdfPrint()");
        $log.log("item", item);

        //Genera el pdf
        var pdf = new jsPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'a4',
          putOnlyUsedFonts:true,
          floatPrecision: 16 // or "smart", default is 16
        });

        //Imágenes
        var img1 = new Image;
        var img2 = new Image;

        //Rutas de imágenes
        img1.crossOrigin = "";
        img2.crossOrigin = "";
        img1.src = "assets/images/conapafa/all.png";
        img2.src = "assets/images/conapafa/qrsat.jpg";

        //Añade toda la info al pdf
        pdf.addImage(img1, 'JPG', 18, 12, 182, 111);

        // Texto
        // line(x1, y1, x2, y2, style) → {jsPDF}

        // Cuadro 1 Titulo
        pdf.line(15, 130, 15, 160); // Vertical 1
        pdf.line(15, 130, 20, 130); // Horizontal 1
        pdf.line(15, 160, 20, 160); // Horizontal 2
        pdf.setFontSize(7);
        pdf.setFontType("bold");
        pdf.text(19, 159, 'DATOS DEL AFILIADO', null, 90);

        // Cuadro 2 Titulo
        pdf.line(15, 170, 15, 192); // Vertical 1
        pdf.line(15, 170, 20, 170); // Horizontal 1
        pdf.line(15, 192, 20, 192); // Horizontal 2
        pdf.setFontSize(7);
        pdf.setFontType("bold");
        pdf.text(19, 187, 'VEHICULO', null, 90);

        // Cuadro 3 Titulo
        pdf.line(15, 208, 15, 232); // Vertical 1
        pdf.line(15, 208, 20, 208); // Horizontal 1
        pdf.line(15, 232, 20, 232); // Horizontal 2
        pdf.text(19, 226, 'REGISTRO', null, 90);

        // Primer Cuadro
        // Verticales
        pdf.line(20, 130, 20, 160); // Vertical 1 a
        pdf.line(20, 170, 20, 192); // Vertical 1 b

        pdf.line(63, 130, 63, 138); // Vertical 2 a
        pdf.line(63, 145, 63, 160); // Vertical 2 b
        pdf.line(63, 170, 63, 192); // Vertical 2 c

        pdf.line(106, 130, 106, 160); // Vertical 3 a
        pdf.line(106, 170, 106, 177); // Vertical 3 b

        pdf.line(94, 184, 94, 192); // Vertical 3 POLIZA

        pdf.line(130, 177, 130, 192); // Vertical 4 a

        pdf.line(162, 130, 162, 177); // Vertical 5 a

        pdf.line(200, 130, 200, 192); // Vertical 6 a

        // Horizontales
        pdf.line(20, 130, 200, 130); // Primera Horizontal
        pdf.line(20, 138, 200, 138); // 1 Horizontal
        pdf.line(20, 145, 200, 145); // 2 Horizontal
        pdf.line(20, 152, 200, 152); // 3 Horizontal
        pdf.line(20, 160, 162, 160); // 4 Horizontal
        pdf.line(20, 170, 200, 170); // 5 Horizontal
        pdf.line(20, 177, 200, 177); // 6 Horizontal
        pdf.line(20, 184, 130, 184); // 7 Horizontal
        pdf.line(20, 192, 200, 192); // Ultima Horizontal

        pdf.setFontSize(10);
        pdf.setFontType("bold");
        pdf.text('ACREDITA AL TITULAR:', 21, 129);

        pdf.setFontSize(6);
        pdf.text('APELLIDO PATERNO', 21, 132);
        pdf.text('APELLIDO MATERNO', 64, 132);
        pdf.text('NOMBRE(S)', 107, 132);
        pdf.text('TELEFONO', 163, 132);

        pdf.setFontSize(8);
        pdf.text(item.lastNameFather.toUpperCase(), 21, 136);
        pdf.text(item.lastNameMother.toUpperCase(), 64, 136);
        pdf.text(item.fullName.toUpperCase(), 107, 136);
        pdf.text(item.telephone.toUpperCase(), 163, 136);

        pdf.setFontSize(6);
        pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140);
        pdf.text('COLONIA', 107, 140);
        pdf.text('CODIGO POSTAL', 163, 140);

        pdf.setFontSize(8);
        pdf.text(item.direction.toUpperCase(), 21, 144);
        pdf.text(item.colony.toUpperCase(), 107, 144);
        pdf.text(item.postalCode.toUpperCase(), 163, 144);

        pdf.setFontSize(6);
        pdf.text('POBLACION', 21, 147);
        pdf.text('MUNICIPIO', 64, 147);
        pdf.text('ESTADO', 107, 147);
        pdf.text('RFC', 163, 147);

        pdf.setFontSize(8);
        pdf.text(item.population.toUpperCase(), 21, 151);
        pdf.text(item.municipality.toUpperCase(), 64, 151);
        pdf.text(item.state.toUpperCase(), 107, 151);
        pdf.text(item.rfc.toUpperCase(), 163, 151);

        pdf.setFontSize(6);
        pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154);
        pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154);
        pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154);
        pdf.setFontSize(5);
        pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154);

        //Añade QR
        pdf.addImage(img2, 'JPG', 174, 155, 14, 14);

        pdf.setFontSize(8);
        pdf.text(item.credentialCard.toUpperCase(), 21, 158);
        pdf.text(item.licenseType.toUpperCase(), 64, 158);
        pdf.text(item.licenseNumber.toUpperCase(), 107, 158);

        pdf.setFontSize(10);
        pdf.setFontType("bold");
        pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169);

        pdf.setFontSize(6);
        pdf.text('MARCA', 21, 172);
        pdf.text('TIPO', 64, 172);
        pdf.text('LINEA', 107, 172);
        pdf.text('MODELO', 163, 172);

        pdf.setFontSize(8);
        pdf.text(item.brand.toUpperCase(), 21, 176);
        pdf.text(item.type.toUpperCase(), 64, 176);
        pdf.text(item.line.toUpperCase(), 107, 176);
        pdf.text(item.model.toUpperCase(), 163, 176);

        pdf.setFontSize(6);
        pdf.text('COLOR', 21, 179);
        pdf.text('NUMERO DE SERIE (VIN)', 64, 179);
        pdf.text('NUMERO DE PLACAS', 131, 179);

        pdf.setFontSize(8);
        pdf.text(item.color.toUpperCase(), 21, 183);
        pdf.text(item.vin.toUpperCase(), 64, 183);

        pdf.setFontSize(28);
        pdf.text('MEC-', 135, 189);
        pdf.text(item.plates.toUpperCase(), 161, 189);

        pdf.setFontSize(6);
        pdf.text('CILINDROS', 21, 186);
        pdf.text('PUERTAS', 64, 186);
        pdf.text('PÓLIZA', 96, 186);

        pdf.setFontSize(8);
        pdf.text(item.cylinders.toUpperCase(), 21, 190);
        pdf.text(item.doors.toUpperCase(), 64, 190);

        if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
          vm.objPolicy = 'MOCH 2-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 96, 190);
        }else if(item.hasPolicy){
          vm.objPolicy = 'LM-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 96, 190);
        }else{

        }

        // Segundo cuadro
        // Verticales
        pdf.line(20, 208, 20, 232); // Vertical 1 a
        pdf.line(63, 208, 63, 215); // Vertical 2 a
        pdf.line(106, 208, 106, 215); // Vertical 3 a
        pdf.line(162, 208, 162, 232); // Vertical 4 a
        pdf.line(200, 208, 200, 232); // Vertical 5 a

        // Horizontales
        pdf.line(20, 208, 200, 208); // Primera Horizontal
        pdf.line(20, 215, 162, 215); // 1 Horizontal
        pdf.line(20, 232, 200, 232); // Ultima Horizontal

        pdf.setFontSize(9);
        pdf.setFontType("bold");
        pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202);
        pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207);

        pdf.setFontSize(6);
        pdf.text('LUGAR DE REGSITRO', 21, 210);
        pdf.text('ESTADO DE REGISTRO', 64, 210);
        pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210);
        pdf.setFontSize(10);
        pdf.text('VIGENCIA', 172, 213);

        pdf.setFontSize(8);
        pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214);
        pdf.text(item.registerLocationState.toUpperCase(), 64, 214);

        vm.dateRegister = new Date(item.dateRegister);
        vm.dateValidity = new Date(item.dateValidity);
        vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

        vm.day1 = vm.dateRegister.getDate();
        vm.month1 = vm.dateRegister.getMonth();
        vm.year1 = vm.dateRegister.getFullYear();
        vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

        vm.day2 = vm.dateValidity.getDate();
        vm.month2 = vm.dateValidity.getMonth();
        vm.year2 = vm.dateValidity.getFullYear();
        vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

        pdf.text(vm.dateRegisterFull, 110, 214);

        pdf.setFontSize(16);
        pdf.text(vm.dateValidityrFull, 164, 222);

        pdf.setFontSize(6);
        pdf.text('SUGERENCIAS', 21, 217);

        pdf.setFontSize(8);
        pdf.text(item.sugestion.toUpperCase(), 21, 221);
        pdf.text(item.obervations.toUpperCase(), 21, 225);
        if(item.sugestion1 != 'Sin definir'){
          pdf.text(item.sugestion1.toUpperCase(), 21, 229);
        }
        pdf.setFontSize(10);
        vm.widthPage = pdf.internal.pageSize.getWidth();
        vm.widthText1 = pdf.getTextWidth('ATENTAMENTE');
        vm.xText1 = (vm.widthPage - vm.widthText1 ) / 2;
        pdf.text('ATENTAMENTE', vm.xText1, 245);

        vm.widthText2 = pdf.getTextWidth('PROFR. MANUEL ESCALANTE COTA');
        vm.xText2 = (vm.widthPage - vm.widthText2 ) / 2;
        pdf.text('PROFR. MANUEL ESCALANTE COTA', vm.xText2, 268);

        pdf.setFontType("normal");
        vm.widthText3 = pdf.getTextWidth('PRESIDENTE DEL COMITÉ NACIONAL');
        vm.xText3 = (vm.widthPage - vm.widthText3 ) / 2;
        pdf.text('PRESIDENTE DEL COMITÉ NACIONAL', vm.xText3, 273);

        vm.widthText4 = pdf.getTextWidth('PRO-DEFENSA DEL PATRIMONIO FAMILIAR');
        vm.xText4 = (vm.widthPage - vm.widthText4 ) / 2;
        pdf.text('PRO-DEFENSA DEL PATRIMONIO FAMILIAR', vm.xText4, 278);

        // // Print
        // pdf.autoPrint({variant: 'non-conform'});
        // //This is a key for printing
        // pdf.output('dataurlnewwindow');

        window.open(pdf.output('bloburl'), '_blank');

      };

      vm.pdfPrint1 = function (item) {
        $log.log("vm.pdfPrint()");
        $log.log("item", item);

        //Genera el pdf
        var pdf = new jsPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'a4',
          putOnlyUsedFonts:true,
          floatPrecision: 16 // or "smart", default is 16
        });

        //Imágenes
        var img2 = new Image;

        //Rutas de imágenes
        img2.crossOrigin = "";
        img2.src = "assets/images/conapafa/qrsat.jpg";

        // Texto
        // line(x1, y1, x2, y2, style) → {jsPDF}
        vm.marginAllY = vm.settings.marginY;

        // Cuadro 1 Titulo
        pdf.line(15, 130+vm.marginAllY, 15, 160+vm.marginAllY); // Vertical 1
        pdf.line(15, 130+vm.marginAllY, 20, 130+vm.marginAllY); // Horizontal 1
        pdf.line(15, 160+vm.marginAllY, 20, 160+vm.marginAllY); // Horizontal 2
        pdf.setFontSize(7);
        pdf.setFontType("bold");
        pdf.text(19, 159+vm.marginAllY, 'DATOS DEL AFILIADO', null, 90);

        // Cuadro 2 Titulo
        pdf.line(15, 170+vm.marginAllY, 15, 192+vm.marginAllY); // Vertical 1
        pdf.line(15, 170+vm.marginAllY, 20, 170+vm.marginAllY); // Horizontal 1
        pdf.line(15, 192+vm.marginAllY, 20, 192+vm.marginAllY); // Horizontal 2
        pdf.setFontSize(7);
        pdf.setFontType("bold");
        pdf.text(19, 187+vm.marginAllY, 'VEHICULO', null, 90);

        // Cuadro 3 Titulo
        pdf.line(15, 208+vm.marginAllY, 15, 232+vm.marginAllY); // Vertical 1
        pdf.line(15, 208+vm.marginAllY, 20, 208+vm.marginAllY); // Horizontal 1
        pdf.line(15, 232+vm.marginAllY, 20, 232+vm.marginAllY); // Horizontal 2
        pdf.text(19, 226+vm.marginAllY, 'REGISTRO', null, 90);

        // Primer Cuadro
        // Verticales
        pdf.line(20, 130+vm.marginAllY, 20, 160+vm.marginAllY); // Vertical 1 a
        pdf.line(20, 170+vm.marginAllY, 20, 192+vm.marginAllY); // Vertical 1 b

        pdf.line(63, 130+vm.marginAllY, 63, 138+vm.marginAllY); // Vertical 2 a
        pdf.line(63, 145+vm.marginAllY, 63, 160+vm.marginAllY); // Vertical 2 b
        pdf.line(63, 170+vm.marginAllY, 63, 192+vm.marginAllY); // Vertical 2 c

        pdf.line(106, 130+vm.marginAllY, 106, 160+vm.marginAllY); // Vertical 3 a
        pdf.line(106, 170+vm.marginAllY, 106, 177+vm.marginAllY); // Vertical 3 b

        pdf.line(94, 184+vm.marginAllY, 94, 192+vm.marginAllY); // Vertical 3 POLIZA

        pdf.line(130, 177+vm.marginAllY, 130, 192+vm.marginAllY); // Vertical 4 a

        pdf.line(162, 130+vm.marginAllY, 162, 177+vm.marginAllY); // Vertical 5 a

        pdf.line(200, 130+vm.marginAllY, 200, 192+vm.marginAllY); // Vertical 6 a

        // Horizontales
        pdf.line(20, 130+vm.marginAllY, 200, 130+vm.marginAllY); // Primera Horizontal
        pdf.line(20, 138+vm.marginAllY, 200, 138+vm.marginAllY); // 1 Horizontal
        pdf.line(20, 145+vm.marginAllY, 200, 145+vm.marginAllY); // 2 Horizontal
        pdf.line(20, 152+vm.marginAllY, 200, 152+vm.marginAllY); // 3 Horizontal
        pdf.line(20, 160+vm.marginAllY, 162, 160+vm.marginAllY); // 4 Horizontal
        pdf.line(20, 170+vm.marginAllY, 200, 170+vm.marginAllY); // 5 Horizontal
        pdf.line(20, 177+vm.marginAllY, 200, 177+vm.marginAllY); // 6 Horizontal
        pdf.line(20, 184+vm.marginAllY, 130, 184+vm.marginAllY); // 7 Horizontal
        pdf.line(20, 192+vm.marginAllY, 200, 192+vm.marginAllY); // Ultima Horizontal

        pdf.setFontSize(10);
        pdf.setFontType("bold");
        pdf.text('ACREDITA AL TITULAR:', 21, 129+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('APELLIDO PATERNO', 21, 132+vm.marginAllY);
        pdf.text('APELLIDO MATERNO', 64, 132+vm.marginAllY);
        pdf.text('NOMBRE(S)', 107, 132+vm.marginAllY);
        pdf.text('TELEFONO', 163, 132+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.lastNameFather.toUpperCase(), 21, 136+vm.marginAllY);
        pdf.text(item.lastNameMother.toUpperCase(), 64, 136+vm.marginAllY);
        pdf.text(item.fullName.toUpperCase(), 107, 136+vm.marginAllY);
        pdf.text(item.telephone.toUpperCase(), 163, 136+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('DOMICILIO: CALLE Y NUMERO EXTERIOR E INTERIOR', 21, 140+vm.marginAllY);
        pdf.text('COLONIA', 107, 140+vm.marginAllY);
        pdf.text('CODIGO POSTAL', 163, 140+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.direction.toUpperCase(), 21, 144+vm.marginAllY);
        pdf.text(item.colony.toUpperCase(), 107, 144+vm.marginAllY);
        pdf.text(item.postalCode.toUpperCase(), 163, 144+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('POBLACION', 21, 147+vm.marginAllY);
        pdf.text('MUNICIPIO', 64, 147+vm.marginAllY);
        pdf.text('ESTADO', 107, 147+vm.marginAllY);
        pdf.text('RFC', 163, 147+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.population.toUpperCase(), 21, 151+vm.marginAllY);
        pdf.text(item.municipality.toUpperCase(), 64, 151+vm.marginAllY);
        pdf.text(item.state.toUpperCase(), 107, 151+vm.marginAllY);
        pdf.text(item.rfc.toUpperCase(), 163, 151+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('NO. CREDENCIAL DE LECTOR', 21, 154+vm.marginAllY);
        pdf.text('TIPO DE LICENCIA DE CONDUCIR', 64, 154+vm.marginAllY);
        pdf.text('NUMERO DE LICENCIA DE CONDUCIR', 107, 154+vm.marginAllY);
        pdf.setFontSize(5);
        pdf.text('CEDULA DE IDENTIFICACION FISCAL', 163, 154+vm.marginAllY);

        //Añade QR
        pdf.addImage(img2, 'JPG', 174, 155+vm.marginAllY, 14, 14);

        pdf.setFontSize(8);
        pdf.text(item.credentialCard.toUpperCase(), 21, 158+vm.marginAllY);
        pdf.text(item.licenseType.toUpperCase(), 64, 158+vm.marginAllY);
        pdf.text(item.licenseNumber.toUpperCase(), 107, 158+vm.marginAllY);

        pdf.setFontSize(10);
        pdf.setFontType("bold");
        pdf.text('CARACTERÍSTICAS DEL VEHÍCULO:', 21, 169+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('MARCA', 21, 172+vm.marginAllY);
        pdf.text('TIPO', 64, 172+vm.marginAllY);
        pdf.text('LINEA', 107, 172+vm.marginAllY);
        pdf.text('MODELO', 163, 172+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.brand.toUpperCase(), 21, 176+vm.marginAllY);
        pdf.text(item.type.toUpperCase(), 64, 176+vm.marginAllY);
        pdf.text(item.line.toUpperCase(), 107, 176+vm.marginAllY);
        pdf.text(item.model.toUpperCase(), 163, 176+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('COLOR', 21, 179+vm.marginAllY);
        pdf.text('NUMERO DE SERIE (VIN)', 64, 179+vm.marginAllY);
        pdf.text('NUMERO DE PLACAS', 131, 179+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.color.toUpperCase(), 21, 183+vm.marginAllY);
        pdf.text(item.vin.toUpperCase(), 64, 183+vm.marginAllY);

        pdf.setFontSize(28);
        pdf.text('MEC-', 135, 189+vm.marginAllY);
        pdf.text(item.plates.toUpperCase(), 161, 189+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('CILINDROS', 21, 186+vm.marginAllY);
        pdf.text('PUERTAS', 64, 186+vm.marginAllY);
        pdf.text('PÓLIZA', 96, 186+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.cylinders.toUpperCase(), 21, 190+vm.marginAllY);
        pdf.text(item.doors.toUpperCase(), 64, 190+vm.marginAllY);

        if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
          vm.objPolicy = 'MOCH 2-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
        }else if(item.hasPolicy){
          vm.objPolicy = 'LM-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 96, 190+vm.marginAllY);
        }

        // Segundo cuadro
        // Verticales
        pdf.line(20, 208+vm.marginAllY, 20, 232+vm.marginAllY); // Vertical 1 a
        pdf.line(63, 208+vm.marginAllY, 63, 215+vm.marginAllY); // Vertical 2 a
        pdf.line(106, 208+vm.marginAllY, 106, 215+vm.marginAllY); // Vertical 3 a
        pdf.line(162, 208+vm.marginAllY, 162, 232+vm.marginAllY); // Vertical 4 a
        pdf.line(200, 208+vm.marginAllY, 200, 232+vm.marginAllY); // Vertical 5 a

        // Horizontales
        pdf.line(20, 208+vm.marginAllY, 200, 208+vm.marginAllY); // Primera Horizontal
        pdf.line(20, 215+vm.marginAllY, 162, 215+vm.marginAllY); // 1 Horizontal
        pdf.line(20, 232+vm.marginAllY, 200, 232+vm.marginAllY); // Ultima Horizontal

        pdf.setFontSize(9);
        pdf.setFontType("bold");
        pdf.text('MUCHO AGRADECEMOS LAS ATENCIONES Y FACILIDADES QUE SE SIRVAN OTORGARLE PARA QUE ESTA UNIDAD', 21, 202+vm.marginAllY);
        pdf.text('PUEDA CIRCULAR SIN NINGÚN PROBLEMA.', 21, 207+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('LUGAR DE REGSITRO', 21, 210+vm.marginAllY);
        pdf.text('ESTADO DE REGISTRO', 64, 210+vm.marginAllY);
        pdf.text('FECHA DE REGSITRO DIA/MES/AÑO', 107, 210+vm.marginAllY);
        pdf.setFontSize(10);
        pdf.text('VIGENCIA', 172, 213+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.registerLocationPlace.toUpperCase(), 21, 214+vm.marginAllY);
        pdf.text(item.registerLocationState.toUpperCase(), 64, 214+vm.marginAllY);

        vm.dateRegister = new Date(item.dateRegister);
        vm.dateValidity = new Date(item.dateValidity);
        vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        vm.monthsSimple = ['Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

        vm.day1 = vm.dateRegister.getDate();
        vm.month1 = vm.dateRegister.getMonth();
        vm.year1 = vm.dateRegister.getFullYear();
        vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1].toUpperCase() + ' / ' + vm.year1;

        vm.day2 = vm.dateValidity.getDate();
        vm.month2 = vm.dateValidity.getMonth();
        vm.year2 = vm.dateValidity.getFullYear();
        vm.dateValidityrFull = vm.day2 + '-' + vm.monthsSimple[vm.month2].toUpperCase() + '-' + vm.year2;

        pdf.text(vm.dateRegisterFull, 110, 214+vm.marginAllY);

        pdf.setFontSize(16);
        pdf.text(vm.dateValidityrFull, 164, 222+vm.marginAllY);

        pdf.setFontSize(6);
        pdf.text('SUGERENCIAS', 21, 217+vm.marginAllY);

        pdf.setFontSize(8);
        pdf.text(item.sugestion.toUpperCase(), 21, 221+vm.marginAllY);
        pdf.text(item.obervations.toUpperCase(), 21, 225+vm.marginAllY);
        if(item.sugestion1 != 'Sin definir'){
          pdf.text(item.sugestion1.toUpperCase(), 21, 229+vm.marginAllY);
        }
        // // Print
        // pdf.autoPrint({variant: 'non-conform'});
        // //This is a key for printing
        // pdf.output('dataurlnewwindow');

        window.open(pdf.output('bloburl'), '_blank');

      };

      vm.pdfPrintNewCert = function (item) {
        $log.log("vm.pdfPrintNewCert()");
        $log.log("item", item);

        //Genera el pdf
        var pdf = new jsPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'letter',
          putOnlyUsedFonts: true,
          floatPrecision: 16 // or "smart", default is 16
        });

        //Imágenes
        var img2 = new Image;

        //Rutas de imágenes
        img2.crossOrigin = "";
        img2.src = "assets/images/conapafa/cert2.jpg";

        //Añade QR
        pdf.addImage(img2, 'JPG', 0, 0, 215.9, 279.4);

        pdf.setFontSize(13);
        pdf.setFontType("bold");
        pdf.setTextColor(0, 176, 240);
        vm.newDate = new Date();
        vm.newYear = ' ' + vm.newDate.getFullYear();
        pdf.text(vm.newYear, 49, 57.5);

        pdf.setFontSize(12);
        pdf.setFontType("bold");
        pdf.setTextColor(0, 0, 0);
        vm.fullName = item.fullName.toUpperCase() + ' ' + item.lastNameFather.toUpperCase() + ' ' + item.lastNameMother.toUpperCase();
        pdf.text(vm.fullName, 38, 143.5);

        pdf.setFontSize(8);
        pdf.setFontType("normal");
        pdf.text(item.telephone.toUpperCase(), 163, 143);

        vm.address = item.direction + ' COL. ' + item.colony + ', C.P. ' + item.postalCode + ', ' + item.population +
          ', ' + item.municipality + ', ' + item.state + '.';
        pdf.text(vm.address.toUpperCase(), 38, 149);

        pdf.text(item.credentialCard.toUpperCase(), 38, 154);
        pdf.text(item.rfc.toUpperCase(), 163, 153.5);

        pdf.text(item.licenseType.toUpperCase(), 70, 158.5);
        pdf.text(item.licenseNumber.toUpperCase(), 163, 158.5);

        pdf.text(item.brand.toUpperCase(), 45, 172);
        pdf.text(item.color.toUpperCase(), 130, 172);

        pdf.text(item.type.toUpperCase(), 45, 177);
        pdf.text(item.cylinders.toUpperCase(), 130, 177);

        pdf.text(item.line.toUpperCase(), 45, 182);
        pdf.text(item.doors.toUpperCase(), 130, 182);

        pdf.text(item.model.toUpperCase(), 45, 187);
        if(item.hasPolicy && item.registerLocationPlace == 'Los Mochis Matriz'){
          vm.objPolicy = 'MOCH 2-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
        }else if(item.hasPolicy){
          vm.objPolicy = 'LM-' + item.policyNumber;
          pdf.text(vm.objPolicy.toUpperCase(), 130, 187);
        }

        pdf.setFontSize(14);
        pdf.setFontType("bold");
        pdf.text(item.vin.toUpperCase(), 65, 193.5);

        pdf.setFontSize(18);
        pdf.setFontType("bold");
        vm.platesMec = 'MEC-' + item.plates.toUpperCase();
        pdf.text(vm.platesMec.toUpperCase(), 160.5, 193.5);

        pdf.setFontSize(8);
        pdf.setFontType("normal");

        pdf.text(item.registerLocationPlace.toUpperCase(), 60, 213);
        pdf.text(item.registerLocationState.toUpperCase(), 163, 213);

        vm.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        vm.dateRegister = new Date(item.dateRegister);
        vm.day1 = vm.dateRegister.getDate();
        vm.month1 = vm.dateRegister.getMonth() + 1;
        vm.year1 = vm.dateRegister.getFullYear();
        vm.hour = vm.dateRegister.getHours();
        vm.minutes = vm.dateRegister.getMinutes();
        vm.suffix = vm.hour >= 12 ? "PM":"AM";
        vm.hoursNew = ((vm.hour + 11) % 12 + 1) + ':' + vm.minutes + ' ' + vm.suffix;
        vm.dateRegisterFull = vm.day1 + ' / ' + vm.months[vm.month1-1].toUpperCase() + ' / ' + vm.year1 + ' - ' + vm.hoursNew;

        pdf.setFontSize(11);
        pdf.setFontType("bold");
        pdf.text(vm.dateRegisterFull.toUpperCase(), 70, 218);

        pdf.setFontType("normal");
        if(item.sugestion1 != 'Sin definir'){
          pdf.text(item.sugestion1.toUpperCase(), 19, 227);
        }else{
          //pdf.text(item.sugestion1.toUpperCase(), 18.5, 228);
        }

        // // Print
        // pdf.autoPrint({variant: 'non-conform'});
        // //This is a key for printing
        // pdf.output('dataurlnewwindow');

        window.open(pdf.output('bloburl'), '_blank');

      };

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.places.places', {
      url: "/places/:id",
      views: {
        places:{
          templateUrl: "app/main/admin/places/places/places.html"
        }
      },
      data: {
        pageTitle: 'Places places'
      }
    });
  })
  .controller('PlacesPlacesController', function ($log, $window, $state, $stateParams, $timeout, $scope, AppUser, Brand) {

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    $log.log('Places Places');
    $log.log('stateparameter', $stateParams);

    vm.addItemDirective = function(){
      $log.log('addItemDirective');
      $state.go('main.admin.modules.module', {id: 'new'});
    };

    vm.configTitle = {
      'title': "Detalle del Lugar",
      'icon': "fa-map-pin",
      'iconButton': "fa-plus",
      'buttonName': "Añadir lugar",
      'addButton': false,
      'style': {
          "background-color" : "#313639",
          "color": "#fff"
      },
      'styleHover': {
          "background-color" : "#313639",
          "color": "#fff"
      }
    };

    // Variable
    vm.createBlock = false;
    vm.errorFlag = false;
    vm.placeToAdd = '';

    vm.cancel = function(){
      $state.go('^.all');
    };

    vm.create = function(){
      $log.log('vm.create');

      vm.errorFlag = true;
      $log.log('vm.state', vm.state);

      if(vm.state.name == ""){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{

          Brand.create(vm.state, function successSaveUser(datos){
            $log.log('created', datos);
            $state.go('^.all');
          },function errorSaveProduct(err){
              $log.log(err);
          });
      }

    };

    vm.update = function(){
      $log.log('vm.update');

      vm.errorFlag = true;
      $log.log('vm.state', vm.state);

      if(vm.state.name == ""){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{

        Brand.prototype$patchAttributes(
            {id:  vm.state.id},
            vm.state, function (success){
                $log.log("Success", success);
                $state.go('^.all');
            }, function (err) {
                $log.log(err, 'error');
            });
      }

    };


    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
        if(vm.flag){
          $log.log('Create');
          vm.create();
        }else{
          $log.log('Update');
          vm.update();
        }
      }
    };

    vm.itemCreateUpdate = function(){

      if($stateParams.id === 'new'){
        $log.log("New brand");
        vm.flag = true;
        vm.state = {
          name: ''
        };
      }
      else{
        $log.log("Update brand");
        vm.flag = false;

        Brand.findOne({
            filter: {
              where: {
                id: $stateParams.id
              }
            }
          },
          function(state){
            vm.state = angular.copy(state);
            $log.log("vm.state",  vm.state);
          },
          function(err){
            $log.log(err);
          });

      }

    };


    vm.getAppUserData = function(){

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);
          vm.itemCreateUpdate();

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.places.all', {
      url: "/all",
      views: {
        places:{
          templateUrl: "app/main/admin/places/all/all.html"
        }
      },
      data: {
        pageTitle: 'Places All'
      }
    });
  })
  .controller('AllPlacesAdminController', function ($log, $window, $state, $scope, AppUser, Brand) {

    $log.log('Brands All');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;
    vm.spinnerFlag = true;

    // Titulo
    vm.titleButtonCreate = 'Añadir estado';

    vm.create = function(){
      $log.log('create new places');
      $state.go('main.admin.places.places', {id: 'new'});
    };

    // Buscador
    vm.itemsText = '';
    vm.withText = false;
    vm.searchLikes = [
      "name"
    ];

    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
        $log.log('enterFunction', keyEvent);
        vm.searchText(vm.itemsText);
      }
    };

    vm.searchText = function(text) {
      $log.log('text', text);
      vm.itemsText = text;

      if(vm.itemsText == ''){
        $log.log('nothing');
        vm.withText = false;
        vm.loadItems(0);
      }else{
        $log.log('text text');
        vm.withText = true;
        vm.loadItems(0);
      }
    };

    // Lista

    vm.editModule = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.admin.places.places', {id: vm.itemToGo});
    };

    vm.deleteModule = function(index){
      $log.log("Item to Delete");
      swal({
        title: "Estas seguro?",
        text: "Si lo elmininas no hay manera de volver a recuperarlo",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sí",
        cancelButtonText: "No!",
        closeOnConfirm: false,
        closeOnCancel: false },
      function(isConfirm){
        if (isConfirm) {
          swal("Eliminado", "", "");
          vm.deleteOk(index);
        } else {
          swal("Cancelado", "", "");
        }
      });
    };

    vm.deleteOk = function(index){
      $log.log('index', index);
      vm.itemToDelete = vm.items[index].id;

      Brand.deleteById({id: vm.itemToDelete},
        function(itemDeleted){
          vm.itemDeleted = itemDeleted;
          $log.log("ItemDeleted", vm.itemDeleted);

          vm.items.splice(index, 1);

          if(vm.items.length == 0){
            vm.paginationFor = 0;
          }
        },
        function(err){
          $log.log(err);
        });
    };

    vm.limit = 50;
    vm.paginationFor = 0;

    vm.loadItems = function(skip) {

      vm.filterItems = {
        filter:{
          where: {},
          skip: skip*vm.limit,
          limit: vm.limit,
          order: "name ASC"
        }
      };

      vm.filterItemsQuantity = {
        where:{}
      };

      if(vm.withText){
        $log.log('vm.itemsText', vm.itemsText);

        vm.searchInputString = angular.copy(vm.itemsText);
        var stringsArray = vm.searchInputString.split(" ");

        vm.filterItems.filter.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        vm.filterItemsQuantity.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        for(var a = 0; a < stringsArray.length; a++){
          var word = stringsArray[a];

          for (var x = 0; x < vm.searchLikes.length; x++) {
            var objects = {};

            objects[vm.searchLikes[x]] = {
              like: word,
              options: 'i'
            };

            vm.filterItems.filter.where.and[0].or.push(angular.copy(objects));
            vm.filterItemsQuantity.where.and[0].or.push(angular.copy(objects));
          }
        }
      }

      $log.log('filterItems', vm.filterItems);
      $log.log('filterItemsQuantity', vm.filterItemsQuantity);

      Brand.count(
        vm.filterItemsQuantity,
        function (quantityItems) {
          vm.quantityItems = quantityItems;
          $log.log('quantityItems', vm.quantityItems.count);
          vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
          vm.paginationOptions = [];

          if(vm.quantityItems.count != 0){
            if(vm.quantityItems.count % vm.limit != 0){
              vm.paginationFor =  vm.paginationFor + 1;
            }

            for(var n=0; n<vm.paginationFor; n++){
              vm.paginationOptions.push(n+1);
            }

            $log.log('vm.paginationOptions', vm.paginationOptions);
            vm.paginationOptions = vm.paginationOptions;
          }

          $log.log('vm.paginationFor', vm.paginationFor);
          $log.log('vm.paginationOptions', vm.paginationOptions);

          vm.paginationOptions = vm.paginationOptions;
          vm.paginationFor = vm.paginationFor;

        },
        function (err) {
          $log.log(err);
        });

      Brand.find(
        vm.filterItems,
        function (places) {
          vm.places = places;
          $log.log('vm.places', vm.places);
          vm.spinnerFlag = false;
        },
        function (err) {
          $log.log(err);
        });

    };

    // Pagination Seleccion
    vm.paginationOptions = [];
    vm.pageSelected = 1;

    vm.changeRight = function(){
      $log.log('vm.changeRight');

      if(vm.paginationOptions.length != 1){
        vm.pageSelected =  vm.pageSelected + 1;
        if(vm.paginationOptions.length < vm.pageSelected){
          vm.pageSelected = vm.paginationOptions.length;
        }

        $log.log('vm.pageSelected', vm.pageSelected);
        vm.loadItems(vm.pageSelected-1);
      }

    };

    vm.changeLeft = function(){
      $log.log('vm.changeLeft');

      if(vm.paginationOptions.length != 1){
        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected - 1;
          if(vm.pageSelected < 1){
            vm.pageSelected = 1;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }
      }
    };

    vm.changePage = function(pageIndex){
      $log.log('pageIndex', pageIndex);
      vm.pageSelected = pageIndex;
      vm.loadItems(pageIndex-1);
    };


    // Buscar compañia

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.loadItems(0);

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();


  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.colors.all', {
      url: "/all",
      views: {
        colors:{
          templateUrl: "app/main/admin/colors/all/all.html"
        }
      },
      data: {
        pageTitle: 'Colors All'
      }
    });
  })
  .controller('ColorsAllController', function ($log, $window, $state, $scope, AppUser, Color) {

    $log.log('Colors All');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;
    vm.spinnerFlag = true;

    // Titulo
    vm.title = 'Colors';
    vm.titleButtonCreate = 'Añadir color';

    vm.create = function(){
      $log.log('create new user');
      $state.go('main.admin.colors.color', {id: 'new'});
    };

    // Buscador
    vm.itemsText = '';
    vm.withText = false;
    vm.searchLikes = [
      "name"
    ];

    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
        $log.log('enterFunction', keyEvent);
        vm.searchText(vm.itemsText);
      }
    };

    vm.searchText = function(text) {
      $log.log('text', text);
      vm.itemsText = text;

      if(vm.itemsText == ''){
        $log.log('nothing');
        vm.withText = false;
        vm.loadItems(0);
      }else{
        $log.log('text text');
        vm.withText = true;
        vm.loadItems(0);
      }
    };

    // Lista

    vm.editModule = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.admin.colors.color', {id: vm.itemToGo});
    };

    vm.deleteModule = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteOk(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };

    vm.deleteOk = function(index){
      $log.log('index', index);
      vm.itemToDelete = vm.items[index].id;

      Color.deleteById({id: vm.itemToDelete},
        function(itemDeleted){
          vm.itemDeleted = itemDeleted;
          $log.log("ItemDeleted", vm.itemDeleted);

          vm.items.splice(index, 1);

          if(vm.items.length == 0){
            vm.paginationFor = 0;
          }
        },
        function(err){
          $log.log(err);
        });
    };

    vm.limit = 50;
    vm.paginationFor = 0;

    vm.loadItems = function(skip) {

      vm.filterItems = {
        filter:{
          where: {},
          skip: skip*vm.limit,
          limit: vm.limit,
          order: "name ASC"
        }
      };

      vm.filterItemsQuantity = {
        where:{}
      };

      if(vm.withText){
        $log.log('vm.itemsText', vm.itemsText);

        vm.searchInputString = angular.copy(vm.itemsText);
        var stringsArray = vm.searchInputString.split(" ");

        vm.filterItems.filter.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        vm.filterItemsQuantity.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        for(var a = 0; a < stringsArray.length; a++){
          var word = stringsArray[a];

          for (var x = 0; x < vm.searchLikes.length; x++) {
            var objects = {};

            objects[vm.searchLikes[x]] = {
              like: word,
              options: 'i'
            };

            vm.filterItems.filter.where.and[0].or.push(angular.copy(objects));
            vm.filterItemsQuantity.where.and[0].or.push(angular.copy(objects));
          }
        }
      }

      $log.log('filterItems', vm.filterItems);
      $log.log('filterItemsQuantity', vm.filterItemsQuantity);

      Color.count(
        vm.filterItemsQuantity,
        function (quantityItems) {
          vm.quantityItems = quantityItems;
          $log.log('quantityItems', vm.quantityItems.count);
          vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
          vm.paginationOptions = [];

          if(vm.quantityItems.count != 0){
            if(vm.quantityItems.count % vm.limit != 0){
              vm.paginationFor =  vm.paginationFor + 1;
            }

            for(var n=0; n<vm.paginationFor; n++){
              vm.paginationOptions.push(n+1);
            }

            $log.log('vm.paginationOptions', vm.paginationOptions);
            vm.paginationOptions = vm.paginationOptions;
          }

          $log.log('vm.paginationFor', vm.paginationFor);
          $log.log('vm.paginationOptions', vm.paginationOptions);

          vm.paginationOptions = vm.paginationOptions;
          vm.paginationFor = vm.paginationFor;

        },
        function (err) {
          $log.log(err);
        });

      Color.find(
        vm.filterItems,
        function (items) {
          vm.items = items;
          $log.log('vm.items', vm.items);
          vm.spinnerFlag = false;
        },
        function (err) {
          $log.log(err);
        });

    };

    // Pagination Seleccion
    vm.paginationOptions = [];
    vm.pageSelected = 1;

    vm.changeRight = function(){
      $log.log('vm.changeRight');

      if(vm.paginationOptions.length != 1){
        vm.pageSelected =  vm.pageSelected + 1;
        if(vm.paginationOptions.length < vm.pageSelected){
          vm.pageSelected = vm.paginationOptions.length;
        }

        $log.log('vm.pageSelected', vm.pageSelected);
        vm.loadItems(vm.pageSelected-1);
      }

    };

    vm.changeLeft = function(){
      $log.log('vm.changeLeft');

      if(vm.paginationOptions.length != 1){
        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected - 1;
          if(vm.pageSelected < 1){
            vm.pageSelected = 1;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }
      }
    };

    vm.changePage = function(pageIndex){
      $log.log('pageIndex', pageIndex);
      vm.pageSelected = pageIndex;
      vm.loadItems(pageIndex-1);
    };


    // Buscar compañia

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.loadItems(0);

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();


  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.colors.color', {
      url: "/color/:id",
      views: {
        colors:{
          templateUrl: "app/main/admin/colors/color/color.html"
        }
      },
      data: {
        pageTitle: 'Colors Color'
      }
    });
  })
  .controller('ColorsColorController', function ($log, $window, $state, $stateParams, $timeout, $scope, AppUser, Color) {

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    $log.log('Colors Color');
    $log.log('stateparameter', $stateParams);

    // <title-model data-config="vm.configTitle"></title-model>
    // Directiva Título

    vm.addItemDirective = function(){
      $log.log('addItemDirective');
      $state.go('main.admin.modules.module', {id: 'new'});
    };

    vm.configTitle = {
      'title': "Detalle de la Color",
      'icon': "fa-palette",
      'iconButton': "fa-plus",
      'buttonName': "Añadir módulo",
      'addButton': false,
      'style': {
          "background-color" : "#313639",
          "color": "#fff"
      },
      'styleHover': {
          "background-color" : "#313639",
          "color": "#fff"
      }
    };

    vm.createBlock = false;

    vm.cancel = function(){
      $state.go('^.all');
    };

    // Se crea una nueva User
    // Antes de crearla se hace un chequeo para que todó lo necesario
    // este definido sino sale una modal que te lo recuerda
    vm.create = function(){
      vm.errorFlag = true;
      $log.log('color create', vm.color);

      if(vm.color.fullName == ""){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{

          Color.create(vm.color, function successSaveUser(datos){
              $log.log('created', datos);
              $state.go('^.all');
          },function errorSaveProduct(err){
              $log.log(err);
          })
      }

    };

    // Se actualiza una User
    // Antes de crearla se hace un chequeo para que todó lo necesario
    // este definido sino sale una modal que te lo recuerda
    vm.update = function(){
      vm.errorFlag = true;

      $log.log('color update', vm.color);

      if(vm.color.name == ""){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{

        Color.prototype$patchAttributes(
            {id:  vm.color.id},
            vm.color, function (success){
                $log.log("Success", success);
                $state.go('^.all');
            }, function (err) {
                $log.log(err, 'error');
            });
      }

    };

    // Cuando le das enter a un input se ejecuta dicha dunción
    // el numero 13 indica el enter
    // ng-keypress="vm.enterFunction($event)"
    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
          if(vm.flag){
              $log.log('Create');
              vm.create();
          }else{
              $log.log('Update');
              vm.update();
          }
      }
    };

    vm.itemCreateUpdate = function(){

      // Depende de la $stateParams.id nos indica si vamos a crear una nueva PurchaseRequest
      // o vamos a actualizar una ya creada
      if($stateParams.id === 'new'){
        $log.log("New color");
        vm.flag = true;
        vm.color = {};
        vm.color.name = '';
        vm.errorFlag = false;
      }
      else{
        $log.log("Update color");
        vm.flag = false;

        Color.findOne({
            filter: {
              where:
                {
                  id: $stateParams.id
                }
            }
          },
          function(color){
            vm.color = angular.copy(color);

            $log.log("vm.color",  vm.color);
          },
          function(err){
            $log.log(err);
          });

      }

    };

    // Buscar compañia
    //
    //

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.itemCreateUpdate();

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.brands.brand', {
      url: "/brand/:id",
      views: {
        brands:{
          templateUrl: "app/main/admin/brands/brand/brand.html"
        }
      },
      data: {
        pageTitle: 'Brands Brand'
      }
    });
  })
  .controller('BrandsBrandController', function ($log, $window, $state, $stateParams, $timeout, $scope, AppUser, Brand) {

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    $log.log('Brands Brand');
    $log.log('stateparameter', $stateParams);

    // <title-model data-config="vm.configTitle"></title-model>
    // Directiva Título

    vm.addItemDirective = function(){
      $log.log('addItemDirective');
      $state.go('main.admin.modules.module', {id: 'new'});
    };

    vm.configTitle = {
      'title': "Detalle de la Marca",
      'icon': "fa-car",
      'iconButton': "fa-plus",
      'buttonName': "Añadir módulo",
      'addButton': false,
      'style': {
          "background-color" : "#313639",
          "color": "#fff"
      },
      'styleHover': {
          "background-color" : "#313639",
          "color": "#fff"
      }
    };

    // Variable
    vm.createBlock = false;
    vm.typeRegisters = [
      'Vehículo',
      'Motocicleta'
    ];

    vm.cancel = function(){
      $state.go('^.all');
    };

    // Se crea una nueva User
    // Antes de crearla se hace un chequeo para que todó lo necesario
    // este definido sino sale una modal que te lo recuerda
    vm.create = function(){
      vm.errorFlag = true;
      $log.log('brand create', vm.brand);

      if(vm.brand.fullName == ""){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{

          Brand.create(vm.brand, function successSaveUser(datos){
              $log.log('created', datos);
              $state.go('^.all');
          },function errorSaveProduct(err){
              $log.log(err);
          })
      }

    };

    // Se actualiza una User
    // Antes de crearla se hace un chequeo para que todó lo necesario
    // este definido sino sale una modal que te lo recuerda
    vm.update = function(){
      vm.errorFlag = true;

      $log.log('brand update', vm.brand);

      if(vm.brand.name == ""){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{

        Brand.prototype$patchAttributes(
            {id:  vm.brand.id},
            vm.brand, function (success){
                $log.log("Success", success);
                $state.go('^.all');
            }, function (err) {
                $log.log(err, 'error');
            });
      }

    };

    // Cuando le das enter a un input se ejecuta dicha dunción
    // el numero 13 indica el enter
    // ng-keypress="vm.enterFunction($event)"
    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
          if(vm.flag){
              $log.log('Create');
              vm.create();
          }else{
              $log.log('Update');
              vm.update();
          }
      }
    };

    vm.itemCreateUpdate = function(){

      // Depende de la $stateParams.id nos indica si vamos a crear una nueva PurchaseRequest
      // o vamos a actualizar una ya creada
      if($stateParams.id === 'new'){
        $log.log("New brand");
        vm.flag = true;
        vm.brand = {};
        vm.brand.name = '';
        vm.errorFlag = false;
      }
      else{
        $log.log("Update brand");
        vm.flag = false;

        Brand.findOne({
            filter: {
              where:
                {
                  id: $stateParams.id
                }
            }
          },
          function(brand){
            vm.brand = angular.copy(brand);
            $log.log("vm.brand",  vm.brand);
          },
          function(err){
            $log.log(err);
          });

      }

    };

    // Buscar compañia
    //
    //

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.itemCreateUpdate();

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.brands.all', {
      url: "/all",
      views: {
        brands:{
          templateUrl: "app/main/admin/brands/all/all.html"
        }
      },
      data: {
        pageTitle: 'Brands All'
      }
    });
  })
  .controller('BrandsAllController', function ($log, $window, $state, $scope, AppUser, Brand) {

    $log.log('Brands All');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;
    vm.spinnerFlag = true;

    // Titulo
    vm.title = 'Marcas';
    vm.titleButtonCreate = 'Añadir marca';

    vm.create = function(){
      $log.log('create new user');
      $state.go('main.admin.brands.brand', {id: 'new'});
    };

    // Buscador
    vm.itemsText = '';
    vm.withText = false;
    vm.searchLikes = [
      "name"
    ];

    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
        $log.log('enterFunction', keyEvent);
        vm.searchText(vm.itemsText);
      }
    };

    vm.searchText = function(text) {
      $log.log('text', text);
      vm.itemsText = text;

      if(vm.itemsText == ''){
        $log.log('nothing');
        vm.withText = false;
        vm.loadItems(0);
      }else{
        $log.log('text text');
        vm.withText = true;
        vm.loadItems(0);
      }
    };

    // Lista

    vm.editModule = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.admin.brands.brand', {id: vm.itemToGo});
    };

    vm.deleteModule = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteOk(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };

    vm.deleteOk = function(index){
      $log.log('index', index);
      vm.itemToDelete = vm.items[index].id;

      Brand.deleteById({id: vm.itemToDelete},
        function(itemDeleted){
          vm.itemDeleted = itemDeleted;
          $log.log("ItemDeleted", vm.itemDeleted);

          vm.items.splice(index, 1);

          if(vm.items.length == 0){
            vm.paginationFor = 0;
          }
        },
        function(err){
          $log.log(err);
        });
    };

    vm.limit = 50;
    vm.paginationFor = 0;

    vm.loadItems = function(skip) {

      vm.filterItems = {
        filter:{
          where: {},
          skip: skip*vm.limit,
          limit: vm.limit,
          order: "name ASC"
        }
      };

      vm.filterItemsQuantity = {
        where:{}
      };

      if(vm.withText){
        $log.log('vm.itemsText', vm.itemsText);

        vm.searchInputString = angular.copy(vm.itemsText);
        var stringsArray = vm.searchInputString.split(" ");

        vm.filterItems.filter.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        vm.filterItemsQuantity.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        for(var a = 0; a < stringsArray.length; a++){
          var word = stringsArray[a];

          for (var x = 0; x < vm.searchLikes.length; x++) {
            var objects = {};

            objects[vm.searchLikes[x]] = {
              like: word,
              options: 'i'
            };

            vm.filterItems.filter.where.and[0].or.push(angular.copy(objects));
            vm.filterItemsQuantity.where.and[0].or.push(angular.copy(objects));
          }
        }
      }

      $log.log('filterItems', vm.filterItems);
      $log.log('filterItemsQuantity', vm.filterItemsQuantity);

      Brand.count(
        vm.filterItemsQuantity,
        function (quantityItems) {
          vm.quantityItems = quantityItems;
          $log.log('quantityItems', vm.quantityItems.count);
          vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
          vm.paginationOptions = [];

          if(vm.quantityItems.count != 0){
            if(vm.quantityItems.count % vm.limit != 0){
              vm.paginationFor =  vm.paginationFor + 1;
            }

            for(var n=0; n<vm.paginationFor; n++){
              vm.paginationOptions.push(n+1);
            }

            $log.log('vm.paginationOptions', vm.paginationOptions);
            vm.paginationOptions = vm.paginationOptions;
          }

          $log.log('vm.paginationFor', vm.paginationFor);
          $log.log('vm.paginationOptions', vm.paginationOptions);

          vm.paginationOptions = vm.paginationOptions;
          vm.paginationFor = vm.paginationFor;

        },
        function (err) {
          $log.log(err);
        });

      Brand.find(
        vm.filterItems,
        function (items) {
          vm.items = items;
          $log.log('vm.items', vm.items);
          vm.spinnerFlag = false;
        },
        function (err) {
          $log.log(err);
        });

    };

    // Pagination Seleccion
    vm.paginationOptions = [];
    vm.pageSelected = 1;

    vm.changeRight = function(){
      $log.log('vm.changeRight');

      if(vm.paginationOptions.length != 1){
        vm.pageSelected =  vm.pageSelected + 1;
        if(vm.paginationOptions.length < vm.pageSelected){
          vm.pageSelected = vm.paginationOptions.length;
        }

        $log.log('vm.pageSelected', vm.pageSelected);
        vm.loadItems(vm.pageSelected-1);
      }

    };

    vm.changeLeft = function(){
      $log.log('vm.changeLeft');

      if(vm.paginationOptions.length != 1){
        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected - 1;
          if(vm.pageSelected < 1){
            vm.pageSelected = 1;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }
      }
    };

    vm.changePage = function(pageIndex){
      $log.log('pageIndex', pageIndex);
      vm.pageSelected = pageIndex;
      vm.loadItems(pageIndex-1);
    };


    // Buscar compañia

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.loadItems(0);

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();


  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.clients.client', {
      url: "/client/:id",
      views: {
        clients:{
          templateUrl: "app/main/admin/clients/client/client.html"
        }
      },
      data: {
        pageTitle: 'Clients Client'
      }
    });
  })
  .controller('ClientsClientController', function ($log, $window, $state, $stateParams, $timeout, $scope, Client, AppUser) {

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    $log.log('Client');
    $log.log('stateparameter', $stateParams);

    // <title-model data-config="vm.configTitle"></title-model>
    // Directiva Título

    vm.addItemDirective = function(){
      $log.log('addItemDirective');
      $state.go('main.admin.modules.module', {id: 'new'});
    };

    vm.configTitle = {
      'title': "Detalle del Cliente",
      'icon': "fa-user-friends",
      'iconButton': "fa-plus",
      'buttonName': "Añadir módulo",
      'addButton': false,
      'style': {
          "background-color" : "#313639",
          "color": "#fff"
      },
      'styleHover': {
          "background-color" : "#313639",
          "color": "#fff"
      }
    };

    vm.createBlock = false;

    vm.cancel = function(){
      $state.go('^.all');
    };

    // Se crea una nueva User
    // Antes de crearla se hace un chequeo para que todó lo necesario
    // este definido sino sale una modal que te lo recuerda
    vm.create = function(){
      vm.errorFlag = true;
      $log.log('client create', vm.client);

      if(vm.client.name == undefined || vm.client.name == ""){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{
        Client.create(vm.client, function successSaveUser(datos){
              $log.log('created', datos);
              $state.go('^.all');
          },function errorSaveProduct(err){
              $log.log(err);
          });
      }

    };

    // Se actualiza una User
    // Antes de crearla se hace un chequeo para que todó lo necesario
    // este definido sino sale una modal que te lo recuerda
    vm.update = function(){
      vm.errorFlag = true;

      $log.log('client update', vm.client);

      if(vm.client.name == undefined || vm.client.name == ""){
          sweetAlert("Oops...", "Te faltan campos por llenar", "error");
      }else{
        Client.prototype$patchAttributes(
            {id:  vm.client.id},
            vm.client, function (success){
                $log.log("Success", success);
                $state.go('^.all');
            }, function (err) {
                $log.log(err, 'error');
            });
      }

    };

    // Cuando le das enter a un input se ejecuta dicha dunción
    // el numero 13 indica el enter
    // ng-keypress="vm.enterFunction($event)"
    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
          if(vm.flag){
              $log.log('Create');
              vm.create();
          }else{
              $log.log('Update');
              vm.update();
          }
      }
    };


    vm.itemCreateUpdate = function () {

      // Depende de la $stateParams.id nos indica si vamos a crear una nueva PurchaseRequest
      // o vamos a actualizar una ya creada
      if($stateParams.id === 'new'){
        $log.log("New user");
        vm.flag = true;
        vm.client = {};

        vm.errorFlag = false;

      }
      else{
        $log.log("Update client");
        vm.flag = false;

        Client.findOne({
            filter: {
              where:
                {
                  id: $stateParams.id
                }
            }
          },
          function(client){
            vm.client = angular.copy(client);

            $log.log("vm.client",  vm.client);
          },
          function(err){
            $log.log(err);
          });

      }

    };



    // Buscar compañia
    //
    //

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.itemCreateUpdate();

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();



  });




'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.clients.all', {
      url: "/all",
      views: {
        clients:{
          templateUrl: "app/main/admin/clients/all/all.html"
        }
      },
      data: {
        pageTitle: 'Clients All'
      }
    });
  })
  .controller('ClientsAllController', function ($log, $window, $state, $scope, Client, AppUser) {

    $log.log('Clients All');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;
    vm.spinnerFlag = true;

    // Titulo
    vm.title = 'Clientes';
    vm.titleButtonCreate = 'Añadir cliente';

    vm.create = function(){
      $log.log('create new user');
      $state.go('main.admin.clients.client', {id: 'new'});
    };

    // Buscador
    vm.itemsText = '';
    vm.withText = false;
    vm.searchLikes = [
      "name"
    ];

    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
        $log.log('enterFunction', keyEvent);
        vm.searchText(vm.itemsText);
      }
    };

    vm.searchText = function(text) {
      $log.log('text', text);
      vm.itemsText = text;

      if(vm.itemsText == ''){
        $log.log('nothing');
        vm.withText = false;
        vm.loadItems(0);
      }else{
        $log.log('text text');
        vm.withText = true;
        vm.loadItems(0);
      }
    };

    // Lista

    vm.editModule = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.admin.clients.client', {id: vm.itemToGo});
    };

    vm.deleteModule = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteOk(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };

    vm.deleteOk = function(index){
      $log.log('index', index);
      vm.itemToDelete = vm.items[index].id;

      Client.deleteById({id: vm.itemToDelete},
        function(itemDeleted){
          vm.itemDeleted = itemDeleted;
          $log.log("ItemDeleted", vm.itemDeleted);

          vm.items.splice(index, 1);

          if(vm.items.length == 0){
            vm.paginationFor = 0;
          }
        },
        function(err){
          $log.log(err);
        });
    };

    vm.limit = 50;
    vm.paginationFor = 0;

    vm.loadItems = function(skip) {

      vm.filterItems = {
        filter:{
          where: {},
          skip: skip*vm.limit,
          limit: vm.limit,
          order: "name ASC"
        }
      };

      vm.filterItemsQuantity = {
        where:{}
      };

      if(vm.withText){
        $log.log('vm.itemsText', vm.itemsText);

        vm.searchInputString = angular.copy(vm.itemsText);
        var stringsArray = vm.searchInputString.split(" ");

        vm.filterItems.filter.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        vm.filterItemsQuantity.where = {
          and:[
            {
              or:[]
            }
          ]
        };

        for(var a = 0; a < stringsArray.length; a++){
          var word = stringsArray[a];

          for (var x = 0; x < vm.searchLikes.length; x++) {
            var objects = {};

            objects[vm.searchLikes[x]] = {
              like: word,
              options: 'i'
            };

            vm.filterItems.filter.where.and[0].or.push(angular.copy(objects));
            vm.filterItemsQuantity.where.and[0].or.push(angular.copy(objects));
          }
        }
      }

      $log.log('filterItems', vm.filterItems);
      $log.log('filterItemsQuantity', vm.filterItemsQuantity);

      Client.count(
        vm.filterItemsQuantity,
        function (quantityItems) {
          vm.quantityItems = quantityItems;
          $log.log('quantityItems', vm.quantityItems.count);
          vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
          vm.paginationOptions = [];

          if(vm.quantityItems.count != 0){
            if(vm.quantityItems.count % vm.limit != 0){
              vm.paginationFor =  vm.paginationFor + 1;
            }

            for(var n=0; n<vm.paginationFor; n++){
              vm.paginationOptions.push(n+1);
            }

            $log.log('vm.paginationOptions', vm.paginationOptions);
            vm.paginationOptions = vm.paginationOptions;
          }

          $log.log('vm.paginationFor', vm.paginationFor);
          $log.log('vm.paginationOptions', vm.paginationOptions);

          vm.paginationOptions = vm.paginationOptions;
          vm.paginationFor = vm.paginationFor;

        },
        function (err) {
          $log.log(err);
        });

      Client.find(
        vm.filterItems,
        function (items) {
          vm.items = items;
          $log.log('vm.items', vm.items);
          vm.spinnerFlag = false;
        },
        function (err) {
          $log.log(err);
        });

    };

    // Pagination Seleccion
    vm.paginationOptions = [];
    vm.pageSelected = 1;

    vm.changeRight = function(){
      $log.log('vm.changeRight');

      if(vm.paginationOptions.length != 1){
        vm.pageSelected =  vm.pageSelected + 1;
        if(vm.paginationOptions.length < vm.pageSelected){
          vm.pageSelected = vm.paginationOptions.length;
        }

        $log.log('vm.pageSelected', vm.pageSelected);
        vm.loadItems(vm.pageSelected-1);
      }

    };

    vm.changeLeft = function(){
      $log.log('vm.changeLeft');

      if(vm.paginationOptions.length != 1){
        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected - 1;
          if(vm.pageSelected < 1){
            vm.pageSelected = 1;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }
      }
    };

    vm.changePage = function(pageIndex){
      $log.log('pageIndex', pageIndex);
      vm.pageSelected = pageIndex;
      vm.loadItems(pageIndex-1);
    };

    // Buscar compañia

    vm.getAppUserData = function(){

      //  AppUser, Company

      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          vm.loadItems(0);

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();


  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.admins.all', {
      url: "/all",
      views: {
        admins:{
          templateUrl: "app/main/admin/admins/all/all.html"
        }
      },
      data: {
        pageTitle: 'All Admins Admin'
      }
    });
  })
  .controller('AllAdminsAdminController', function ($log, $window, $state, $scope, AppUser) {

    $log.log('All Admins Admin');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    vm.today = new Date();

    // Variable Spinner
    vm.spinnerFlag = true;

    // Crear nuevo administrador
    vm.create = function(){
      $log.log('create new user');
      $state.go('main.admin.admins.admin', {id: 'new'});
    };

    // Buscador
    vm.itemsText = '';
    vm.withText = false;
    vm.searchLikes = [
      "fullName"
    ];

    vm.enterFunction = function(keyEvent) {
      if (keyEvent.which === 13){
        $log.log('enterFunction', keyEvent);
        vm.searchText(vm.itemsText);
      }
    };

    vm.searchText = function(text) {
      $log.log('text', text);
      vm.itemsText = text;

      if(vm.itemsText == ''){
        $log.log('nothing');
        vm.withText = false;
        vm.loadItems(0);
      }else{
        $log.log('text text');
        vm.withText = true;
        vm.loadItems(0);
      }
    };

    // Lista

    // Editar Admin
    vm.editModule = function(index){
      $log.log('editModule');
      $log.log('index', index);
      vm.itemToGo = vm.items[index].id;
      $state.go('main.admin.admins.admin', {id: vm.itemToGo});
    };

    // Eliminar Admin
    vm.deleteModule = function(index){
      $log.log("Item to Delete");
      swal({
          title: "Estas seguro?",
          text: "Si lo elmininas no hay manera de volver a recuperarlo",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No!",
          closeOnConfirm: false,
          closeOnCancel: false },
        function(isConfirm){
          if (isConfirm) {
            swal("Eliminado", "", "");
            vm.deleteOk(index);
          } else {
            swal("Cancelado", "", "");
          }
        });
    };

    vm.deleteOk = function(index){
      $log.log('index', index);
      vm.itemToDelete = vm.items[index].id;

      AppUser.deleteById({id: vm.itemToDelete},
        function(itemDeleted){
          vm.itemDeleted = itemDeleted;
          $log.log("ItemDeleted", vm.itemDeleted);

          vm.items.splice(index, 1);

          if(vm.items.length == 0){
            vm.paginationFor = 0;
          }
        },
        function(err){
          $log.log(err);
        });
    };

    vm.limit = 50;
    vm.paginationFor = 0;

    vm.loadItems = function(skip) {

      vm.filterItems = {
        filter:{
          where: {
            role: 'Admin General'
          },
          skip: skip*vm.limit,
          limit: vm.limit,
          order: "fullName ASC"
        }
      };

      vm.filterItemsQuantity = {
        where:{
          role: 'Admin General'
        }
      };

      if(vm.withText){
        $log.log('vm.itemsText', vm.itemsText);

        vm.searchInputString = angular.copy(vm.itemsText);
        var stringsArray = vm.searchInputString.split(" ");

        vm.filterItems.filter.where = {
          and:[
            {
              or:[]
            },
            {
              isAdmin: true
            }
          ]
        };

        vm.filterItemsQuantity.where = {
          and:[
            {
              or:[]
            },
            {
              isAdmin: true
            }
          ]
        };

        for(var a = 0; a < stringsArray.length; a++){
          var word = stringsArray[a];

          for (var x = 0; x < vm.searchLikes.length; x++) {
            var objects = {};

            objects[vm.searchLikes[x]] = {
              like: word,
              options: 'i'
            };

            vm.filterItems.filter.where.and[0].or.push(angular.copy(objects));
            vm.filterItemsQuantity.where.and[0].or.push(angular.copy(objects));
          }
        }
      }

      $log.log('filterItems', vm.filterItems);
      $log.log('filterItemsQuantity', vm.filterItemsQuantity);

      AppUser.count(
        vm.filterItemsQuantity,
        function (quantityItems) {
          vm.quantityItems = quantityItems;
          $log.log('quantityItems', vm.quantityItems.count);
          vm.paginationFor =  Math.floor(vm.quantityItems.count / vm.limit);
          vm.paginationOptions = [];

          if(vm.quantityItems.count != 0){
            if(vm.quantityItems.count % vm.limit != 0){
              vm.paginationFor =  vm.paginationFor + 1;
            }

            for(var n=0; n<vm.paginationFor; n++){
              vm.paginationOptions.push(n+1);
            }

            $log.log('vm.paginationOptions', vm.paginationOptions);
            vm.paginationOptions = vm.paginationOptions;
          }

          $log.log('vm.paginationFor', vm.paginationFor);
          $log.log('vm.paginationOptions', vm.paginationOptions);

          vm.paginationOptions = vm.paginationOptions;
          vm.paginationFor = vm.paginationFor;

        },
        function (err) {
          $log.log(err);
        });

      AppUser.find(
        vm.filterItems,
        function (items) {
          vm.items = items;
          $log.log('vm.items', vm.items);
          vm.spinnerFlag = false;
        },
        function (err) {
          $log.log(err);
        });

    };

    // Pagination Seleccion
    vm.paginationOptions = [];
    vm.pageSelected = 1;

    vm.changeRight = function(){
      $log.log('vm.changeRight');

      if(vm.paginationOptions.length != 1){
        vm.pageSelected =  vm.pageSelected + 1;
        if(vm.paginationOptions.length < vm.pageSelected){
          vm.pageSelected = vm.paginationOptions.length;
        }

        $log.log('vm.pageSelected', vm.pageSelected);
        vm.loadItems(vm.pageSelected-1);
      }

    };

    vm.changeLeft = function(){
      $log.log('vm.changeLeft');

      if(vm.paginationOptions.length != 1){
        if(vm.paginationOptions.length != 1){
          vm.pageSelected =  vm.pageSelected - 1;
          if(vm.pageSelected < 1){
            vm.pageSelected = 1;
          }

          $log.log('vm.pageSelected', vm.pageSelected);
          vm.loadItems(vm.pageSelected-1);
        }
      }
    };

    vm.changePage = function(pageIndex){
      $log.log('pageIndex', pageIndex);
      vm.pageSelected = pageIndex;
      vm.loadItems(pageIndex-1);
    };

    // ----------- Block Page -----------------------------------------------------------------------//
    vm.blockPage = function(){
      $log.log('vm.blockPage()');
      $state.go('main.admin.blockPage');
    };

    // ----------- Access Granted -------------------------------------------------------------------//
    vm.accessGranted = function(){
      $log.log('vm.accessGranted()');
      vm.loadItems(0);
    };

    // Usuario Logeado
    vm.getAppUserData = function(){
      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userCompany){
          vm.userCompany = angular.copy(userCompany);
          $log.log("vm.user para buscar company", vm.userCompany);

          if(vm.userCompany.role == 'Trabajador'){
            vm.blockPage();
          }else if(vm.userCompany.role == 'Admin General'){
            vm.accessGranted();
          }else{
            vm.blockPage();
          }

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.admins.admin', {
      url: "/admin/:id",
      views: {
        admins:{
          templateUrl: "app/main/admin/admins/admin/admin.html"
        }
      },
      data: {
        pageTitle: 'Admin Admins Admin'
      }
    });
  })
  .controller('AdminAdminsAdminController', function ($log, $window, $state, $stateParams, $timeout, $scope, AppUser) {

    $log.log('Admin Admins Admin');

    // Subir la pantalla
    function scrollWin() {$window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    // Regresar a All Users
    vm.cancel = function(){
      $state.go('^.all');
    };

    // stateparameter
    $log.log('stateparameter', $stateParams);

    // Variables Generales
    vm.errorFlag = false;
    vm.createBlock = false;
    vm.states = [
      'Sinaloa',
      'Sonora'
    ];

    vm.roles = [
      'Admin General',
      'Operador'
    ];

    vm.stateFlag = false;

    // Crear Usuario
    vm.create = function(){
      vm.errorFlag = true;
      vm.createBlock = true;
      $log.log('user create', vm.user);

      if(vm.user.fullName == '' || vm.user.username == '' || vm.user.password == ''||
        vm.user.state == '' || vm.user.location == '' || vm.user.role == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
        vm.createBlock = false;
      }else{

        vm.user.isAdmin = false;

        AppUser.create(vm.user, function successSaveUser(datos){
          $log.log('created', datos);
          $state.go('^.all');
        },function errorSaveProduct(err){
          $log.log(err);
        });
      }

    };

    // Actualizar Usuario
    vm.update = function(){
      vm.errorFlag = true;
      vm.createBlock = true;

      if(vm.flagg.changePassword){
        vm.user.password = vm.newPassword;
      }

      $log.log('user update', vm.user);

      if(vm.user.fullName == '' || vm.user.username == '' || vm.user.password == ''||
        vm.user.state == '' || vm.user.location == '' || vm.user.role == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
        vm.createBlock = false;
      }else{

        vm.user.isAdmin = false;

        AppUser.prototype$patchAttributes(
          {id:  vm.user.id},
          vm.user, function (success){
            $log.log("Success", success);
            $state.go('^.all');
          }, function (err) {
            $log.log(err, 'error');
          });
      }

    };

    // Convertir a usuario
    vm.changeToUser = function(){

      vm.errorFlag = true;
      vm.createBlock = true;

      if(vm.flagg.changePassword){
        vm.user.password = vm.newPassword;
      }

      $log.log('user update', vm.user);

      if(vm.user.fullName == '' || vm.user.username == '' || vm.user.password == ''||
        vm.user.state == '' || vm.user.location == '' || vm.user.role == ''){
        sweetAlert("Oops...", "Te faltan campos por llenar", "error");
        vm.createBlock = false;
      }else{

        vm.user.isAdmin = false;
        vm.user.role = 'Trabajador';

        AppUser.prototype$patchAttributes(
          {id:  vm.user.id},
          vm.user, function (success){
            $log.log("Success", success);
            $state.go('^.all');
          }, function (err) {
            $log.log(err, 'error');
          });
      }


    };

    // Se selecciona el role para el User
    vm.selectState = function() {
      $log.log('selectState');
      vm.user.location = '';

      if(vm.user.state == ''){

      }else{
        vm.stateFlag = true;

        if(vm.user.state == 'Sinaloa'){
          vm.locations = [
            'Los Mochis Matriz',
            'Los Mochis Gaxiola',
            'Mochicahui',
            'El Carrizo',
            'Juan Jose Ríos',
            'Ruiz Cortines',
            'Leyva Solano',
            'Sinaloa de Leyva',
            'Guasave',
            'Guamuchil',
            'Culiacán',
            'Mazatlán'
          ];
        }else if(vm.user.state == 'Sonora'){
          vm.locations = [
            'Hermosillo'
          ];
        }
      }
    };

    vm.itemCreateUpdate = function(){

      // Depende de la $stateParams.id nos indica si vamos a crear una nueva PurchaseRequest
      // o vamos a actualizar una ya creada
      if($stateParams.id === 'new'){
        $log.log("New user");
        vm.flag = true;
        vm.user = {
          fullName: '',
          username: '',
          state: '',
          location: '',
          role: 'Admin General',
          fullEdit: false
        };
      }
      else{
        $log.log("Update user");
        vm.flag = false;
        vm.flagg = {};
        vm.flagg.changePassword = false;
        vm.newPassword = "";

        vm.stateFlag = true;

        AppUser.findOne({
            filter: {
              where:
                {
                  id: $stateParams.id
                }
            }
          },
          function(user){
            vm.user = angular.copy(user);

            $log.log("vm.user",  vm.user);

            if(vm.user.state == 'Sinaloa'){
              vm.locations = [
                'Los Mochis Matriz',
                'Los Mochis Gaxiola',
                'Mochicahui',
                'El Carrizo',
                'Juan Jose Ríos',
                'Ruiz Cortines',
                'Leyva Solano',
                'Sinaloa de Leyva',
                'Guasave',
                'Guamuchil',
                'Culiacán',
                'Mazatlán'
              ];
            }else if(vm.user.state == 'Sonora'){
              vm.locations = [
                'Hermosillo'
              ];
            }
          },
          function(err){
            $log.log(err);
          });

      }

    };

    // Usuario Logeado
    vm.getAppUserData = function(){
      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userCompany){
          vm.userCompany = angular.copy(userCompany);
          $log.log("vm.user para buscar company", vm.userCompany);
          vm.itemCreateUpdate();
        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();

  });




angular.module('common.directives.titleWidget', [])

  .directive('titleWidget', function () {

      return {
          scope:{
              config:"="
          },
          controller: 'TitleWidgetController as vm',
          templateUrl: 'app/components/common/directives/titleWidget/titleWidget.html'
      };

  })

  .controller('TitleWidgetController', function TitleWidgetController($log, $state, $scope) {

    $log.log('titleWidget', $scope.config);

    var vm = this;

    vm.addItemDirective = function(){
        $log.log('addItemDirective');
        $state.go($scope.config.state, {id: 'new'});
    };

      vm.style = $scope.config.style;

      vm.hoverIn = function() {
          $log.log('hoverIn');
          vm.style = $scope.config.styleHover;
      };

      vm.hoverOut = function() {
          $log.log('hoverOut');
          vm.style = $scope.config.style;
      };

  });


angular.module('common.directives.titleModel', [])

  .directive('titleModel', function () {

      return {
          scope:{
              config:"="
          },
          controller: 'TitleModelController as vm',
          templateUrl: 'app/components/common/directives/titleModel/titleModel.html'
      };

  })

  .controller('TitleModelController', function TitleWidgetController($log, $state, $scope) {

    $log.log('TitleModel', $scope.config);

    var vm = this;

    vm.addItemDirective = function(){
        $log.log('addItemDirective');

        if($scope.config.stateInfoFlag){
            $state.go($scope.config.state, {id: $scope.config.stateInfo});
        }else{
            $state.go($scope.config.state, {id: 'new'});
        }
    };

    vm.style = $scope.config.style;

    vm.hoverIn = function() {
      $log.log('hoverIn');
      vm.style = $scope.config.styleHover;
    };

    vm.hoverOut = function() {
      $log.log('hoverOut');
      vm.style = $scope.config.style;
    };

  });


angular.module('common.directives.showMessage', [])

  .directive('showMessage', function () {

      return {
          scope:{
              config:"="
          },
          controller: 'ShowMessageController as vm',
          templateUrl: 'app/components/common/directives/showMessage/showMessage.html'
      };

  })

  .controller('ShowMessageController', function ShowMessageController($log, $state, $scope) {

  });


angular.module('common.directives.searchList', [])

  .directive('searchList', function () {

      return {
          restrict: 'E',
          replace: true,
          scope:{
              paginationFor:"=",
              searchedItems:"=",
              somePlaceholder:"=",
              itemsText:"=",
              whenClick:"&"
          },
          templateUrl: 'app/components/common/directives/searchList/searchList.html'
      };

  })

  .controller('SearchListController', function FilterByController($log) {

    $log.log('searchList');


  });


angular.module('common.directives.printPDF', [])

  .directive('printPDF', function () {

      return {
          scope:{
              config:"="
          },
          controller: 'PrintPDFController',
          templateUrl: 'app/components/common/directives/printPDF/printPDF.html'
      };

  })

  .controller('PrintPDFController', function PrintPDFController($log, $state, $scope, $uibModalInstance, param) {

    $log.log('PrintPDFController');

    var vm = this;

    $log.log('param', param);

    vm.windowHeight = param.windowHeight;

    vm.pdf = param.image;
    $log.log('vm.pdf directive', vm.pdf);

    vm.cancel = function(){
        $uibModalInstance.dismiss('cancel');
    };

    vm.print = function(){

        $log.log('print');
        var iframe = document.getElementById('pdfName');
        var frm = iframe.contentWindow;
        frm.focus();
        frm.print();
    };

    vm.save = function(){
        $log.log('save');
        vm.nameFile = param.nameFile;
        param.doc.save(vm.nameFile);

    };

  });


angular.module('common.directives.listModel', [])

.directive('listModel', function () {

    return {
        scope:{
            config:"="
        },
        controller: 'ListModelController as vm',
        templateUrl: 'app/components/common/directives/listModel/listModel.html'
    };

})

.controller('ListModelController', function ListModelController($log, $scope) {

    $log.log('listModel', $scope.config);

    var vm = this;

    // Cuando le das enter a un input se ejecuta dicha dunción
    // el numero 13 indica el enter
    // ng-keypress="vm.enterFunction($event)"
    vm.enterFunction = function(keyEvent) {
        if (keyEvent.which === 13){
            $log.log('enterFunction', keyEvent);
            $scope.config.searchText($scope.config.itemsText);
        }
    };

    vm.changeRight = function(){
        $log.log('$scope.config.paginationOptions changeRight', $scope.config.paginationOptions);

        if($scope.config.paginationOptions.length != 1){
            $scope.config.pageSelected =  $scope.config.pageSelected + 1;
            if($scope.config.paginationOptions.length < $scope.config.pageSelected){
                $scope.config.pageSelected = $scope.config.paginationOptions.length;
            }

            $log.log('$scope.config.pageSelected', $scope.config.pageSelected);
            $scope.config.loadItems($scope.config.pageSelected-1);
        }

    };

    vm.changeLeft = function(){
        $log.log('$scope.config.paginationOptions changeLeft', $scope.config.paginationOptions);

        if($scope.config.paginationOptions.length != 1){
            if($scope.config.paginationOptions.length != 1){
                $scope.config.pageSelected =  $scope.config.pageSelected - 1;
                if($scope.config.pageSelected < 1){
                    $scope.config.pageSelected = 1;
                }

                $log.log('$scope.config.pageSelected', $scope.config.pageSelected);
                $scope.config.loadItems($scope.config.pageSelected-1);
            }
        }
    };

    vm.changePage = function(pageIndex){
        $log.log('pageIndex', pageIndex);
        $scope.config.pageSelected = pageIndex;
        $scope.config.loadItems(pageIndex-1);
    };

    vm.searchText = function(text) {
        $log.log('text', text);
        $scope.config.itemsText = text;

        if($scope.config.itemsText == ''){
            $log.log('nothing');
            $scope.config.withText = false;
            $scope.config.loadItems(0);
        }else{
            $log.log('text text');
            $scope.config.withText = true;
            $scope.config.loadItems(0);
        }
    };

    vm.filterList = function() {
        $log.log('filterList', vm.itemSelected);
        $scope.config.filterSelected = vm.itemSelected;
        $scope.config.loadItems(0);
    };

});



angular.module('common.directives.titleWidget', [])

  .directive('titleWidget', function () {

      return {
          restrict: 'E',
          replace: true,
          scope:{
              title:"@",
              icon:"@",
              iconButton:"@",
              buttonName:"@",
              addButton:"=",
              whenClickAdd:"&"
          },
          templateUrl: 'app/components/common/directives/titleWidget/titleWidget.html'
      };

  })

  .controller('TitleWidgetController', function FilterByController($log) {

    $log.log('titleWidget');


  });


angular.module('common.directives.indicatorWidget', [])

  .directive('indicatorWidget', function () {

      return {
          scope:{
              config:"="
          },
          controller: 'IndicatorWidgetController as vm',
          templateUrl: 'app/components/common/directives/indicatorWidget/indicatorWidget.html'
      };

  })

  .controller('IndicatorWidgetController', function IndicatorWidgetController($log, $scope, $state) {

      $log.log('indicatorWidget', $scope.config);
      var vm = this;

      vm.style = {"background-color" : "#313639"};

      vm.hoverIn = function() {
          $log.log('hoverIn');
          vm.style = {"background-color" : "#3d4347"};
      };

      vm.hoverOut = function() {
          $log.log('hoverOut');
          vm.style = {"background-color" : "#313639"};
      };

      vm.goTo = function() {
          $log.log('addItemDirective');
          if($scope.config.state != ''){
              if($scope.config.stateInfoFlag){
                  $state.go($scope.config.state, {id: $scope.config.stateInfo});
              }else{
                  $state.go($scope.config.state);
              }
          }else{
              $log.log('$scope.config.state', $scope.config.state);
          }
      };


  });


angular.module('common.directives.indicatorWidget3', [])

  .directive('indicatorWidget3', function () {

      return {
          scope:{
              config:"="
          },
          controller: 'IndicatorWidget3Controller as vm',
          templateUrl: 'app/components/common/directives/indicatorWidget3/indicatorWidget3.html'
      };

  })

  .controller('IndicatorWidget3Controller', function IndicatorWidgetController($log, $scope, $state) {

      $log.log('indicatorWidget', $scope.config);

      var vm = this;

      vm.style = $scope.config.style;

      vm.hoverIn = function() {
          $log.log('hoverIn');
          vm.style = $scope.config.styleHover;
      };

      vm.hoverOut = function() {
          $log.log('hoverOut');
          vm.style = $scope.config.style;
      };

      vm.goTo = function() {
          $log.log('addItemDirective');
          if($scope.config.state != ''){
              if($scope.config.stateInfoFlag){
                  $state.go($scope.config.state, {id: $scope.config.stateInfo});
              }else{
                  $state.go($scope.config.state);
              }
          }else{
              $log.log('$scope.config.state', $scope.config.state);
          }
      };


  });


angular.module('common.directives.googlePlacesDrawing', [])

  .directive('googlePlacesDrawing', function () {

      return {
          scope:{
              config:"="
          },
          controller: 'GooglePlacesDrawingController as vm',
          templateUrl: 'app/components/common/directives/googlePlacesDrawing/googlePlacesDrawing.html'
      };

  })

  .controller('GooglePlacesDrawingController', function GooglePlacesDrawingController($log, $scope) {

    $log.log('googlePlacesDrawing', $scope.config);

    var vm = this;
      // MAPA POLIGONOS

    $log.log('Maps Poligonos');

    // Inicializamos el mapa
    vm.initMap = function(){

      vm.mapRuba = new google.maps.Map(document.getElementById('mapRubaDirective'), {
          center: {
              lat: vm.lat,
              lng: vm.lng
          },
          zoom: 11
      });

      var drawingManager = new google.maps.drawing.DrawingManager({
          //drawingMode: google.maps.drawing.OverlayType.POLYGON,
          drawingControl: true,
          drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: ['polygon']
          },
          markerOptions: {icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'},
          polygonOptions: {
              strokeColor: '#FF0000',
              fillColor: '#FF0000',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillOpacity: 0.35,
              clickable: false,
              editable: true,
              zIndex: 1
          }
      });

      vm.makeMarker();

      drawingManager.setMap(vm.mapRuba);

      if($scope.config.mapCreated){
          drawingManager.setOptions({drawingControl: false});
          drawingManager.setOptions({drawingMode: null});

          // Construct the polygon.
          vm.bermudaTriangle = new google.maps.Polygon({
              paths: vm.limitsPolygonToAdd,
              strokeColor: '#FF0000',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              editable: true
          });
          vm.bermudaTriangle.setMap(vm.mapRuba);
      }

      google.maps.event.addListener(drawingManager, 'overlaycomplete', function(polygon) {

          $log.log('polygon', polygon);

          vm.polygon = polygon;
          vm.limitsPolygon = polygon.overlay.getPath().getArray();

          drawingManager.setOptions({drawingControl: false});
          drawingManager.setOptions({drawingMode: null});

          vm.getLimitsPolygon();
      });

    };

    // Conseguimos los limites del polígono dibujado
    vm.getLimitsPolygon = function(){

      vm.limitsPolygonToAdd = [];

      $log.log('vm.limitsPolygon', vm.limitsPolygon);
      for(var a=0; a<vm.limitsPolygon.length; a++){
          $log.log('a', a);
          $log.log('vm.limitsPolygon[a] lat', vm.limitsPolygon[a].toJSON().lat);
          $log.log('vm.limitsPolygon[a] lng', vm.limitsPolygon[a].toJSON().lng);

          var obj = {
              lat: vm.limitsPolygon[a].toJSON().lat,
              lng: vm.limitsPolygon[a].toJSON().lng
          };

          vm.limitsPolygonToAdd.push(angular.copy(obj));

          if(a==vm.limitsPolygon.length-1){
              $log.log('vm.limitsPolygonToAdd', vm.limitsPolygonToAdd);

              $scope.config.points = vm.limitsPolygonToAdd;
          }
      }
    };

    var options = {
      enableHighAccuracy: true
    };

    //Buscamos el lugar donde te encuentras e inicializamos el mapa
    vm.geolocation = function(){
      navigator.geolocation.getCurrentPosition(function(pos) {
              vm.position = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
              vm.lat = pos.coords.latitude;
              vm.lng = pos.coords.longitude;

              $log.log('lat', vm.lat);
              $log.log('lng', vm.lng);

              vm.initMap();
          },
          function(error) {
              alert('Unable to get location: ' + error.message);
          }, options);
    };

    // Autocomplete Input
    $scope.$on('g-places-autocomplete:select', function (event, param) {

        $log.log('g-places-autocomplete Directive');

        $log.log(event, param);
        $log.log('lat', param.geometry.location.toJSON().lat);
        $log.log('lng', param.geometry.location.toJSON().lng);
        $log.log('locationName', param.formatted_address);

        $scope.config.locationName =  param.formatted_address;
        vm.positions = [];
        $scope.config.lat = param.geometry.location.toJSON().lat;
        $scope.config.lng = param.geometry.location.toJSON().lng;

        vm.lat = param.geometry.location.toJSON().lat;
        vm.lng = param.geometry.location.toJSON().lng;
        vm.positions.push([vm.lat, vm.lng]);

        for(var i=0; i<param.address_components.length; i++){
            if(param.address_components[i].types[0] == 'administrative_area_level_1'){
                $scope.config.state = param.address_components[i].long_name;
            }else if(param.address_components[i].types[0] == 'locality'){
                $scope.config.municipality = param.address_components[i].long_name;
            }
        }

        $log.log('$scope.config.state', $scope.config.state);
        $log.log('$scope.config.municipality', $scope.config.municipality);

        vm.setCenter();

    });

    // Centramos el mapa dependendiendo del autocomplete
    vm.setCenter = function(){
      $log.log('vm.setCenter');

      vm.mapRuba.setCenter({
          lat: vm.lat,
          lng: vm.lng
      });

      vm.makeMarker();
    };

    // Reiniciar mapa
    vm.resetMap = function(){
        $scope.config.mapCreated = false;

        vm.initMap();
    };

    // Get PolygonLimits mapa
    vm.getMap = function(){

        $log.log('vm.getMap');

      if($scope.config.mapCreated) {
          vm.limitsPolygon = vm.bermudaTriangle.getPath().getArray();
          vm.getLimitsPolygon();
      }else{
          vm.limitsPolygon = vm.polygon.overlay.getPath().getArray();
          vm.getLimitsPolygon();
      }

    };

    $scope.config.getMap = function(){
      $log.log('vm.getMap');

      if($scope.config.mapCreated) {
          vm.limitsPolygon = vm.bermudaTriangle.getPath().getArray();
          vm.getLimitsPolygon();
      }else{
          vm.limitsPolygon = vm.polygon.overlay.getPath().getArray();
          vm.getLimitsPolygon();
      }
    };

    //Markers
    var marker;
    vm.firstMarker = false;

    vm.makeMarker = function() {

      if(!vm.firstMarker){

          marker = new google.maps.Marker({
              map: vm.mapRuba,
              animation: google.maps.Animation.DROP,
              position: {
                  lat: vm.lat,
                  lng: vm.lng
              }
          });

          vm.firstMarker = true;

      }else{
          marker.setMap(null);

          marker = new google.maps.Marker({
              map: vm.mapRuba,
              animation: google.maps.Animation.DROP,
              position: {
                  lat: vm.lat,
                  lng: vm.lng
              }
          });
      }

    };

    // Donde inicia todoO

    //$scope.config.mapCreated = false;

    vm.initAll = function(){

      $log.log('initAll');

      if($scope.config.mapCreated){
          $log.log('created already');

          vm.lat = $scope.config.lat;
          vm.lng = $scope.config.lng;

          vm.limitsPolygonToAdd = $scope.config.points;

          vm.place = $scope.config.locationName;

          vm.initMap();
      }else{

          $log.log('new to create');

          vm.geolocation();
      }

    };

    vm.initAll();

  });


angular.module('common.directives.filterBy', [])

  .directive('filterBy', function () {
      return {
          scope:{
              config:"="
          },
          controller: 'FilterByController as vm',
          templateUrl: 'app/components/common/directives/filterBy/filterBy.html'
      };

  })

  .controller('FilterByController', function FilterByController($log, $scope) {

    $log.log('filterBy');
    $log.log('config', $scope.config);

    var vm = this;
    vm.itemSelected = '';

    vm.selectFilter = function(){
        $log.log('vm.itemSelected', vm.itemSelected);
        $scope.config.funcFilter(vm.itemSelected);
    };


  });


angular.module('common.directives.googlePlaces', [])

  .directive('googlePlaces', function () {

      return {
          scope:{
              config:"="
          },
          controller: 'GooglePlacesController as vm',
          templateUrl: 'app/components/common/directives/googlePlaces/googlePlaces.html'
      };

  })

  .controller('GooglePlacesController', function GooglePlacesController($log, $scope) {

    $log.log('googlePlaces', $scope.config);

    var vm = this;
    var options = {
      enableHighAccuracy: true
    };

    $scope.$on('g-places-autocomplete:select', function (event, param) {
      $log.log('g-places-autocomplete Directive');

      $log.log(event, param);
      $log.log('lat', param.geometry.location.toJSON().lat);
      $log.log('lng', param.geometry.location.toJSON().lng);
      $log.log('locationName', param.formatted_address);

      $scope.config.locationName =  param.formatted_address;
      $scope.config.positions = [];
      $scope.config.lat = param.geometry.location.toJSON().lat;
      $scope.config.lng = param.geometry.location.toJSON().lng;

      $scope.config.latNumber = param.geometry.location.toJSON().lat;
      $scope.config.lngNumber = param.geometry.location.toJSON().lng;

      $scope.config.positions.push([$scope.config.lat, $scope.config.lng]);

        for(var i=0; i<param.address_components.length; i++){
            if(param.address_components[i].types[0] == 'administrative_area_level_1'){
                $scope.config.state = param.address_components[i].long_name;
            }else if(param.address_components[i].types[0] == 'administrative_area_level_2'){
                $scope.config.municipality = param.address_components[i].long_name;
            }
        }

        $log.log('$scope.config.state', $scope.config.state);
        $log.log('$scope.config.municipality', $scope.config.municipality);
    });

    if($scope.config.maps){
        navigator.geolocation.getCurrentPosition(function(pos) {
            vm.position = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            $log.log(pos.coords.latitude);
            $log.log(pos.coords.longitude);
            vm.lat = pos.coords.latitude;
            vm.lng = pos.coords.longitude;

            $scope.config.lat = vm.lat;
            $scope.config.lng = vm.lng;

            $scope.config.positions.push(vm.position);
        },
        function(error) {
            alert('Unable to get location: ' + error.message);
        }, options);
    }


  });


angular.module('common.directives.extras', [])

    // **DOCUMENTACIÓN:
    // se agregó la variable de contactsToInvite, esta variable contendrá la lista de usuarios (objetos) a invitar,
    // cada elemento del arreglo contiene un property name y un property email.

    .directive('extras', function () {
        return {
            scope: {
                config: '='
            },
            controller: 'ExtrasController',
            templateUrl: 'components/common/directives/extras/extras.html'
        }
    })

    .controller('ExtrasController', function ($log, $window, $state, $uibModalInstance, $scope, $rootScope, $timeout, param, AppUser, Brand, Cap, Confection, Embroidery, Laser, PoloShirt, Promotional, RoundShirt, Serigraphy, Setting, Shirt, Sublimation, Sweatshirt, Transfer, UserRole, Vinyl) {

        // Subir la pantalla
        function scrollWin() {
            window.scrollTo(0, 0);
        }
        scrollWin();

        var vm = this;
        var _timeout;

        $log.log('ExtrasController Directive');
        $log.log('param', param);

        vm.array = param.array;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.totalItems = [];

        vm.products = [
            'Bordado',
            'Serigrafía',
            'Transfer',
            'Vinil',
            'Sublimación',
            'Laser'
        ];

        vm.changeOptionWith = function(){
            $log.log('changeOptionWith', vm.optionWith);

            switch(vm.optionWith) {
                case 'Bordado':
                    vm.embroideryRequest();
                    break;
                case 'Serigrafía':
                    vm.serigraphyRequest();
                    break;
                case 'Transfer':
                    vm.transferRequest();
                    break;
                case 'Vinil':
                    vm.vinylRequest();
                    break;
                case 'Sublimación':
                    vm.sublimationRequest();
                    break;
                case 'Laser':
                    vm.laserRequest();
                    break;
                default:
                    break;
            }

        };


        // Seccion para Bordado
        //
        //
        //
        vm.embroideryRequest = function(){
            $log.log('embroideryRequest');

            vm.embroideryType = '';

            Embroidery.find({},
                function(embroideries){
                    vm.embroideries = embroideries;
                    $log.log("embroideries", vm.embroideries);

                    vm.embroideryTypes = [];
                    vm.embroideryTypesRepeat = [];

                    for (var a=0; a<vm.embroideries.length; a++) {
                        vm.embroideryTypesRepeat.push(vm.embroideries[a].type);

                        if (a==vm.embroideries.length-1){
                            $log.log("embroideryTypesRepeat", vm.embroideryTypesRepeat);

                            $.each(vm.embroideryTypesRepeat, function(i, el){
                                if($.inArray(el, vm.embroideryTypes) === -1) vm.embroideryTypes.push(el);
                            });

                            $log.log("embroideryTypes", vm.embroideryTypes);
                        }
                    }
                },
                function(err){
                    $log.log(err);
                });
        };

        vm.embroideryType = '';

        vm.changeEmbroideryType = function(){
            $log.log('changeEmbroideryType');
            $log.log('optionSelected', vm.optionSelected);
            $log.log('optionWith', vm.optionWith);
            $log.log('embroideryType', vm.embroideryType);
        };

        // Añadir Producto Bordado

        vm.quantityEmbroideries = 0;

        vm.addEmbroidery = function() {
            $log.log('addEmbroidery');
            // $log.log('optionSelected', vm.optionSelected);
            // $log.log('optionWith', vm.optionWith);
            // $log.log('embroideryType', vm.embroideryType);

            Embroidery.findOne({
                    filter: {
                        where: {
                            type: vm.embroideryType
                        }
                    }
                },
                function(embroideryToAdd){
                    vm.embroideryToAdd = embroideryToAdd;
                    $log.log("embroideryToAdd", vm.embroideryToAdd);
                    $log.log("vm.quantityEmbroideries", vm.quantityEmbroideries);

                    var objPriceEmbroidery = 0;
                    var rangeEmbroidery = 0;

                    if(5 >= vm.quantityEmbroideries && 1 < vm.quantityEmbroideries){
                        $log.log("1 a 5");
                        rangeEmbroidery = 0;
                    }else if(10 >= vm.quantityEmbroideries && 5 < vm.quantityEmbroideries){
                        $log.log("6 a 10");
                        rangeEmbroidery = 1;
                    }else if(20 >= vm.quantityEmbroideries && 10 < vm.quantityEmbroideries){
                        $log.log("11 a 20");
                        rangeEmbroidery = 2;
                    }else if(50 >= vm.quantityEmbroideries && 20 < vm.quantityEmbroideries){
                        $log.log("21 a 50");
                        rangeEmbroidery = 3;
                    }else if(200 >= vm.quantityEmbroideries && 50 < vm.quantityEmbroideries){
                        $log.log("51 a 200");
                        rangeEmbroidery = 4;
                    }else if(200 < vm.quantityEmbroideries){
                        $log.log("200 a mas");
                        rangeEmbroidery = 5;
                    }

                    var objDescriptionEmbroidery = '';

                    objDescriptionEmbroidery = angular.copy(vm.optionWith) + " " + angular.copy(vm.embroideryType);
                    objPriceEmbroidery = vm.embroideryToAdd.sale[rangeEmbroidery];

                    vm.itemToAdd = {
                        id: angular.copy(vm.embroideryToAdd.id),
                        quantity: angular.copy(vm.quantityEmbroideries),
                        description: angular.copy(objDescriptionEmbroidery),
                        price: angular.copy(objPriceEmbroidery),
                        priceTotal: angular.copy(objPriceEmbroidery*vm.quantityEmbroideries),
                        priceToChange: angular.copy(objPriceEmbroidery*vm.quantityEmbroideries)
                    };

                    vm.totalItems.push(vm.itemToAdd);

                    vm.calculateTotalPrice();
                },
                function(err){
                    $log.log(err);
                });
        };

        // Seccion para Transfer
        //
        //
        //
        vm.transferRequest = function(){
            $log.log('transferRequest');

            vm.transferBackground = '';
            vm.transferSize = '';

            Transfer.find({},
                function(transfers){
                    vm.transfers = transfers;
                    $log.log("transfers", vm.transfers);

                    vm.transferBackgrounds = [];
                    vm.transferBackgroundsRepeat = [];

                    for (var a=0; a<vm.transfers.length; a++) {
                        vm.transferBackgroundsRepeat.push(vm.transfers[a].background);

                        if (a==vm.transfers.length-1){
                            $log.log("transferBackgroundsRepeat", vm.transferBackgroundsRepeat);

                            $.each(vm.transferBackgroundsRepeat, function(i, el){
                                if($.inArray(el, vm.transferBackgrounds) === -1) vm.transferBackgrounds.push(el);
                            });

                            $log.log("transferBackgrounds", vm.transferBackgrounds);
                        }
                    }
                },
                function(err){
                    $log.log(err);
                });
        };

        vm.transferBackground = '';
        vm.transferSize = '';

        vm.changeTransferBackground = function(){
            $log.log('changeTransferBackground');
            $log.log('transferBackground', vm.transferBackground);
            vm.transferSize = '';

            vm.newTransferSizes = [];
            vm.transferSizes = [];
            vm.transferSizesRepeat = [];

            for (var a=0; a<vm.transfers.length; a++) {

                if(vm.transferBackground == vm.transfers[a].background) {
                    vm.transferSizesRepeat.push(vm.transfers[a].size);
                    vm.newTransferSizes.push(vm.transfers[a]);
                }

                if (a==vm.transfers.length-1){
                    $log.log("transferSizesRepeat", vm.transferSizesRepeat);

                    $.each(vm.transferSizesRepeat, function(i, el){
                        if($.inArray(el, vm.transferSizes) === -1) vm.transferSizes.push(el);
                    });

                    $log.log("transferSizes", vm.transferSizes);
                    $log.log("newTransferSizes", vm.newTransferSizes);

                }
            }

        };

        vm.changeTransferSize = function(){
            $log.log('transferSize');
            $log.log('optionSelected', vm.optionSelected);
            $log.log('optionWith', vm.optionWith);
            $log.log('transferBackground', vm.transferBackground);
            $log.log('transferSize', vm.transferSize);
        };

        // Añadir Producto Transfer

        vm.quantityTransfers = 0;

        vm.addTransfer = function() {
            $log.log('addTransfer');
            // $log.log('optionSelected', vm.optionSelected);
            // $log.log('optionWith', vm.optionWith);
            // $log.log('transferBackground', vm.transferBackground);
            // $log.log('transferSize', vm.transferSize);

            Transfer.findOne({
                    filter: {
                        where: {
                            background: vm.transferBackground,
                            size: vm.transferSize
                        }
                    }
                },
                function(transferToAdd){
                    vm.transferToAdd = transferToAdd;
                    $log.log("transferToAdd", vm.transferToAdd);
                    $log.log("vm.quantityTransfers", vm.quantityTransfers);

                    var objPriceTransfer = 0;
                    var rangeTransfer = 0;

                    if(5 >= vm.quantityTransfers && 1 < vm.quantityTransfers){
                        $log.log("1 a 5");
                        rangeTransfer = 0;
                    }else if(10 >= vm.quantityTransfers && 5 < vm.quantityTransfers){
                        $log.log("6 a 10");
                        rangeTransfer = 1;
                    }else if(20 >= vm.quantityTransfers && 10 < vm.quantityTransfers){
                        $log.log("11 a 20");
                        rangeTransfer = 2;
                    }else if(50 >= vm.quantityTransfers && 20 < vm.quantityTransfers){
                        $log.log("21 a 50");
                        rangeTransfer = 3;
                    }else if(200 >= vm.quantityTransfers && 50 < vm.quantityTransfers){
                        $log.log("51 a 200");
                        rangeTransfer = 4;
                    }else if(200 < vm.quantityTransfers){
                        $log.log("200 a mas");
                        rangeTransfer = 5;
                    }

                    var objDescriptionTransfer = '';

                    objDescriptionTransfer = angular.copy(vm.optionWith) + " " + angular.copy(vm.transferBackground)
                        + " " + angular.copy(vm.transferSize);
                    objPriceTransfer = vm.transferToAdd.saleAlone[rangeTransfer];

                    vm.itemToAdd = {
                        id: angular.copy(vm.transferToAdd.id),
                        quantity: angular.copy(vm.quantityTransfers),
                        description: angular.copy(objDescriptionTransfer),
                        price: angular.copy(objPriceTransfer),
                        priceTotal: angular.copy(objPriceTransfer*vm.quantityTransfers),
                        priceToChange: angular.copy(objPriceTransfer*vm.quantityTransfers)
                    };

                    vm.totalItems.push(vm.itemToAdd);

                    vm.calculateTotalPrice();
                },
                function(err){
                    $log.log(err);
                });
        };

        // Seccion para Sublimation
        //
        //
        //
        vm.sublimationRequest = function(){
            $log.log('sublimationRequest');

            vm.sublimationSize = '';

            Sublimation.find({},
                function(sublimations){
                    vm.sublimations = sublimations;
                    $log.log("sublimations", vm.sublimations);

                    vm.sublimationSizes = [];
                    vm.sublimationSizesRepeat = [];

                    for (var a=0; a<vm.sublimations.length; a++) {
                        vm.sublimationSizesRepeat.push(vm.sublimations[a].size);

                        if (a==vm.sublimations.length-1){
                            $log.log("sublimationSizesRepeat", vm.sublimationSizesRepeat);

                            $.each(vm.sublimationSizesRepeat, function(i, el){
                                if($.inArray(el, vm.sublimationSizes) === -1) vm.sublimationSizes.push(el);
                            });

                            $log.log("sublimationSizes", vm.sublimationSizes);
                        }
                    }
                },
                function(err){
                    $log.log(err);
                });
        };

        vm.sublimationSize = '';

        vm.changeSublimationSize = function(){
            $log.log('changeSublimationSize');
            $log.log('optionSelected', vm.optionSelected);
            $log.log('optionWith', vm.optionWith);
            $log.log('sublimationSize', vm.sublimationSize);
        };

        // Añadir Producto Sublimation

        vm.quantitySublimations = 0;

        vm.addSublimation = function() {
            $log.log('addSublimation');
            // $log.log('optionSelected', vm.optionSelected);
            // $log.log('optionWith', vm.optionWith);
            // $log.log('sublimationSize', vm.sublimationSize);

            Sublimation.findOne({
                    filter: {
                        where: {
                            size: vm.sublimationSize
                        }
                    }
                },
                function(sublimationToAdd){
                    vm.sublimationToAdd = sublimationToAdd;
                    $log.log("sublimationToAdd", vm.sublimationToAdd);
                    $log.log("vm.quantitySublimations", vm.quantitySublimations);

                    var objPriceSublimation = 0;
                    var rangeSublimation = 0;

                    if(5 >= vm.quantitySublimations && 1 < vm.quantitySublimations){
                        $log.log("1 a 5");
                        rangeSublimation = 0;
                    }else if(10 >= vm.quantitySublimations && 5 < vm.quantitySublimations){
                        $log.log("6 a 10");
                        rangeSublimation = 1;
                    }else if(20 >= vm.quantitySublimations && 10 < vm.quantitySublimations){
                        $log.log("11 a 20");
                        rangeSublimation = 2;
                    }else if(50 >= vm.quantitySublimations && 20 < vm.quantitySublimations){
                        $log.log("21 a 50");
                        rangeSublimation = 3;
                    }else if(200 >= vm.quantitySublimations && 50 < vm.quantitySublimations){
                        $log.log("51 a 200");
                        rangeSublimation = 4;
                    }else if(200 < vm.quantitySublimations){
                        $log.log("200 a mas");
                        rangeSublimation = 5;
                    }

                    var objDescriptionSublimation = '';

                    objDescriptionSublimation = angular.copy(vm.optionWith) + " " + angular.copy(vm.laserSize);
                    objPriceSublimation = vm.sublimationToAdd.saleAlone[rangeSublimation];

                    vm.itemToAdd = {
                        id: angular.copy(vm.sublimationToAdd.id),
                        quantity: angular.copy(vm.quantitySublimations),
                        description: angular.copy(objDescriptionSublimation),
                        price: angular.copy(objPriceSublimation),
                        priceTotal: angular.copy(objPriceSublimation*vm.quantitySublimations),
                        priceToChange: angular.copy(objPriceSublimation*vm.quantitySublimations)
                    };

                    vm.totalItems.push(vm.itemToAdd);

                    vm.calculateTotalPrice();
                },
                function(err){
                    $log.log(err);
                });
        };

        // Seccion para Laser
        //
        //
        //
        vm.laserRequest = function(){
            $log.log('laserRequest');

            vm.laserSize = '';

            Laser.find({},
                function(lasers){
                    vm.lasers = lasers;
                    $log.log("lasers", vm.lasers);

                    vm.laserSizes = [];
                    vm.laserSizesRepeat = [];

                    for (var a=0; a<vm.lasers.length; a++) {
                        vm.laserSizesRepeat.push(vm.lasers[a].size);

                        if (a==vm.lasers.length-1){
                            $log.log("laserSizesRepeat", vm.laserSizesRepeat);

                            $.each(vm.laserSizesRepeat, function(i, el){
                                if($.inArray(el, vm.laserSizes) === -1) vm.laserSizes.push(el);
                            });

                            $log.log("laserSizes", vm.laserSizes);
                        }
                    }
                },
                function(err){
                    $log.log(err);
                });
        };

        vm.laserSize = '';

        vm.changeLaserSize = function(){
            $log.log('changeLaserSize');
            $log.log('optionSelected', vm.optionSelected);
            $log.log('optionWith', vm.optionWith);
            $log.log('laserSize', vm.laserSize);
        };

        // Añadir Producto Laser

        vm.quantityLasers = 0;

        vm.addLaser = function() {
            $log.log('addLaser');
            // $log.log('optionSelected', vm.optionSelected);
            // $log.log('optionWith', vm.optionWith);
            // $log.log('laserSize', vm.laserSize);

            Laser.findOne({
                    filter: {
                        where: {
                            size: vm.laserSize
                        }
                    }
                },
                function(laserToAdd){
                    vm.laserToAdd = laserToAdd;
                    $log.log("laserToAdd", vm.laserToAdd);
                    $log.log("vm.quantityLasers", vm.quantityLasers);

                    var objPriceLaser = 0;
                    var rangeLaser = 0;

                    if(5 >= vm.quantityLasers && 1 < vm.quantityLasers){
                        $log.log("1 a 5");
                        rangeLaser = 0;
                    }else if(10 >= vm.quantityLasers && 5 < vm.quantityLasers){
                        $log.log("6 a 10");
                        rangeLaser = 1;
                    }else if(20 >= vm.quantityLasers && 10 < vm.quantityLasers){
                        $log.log("11 a 20");
                        rangeLaser = 2;
                    }else if(50 >= vm.quantityLasers && 20 < vm.quantityLasers){
                        $log.log("21 a 50");
                        rangeLaser = 3;
                    }else if(200 >= vm.quantityLasers && 50 < vm.quantityLasers){
                        $log.log("51 a 200");
                        rangeLaser = 4;
                    }else if(200 < vm.quantityLasers){
                        $log.log("200 a mas");
                        rangeLaser = 5;
                    }

                    var objDescriptionLaser = '';

                    objDescriptionLaser = angular.copy(vm.optionWith) + " " + angular.copy(vm.laserSize);
                    objPriceLaser = vm.laserToAdd.sale[rangeLaser];

                    vm.itemToAdd = {
                        id: angular.copy(vm.laserToAdd.id),
                        quantity: angular.copy(vm.quantityLasers),
                        description: angular.copy(objDescriptionLaser),
                        price: angular.copy(objPriceLaser),
                        priceTotal: angular.copy(objPriceLaser*vm.quantityLasers),
                        priceToChange: angular.copy(objPriceLaser*vm.quantityLasers)
                    };

                    vm.totalItems.push(vm.itemToAdd);

                    vm.calculateTotalPrice();
                },
                function(err){
                    $log.log(err);
                });
        };

        // Seccion para Vinil
        //
        //
        //
        vm.vinylRequest = function(){
            $log.log('vinylRequest');

            vm.vinylColor = '';
            vm.vinylNumberColor = '';
            vm.vinylSize = '';

            Vinyl.find({},
                function(vinyls){
                    vm.vinyls = vinyls;
                    $log.log("vinyls", vm.vinyls);

                    vm.vinylColors = [];
                    vm.vinylColorsRepeat = [];

                    for (var a=0; a<vm.vinyls.length; a++) {
                        vm.vinylColorsRepeat.push(vm.vinyls[a].color);

                        if (a==vm.vinyls.length-1){
                            $log.log("vinylColorsRepeat", vm.vinylColorsRepeat);

                            $.each(vm.vinylColorsRepeat, function(i, el){
                                if($.inArray(el, vm.vinylColors) === -1) vm.vinylColors.push(el);
                            });

                            $log.log("vinylColors", vm.vinylColors);
                        }
                    }
                },
                function(err){
                    $log.log(err);
                });
        };

        vm.vinylColor = '';
        vm.vinylNumberColor = '';
        vm.vinylSize = '';

        vm.changeVinylColor = function(){
            $log.log('changeVinylColor');
            $log.log('vinylColor', vm.vinylColor);
            vm.vinylNumberColor = '';
            vm.vinylSize = '';

            vm.newVinylNumberColors = [];
            vm.vinylNumberColors = [];
            vm.vinylNumberColorsRepeat = [];

            for (var a=0; a<vm.vinyls.length; a++) {

                if(vm.vinylColor == vm.vinyls[a].color) {
                    vm.vinylNumberColorsRepeat.push(vm.vinyls[a].numberColors);
                    vm.newVinylNumberColors.push(vm.vinyls[a]);
                }

                if (a==vm.vinyls.length-1){
                    $log.log("vinylNumberColorsRepeat", vm.vinylNumberColorsRepeat);

                    $.each(vm.vinylNumberColorsRepeat, function(i, el){
                        if($.inArray(el, vm.vinylNumberColors) === -1) vm.vinylNumberColors.push(el);
                    });

                    $log.log("vinylNumberColors", vm.vinylNumberColors);
                    $log.log("newVinylNumberColors", vm.newVinylNumberColors);

                }
            }

        };

        vm.changeVinylNumberColor = function(){
            $log.log('changeVinylNumberColor');
            $log.log('vinylNumberColor', vm.vinylNumberColor);
            vm.vinylSize = '';

            vm.newVinylSize = [];
            vm.vinylSizes = [];
            vm.vinylSizesRepeat = [];

            for (var a=0; a<vm.newVinylNumberColors.length; a++) {

                if(vm.vinylNumberColor == vm.newVinylNumberColors[a].numberColors) {
                    vm.vinylSizesRepeat.push(vm.newVinylNumberColors[a].size);
                    vm.newVinylSize.push(vm.newVinylNumberColors[a]);
                }

                if (a==vm.newVinylNumberColors.length-1){
                    $log.log("vinylSizesRepeat", vm.vinylSizesRepeat);

                    $.each(vm.vinylSizesRepeat, function(i, el){
                        if($.inArray(el, vm.vinylSizes) === -1) vm.vinylSizes.push(el);
                    });

                    $log.log("vinylSizes", vm.vinylSizes);
                    $log.log("newVinylSize", vm.newVinylSize);

                }
            }
        };

        vm.changeVinylSize = function(){
            $log.log('changeVinylSize');
            $log.log('optionSelected', vm.optionSelected);
            $log.log('optionWith', vm.optionWith);
            $log.log('vinylColor', vm.vinylColor);
            $log.log('vinylNumberColor', vm.vinylNumberColor);
            $log.log('vinylSize', vm.vinylSize);
        };

        // Añadir Producto Vinil

        vm.quantityVinyls = 0;

        vm.addVinyl = function() {
            $log.log('addVinyl');
            // $log.log('optionSelected', vm.optionSelected);
            // $log.log('optionWith', vm.optionWith);
            // $log.log('vinylColor', vm.vinylColor);
            // $log.log('vinylNumberColor', vm.vinylNumberColor);
            // $log.log('vinylSize', vm.vinylSize);

            Vinyl.findOne({
                    filter: {
                        where: {
                            color: vm.vinylColor,
                            numberColors: vm.vinylNumberColor,
                            size: vm.vinylSize
                        }
                    }
                },
                function(vinylToAdd){
                    vm.vinylToAdd = vinylToAdd;
                    $log.log("vinylToAdd", vm.vinylToAdd);
                    $log.log("vm.quantityVinyls", vm.quantityVinyls);

                    var objPriceVinyl = 0;
                    var rangeVinyl = 0;

                    if(5 >= vm.quantityVinyls && 1 < vm.quantityVinyls){
                        $log.log("1 a 5");
                        rangeVinyl = 0;
                    }else if(10 >= vm.quantityVinyls && 5 < vm.quantityVinyls){
                        $log.log("6 a 10");
                        rangeVinyl = 1;
                    }else if(20 >= vm.quantityVinyls && 10 < vm.quantityVinyls){
                        $log.log("11 a 20");
                        rangeVinyl = 2;
                    }else if(50 >= vm.quantityVinyls && 20 < vm.quantityVinyls){
                        $log.log("21 a 50");
                        rangeVinyl = 3;
                    }else if(200 >= vm.quantityVinyls && 50 < vm.quantityVinyls){
                        $log.log("51 a 200");
                        rangeVinyl = 4;
                    }else if(200 < vm.quantityVinyls){
                        $log.log("200 a mas");
                        rangeVinyl = 5;
                    }

                    var objDescriptionVinyl = '';

                    objDescriptionVinyl = angular.copy(vm.optionWith) + " "  +
                        angular.copy(vm.vinylColor) + " " + angular.copy(vm.vinylNumberColor) + " " +
                        angular.copy(vm.vinylSize);
                    objPriceVinyl = vm.vinylToAdd.saleAlone[rangeVinyl];

                    vm.itemToAdd = {
                        id: angular.copy(vm.vinylToAdd.id),
                        quantity: angular.copy(vm.quantityVinyls),
                        description: angular.copy(objDescriptionVinyl),
                        price: angular.copy(objPriceVinyl),
                        priceTotal: angular.copy(objPriceVinyl*vm.quantityVinyls),
                        priceToChange: angular.copy(objPriceVinyl*vm.quantityVinyls)
                    };

                    vm.totalItems.push(vm.itemToAdd);

                    vm.calculateTotalPrice();
                },
                function(err){
                    $log.log(err);
                });
        };

        // Seccion para Serigraphy
        //
        //
        //
        vm.serigraphyRequest = function(){
            $log.log('promotionalRequest');

            vm.serigraphyBackground = '';
            vm.serigraphyInk = '';
            vm.serigraphyType = '';

            Serigraphy.find({},
                function(serigraphys){
                    vm.serigraphys = serigraphys;
                    $log.log("serigraphys", vm.serigraphys);

                    vm.serigraphyBackgrounds = [];
                    vm.serigraphyBackgroundsRepeat = [];

                    for (var a=0; a<vm.serigraphys.length; a++) {
                        vm.serigraphyBackgroundsRepeat.push(vm.serigraphys[a].background);

                        if (a==vm.serigraphys.length-1){
                            $log.log("serigraphyBackgroundsRepeat", vm.serigraphyBackgroundsRepeat);

                            $.each(vm.serigraphyBackgroundsRepeat, function(i, el){
                                if($.inArray(el, vm.serigraphyBackgrounds) === -1) vm.serigraphyBackgrounds.push(el);
                            });

                            $log.log("serigraphyBackgrounds", vm.serigraphyBackgrounds);
                        }
                    }
                },
                function(err){
                    $log.log(err);
                });
        };

        vm.serigraphyBackground = '';
        vm.serigraphyInk = '';
        vm.serigraphyType = '';

        vm.changeSerigraphyBackground = function(){
            $log.log('changeSerigraphyBackground');
            $log.log('serigraphyBackground', vm.serigraphyBackground);
            vm.serigraphyInk = '';
            vm.serigraphyType = '';

            vm.newSerigraphyBackground = [];
            vm.serigraphyInks = [];
            vm.serigraphyInksRepeat = [];

            for (var a=0; a<vm.serigraphys.length; a++) {

                if(vm.serigraphyBackground == vm.serigraphys[a].background) {
                    vm.serigraphyInksRepeat.push(vm.serigraphys[a].numberInks);
                    vm.newSerigraphyBackground.push(vm.serigraphys[a]);
                }

                if (a==vm.serigraphys.length-1){
                    $log.log("serigraphyInksRepeat", vm.serigraphyInksRepeat);

                    $.each(vm.serigraphyInksRepeat, function(i, el){
                        if($.inArray(el, vm.serigraphyInks) === -1) vm.serigraphyInks.push(el);
                    });

                    $log.log("serigraphyInks", vm.serigraphyInks);
                    $log.log("newSerigraphyBackground", vm.newSerigraphyBackground);

                }
            }

        };

        vm.changeSerigraphyInks = function(){
            $log.log('changeSerigraphyInks');
            $log.log('serigraphyInk', vm.serigraphyInk);
            vm.serigraphyType = '';

            vm.newSerigraphyInk = [];
            vm.serigraphyTypes = [];
            vm.serigraphyTypesRepeat = [];

            for (var a=0; a<vm.newSerigraphyBackground.length; a++) {

                if(vm.serigraphyInk == vm.newSerigraphyBackground[a].numberInks) {
                    vm.serigraphyTypesRepeat.push(vm.newSerigraphyBackground[a].type);
                    vm.newSerigraphyInk.push(vm.newSerigraphyBackground[a]);
                }

                if (a==vm.newSerigraphyBackground.length-1){
                    $log.log("serigraphyTypesRepeat", vm.serigraphyTypesRepeat);

                    $.each(vm.serigraphyTypesRepeat, function(i, el){
                        if($.inArray(el, vm.serigraphyTypes) === -1) vm.serigraphyTypes.push(el);
                    });

                    $log.log("serigraphyTypes", vm.serigraphyTypes);
                    $log.log("newPromotionalModel", vm.newPromotionalModel);

                }
            }
        };

        vm.changeSerigraphyType = function(){
            $log.log('changeSerigraphyType');
            $log.log('optionSelected', vm.optionSelected);
            $log.log('optionWith', vm.optionWith);
            $log.log('serigraphyBackground', vm.serigraphyBackground);
            $log.log('serigraphyInk', vm.serigraphyInk);
            $log.log('serigraphyType', vm.serigraphyType);
        };

        // Añadir Producto Serigraphy

        vm.quantitySerigraphys = 0;

        vm.addSerigraphy = function() {
            $log.log('addSerigraphy');
            // $log.log('optionSelected', vm.optionSelected);
            // $log.log('optionWith', vm.optionWith);
            // $log.log('serigraphyBackground', vm.serigraphyBackground);
            // $log.log('serigraphyInk', vm.serigraphyInk);
            // $log.log('serigraphyType', vm.serigraphyType);

            Serigraphy.findOne({
                    filter: {
                        where: {
                            background: vm.serigraphyBackground,
                            numberInks: vm.serigraphyInk,
                            type: vm.serigraphyType
                        }
                    }
                },
                function(serigraphyToAdd){
                    vm.serigraphyToAdd = serigraphyToAdd;
                    $log.log("serigraphyToAdd", vm.serigraphyToAdd);
                    $log.log("vm.quantitySerigraphys", vm.quantitySerigraphys);

                    var objPriceSerigraphy = 0;
                    var rangeSerigraphy = 0;

                    if(10 >= vm.quantitySerigraphys && 1 < vm.quantitySerigraphys){
                        $log.log("1 a 10");
                        rangeSerigraphy = 0;
                    }else if(20 >= vm.quantitySerigraphys && 10 < vm.quantitySerigraphys){
                        $log.log("11 a 20");
                        rangeSerigraphy = 1;
                    }else if(30 >= vm.quantitySerigraphys && 20 < vm.quantitySerigraphys){
                        $log.log("21 a 30");
                        rangeSerigraphy = 2;
                    }else if(40 >= vm.quantitySerigraphys && 30 < vm.quantitySerigraphys){
                        $log.log("31 a 40");
                        rangeSerigraphy = 3;
                    }else if(50 >= vm.quantitySerigraphys && 40 < vm.quantitySerigraphys){
                        $log.log("41 a 50");
                        rangeSerigraphy = 4;
                    }else if(50 < vm.quantitySerigraphys){
                        $log.log("50 a mas");
                        rangeSerigraphy = 4;
                    }

                    var objDescriptionSerigraphy = '';

                    objDescriptionSerigraphy = angular.copy(vm.optionWith) + " "  +
                        angular.copy(vm.serigraphyBackground) + " " + angular.copy(vm.serigraphyInk) + " " +
                        angular.copy(vm.serigraphyType);
                    objPriceSerigraphy = vm.serigraphyToAdd.saleAlone[rangeSerigraphy];

                    vm.itemToAdd = {
                        id: angular.copy(vm.serigraphyToAdd.id),
                        quantity: angular.copy(vm.quantitySerigraphys),
                        description: angular.copy(objDescriptionSerigraphy),
                        price: angular.copy(objPriceSerigraphy),
                        priceTotal: angular.copy(objPriceSerigraphy*vm.quantitySerigraphys),
                        priceToChange: angular.copy(objPriceSerigraphy*vm.quantitySerigraphys)
                    };

                    vm.totalItems.push(vm.itemToAdd);

                    vm.calculateTotalPrice();
                },
                function(err){
                    $log.log(err);
                });
        };

        // Totales
        //
        //
        //

        vm.calculateTotalPrice = function(){
            $log.log('vm.totalItems', vm.totalItems);

            if(_timeout){
                //if there is already a timeout in process cancel it
                $timeout.cancel(_timeout);
            }

            _timeout = $timeout(function(){

                vm.subTotalCotization = 0;
                vm.ivaCotization = 0;
                vm.totalCotization = 0;
                vm.extraNames = '';
                vm.space = ' ';

                for(var a=0; a<vm.totalItems.length; a++){

                    $log.log('price', vm.totalItems[a].priceToChange);

                    vm.subTotalCotization = vm.subTotalCotization + vm.totalItems[a].priceToChange;

                    vm.extraNames = vm.extraNames.concat(vm.totalItems[a].description);
                    vm.extraNames = vm.extraNames.concat(vm.space);

                    if (a==vm.totalItems.length-1) {
                        vm.ivaCotization = vm.subTotalCotization * 0.16;
                        vm.totalCotization = vm.subTotalCotization + vm.ivaCotization;
                    }
                }

                _timeout = null;
            },500);

        };

        vm.checkArray = function(){
            $log.log('vm.addExtras');

            if (vm.array.length != 0) {
                vm.totalItems = vm.array;
                vm.calculateTotalPrice();
            }

        };

        vm.checkArray();

        vm.addExtras = function(){
            $log.log('vm.addExtras');
            $log.log('vm.totalItems', vm.totalItems);

            vm.objDiss = {
                array: vm.totalItems,
                subTotalCotization: vm.subTotalCotization,
                ivaCotization: vm.ivaCotization,
                totalCotization: vm.totalCotization,
                extraNames: vm.extraNames
            };

            $uibModalInstance.dismiss(vm.objDiss);

        };

        Setting.findOne({},
            function(setting){
                vm.setting = setting;
                $log.log("setting", vm.setting);
            },
            function(err){
                $log.log(err);
            });


    });







'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.worker.registers', {
      url: "/registers",
      abstract: true,
      views: {
        worker:{
          template: '<div ui-view="registers"></div>'
        }
      },
      data: {
        pageTitle: 'Registers'
      }
    });
  })
  .controller('RegistersController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.worker.dashboard', {
      url: "/dashboard",
      views: {
        worker:{
          templateUrl: "app/main/worker/dashboard/dashboard.html"
        }
      },
      data: {
        pageTitle: 'Inicio'
      }
    });
  })
  .controller('DashboardWorkerController', function ($log, $state, RegisterPlate) {

    $log.log('DashboardWorkerController');

    var vm = this;
    vm.plates = '';

    vm.registerFlag = false;
    vm.platesFlag = false;
    vm.typeRegister = '';
    vm.today = new Date();
    vm.newFormatDate = new Date(2022, 0, 11, 23, 59, 59);

    // Elegir tipo de Placa
    vm.selectCarOrMoto = function(item){
      $log.log('vm.selectCarOrMoto');
      vm.typeRegister = item;
    };

    // Buscar Placas
    vm.searchPlates = function (plates){
      $log.log('vm.searchPlates');
      $log.log('vm.plates', vm.plates);
      $log.log('vm.typeRegister', vm.typeRegister);

      if(vm.plates == ''){
        vm.platesFlag = false;
        sweetAlert("Oops...", "El número de placa no puede estar en blanco", "error");
      }else if(vm.typeRegister == ''){
        vm.platesFlag = false;
        sweetAlert("Oops...", "Seleccionar un tipo de registro: vehiculo o motocicleta", "error");
      }else{

        vm.platesFlag = true;

        RegisterPlate.findOne({
            filter: {
              where:{
                and:[
                  {typeRegister: vm.typeRegister},
                  {or: [
                      {plates: plates},
                      {vin: plates}
                    ]
                  }
                ]
              },
              include:[
                {
                  relation: 'appUser'
                }
              ]
            }
          },
          function(register){
            vm.register = angular.copy(register);

            $log.log("vm.register",  vm.register);
            vm.registerFlag = true;

            vm.register.dateValidity = new Date(vm.register.dateValidity);

            // Revisa la vigencia
            if(vm.register.dateValidity.getTime() > vm.today.getTime()){
              vm.register.isExpired = false;
            }else{
              vm.register.isExpired = true;
            }

            vm.register.dateRegister = new Date(vm.register.dateRegister);

            if(!vm.register.status){
              vm.statusPlates = 'BAJA';
            }else if(vm.register.isExpired){
              vm.statusPlates = 'VENCIDO';
            }else{
              vm.statusPlates = 'VIGENTE';
            }

            vm.fullName = vm.register.fullName + ' ' + vm.register.lastNameFather;

          },
          function(err){
            $log.log(err);
            vm.registerFlag = false;
          });
      }

    };

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.vendors', {
      url: "/vendors",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="vendors"></div>'
        }
      },
      data: {
        pageTitle: 'Vendors'
      }
    });
  })
  .controller('VendorsController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.users', {
      url: "/users",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="users"></div>'
        }
      },
      data: {
        pageTitle: 'Users'
      }
    });
  })
  .controller('UsersController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.typeCars', {
      url: "/typeCars",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="typeCars"></div>'
        }
      },
      data: {
        pageTitle: 'TypeCars'
      }
    });
  })
  .controller('TypeCarsController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.settings', {
      url: "/settings",
      views: {
        admin:{
          templateUrl: "app/main/admin/settings/settings.html"
        }
      },
      data: {
        pageTitle: 'Settings'
      }
    });
  })
  .controller('SettingsAdminController', function ($log, $state, AppUser, Setting) {

    $log.log('SettingsAdminController');

    var vm = this;

    // Actualizar Configuracion
    vm.update = function(){
      vm.errorFlag = true;

      $log.log('vm.settings', vm.settings);

      Setting.prototype$patchAttributes(
        {id:  vm.settings.id},
        vm.settings, function (success){
          $log.log("Success", success);
          toastr.success('Conifugración actualizada');

        }, function (err) {
          $log.log(err, 'error');
        });

    };

    // Usuario Logeado
    vm.getAppUserData = function(){
      AppUser.findOne({
          filter: {
            where: {
              id: AppUser.getCurrentId()
            }
          }
        },
        function(userLog){
          vm.userLog = angular.copy(userLog);
          $log.log("vm.userLog", vm.userLog);

          Setting.findOne({
              filter: {
                where: {
                  name: 'configuration'
                }
              }
            },
            function(settings){
              vm.settings = angular.copy(settings);
              $log.log("vm.settings", vm.settings);

            },
            function(err){
              $log.log(err);
            });

        },
        function(err){
          $log.log(err);
        });
    };

    vm.getAppUserData();



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.roles', {
      url: "/roles",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="roles"></div>'
        }
      },
      data: {
        pageTitle: 'Roles'
      }
    });
  })
  .controller('RolesController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.searcher', {
      url: "/searcher",
      views: {
        admin:{
          templateUrl: "app/main/admin/searcher/searcher.html"
        }
      },
      data: {
        pageTitle: 'Searcher'
      }
    });
  })
  .controller('SearcherAdminController', function ($log, $state, RegisterPlate) {

    $log.log('SearcherAdminController');

    var vm = this;

    vm.infoToSearch = {
      fullName: '',
      lastNameFather: '',
      lastNameMother: '',
      telephone: '',
      vin: '',
    };
    vm.spinnerFlag = false;
    vm.today = new Date();
    vm.newFormatDate = new Date(2022, 0, 11, 23, 59, 59);
    vm.items = [];

    vm.filterItems = {
      filter:{
        where: {},
        skip: 0,
        limit: 100,
        order: "createdAt DESC",
        include:[{relation: 'appUser'}]
      }
    };

    // Borrar datos

    vm.deleteInfo = function(){
      $log.log('vm.deleteInfo()');
      vm.infoToSearch = {
        fullName: '',
        lastNameFather: '',
        lastNameMother: '',
        telephone: '',
        vin: '',
      };

      vm.items = [];
    };

    // Buscar Placas
    vm.search = function (){
      $log.log('vm.searchPlates');
      $log.log('vm.infoToSearch', vm.infoToSearch);
      vm.spinnerFlag = true;

      if(vm.infoToSearch.fullName === '' && vm.infoToSearch.lastNameFather === '' && vm.infoToSearch.lastNameMother === ''
        && vm.infoToSearch.telephone === '' && vm.infoToSearch.vin === ''){
        vm.spinnerFlag = false;
        sweetAlert("Oops...", "Tienes todos los campos vacios", "error");
      }else{

        vm.platesFlag = true;
        $log.log('vm.loadItems');

        vm.filterItems.filter.where = {
          and:[
            {fullName: {like: vm.infoToSearch.fullName, options: 'i'}},
            {lastNameFather: {like: vm.infoToSearch.lastNameFather, options: 'i'}},
            {lastNameMother: {like: vm.infoToSearch.lastNameMother, options: 'i'}},
            {telephone: {like: vm.infoToSearch.telephone, options: 'i'}},
            {vin: {like: vm.infoToSearch.vin, options: 'i'}}
          ]
        };
        vm.searchInputString = angular.copy(vm.infoToSearch);

        $log.log('filterItems', vm.filterItems);

        RegisterPlate.find(
          vm.filterItems,
          function (items) {
            vm.items = items;
            $log.log('vm.items', vm.items);
            vm.spinnerFlag = false;

            for(var a=0; a<vm.items.length; a++){

              vm.items[a].dateValidity = new Date(vm.items[a].dateValidity);
              if(vm.items[a].dateValidity.getTime() > vm.today.getTime()){
                vm.items[a].isExpired = false;
              }else{
                vm.items[a].isExpired = true;
              }

              vm.items[a].dateRegister = new Date(vm.items[a].dateRegister);
              if(vm.items[a].dateRegister.getTime() < vm.newFormatDate.getTime()){
                vm.items[a].isNewFormat = false;
              }else{
                vm.items[a].isNewFormat = true;
              }

            }

          },
          function (err) {
            $log.log(err);
          });

      }

    };

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.registers', {
      url: "/registers",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="registers"></div>'
        }
      },
      data: {
        pageTitle: 'Registers'
      }
    });
  })
  .controller('RegistersController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.renovations', {
      url: "/renovations",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="renovations"></div>'
        }
      },
      data: {
        pageTitle: 'Renovations'
      }
    });
  })
  .controller('RenovationsController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.places', {
      url: "/places",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="places"></div>'
        }
      },
      data: {
        pageTitle: 'Places'
      }
    });
  })
  .controller('PlacesController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.extract', {
      url: "/extract",
      views: {
        admin:{
          templateUrl: "app/main/admin/extract/extract.html"
        }
      },
      data: {
        pageTitle: 'Extract Admin'
      }
    });
  })
  .controller('AdminExtractController', function ($log, $state, RegisterPlate) {

    $log.log('AdminExtractController');

    var vm = this;
    vm.plates = '';

    vm.registerFlag = false;
    vm.platesFlag = false;
    vm.typeRegister = '';

    // Elegir tipo de Placa
    vm.selectCarOrMoto = function(item){
      $log.log('vm.selectCarOrMoto');
      vm.typeRegister = item;
    };

    // Buscar Placas
    vm.searchPlates = function (plates){
      $log.log('vm.searchPlates');
      $log.log('vm.plates', vm.plates);
      $log.log('vm.typeRegister', vm.typeRegister);

      if(vm.plates == ''){
        vm.platesFlag = false;
        sweetAlert("Oops...", "El número de placa no puede estar en blanco", "error");
      }else if(vm.typeRegister == ''){
        vm.platesFlag = false;
        sweetAlert("Oops...", "Seleccionar un tipo de registro: vehiculo o motocicleta", "error");
      }else{

        vm.platesFlag = true;

        RegisterPlate.findOne({
            filter: {
              where:{
                and:[
                  {plates: plates},
                  {typeRegister: vm.typeRegister}
                ]
              }
            }
          },
          function(register){
            vm.register = angular.copy(register);

            $log.log("vm.register",  vm.register);
            vm.registerFlag = true;
          },
          function(err){
            $log.log(err);
            vm.registerFlag = false;
          });
      }

    };

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.dashboard', {
      url: "/dashboard",
      views: {
        admin:{
          templateUrl: "app/main/admin/dashboard/dashboard.html"
        }
      },
      data: {
        pageTitle: 'Inicio'
      }
    });
  })
  .controller('AdminDashboardController', function ($log, $state, RegisterPlate) {

    $log.log('AdminDashboardController');

    // Ejemplo VIN que tiene 2 placas 1N6ED26T74C473385

    var vm = this;
    vm.plates = '';

    vm.registerFlag = false;
    vm.platesFlag = false;
    vm.typeRegister = '';
    vm.today = new Date();
    vm.newFormatDate = new Date(2022, 0, 11, 23, 59, 59);

    // Elegir tipo de Placa
    vm.selectCarOrMoto = function(item){
      $log.log('vm.selectCarOrMoto');
      vm.typeRegister = item;
    };

    // Buscar Placas
    vm.searchPlates = function (plates){
      $log.log('vm.searchPlates');
      $log.log('vm.plates', vm.plates);
      $log.log('vm.typeRegister', vm.typeRegister);

      if(vm.plates == ''){
        vm.platesFlag = false;
        sweetAlert("Oops...", "El número de placa no puede estar en blanco", "error");
      }else if(vm.typeRegister == ''){
        vm.platesFlag = false;
        sweetAlert("Oops...", "Seleccionar un tipo de registro: vehiculo o motocicleta", "error");
      }else{

        vm.platesFlag = true;

        RegisterPlate.findOne({
            filter: {
              where:{
                and:[
                  {typeRegister: vm.typeRegister},
                  {or: [
                      {plates: plates},
                      {vin: plates}
                    ]
                  }
                ]
              },
              order: "createdAt DESC",
              include:[
                {
                  relation: 'appUser'
                }
              ]
            }
          },
          function(register){
            vm.register = angular.copy(register);

            $log.log("vm.register",  vm.register);
            vm.registerFlag = true;

            vm.register.dateValidity = new Date(vm.register.dateValidity);

            // Revisa la vigencia
            if(vm.register.dateValidity.getTime() > vm.today.getTime()){
              vm.register.isExpired = false;
            }else{
              vm.register.isExpired = true;
            }

            vm.register.dateRegister = new Date(vm.register.dateRegister);

            if(!vm.register.status){
              vm.statusPlates = 'BAJA';
            }else if(vm.register.isExpired){
              vm.statusPlates = 'VENCIDO';
            }else{
              vm.statusPlates = 'VIGENTE';
            }

            vm.fullName = vm.register.fullName + ' ' + vm.register.lastNameFather;

          },
          function(err){
            $log.log(err);
            vm.registerFlag = false;
          });
      }

    };

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.colors', {
      url: "/colors",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="colors"></div>'
        }
      },
      data: {
        pageTitle: 'Colors'
      }
    });
  })
  .controller('ColorsController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.brands', {
      url: "/brands",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="brands"></div>'
        }
      },
      data: {
        pageTitle: 'Brands'
      }
    });
  })
  .controller('BrandsController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.clients', {
      url: "/clients",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="clients"></div>'
        }
      },
      data: {
        pageTitle: 'Clients'
      }
    });
  })
  .controller('ClientsController', function () {



  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.blockPage', {
      url: "/blockPage",
      views: {
        admin:{
          templateUrl: "app/main/admin/blockPage/blockPage.html"
        }
      },
      data: {
        pageTitle: 'BlockPage Admin'
      }
    });
  })
  .controller('BlockPageAdminController', function ($log, $state, $location, $window, $uibModal, AppUser, Crop, LandLot, Activity, Machine, StockTransfer, TransferFuel, InventoryFuel, ApplicationProduct, ApplicationFuel) {

    $log.log('BlockPage Admin');

    // ----------- VM  ------------------------------------------------------//
    var vm = this;

    vm.spinnerFlag = true;

    // ----------- Go To  ------------------------------------------------------//
    vm.goTo = function(state){
      $log.log('vm.goTo()');
      $log.log('state', state);
      $state.go(state);
    };

    // ----------- Buscar Info  ------------------------------------------------------//

    vm.getApplicationFuel = function(){
      $log.log('vm.getApplicationFuel()');

      ApplicationFuel.count({
          where:{}
        },
        function(appFuels){
          $log.log('appFuels', appFuels);
          vm.appFuelsQty = appFuels.count;
          vm.spinnerFlag = false;
        },
        function(err){
          $log.log(err);
          toastr.error('Error', 'Error');
        });

    };

    vm.getApplicationProduct = function(){
      $log.log('vm.getApplicationProduct()');

      ApplicationProduct.count({
          where:{}
        },
        function(appProducts){
          $log.log('appProducts', appProducts);
          vm.appProductsQty = appProducts.count;
          vm.getApplicationFuel();
        },
        function(err){
          $log.log(err);
          toastr.error('Error', 'Error');
        });


    };

    vm.getInventoryFuel = function(){
      $log.log('vm.getTransferFuel()');

      InventoryFuel.findOne({
          filter: {
            where: {
              name: 'fuel'
            }
          }
        },
        function(inventoryFuel){
          vm.inventoryFuel = angular.copy(inventoryFuel);
          $log.log("vm.inventoryFuel",  vm.inventoryFuel);

          vm.getApplicationProduct();
        },
        function(err){
          $log.log(err);
          toastr.error('Error', 'Error');
        });

    };

    vm.getTransferFuel = function(){
      $log.log('vm.getTransferFuel()');

      TransferFuel.count({
          where:{}
        },
        function(transferFuel){
          $log.log('transferFuel', transferFuel);
          vm.transferFuelQty = transferFuel.count;
          vm.getInventoryFuel();
        },
        function(err){
          $log.log(err);
          toastr.error('Error', 'Error');
        });

    };

    vm.getStockTransfer = function(){
      $log.log('vm.getStockTransfer()');

      StockTransfer.count({
          where:{}
        },
        function(stockTransfers){
          $log.log('stockTransfers', stockTransfers);
          vm.stockTransfersQty = stockTransfers.count;
          vm.getTransferFuel();
        },
        function(err){
          $log.log(err);
          toastr.error('Error', 'Error');
        });

    };

    vm.getActivities = function(){
      $log.log('vm.getActivities()');

      Activity.count({
          where:{}
        },
        function(activities){
          $log.log('activities', activities);
          vm.activitiesQty = activities.count;
          vm.getStockTransfer();
        },
        function(err){
          $log.log(err);
          toastr.error('Error', 'Error');
        });

    };

    vm.getMachines = function(){
      $log.log('vm.getMachines()');

      Machine.count({
          where:{}
        },
        function(machines){
          $log.log('machines', machines);
          vm.machinesQty = machines.count;
          vm.getActivities();
        },
        function(err){
          $log.log(err);
          toastr.error('Error', 'Error');
        });

    };

    vm.getLandLot = function(){
      $log.log('vm.getInfo()');

      LandLot.count({
          where:{}
        },
        function(landLots){
          $log.log('landLots', landLots);
          vm.landLotsQty = landLots.count;
          vm.getMachines();
        },
        function(err){
          $log.log(err);
          toastr.error('Error', 'Error');
        });

    };

    vm.getCrop = function(){
      $log.log('vm.getCrop()');

      Crop.count({
          where:{}
        },
        function(crops){
          $log.log('crops', crops);
          vm.cropsQty = crops.count;
          vm.getLandLot();
        },
        function(err){
          $log.log(err);
          toastr.error('Error', 'Error');
        });

    };

    vm.getInfo = function(){

      $log.log('vm.getInfo()');
      vm.getCrop();

    };

    // ----------- Usuario Logeado  ------------------------------------------------------//
    vm.getAppUserLogged = function(){
      $log.log('vm.getAppUserLogged()');

      AppUser.getCurrent(
        function(userLogged) {
          vm.userLogged = angular.copy(userLogged);
          $log.log('vm.userLogged', vm.userLogged);

          vm.spinnerFlag = false;

          vm.getInfo();
        },
        function () {
          $log.log('failure');
          toastr.error('No esta logeado ningun usuario', 'Error');
        });

    };

    vm.getAppUserLogged();

  });







'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin.admins', {
      url: "/admins",
      abstract: true,
      views: {
        admin:{
          template: '<div ui-view="admins"></div>'
        }
      },
      data: {
        pageTitle: 'Admins'
      }
    });
  })
  .controller('AdminsAdminController', function () {



  });



angular.module('common.directives', [
  'common.directives.filterBy',
  'common.directives.searchList',
  'common.directives.titleWidget',
  'common.directives.indicatorWidget',
  'common.directives.indicatorWidget3',
  'common.directives.listModel',
  'common.directives.titleModel',
  'common.directives.printPDF',
  'common.directives.showMessage',
  'common.directives.extras',
  'common.directives.googlePlaces',
  'common.directives.googlePlacesDrawing'
]);

'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('start.police', {
      url: "/police",
      views: {
        start:{
          templateUrl: "app/start/police/police.html"
        }
      },
      data: {
        pageTitle: 'Police'
      }
    });
  })
.controller('StartPoliceController', function ($log, $state, $stateParams, RegisterPlate, Setting) {

  var vm = this;

  vm.return = function (){
    $log.log('return');

    $state.go('start.options');
  };

  vm.plates = '';
  vm.typeRegister = '';
  vm.code = '';

  vm.registerFlag = false;
  vm.platesFlag = false;

  vm.today = new Date();
  vm.newFormatDate = new Date(2022, 0, 10, 23, 59, 59);

  // Elegir tipo de Placa
  vm.selectCarOrMoto = function(item){
    $log.log('vm.selectCarOrMoto');
    vm.typeRegister = item;
  };

  // Buscar Placas
  vm.searchPlates = function (){
    $log.log('vm.searchPlates');
    $log.log('vm.plates', vm.plates);
    $log.log('vm.typeRegister', vm.typeRegister);

    if(vm.plates == ''){
      vm.platesFlag = false;
      sweetAlert("Oops...", "El número de placa no puede estar en blanco", "error");
    }else if(vm.code == ''){
      vm.platesFlag = false;
      sweetAlert("Oops...", "La clave no puede estar en blanco", "error");
    }else if(vm.typeRegister == ''){
      vm.platesFlag = false;
      sweetAlert("Oops...", "Seleccionar un tipo de registro: vehiculo o motocicleta", "error");
    }else if(vm.settings.policeCode != vm.code){
      sweetAlert("Oops...", "La clave es incorrecta", "error");
    }else{

      vm.platesFlag = true;

      RegisterPlate.findOne({
          filter: {
            where:{
              and:[
                {plates: vm.plates},
                {typeRegister: vm.typeRegister}
              ]
            }
          }
        },
        function(register){
          vm.register = angular.copy(register);

          $log.log("vm.register",  vm.register);
          vm.registerFlag = true;

          vm.register.dateValidity = new Date(vm.register.dateValidity);
          if(vm.register.dateValidity.getTime() > vm.today.getTime()){
            vm.register.isExpired = false;
          }else{
            vm.register.isExpired = true;
          }

          vm.register.dateRegister = new Date(vm.register.dateRegister);

          if(!vm.register.status){
            vm.statusPlates = 'BAJA';
          }else if(vm.register.dateRegister.getTime() > vm.newFormatDate.getTime()){
            vm.statusPlates = 'INDEFINIDO';
          }else if(vm.register.isExpired){
            vm.statusPlates = 'VENCIDO';
          }else{
            vm.statusPlates = 'VIGENTE';
          }

          vm.fullName = vm.register.fullName + ' ' + vm.register.lastNameFather;

        },
        function(err){
          $log.log(err);
          vm.registerFlag = false;
        });
    }

  };


  // Usuario Logeado
  vm.getCode = function(){
    Setting.findOne({
        filter: {
          where: {
            name: 'configuration'
          }
        }
      },
      function(settings){
        vm.settings = angular.copy(settings);
        $log.log("vm.settings", vm.settings);

      },
      function(err){
        $log.log(err);
      });
  };

  vm.getCode();

});



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('start.plates', {
      url: "/placas/:id/:type",
      views: {
        start:{
          templateUrl: "app/start/plates/plates.html"
        }
      },
      data: {
        pageTitle: 'Plates'
      }
    });
  })
.controller('StartPlatesController', function ($log, $state, $stateParams, RegisterPlate) {

  var vm = this;

  vm.return = function (){
    $log.log('return');

    $state.go('start.options');
  };

  vm.plates = $stateParams.id;
  vm.typeRegister = $stateParams.type;

  vm.registerFlag = false;
  vm.platesFlag = false;

  vm.today = new Date();
  vm.newFormatDate = new Date(2022, 0, 10, 23, 59, 59);

  // Elegir tipo de Placa
  vm.selectCarOrMoto = function(item){
    $log.log('vm.selectCarOrMoto');
    vm.typeRegister = item;
  };

  // Buscar Placas
  vm.searchPlates = function (){
    $log.log('vm.searchPlates');
    $log.log('vm.plates', vm.plates);
    $log.log('vm.typeRegister', vm.typeRegister);

    if(vm.plates == ''){
      vm.platesFlag = false;
      sweetAlert("Oops...", "El número de placa no puede estar en blanco", "error");
    }else if(vm.typeRegister == ''){
      vm.platesFlag = false;
      sweetAlert("Oops...", "Seleccionar un tipo de registro: vehiculo o motocicleta", "error");
    }else{

      vm.platesFlag = true;

      RegisterPlate.findOne({
          filter: {
            where:{
              and:[
                {plates: vm.plates},
                {typeRegister: vm.typeRegister}
              ]
            }
          }
        },
        function(register){
          vm.register = angular.copy(register);

          $log.log("vm.register",  vm.register);
          vm.registerFlag = true;

          vm.register.dateValidity = new Date(vm.register.dateValidity);
          // Revisa la vigencia
          if(vm.register.dateValidity.getTime() > vm.today.getTime()){
            vm.register.isExpired = false;
          }else{
            vm.register.isExpired = true;
          }

          vm.register.dateRegister = new Date(vm.register.dateRegister);

          if(!vm.register.status){
            vm.statusPlates = 'BAJA';
          }else if(vm.register.isExpired){
            vm.statusPlates = 'VENCIDO';
          }else{
            vm.statusPlates = 'VIGENTE';
          }

          vm.fullName = vm.register.fullName + ' ' + vm.register.lastNameFather;

        },
        function(err){
          $log.log(err);
          vm.registerFlag = false;
        });
    }

  };

  vm.searchPlates();

});



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('start.options', {
      url: "/opciones",
      views: {
        start:{
          templateUrl: "app/start/options/options.html"
        }
      },
      data: {
        pageTitle: 'Options'
      }
    });
  })
.controller('StartOptionsController', function ($log, $state, $rootScope, AppUser) {

  var vm = this;

  vm.plateToSearch = '';
  vm.typeRegister = '';

  // Elegir tipo de Placa
  vm.selectCarOrMoto = function(item){
    $log.log('vm.selectCarOrMoto');
    vm.typeRegister = item;
  };

  // buscar Placas
  vm.platesOption = function (){
    $log.log('platesOption');
    $log.log('vm.plateToSearch', vm.plateToSearch.toUpperCase());
    $log.log('vm.typeRegister', vm.typeRegister);

    if(vm.plateToSearch == ''){
      sweetAlert("Oops...", "El número de placa no puede estar en blanco", "error");
    }else if(vm.typeRegister == ''){
      sweetAlert("Oops...", "Seleccionar un tipo de registro: vehiculo o motocicleta", "error");
    }else{
      $state.go('start.plates', {id: vm.plateToSearch.toUpperCase(), type: vm.typeRegister});
    }

  };

  //loginAlready
  vm.loginAlready = function(user){
    $log.log('loginAlready');
    $log.log('user', user);
    $state.go('main.admin.dashboard');
  };

 // Auntentifica que el usuario siga loggeado

 if(AppUser.isAuthenticated()) {
    AppUser.getCurrent(function (user) {

      $log.log('Este usuario ya estaba loggeado');
      $log.log('login: success');

      vm.user = angular.copy(user);
      $log.log('user', vm.user);
      vm.loginAlready(vm.user);

    }, function () {
      $state.go('start.login');
      $log.log('login: failure');
    });

  }else{

    $log.log('Problemas Login Start Options');
    $state.go('start.options');

  }


});



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('start.login', {
      url: "/login",
      views: {
        start:{
          templateUrl: "app/start/login/login.html",
          controller: "StartLoginController"
        }
      },
      data: {
        pageTitle: 'Login'
      }
    });
  })
.controller('StartLoginController', function ($log, $state, $rootScope, AppUser, UserRole) {

  var vm = this;

  vm.credentials = {
      username: "",
      password: ""
  };

  // Para que el usuario se loggee
  vm.login = function() {

    $log.log('login  function');
    $log.log(vm.credentials);

    AppUser.login(vm.credentials, function(success) {
      $log.log('login - success');
      $log.log(success.user);

      if(success.user.role == 'Admin General'){
        $state.go('main.admin.dashboard');
      }else if(success.user.role == 'Trabajador'){
        $state.go('main.worker.dashboard');
      }
    }, function() {
      $log.log('login - failure');
      swal("Rechazado", "Datos incorrectos. Por favor intente de nuevo.", "error");
    });

  };

  vm.loginAlready = function(user){
    $log.log('loginAlready');
    $log.log('user', user);

    if(user.role == 'Admin General'){
      $state.go('main.admin.dashboard');
    }else if(user.role == 'Trabajador'){
      $state.go('main.worker.dashboard');
    }

  };

 // Auntentifica que el usuario siga loggeado

 if(AppUser.isAuthenticated()) {
    AppUser.getCurrent(function (user) {

      $log.log('Este usuario ya estaba loggeado');
      $log.log('login: success');

      vm.user = angular.copy(user);
      $log.log('user', vm.user);
      vm.loginAlready(vm.user);

    }, function () {
      $state.go('start.login');
      $log.log('login: failure');
    });

  }else{

    $log.log('Problemas Login');
    $state.go('start.login');

  }


});



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.worker', {
      url: "/worker",
      abstract: true,
      views: {
        main:{
          templateUrl: "app/main/worker/worker.html"
        }
      },
      data: {
        pageTitle: 'worker'
      }
    });
  })
  .controller('MainIsWorker', function ($log) {

    $log.log('worker');

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('main.admin', {
      url: "/admin",
      abstract: true,
      views: {
        main:{
          templateUrl: "app/main/admin/admin.html"
        }
      },
      data: {
        pageTitle: 'admin'
      }
    });
  })
  .controller('MainIsAdmin', function ($log) {

    $log.log('admin');

  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider.state('start', {
      url: "/inicio",
      templateUrl: "app/start/start.html",
      data: {
        pageTitle: 'Start'
      }
    });
  })
  .controller('startCtrl', function ($log) {
      $log.log('start');
  });



'use strict';

angular.module('inspinia')
  .config(function ($stateProvider) {
    $stateProvider
      .state('main', {
        abstract: true,
        url: "/main",
        templateUrl: "app/main/main.html",
        data: { pageTitle: 'Example view' }
      })
  })
  .controller('MainController', function ($scope, $log, $state, $window, AppUser, UserRole) {

    // Subir la pantalla  /main/dashboard
    function scrollWin() {window.scrollTo(0, 0);}
    scrollWin();

    var vm = this;

    $log.log('MainController');

    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-top-right",
      "preventDuplicates": true,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }

    vm.options = [];

    vm.changeState = function(opt, index) {
      $log.log(opt);
      vm.navSelected = index;
      $state.go(opt.stateToGo);
    };

    // Buscamos el usuario loggeado
    AppUser.getCurrent(
      function(user) {
        vm.user = angular.copy(user);
        $log.log('user main controller', vm.user);

        // Opciones que salen el el navigation de la derecha

        vm.options = vm.optionsAdmin;
        if(vm.user.role == 'Admin General' && vm.user.fullEdit){
          vm.options = [
            {
              name: 'Buscador Placas',
              stateToGo: 'main.admin.dashboard',
              fav: 'fa fa-search'
            },
            {
              name: 'Buscador General',
              stateToGo: 'main.admin.searcher',
              fav: 'fa fa-search'
            },
            {
              name: 'Admins',
              stateToGo: 'main.admin.admins.all',
              fav: 'fa fa-user'
            },
            {
              name: 'Usuarios',
              stateToGo: 'main.admin.users.all',
              fav: 'fa fa-users'
            },
            {
              name: 'Lugares',
              stateToGo: 'main.admin.places.all',
              fav: 'fa fa-map-pin'
            },
            {
              name: 'Marcas',
              stateToGo: 'main.admin.brands.all',
              fav: 'fa fa-car'
            },
            {
              name: 'Tipo',
              stateToGo: 'main.admin.typeCars.all',
              fav: 'fa fa-car'
            },
            {
              name: 'Color',
              stateToGo: 'main.admin.colors.all',
              fav: 'fa fa-palette'
            },
            {
              name: 'Placas',
              stateToGo: 'main.admin.registers.all',
              fav: 'fa fa-car-side'
            },
            {
              name: 'Placas A',
              stateToGo: 'main.admin.renovations.all',
              fav: 'fa fa-car-side'
            },
            {
              name: 'Vendedores',
              stateToGo: 'main.admin.vendors.all',
              fav: 'fa fa-car-side'
            },
            {
              name: 'Configuración',
              stateToGo: 'main.admin.settings',
              fav: 'fa fa-cogs'
            }
          ];
        }else if(vm.user.role == 'Admin General' && !vm.user.fullEdit){
          vm.options = [
            {
              name: 'Buscador',
              stateToGo: 'main.admin.dashboard',
              fav: 'fa fa-search'
            },
            {
              name: 'Registro',
              stateToGo: 'main.admin.registers.all',
              fav: 'fa fa-car-side'
            }
          ];
        }else if(vm.user.role == 'Trabajador'){
          vm.options = [
            {
              name: 'Buscador',
              stateToGo: 'main.worker.dashboard',
              fav: 'fa fa-search'
            },
            {
              name: 'Registro',
              stateToGo: 'main.worker.registers.all',
              fav: 'fa fa-car-side'
            }
          ];
        }

      },
      function () {
        $log.log('failure');
        $state.go('start.login');
      });

    // Cerrar sesión Boton

    // Se cierra la sesión y te envia al login
    vm.logout = function () {
      $log.log("Logout");

      AppUser.logout({}, function () {
        $state.go('start.login');
      });
    };

    // Se abre una modal (sweetAlert) para confirmar si quieres cerrar sesion, la cual si aceptas se ejecuta vm.logout();
    vm.logoutModal = function(){
      swal({
          title: "¿Está seguro de que desea cerrar sesión?",
          text: "",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          closeOnConfirm: true,
          closeOnCancel: true },
        function(isConfirm){
          if (isConfirm) {
            vm.logout();
          }
        });
    };

  });

// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }

  var urlBaseHost = getHost(urlBase) || location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.User
 * @header lbServices.User
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `User` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "User",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Users/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__findById__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Buscar un elemento relacionado por id para accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Users/:id/accessTokens/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__destroyById__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Users/:id/accessTokens/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__updateById__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Clave foránea para accessTokens
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Users/:id/accessTokens/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__get__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * accessTokens consultas de User.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/Users/:id/accessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__create__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Crea una nueva instancia en accessTokens de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__create__accessTokens": {
              url: urlBase + "/Users/:id/accessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__delete__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Suprime todos los accessTokens de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__accessTokens": {
              url: urlBase + "/Users/:id/accessTokens",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__count__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Recuentos accessTokens de User.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__accessTokens": {
              url: urlBase + "/Users/:id/accessTokens/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#create
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createMany
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Users",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Users/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#upsertWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Users/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#exists
             * @methodOf lbServices.User
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Users/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Users/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Users/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#find
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findOne
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Users/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#updateAll
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Users/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#deleteById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Users/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#count
             * @methodOf lbServices.User
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Users/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$patchAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Users/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createChangeStream
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Users/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#login
             * @methodOf lbServices.User
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * El cuerpo de respuesta contiene propiedades de la AccessToken creada durante el inicio de la sesión.
             * Dependiendo del valor del parámetro `include`, el cuerpo puede contener propiedades adicionales:
             *   - `user` - `U+007BUserU+007D` - Datos del usuario conectado actualmente. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/Users/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#logout
             * @methodOf lbServices.User
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/Users/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$verify
             * @methodOf lbServices.User
             *
             * @description
             *
             * Trigger user's identity verification with configured verifyOptions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `verifyOptions` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$verify": {
              url: urlBase + "/Users/:id/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#confirm
             * @methodOf lbServices.User
             *
             * @description
             *
             * Confirm a user registration with identity verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/Users/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#resetPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/Users/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#changePassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Change a user's password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/Users/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#setPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Reset user's password via a password-reset token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setPassword": {
              url: urlBase + "/Users/reset-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getCurrent
             * @methodOf lbServices.User
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/Users" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.User#upsert
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.User#updateOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreateWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.User#update
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.User#destroyById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#removeById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#updateAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.User#getCachedCurrent
         * @methodOf lbServices.User
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.User#login} or
         * {@link lbServices.User#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A User instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#isAuthenticated
         * @methodOf lbServices.User
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#getCurrentId
         * @methodOf lbServices.User
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.User#modelName
        * @propertyOf lbServices.User
        * @description
        * The name of the model represented by this $resource,
        * i.e. `User`.
        */
        R.modelName = "User";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AppUser
 * @header lbServices.AppUser
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AppUser` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AppUser",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AppUsers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.AppUser#prototype$__findById__accessTokens
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Buscar un elemento relacionado por id para accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AppUsers/:id/accessTokens/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#prototype$__destroyById__accessTokens
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AppUsers/:id/accessTokens/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#prototype$__updateById__accessTokens
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppUser id
             *
             *  - `fk` – `{*}` - Clave foránea para accessTokens
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AppUsers/:id/accessTokens/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#prototype$__get__accessTokens
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * accessTokens consultas de AppUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/AppUsers/:id/accessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#prototype$__create__accessTokens
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Crea una nueva instancia en accessTokens de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "prototype$__create__accessTokens": {
              url: urlBase + "/AppUsers/:id/accessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#prototype$__delete__accessTokens
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Suprime todos los accessTokens de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__accessTokens": {
              url: urlBase + "/AppUsers/:id/accessTokens",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#prototype$__count__accessTokens
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Recuentos accessTokens de AppUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__accessTokens": {
              url: urlBase + "/AppUsers/:id/accessTokens/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#create
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/AppUsers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#createMany
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/AppUsers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#patchOrCreate
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/AppUsers",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#replaceOrCreate
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/AppUsers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#upsertWithWhere
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/AppUsers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#exists
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/AppUsers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#findById
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/AppUsers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#replaceById
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/AppUsers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#find
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/AppUsers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#findOne
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/AppUsers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#updateAll
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/AppUsers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#deleteById
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/AppUsers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#count
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/AppUsers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#prototype$patchAttributes
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/AppUsers/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#createChangeStream
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/AppUsers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#login
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * El cuerpo de respuesta contiene propiedades de la AccessToken creada durante el inicio de la sesión.
             * Dependiendo del valor del parámetro `include`, el cuerpo puede contener propiedades adicionales:
             *   - `user` - `U+007BUserU+007D` - Datos del usuario conectado actualmente. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/AppUsers/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#logout
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/AppUsers/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#prototype$verify
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Trigger user's identity verification with configured verifyOptions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `verifyOptions` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$verify": {
              url: urlBase + "/AppUsers/:id/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#confirm
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Confirm a user registration with identity verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/AppUsers/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#resetPassword
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/AppUsers/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#changePassword
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Change a user's password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/AppUsers/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#setPassword
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Reset user's password via a password-reset token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setPassword": {
              url: urlBase + "/AppUsers/reset-password",
              method: "POST",
            },

            // INTERNAL. Use RegisterPlate.appUser() instead.
            "::get::RegisterPlate::appUser": {
              url: urlBase + "/RegisterPlates/:id/appUser",
              method: "GET",
            },

            // INTERNAL. Use Renovation.appUser() instead.
            "::get::Renovation::appUser": {
              url: urlBase + "/Renovations/:id/appUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AppUser#getCurrent
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/AppUsers" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.AppUser#upsert
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.AppUser#updateOrCreate
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.AppUser#patchOrCreateWithWhere
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.AppUser#update
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.AppUser#destroyById
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AppUser#removeById
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AppUser#updateAttributes
             * @methodOf lbServices.AppUser
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AppUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.AppUser#getCachedCurrent
         * @methodOf lbServices.AppUser
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.AppUser#login} or
         * {@link lbServices.AppUser#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A AppUser instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.AppUser#isAuthenticated
         * @methodOf lbServices.AppUser
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.AppUser#getCurrentId
         * @methodOf lbServices.AppUser
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.AppUser#modelName
        * @propertyOf lbServices.AppUser
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AppUser`.
        */
        R.modelName = "AppUser";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserRole
 * @header lbServices.UserRole
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserRole` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserRole",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/UserRoles/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.UserRole#create
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/UserRoles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#createMany
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/UserRoles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#patchOrCreate
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/UserRoles",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#replaceOrCreate
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/UserRoles/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#upsertWithWhere
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/UserRoles/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#exists
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/UserRoles/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#findById
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/UserRoles/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#replaceById
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/UserRoles/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#find
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/UserRoles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#findOne
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/UserRoles/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#updateAll
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/UserRoles/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#deleteById
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/UserRoles/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#count
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/UserRoles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#prototype$patchAttributes
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserRole id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/UserRoles/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserRole#createChangeStream
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/UserRoles/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserRole#upsert
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserRole#updateOrCreate
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.UserRole#patchOrCreateWithWhere
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UserRole#update
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UserRole#destroyById
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserRole#removeById
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UserRole#updateAttributes
             * @methodOf lbServices.UserRole
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserRole id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserRole` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UserRole#modelName
        * @propertyOf lbServices.UserRole
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserRole`.
        */
        R.modelName = "UserRole";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Client
 * @header lbServices.Client
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Client` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Client",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Clients/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Client#create
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Clients",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#createMany
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Clients",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#patchOrCreate
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Clients",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#replaceOrCreate
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Clients/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#upsertWithWhere
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Clients/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#exists
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Clients/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#findById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Clients/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#replaceById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Clients/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#find
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Clients",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#findOne
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Clients/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#updateAll
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Clients/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#deleteById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Clients/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#count
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Clients/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$patchAttributes
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Clients/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#createChangeStream
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Clients/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Client#upsert
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Client#updateOrCreate
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Client#patchOrCreateWithWhere
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Client#update
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Client#destroyById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Client#removeById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Client#updateAttributes
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Client id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Client#modelName
        * @propertyOf lbServices.Client
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Client`.
        */
        R.modelName = "Client";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Register
 * @header lbServices.Register
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Register` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Register",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Registers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Register#create
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Registers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#createMany
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Registers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#patchOrCreate
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Registers",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#replaceOrCreate
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Registers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#upsertWithWhere
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Registers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#exists
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Registers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#findById
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Registers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#replaceById
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Registers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#find
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Registers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#findOne
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Registers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#updateAll
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Registers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#deleteById
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Registers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#count
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Registers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#prototype$patchAttributes
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Register id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Registers/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Register#createChangeStream
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Registers/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Register#upsert
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Register#updateOrCreate
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Register#patchOrCreateWithWhere
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Register#update
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Register#destroyById
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Register#removeById
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Register#updateAttributes
             * @methodOf lbServices.Register
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Register id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Register` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Register#modelName
        * @propertyOf lbServices.Register
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Register`.
        */
        R.modelName = "Register";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Brand
 * @header lbServices.Brand
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Brand` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Brand",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Brands/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Brand#create
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Brands",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#createMany
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Brands",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#patchOrCreate
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Brands",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#replaceOrCreate
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Brands/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#upsertWithWhere
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Brands/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#exists
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Brands/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#findById
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Brands/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#replaceById
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Brands/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#find
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Brands",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#findOne
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Brands/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#updateAll
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Brands/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#deleteById
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Brands/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#count
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Brands/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#prototype$patchAttributes
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Brand id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Brands/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Brand#createChangeStream
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Brands/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Brand#upsert
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#updateOrCreate
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#patchOrCreateWithWhere
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#update
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#destroyById
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#removeById
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Brand#updateAttributes
             * @methodOf lbServices.Brand
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Brand id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Brand` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Brand#modelName
        * @propertyOf lbServices.Brand
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Brand`.
        */
        R.modelName = "Brand";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TypeCar
 * @header lbServices.TypeCar
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TypeCar` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TypeCar",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/TypeCars/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#create
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/TypeCars",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#createMany
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/TypeCars",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#patchOrCreate
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/TypeCars",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#replaceOrCreate
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/TypeCars/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#upsertWithWhere
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/TypeCars/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#exists
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/TypeCars/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#findById
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/TypeCars/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#replaceById
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/TypeCars/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#find
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/TypeCars",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#findOne
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/TypeCars/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#updateAll
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/TypeCars/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#deleteById
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/TypeCars/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#count
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/TypeCars/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#prototype$patchAttributes
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TypeCar id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/TypeCars/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#createChangeStream
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/TypeCars/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TypeCar#upsert
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#updateOrCreate
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#patchOrCreateWithWhere
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#update
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#destroyById
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#removeById
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TypeCar#updateAttributes
             * @methodOf lbServices.TypeCar
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TypeCar id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TypeCar` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TypeCar#modelName
        * @propertyOf lbServices.TypeCar
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TypeCar`.
        */
        R.modelName = "TypeCar";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Color
 * @header lbServices.Color
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Color` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Color",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Colors/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Color#create
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Colors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#createMany
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Colors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#patchOrCreate
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Colors",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#replaceOrCreate
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Colors/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#upsertWithWhere
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Colors/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#exists
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Colors/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#findById
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Colors/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#replaceById
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Colors/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#find
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Colors",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#findOne
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Colors/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#updateAll
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Colors/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#deleteById
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Colors/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#count
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Colors/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#prototype$patchAttributes
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Color id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Colors/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Color#createChangeStream
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Colors/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Color#upsert
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Color#updateOrCreate
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Color#patchOrCreateWithWhere
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Color#update
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Color#destroyById
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Color#removeById
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Color#updateAttributes
             * @methodOf lbServices.Color
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Color id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Color` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Color#modelName
        * @propertyOf lbServices.Color
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Color`.
        */
        R.modelName = "Color";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RegisterPlate
 * @header lbServices.RegisterPlate
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RegisterPlate` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RegisterPlate",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RegisterPlates/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RegisterPlate.appUser() instead.
            "prototype$__get__appUser": {
              url: urlBase + "/RegisterPlates/:id/appUser",
              method: "GET",
            },

            // INTERNAL. Use RegisterPlate.renovations.findById() instead.
            "prototype$__findById__renovations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/RegisterPlates/:id/renovations/:fk",
              method: "GET",
            },

            // INTERNAL. Use RegisterPlate.renovations.destroyById() instead.
            "prototype$__destroyById__renovations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/RegisterPlates/:id/renovations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use RegisterPlate.renovations.updateById() instead.
            "prototype$__updateById__renovations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/RegisterPlates/:id/renovations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use RegisterPlate.renovations() instead.
            "prototype$__get__renovations": {
              isArray: true,
              url: urlBase + "/RegisterPlates/:id/renovations",
              method: "GET",
            },

            // INTERNAL. Use RegisterPlate.renovations.create() instead.
            "prototype$__create__renovations": {
              url: urlBase + "/RegisterPlates/:id/renovations",
              method: "POST",
            },

            // INTERNAL. Use RegisterPlate.renovations.destroyAll() instead.
            "prototype$__delete__renovations": {
              url: urlBase + "/RegisterPlates/:id/renovations",
              method: "DELETE",
            },

            // INTERNAL. Use RegisterPlate.renovations.count() instead.
            "prototype$__count__renovations": {
              url: urlBase + "/RegisterPlates/:id/renovations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#create
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/RegisterPlates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#createMany
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/RegisterPlates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#patchOrCreate
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/RegisterPlates",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#replaceOrCreate
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/RegisterPlates/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#upsertWithWhere
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/RegisterPlates/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#exists
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/RegisterPlates/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#findById
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/RegisterPlates/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#replaceById
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/RegisterPlates/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#find
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RegisterPlates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#findOne
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/RegisterPlates/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#updateAll
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/RegisterPlates/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#deleteById
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/RegisterPlates/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#count
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/RegisterPlates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#prototype$patchAttributes
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/RegisterPlates/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#createChangeStream
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/RegisterPlates/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Renovation.registerPlate() instead.
            "::get::Renovation::registerPlate": {
              url: urlBase + "/Renovations/:id/registerPlate",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#upsert
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#updateOrCreate
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#patchOrCreateWithWhere
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#update
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#destroyById
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#removeById
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#updateAttributes
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.RegisterPlate#modelName
        * @propertyOf lbServices.RegisterPlate
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RegisterPlate`.
        */
        R.modelName = "RegisterPlate";


            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#appUser
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * Capta la relación belongsTo appUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
        R.appUser = function() {
          var TargetResource = $injector.get("AppUser");
          var action = TargetResource["::get::RegisterPlate::appUser"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.RegisterPlate.renovations
     * @header lbServices.RegisterPlate.renovations
     * @object
     * @description
     *
     * The object `RegisterPlate.renovations` groups methods
     * manipulating `Renovation` instances related to `RegisterPlate`.
     *
     * Call {@link lbServices.RegisterPlate#renovations RegisterPlate.renovations()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate#renovations
             * @methodOf lbServices.RegisterPlate
             *
             * @description
             *
             * renovations consultas de RegisterPlate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R.renovations = function() {
          var TargetResource = $injector.get("Renovation");
          var action = TargetResource["::get::RegisterPlate::renovations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate.renovations#count
             * @methodOf lbServices.RegisterPlate.renovations
             *
             * @description
             *
             * Recuentos renovations de RegisterPlate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.renovations.count = function() {
          var TargetResource = $injector.get("Renovation");
          var action = TargetResource["::count::RegisterPlate::renovations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate.renovations#create
             * @methodOf lbServices.RegisterPlate.renovations
             *
             * @description
             *
             * Crea una nueva instancia en renovations de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R.renovations.create = function() {
          var TargetResource = $injector.get("Renovation");
          var action = TargetResource["::create::RegisterPlate::renovations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate.renovations#createMany
             * @methodOf lbServices.RegisterPlate.renovations
             *
             * @description
             *
             * Crea una nueva instancia en renovations de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R.renovations.createMany = function() {
          var TargetResource = $injector.get("Renovation");
          var action = TargetResource["::createMany::RegisterPlate::renovations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate.renovations#destroyAll
             * @methodOf lbServices.RegisterPlate.renovations
             *
             * @description
             *
             * Suprime todos los renovations de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.renovations.destroyAll = function() {
          var TargetResource = $injector.get("Renovation");
          var action = TargetResource["::delete::RegisterPlate::renovations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate.renovations#destroyById
             * @methodOf lbServices.RegisterPlate.renovations
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para renovations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para renovations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.renovations.destroyById = function() {
          var TargetResource = $injector.get("Renovation");
          var action = TargetResource["::destroyById::RegisterPlate::renovations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate.renovations#findById
             * @methodOf lbServices.RegisterPlate.renovations
             *
             * @description
             *
             * Buscar un elemento relacionado por id para renovations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para renovations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R.renovations.findById = function() {
          var TargetResource = $injector.get("Renovation");
          var action = TargetResource["::findById::RegisterPlate::renovations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RegisterPlate.renovations#updateById
             * @methodOf lbServices.RegisterPlate.renovations
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para renovations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RegisterPlate id
             *
             *  - `fk` – `{*}` - Clave foránea para renovations
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R.renovations.updateById = function() {
          var TargetResource = $injector.get("Renovation");
          var action = TargetResource["::updateById::RegisterPlate::renovations"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Renovation
 * @header lbServices.Renovation
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Renovation` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Renovation",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Renovations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Renovation.appUser() instead.
            "prototype$__get__appUser": {
              url: urlBase + "/Renovations/:id/appUser",
              method: "GET",
            },

            // INTERNAL. Use Renovation.registerPlate() instead.
            "prototype$__get__registerPlate": {
              url: urlBase + "/Renovations/:id/registerPlate",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#create
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Renovations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#createMany
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Renovations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#patchOrCreate
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Renovations",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#replaceOrCreate
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Renovations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#upsertWithWhere
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Renovations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#exists
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Renovations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#findById
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Renovations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#replaceById
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Renovations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#find
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Renovations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#findOne
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Renovations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#updateAll
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Renovations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#deleteById
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Renovations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#count
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Renovations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#prototype$patchAttributes
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Renovation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Renovations/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Renovation#createChangeStream
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Renovations/change-stream",
              method: "POST",
            },

            // INTERNAL. Use RegisterPlate.renovations.findById() instead.
            "::findById::RegisterPlate::renovations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/RegisterPlates/:id/renovations/:fk",
              method: "GET",
            },

            // INTERNAL. Use RegisterPlate.renovations.destroyById() instead.
            "::destroyById::RegisterPlate::renovations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/RegisterPlates/:id/renovations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use RegisterPlate.renovations.updateById() instead.
            "::updateById::RegisterPlate::renovations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/RegisterPlates/:id/renovations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use RegisterPlate.renovations() instead.
            "::get::RegisterPlate::renovations": {
              isArray: true,
              url: urlBase + "/RegisterPlates/:id/renovations",
              method: "GET",
            },

            // INTERNAL. Use RegisterPlate.renovations.create() instead.
            "::create::RegisterPlate::renovations": {
              url: urlBase + "/RegisterPlates/:id/renovations",
              method: "POST",
            },

            // INTERNAL. Use RegisterPlate.renovations.createMany() instead.
            "::createMany::RegisterPlate::renovations": {
              isArray: true,
              url: urlBase + "/RegisterPlates/:id/renovations",
              method: "POST",
            },

            // INTERNAL. Use RegisterPlate.renovations.destroyAll() instead.
            "::delete::RegisterPlate::renovations": {
              url: urlBase + "/RegisterPlates/:id/renovations",
              method: "DELETE",
            },

            // INTERNAL. Use RegisterPlate.renovations.count() instead.
            "::count::RegisterPlate::renovations": {
              url: urlBase + "/RegisterPlates/:id/renovations/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Renovation#upsert
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Renovation#updateOrCreate
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Renovation#patchOrCreateWithWhere
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Renovation#update
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Renovation#destroyById
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Renovation#removeById
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Renovation#updateAttributes
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Renovation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Renovation` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Renovation#modelName
        * @propertyOf lbServices.Renovation
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Renovation`.
        */
        R.modelName = "Renovation";


            /**
             * @ngdoc method
             * @name lbServices.Renovation#appUser
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Capta la relación belongsTo appUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Renovation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AppUser` object.)
             * </em>
             */
        R.appUser = function() {
          var TargetResource = $injector.get("AppUser");
          var action = TargetResource["::get::Renovation::appUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Renovation#registerPlate
             * @methodOf lbServices.Renovation
             *
             * @description
             *
             * Capta la relación belongsTo registerPlate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Renovation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RegisterPlate` object.)
             * </em>
             */
        R.registerPlate = function() {
          var TargetResource = $injector.get("RegisterPlate");
          var action = TargetResource["::get::Renovation::registerPlate"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Setting
 * @header lbServices.Setting
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Setting` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Setting",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Settings/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Setting#create
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Settings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#createMany
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Settings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#patchOrCreate
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Settings",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#replaceOrCreate
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Settings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#upsertWithWhere
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Settings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#exists
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Settings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#findById
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Settings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#replaceById
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Settings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#find
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Settings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#findOne
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Settings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#updateAll
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Settings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#deleteById
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Settings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#count
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Settings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#prototype$patchAttributes
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Setting id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Settings/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#createChangeStream
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Settings/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Setting#upsert
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#updateOrCreate
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#patchOrCreateWithWhere
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#update
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#destroyById
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#removeById
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#updateAttributes
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Setting id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Setting#modelName
        * @propertyOf lbServices.Setting
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Setting`.
        */
        R.modelName = "Setting";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Container
 * @header lbServices.Container
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Container` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Container",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Containers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Container#getContainers
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "getContainers": {
              isArray: true,
              url: urlBase + "/Containers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#createContainer
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "createContainer": {
              url: urlBase + "/Containers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#destroyContainer
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "destroyContainer": {
              url: urlBase + "/Containers/:container",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#getContainer
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "getContainer": {
              url: urlBase + "/Containers/:container",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#getFiles
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/Containers/:container/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#getFile
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string=}` -
             *
             *  - `file` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "getFile": {
              url: urlBase + "/Containers/:container/files/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#removeFile
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string=}` -
             *
             *  - `file` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "removeFile": {
              url: urlBase + "/Containers/:container/files/:file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#upload
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upload": {
              url: urlBase + "/Containers/:container/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#download
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string=}` -
             *
             *  - `file` – `{string=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/Containers/:container/download/:file",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Container#modelName
        * @propertyOf lbServices.Container
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Container`.
        */
        R.modelName = "Container";



        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && host !== urlBaseHost) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

      .state('index', {
        abstract: true,
        url: "/index",
        templateUrl: "app/components/common/content.html"
      })
      .state('index.minor', {
        url: "/minor",
        templateUrl: "app/minor/minor.html",
        data: { pageTitle: 'Example view 2' }
      });

    $urlRouterProvider.otherwise('/inicio/opciones');
  }

})();

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary" href="" ng-click="minimalize()"><i class="fa fa-bars" style="color: white"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })
    .directive('focusMe', function($timeout) {
        return {
            link: function(scope, element, attrs) {
                scope.$watch(attrs.focusMe, function(value) {
                    if(value === true) {
                        //console.log('value=',value);
                        //$timeout(function() {
                        element[0].focus();
                        scope[attrs.focusMe] = false;
                        //});
                    }
                });
            }
        };
    })

    .filter("trustUrl", ['$sce', function ($sce) {
        return function (recordingUrl) {
            return $sce.trustAsResourceUrl(recordingUrl);
        };
    }]);


angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div ng-controller=\"MainController as vm\" id=\"wrapper\" class=\"main-style\" style=\"background-color: #f3f3f4;\"><div ng-include=\"\'app/components/common/topnavbar.html\'\" style=\"padding: 0 10px; margin-bottom: 15px;\"></div><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" style=\"padding: 0 15px 0 15px; min-height: 0 !important\"><div ui-view=\"main\"></div></div></div>");
$templateCache.put("app/start/start.html","<div ui-view=\"start\" class=\"sizeStart bg-log-in\" style=\"overflow-x:auto; white-space: nowrap; background-color: #f4f4f4;\"></div>");
$templateCache.put("app/minor/minor.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Simple example of second view</h1><small>Configure in app.js as index.minor state.</small></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side main-style\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li style=\"height: 20px;background-color: #313639;border-top-right-radius: 27px;\"></li><li style=\"background-color: #313639\" ng-click=\"vm.changeState(option, $index)\" ng-repeat=\"option in vm.options\"><a ng-style=\"vm.navSelected == $index && {\'background-color\': \'rgb(87, 8, 168)\'}\"><i class=\"{{option.fav}}\"></i> <span class=\"nav-label text-options robotoslabBold\">{{option.name}}</span></a></li><li style=\"height: 20px;background-color: #313639;border-bottom-right-radius: 27px;\"></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top\" role=\"navigation\" style=\"margin-bottom: 0; background-color: white !important;\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span></div><ul class=\"nav navbar-top-links navbar-left noselect\"><li class=\"dropdown profile-dropdown topBarHover li-height noselect\"><a class=\"robotoslabBold\">{{\'v2.0 (08/10/26)\'}}</a></li></ul><ul class=\"nav navbar-top-links navbar-right noselect\"><li class=\"dropdown profile-dropdown topBarHover li-height noselect\"><a class=\"robotoslabBold\" ng-if=\"vm.user.role == \'Admin General\'\">{{vm.user.fullName + \' (Adminstrador)\'}}</a> <a class=\"robotoslabBold\" ng-if=\"vm.user.role == \'Trabajador\'\">{{vm.user.fullName + \' (Usuario)\'}}</a></li><li class=\"dropdown profile-dropdown topBarHover li-height noselect\"><a ng-click=\"vm.logoutModal()\" class=\"robotoslabBold\"><i class=\"fa fa-sign-out\"></i> Cerrar sesión</a></li></ul></nav></div>");
$templateCache.put("app/main/admin/admin.html","<div ui-view=\"admin\"></div>");
$templateCache.put("app/main/worker/worker.html","<div ui-view=\"worker\"></div>");
$templateCache.put("app/start/login/login.html","<div ng-controller=\"StartLoginController as vm\" class=\"text-center loginscreen login-2 no-padding\" style=\"background-color: inherit;\"><div id=\"a\"><div id=\"b\"><div id=\"content\"><div class=\"row\" style=\"width: 100%\"><div class=\"col-md-2\"></div><div class=\"col-md-4\" style=\"padding-top: 50px;\"><center><img class=\"img-responsive logo-login\" ng-src=\"assets/images/conapafa/conapafa3.png\"></center></div><div class=\"col-md-4\"><div class=\"row\" style=\"width: 100%\"><div style=\"padding: 0 20px 20px 20px\"><h2 class=\"pull-left\" style=\"color: black;font-size: 40px;font-weight: bold;\">Bienvenido</h2></div></div><div class=\"row\" style=\"width: 100%\"><div style=\"padding: 0 20px 20px 20px\"><h2 class=\"pull-left\" style=\"color: black;font-size: 20px;font-weight: 700; margin: 0 0 20px 0\">Inicia sesión para acceder al Software</h2></div></div><div class=\"row\" style=\"width: 100%\"><div style=\"padding: 0 20px 0 20px\"><div class=\"form-group\"><div class=\"inputContainer\"><i class=\"fa fa-user icon\"></i> <input class=\"field\" type=\"text\" placeholder=\"Usuario\" ng-model=\"vm.credentials.username\"></div></div><div class=\"form-group\"><div class=\"inputContainer\"><i class=\"fa fa-unlock-alt icon\"></i> <input class=\"field\" type=\"password\" placeholder=\"Contraseña\" ng-model=\"vm.credentials.password\"></div></div><button class=\"btn btn-w-primary block pull-right\" style=\"background-color: #e87b00;color: white;padding: 5px 45px;font-size: 30px;border-radius: 5px;\" ng-click=\"vm.login()\">Entrar</button></div></div></div><div class=\"col-md-2\"></div></div></div></div></div><div class=\"heightLogin hide-cards\" style=\"margin: 15px; padding-bottom: 100px;\"><div><center><img class=\"img-responsive logo-login\" ng-src=\"assets/images/conapafa/conapafa3.png\"></center></div><p style=\"color: #ffffffad; padding-top: 10px;\">Inicia sesión. Para acceder al software.</p><form class=\"m-t\" role=\"form\"><div class=\"form-group\"><div class=\"inputContainer\"><i class=\"fa fa-user icon\"></i> <input class=\"field\" type=\"text\" placeholder=\"Usuario\" ng-model=\"vm.credentials.username\"></div></div><div class=\"form-group\"><div class=\"inputContainer\"><i class=\"fa fa-unlock-alt icon\"></i> <input class=\"field\" type=\"password\" placeholder=\"Contraseña\" ng-model=\"vm.credentials.password\"></div></div><div class=\"form-group\"><button class=\"btn btn-w-primary block pull-right\" style=\"background-color: #e87b00;color: white;padding: 5px 45px;font-size: 30px;border-radius: 5px;\" ng-click=\"vm.login()\">Entrar</button></div></form></div></div>");
$templateCache.put("app/start/options/options.html","<div ng-controller=\"StartOptionsController as vm\" class=\"middle-box text-center loginscreen options-search no-padding\" style=\"background-color: inherit;\"><div class=\"heightLogin\"><div><center><img class=\"img-responsive logo-login\" ng-src=\"assets/images/conapafa/conapafa3.png\"></center></div><form class=\"m-t\" role=\"form\"><div style=\"display: flex; margin-bottom: 15px; align-items: center; justify-content: center;\"><center><button ng-click=\"vm.selectCarOrMoto(\'car\')\" class=\"btn\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'car\', \'btn-black-car\': vm.typeRegister == \'\' || vm.typeRegister == \'moto\'}\"><i class=\"fa fa-car\"></i></button> <button ng-click=\"vm.selectCarOrMoto(\'moto\')\" class=\"btn\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'moto\', \'btn-black-car\': vm.typeRegister == \'\' || vm.typeRegister == \'car\'}\"><i class=\"fa fa-motorcycle\"></i></button></center></div><h2 class=\"colorW name-shadow\">BUSCAR NÚMERO DE PLACA</h2><div class=\"form-group\" style=\"height: 35px; display: flex\"><label class=\"col-sm-3 name-shadow\" style=\"font-size: 25px;\">MEC-</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"00100\" style=\"border: 2px solid #029ed6;\" ng-model=\"vm.plateToSearch\"></div></div><div class=\"form-group\"><center><button ng-click=\"vm.platesOption()\" class=\"btn btn-w-primary block\" style=\"background-color: #e87b00;color: white;padding: 5px 45px;font-size: 25px;border-radius: 5px; width: 100%\">Buscar</button></center></div><div class=\"effect aeneas\"><center><div class=\"buttons\" style=\"display: flex;align-items: center;justify-content: center;\"><a href=\"https://www.facebook.com/1628074940817019/\" target=\"_blank\" class=\"fb\" style=\"margin-right: 5px;\"><i class=\"fa fa-facebook\" aria-hidden=\"true\"></i></a> <a href=\"https://www.instagram.com/conapafa_ac/\" target=\"_blank\" class=\"insta\" style=\"margin-left: 5px;\"><i class=\"fa fa-instagram\" aria-hidden=\"true\"></i></a></div></center></div></form></div></div>");
$templateCache.put("app/start/police/police.html","<div ng-controller=\"StartPoliceController as vm\" class=\"police-start\"><div class=\"ibox-content\" style=\"background-color: inherit; padding: 5px;\"><div class=\"form-horizontal buttons-together\"><h2 class=\"h-title-blue\" style=\"display: flex;\">Buscador de Placas POLICIA</h2></div><div class=\"form-horizontal buttons-list\"><h2 class=\"h-title-blue-police\"><center>Buscador de Placas</center></h2><h2 class=\"h-title-blue-police\"><center>POLICIA</center></h2></div><div class=\"form-horizontal\" style=\"padding: 15px 5px; border: 5px solid #313639; margin-bottom: 15px;\"><div class=\"row\" style=\"display: flex;margin: auto; padding-bottom: 5px;\"><h3 style=\"margin-right: 24px; color: black;\"><strong>Clave</strong></h3><input type=\"text\" class=\"form-control\" style=\"width: auto; height: auto;\" placeholder=\"Escribir clave\" ng-model=\"vm.code\"></div><div class=\"row row-full buttons-together\" style=\"margin: 5px 0 15px 0;\"><button class=\"btn btn-lg\" style=\"margin-right: 10px;\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'car\', \'btn-black-car\': vm.typeRegister == \'\' || vm.typeRegister == \'moto\'}\" ng-click=\"vm.selectCarOrMoto(\'car\')\"><i class=\"fa fa-car\">Vehículo</i></button> <button class=\"btn btn-lg\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'moto\', \'btn-black-car\': vm.typeRegister == \'\' || vm.typeRegister == \'car\'}\" ng-click=\"vm.selectCarOrMoto(\'moto\')\"><i class=\"fa fa-motorcycle\">Motocicleta</i></button></div><div class=\"row row-full buttons-list\" style=\"margin: 5px 0 15px 0;\"><button class=\"btn btn-lg btn-block\" style=\"margin-right: 10px;\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'car\', \'btn-black-car\': vm.typeRegister == \'\' || vm.typeRegister == \'moto\'}\" ng-click=\"vm.selectCarOrMoto(\'car\')\"><i class=\"fa fa-car\">Vehículo</i></button> <button class=\"btn btn-lg btn-block\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'moto\', \'btn-black-car\': vm.typeRegister == \'\' || vm.typeRegister == \'car\'}\" ng-click=\"vm.selectCarOrMoto(\'moto\')\"><i class=\"fa fa-motorcycle\">Motocicleta</i></button></div><div class=\"row row-full\" style=\"display: flex;\"><h2 style=\"margin-right: 5px; color: black;\"><strong>MEC-</strong></h2><input type=\"text\" class=\"form-control\" style=\"width: auto; height: auto;\" placeholder=\"Escribir placas\" ng-model=\"vm.plates\"> <button class=\"btn btn-md btn-w-primary\" ng-click=\"vm.searchPlates(vm.plates)\"><i class=\"fa fa-search\"></i></button></div></div><div class=\"form-horizontal\" ng-if=\"vm.platesFlag\"><h3 class=\"h-title-blue\" style=\"display: flex;\">Información del vehiculo:</h3></div><div class=\"form-horizontal\" ng-if=\"vm.platesFlag\" style=\"padding: 5px; border: 5px solid #313639;\"><div class=\"row row-full\" ng-if=\"vm.registerFlag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Registro</label> <label class=\"col-sm-8\" style=\"margin-top: 7px;color: black;\">{{vm.register.dateRegister | date}}</label></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Periodo</label> <label class=\"col-sm-8\" style=\"margin-top: 7px;color: black;\">{{vm.register.dateValidity | date}}</label></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Marca</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.brand\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Tipo</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.type\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Linea</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.line\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Modelo</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.model\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Color</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.color\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Numero de serie (VIN)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.vin\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Cilindros</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.cylinders\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Puertas</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.doors\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Numero de placas</label><div class=\"col-sm-6\" style=\"display: flex\"><label class=\"control-label\" style=\"color: black; margin: 2px 15px 0 0;\">MEC-</label> <input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.plates\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Lugar de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.registerLocationPlace\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Estatus</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border\" ng-class=\"{\'status-register-red\': vm.statusPlates == \'BAJA\', \'validity-register-yellow\': vm.statusPlates == \'VENCIDO\', \'validity-register-green\': vm.statusPlates == \'VIGENTE\' || vm.statusPlates == \'INDEFINIDO\'}\" readonly=\"\" ng-model=\"vm.statusPlates\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Nombre</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.fullName\"></div></div></div></div><h4 ng-if=\"!vm.registerFlag\" style=\"color: black; padding: 10px;\">No existe ese número de placa</h4></div></div></div>");
$templateCache.put("app/start/plates/plates.html","<div ng-controller=\"StartPlatesController as vm\" class=\"plates-start\"><div class=\"ibox-content\" style=\"background-color: inherit; padding: 5px;\"><div class=\"form-horizontal\"><h3 class=\"h-title-blue\" style=\"display: flex;\"><button ng-click=\"vm.return()\" class=\"btn btn-w-primary block\"><i class=\"fa fa-undo\"></i></button> <span style=\"margin: 8px 0 0 15px;\">Buscador de Placas MEC:</span></h3></div><div class=\"form-horizontal\" style=\"padding: 15px 5px; border: 5px solid #313639; margin-bottom: 15px;\"><div class=\"row row-full buttons-together\" style=\"margin: 5px 0 15px 0;\"><button class=\"btn btn-lg\" style=\"margin-right: 10px;\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'car\', \'btn-black-car\': vm.typeRegister == \'\' || vm.typeRegister == \'moto\'}\" ng-click=\"vm.selectCarOrMoto(\'car\')\"><i class=\"fa fa-car\">Vehículo</i></button> <button class=\"btn btn-lg\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'moto\', \'btn-black-car\': vm.typeRegister == \'\' || vm.typeRegister == \'car\'}\" ng-click=\"vm.selectCarOrMoto(\'moto\')\"><i class=\"fa fa-motorcycle\">Motocicleta</i></button></div><div class=\"row row-full buttons-list\" style=\"margin: 5px 0 15px 0;\"><button class=\"btn btn-lg btn-block\" style=\"margin-right: 10px;\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'car\', \'btn-black-car\': vm.typeRegister == \'\' || vm.typeRegister == \'moto\'}\" ng-click=\"vm.selectCarOrMoto(\'car\')\"><i class=\"fa fa-car\">Vehículo</i></button> <button class=\"btn btn-lg btn-block\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'moto\', \'btn-black-car\': vm.typeRegister == \'\' || vm.typeRegister == \'car\'}\" ng-click=\"vm.selectCarOrMoto(\'moto\')\"><i class=\"fa fa-motorcycle\">Motocicleta</i></button></div><div class=\"row row-full\" style=\"display: flex;\"><h2 style=\"margin-right: 5px; color: black;\"><strong>MEC-</strong></h2><input type=\"text\" class=\"form-control\" style=\"width: auto; height: auto;\" placeholder=\"Escribir placas\" ng-model=\"vm.plates\"> <button class=\"btn btn-md btn-w-primary\" ng-click=\"vm.searchPlates(vm.plates)\"><i class=\"fa fa-search\"></i></button></div></div><div class=\"form-horizontal\" ng-if=\"vm.platesFlag\"><h3 class=\"h-title-blue\" style=\"display: flex;\">Información del vehiculo:</h3></div><div class=\"form-horizontal\" ng-if=\"vm.platesFlag\" style=\"padding: 5px; border: 5px solid #313639;\"><div class=\"row row-full\" ng-if=\"vm.registerFlag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Registro</label> <label class=\"col-sm-8\" style=\"margin-top: 7px;color: black;\">{{vm.register.dateRegister | date}}</label></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Periodo</label> <label class=\"col-sm-8\" style=\"margin-top: 7px;color: black;\">{{vm.register.dateValidity | date}}</label></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Marca</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.brand\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Tipo</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.type\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Linea</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.line\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Modelo</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.model\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Color</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.color\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Numero de serie (VIN)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.vin\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Cilindros</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.cylinders\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Puertas</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.doors\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Numero de placas</label><div class=\"col-sm-6\" style=\"display: flex\"><label class=\"control-label\" style=\"color: black; margin: 2px 15px 0 0;\">MEC-</label> <input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.plates\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Lugar de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"color: black;text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.register.registerLocationPlace\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\" style=\"color: black;\">Estatus</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border\" ng-class=\"{\'status-register-red\': vm.statusPlates == \'BAJA\', \'validity-register-yellow\': vm.statusPlates == \'VENCIDO\', \'validity-register-green\': vm.statusPlates == \'VIGENTE\'}\" readonly=\"\" ng-model=\"vm.statusPlates\"></div></div></div></div><h4 ng-if=\"!vm.registerFlag\" style=\"color: black; padding: 10px;\">No existe ese número de placa</h4></div><div class=\"form-horizontal\" style=\"padding-top: 15px;\"><div class=\"row row-full\"><div class=\"effect aeneas\"><center><div class=\"buttons\" style=\"display: flex;align-items: center;justify-content: center;\"><a href=\"https://www.facebook.com/1628074940817019/\" target=\"_blank\" class=\"fb\" style=\"margin-right: 5px;\"><i class=\"fa fa-facebook\" aria-hidden=\"true\"></i></a> <a href=\"https://www.instagram.com/conapafa_ac/\" target=\"_blank\" class=\"insta\" style=\"margin-left: 5px;\"><i class=\"fa fa-instagram\" aria-hidden=\"true\"></i></a></div></center></div></div></div></div></div>");
$templateCache.put("app/main/admin/blockPage/blockPage.html","<div ng-controller=\"BlockPageAdminController as vm\" class=\"blockPage-admin\"><use></use><svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 1000 1000\" enable-background=\"new 0 0 1000 1000\" xml:space=\"preserve\" class=\"whistle\"><g><g transform=\"translate(0.000000,511.000000) scale(0.100000,-0.100000)\"><path d=\"M4295.8,3963.2c-113-57.4-122.5-107.2-116.8-622.3l5.7-461.4l63.2-55.5c72.8-65.1,178.1-74.7,250.8-24.9c86.2,61.3,97.6,128.3,97.6,584c0,474.8-11.5,526.5-124.5,580.1C4393.4,4001.5,4372.4,4001.5,4295.8,3963.2z\"></path><path d=\"M3053.1,3134.2c-68.9-42.1-111-143.6-93.8-216.4c7.7-26.8,216.4-250.8,476.8-509.3c417.4-417.4,469.1-463.4,526.5-463.4c128.3,0,212.5,88.1,212.5,224c0,67-26.8,97.6-434.6,509.3c-241.2,241.2-459.5,449.9-488.2,465.3C3181.4,3180.1,3124,3178.2,3053.1,3134.2z\"></path><path d=\"M2653,1529.7C1644,1445.4,765.1,850,345.8-32.7C62.4-628.2,22.2-1317.4,234.8-1960.8C451.1-2621.3,947-3186.2,1584.6-3500.2c1018.6-501.6,2228.7-296.8,3040.5,515.1c317.8,317.8,561,723.7,670.1,1120.1c101.5,369.5,158.9,455.7,360,553.3c114.9,57.4,170.4,65.1,1487.7,229.8c752.5,93.8,1392,181.9,1420.7,193.4C8628.7-857.9,9900,1250.1,9900,1328.6c0,84.3-67,172.3-147.4,195.3c-51.7,15.3-790.8,19.1-2558,15.3l-2487.2-5.7l-55.5-63.2l-55.5-61.3v-344.6V719.8h-411.7h-411.7v325.5c0,509.3,11.5,499.7-616.5,494C2921,1537.3,2695.1,1533.5,2653,1529.7z\"></path></g></g></svg><h1>403</h1><h2>No tienes acceso a esta vista</h2></div>");
$templateCache.put("app/main/admin/extract/extract.html","<div ng-controller=\"AdminDashboardController as vm\" class=\"extract-admin\"><div class=\"ibox-content\"><div class=\"form-horizontal\"><h2 class=\"h-title-blue\">Extracción de Excel</h2></div></div></div>");
$templateCache.put("app/main/admin/searcher/searcher.html","<div ng-controller=\"SearcherAdminController as vm\" class=\"searcher-admin\"><div class=\"ibox-content\"><div class=\"form-horizontal\"><h2 class=\"h-title-blue\">Buscador General:</h2><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nombre(s)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" focus-me=\"true\" ng-model=\"vm.infoToSearch.fullName\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Apellido Paterno</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.infoToSearch.lastNameFather\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Apellido Materno</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.infoToSearch.lastNameMother\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Teléfono</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.infoToSearch.telephone\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Vin</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.infoToSearch.vin\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Placa</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.infoToSearch.plate\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Buscar</label><div class=\"col-sm-8\"><button class=\"btn btn-w-primary\" style=\"width: 100%;\" ng-click=\"vm.search()\"><i class=\"fa fa-search\"></i></button></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Borrar datos</label><div class=\"col-sm-8\"><button class=\"btn btn-danger\" style=\"width: 100%;\" ng-click=\"vm.deleteInfo()\"><i class=\"fa fa-trash\"></i></button></div></div></div></div></div></div><div class=\"ibox-content-list-2\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.items.length==0\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.items.length!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Placas</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Tipo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Telefono</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Marca</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">VIN</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Registro</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Vigencia</th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t validity-register-green\" style=\"border: none; font-size: 15px;\" ng-if=\"!item.isExpired\"><center>VIGENTE</center></td><td class=\"t validity-register-yellow\" style=\"border: none; font-size: 15px;\" ng-if=\"item.isExpired\"><center>VENCIDO</center></td><td class=\"t\" style=\"border: none; font-size: 15px;\" ng-if=\"item.status\"></td><td class=\"t status-register-red\" style=\"border: none; font-size: 15px;\" ng-if=\"!item.status\"><center>BAJA</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.seeRegister($index);\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{\'MEC- \' + item.plates}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><span ng-if=\"item.typeRegister == \'car\'\">{{\'Vehículo\'}}</span> <span ng-if=\"item.typeRegister == \'moto\'\">{{\'Motocicleta\'}}</span></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.fullName + \' \'+ item.lastNameFather + \' \'+ item.lastNameMother}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.telephone}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.brand}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.vin}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.dateRegister | date}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.dateValidity | date}}</td></tr></tbody></table></div></div></div></div><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center></div>");
$templateCache.put("app/main/admin/settings/settings.html","<div ng-controller=\"SettingsAdminController as vm\" class=\"settings-admin\"><div class=\"ibox-content\"><div class=\"form-horizontal\"><h2 class=\"h-title-blue\">Configuración</h2><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Margen Y PDF</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control t\" ng-model=\"vm.settings.marginY\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Clave Policia</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" ng-model=\"vm.settings.policeCode\"></div></div></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\">Actualizar</button></div></div></div></div></div>");
$templateCache.put("app/main/admin/dashboard/dashboard.html","<div ng-controller=\"AdminDashboardController as vm\" class=\"dashboard-admin\"><div class=\"ibox-content\"><div class=\"form-horizontal\"><h2 class=\"h-title-blue\">Buscador de Placas MEC:</h2><div class=\"row\" style=\"margin: 5px 0 15px 0;\"><button class=\"btn btn-lg\" style=\"margin-right: 10px;\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'car\'}\" ng-click=\"vm.selectCarOrMoto(\'car\')\"><i class=\"fa fa-car\" style=\"margin-right: 10px;\"></i>{{\'Vehículo\'}}</button> <button class=\"btn btn-lg\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'moto\'}\" ng-click=\"vm.selectCarOrMoto(\'moto\')\"><i class=\"fa fa-motorcycle\" style=\"margin-right: 10px;\"></i>{{\'Motocicleta\'}}</button></div><div class=\"row\" style=\"display: flex;margin: auto;\"><h2 style=\"margin-right: 15px;font-weight: bold;\">MEC-</h2><input type=\"text\" class=\"form-control\" style=\"width: 260px; height: auto;\" placeholder=\"Escribir placas o numero de serie\" ng-model=\"vm.plates\"> <button class=\"btn btn-md btn-w-primary\" ng-click=\"vm.searchPlates(vm.plates)\"><i class=\"fa fa-search\"></i></button></div><h3 class=\"h-title-blue\" style=\"margin-top: 15px;\" ng-if=\"vm.platesFlag\">Información del vehiculo:</h3><div class=\"row\" ng-if=\"vm.registerFlag && vm.platesFlag\"><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Registro</label> <label class=\"col-sm-8\" style=\"margin-top: 7px;\">{{vm.register.dateRegister | date}}</label></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Periodo</label> <label class=\"col-sm-8\" style=\"margin-top: 7px;\">{{vm.register.dateValidity | date}}</label></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Marca</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.brand\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Tipo</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.type\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Linea</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.line\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Modelo</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.model\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Color</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.color\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Numero de serie (VIN)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.vin\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Cilindros</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.cylinders\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Puertas</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.doors\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Numero de placas</label> <label class=\"col-sm-2 control-label\">MEC-</label><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.plates\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Lugar de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.registerLocationPlace\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estatus</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border\" ng-class=\"{\'status-register-red\': vm.statusPlates == \'BAJA\', \'validity-register-yellow\': vm.statusPlates == \'VENCIDO\', \'validity-register-green\': vm.statusPlates == \'VIGENTE\'}\" readonly=\"\" ng-model=\"vm.statusPlates\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nombre</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.fullName\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Afiliado</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.appUser.fullName\"></div></div></div></div><h4 ng-if=\"!vm.registerFlag && vm.platesFlag\">No existe ese número de placa</h4></div></div></div>");
$templateCache.put("app/main/worker/dashboard/dashboard.html","<div ng-controller=\"DashboardWorkerController as vm\" class=\"dashboard-worker\"><div class=\"ibox-content\"><div class=\"form-horizontal\"><h2 class=\"h-title-blue\">Buscador de Placas MEC:</h2><div class=\"row\" style=\"margin: 5px 0 15px 0;\"><button class=\"btn btn-lg\" style=\"margin-right: 10px;\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'car\'}\" ng-click=\"vm.selectCarOrMoto(\'car\')\"><i class=\"fa fa-car\" style=\"margin-right: 10px;\"></i>{{\'Vehículo\'}}</button> <button class=\"btn btn-lg\" ng-class=\"{\'btn-blue-car\': vm.typeRegister === \'moto\'}\" ng-click=\"vm.selectCarOrMoto(\'moto\')\"><i class=\"fa fa-motorcycle\" style=\"margin-right: 10px;\"></i>{{\'Motocicleta\'}}</button></div><div class=\"row\" style=\"display: flex;margin: auto;\"><h2 style=\"margin-right: 15px;font-weight: bold;\">MEC-</h2><input type=\"text\" class=\"form-control\" style=\"width: 260px; height: auto;\" placeholder=\"Escribir placas o numero de serie\" ng-model=\"vm.plates\"> <button class=\"btn btn-md btn-w-primary\" ng-click=\"vm.searchPlates(vm.plates)\"><i class=\"fa fa-search\"></i></button></div><div class=\"hr-line-dashed\" ng-if=\"vm.platesFlag\"></div><h3 class=\"h-title-blue\" ng-if=\"vm.platesFlag\">Información del vehiculo:</h3><div class=\"hr-line-dashed\" ng-if=\"vm.registerFlag && vm.platesFlag\"></div><div class=\"row\" ng-if=\"vm.registerFlag && vm.platesFlag\"><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Registro</label> <label class=\"col-sm-8\" style=\"margin-top: 7px;\">{{vm.register.dateRegister | date}}</label></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Periodo</label> <label class=\"col-sm-8\" style=\"margin-top: 7px;\">{{vm.register.dateValidity | date}}</label></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Marca</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.brand\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Tipo</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.type\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Linea</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.line\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Modelo</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.model\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Color</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.color\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Numero de serie (VIN)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.vin\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Cilindros</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.cylinders\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Puertas</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.doors\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Numero de placas</label> <label class=\"col-sm-2 control-label\">MEC-</label><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.plates\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Lugar de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.registerLocationPlace\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estatus</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border\" ng-class=\"{\'status-register-red\': vm.statusPlates == \'BAJA\', \'validity-register-yellow\': vm.statusPlates == \'VENCIDO\', \'validity-register-green\': vm.statusPlates == \'VIGENTE\'}\" readonly=\"\" ng-model=\"vm.statusPlates\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nombre</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" style=\"text-transform: uppercase;\" readonly=\"\" ng-model=\"vm.fullName\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group height-plate-input\"><label class=\"col-sm-4 control-label\">Afiliado</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t input-border input-white\" readonly=\"\" ng-model=\"vm.register.appUser.fullName\"></div></div></div></div><div class=\"hr-line-dashed\" ng-if=\"!vm.registerFlag && vm.platesFlag\"></div><h4 ng-if=\"!vm.registerFlag && vm.platesFlag\">No existe ese número de placa</h4></div></div></div>");
$templateCache.put("app/components/common/directives/extras/extras.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\" style=\"font-size:40px;\"><span aria-hidden=\"true\">&times;</span></button><h2 class=\"modal-title gravityBold\">Añadir Extrassss</h2></div><div class=\"modal-body extras\"><div class=\"row row-button\"><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.optionWith\" ng-change=\"vm.changeOptionWith()\" ng-options=\"product for product in vm.products\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Opción --</option></select></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Bordado\'\"><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.embroideryType\" ng-change=\"vm.changeEmbroideryType()\" ng-options=\"option for option in vm.embroideryTypes\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Tipo --</option></select></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Bordado\'\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 margin-top-qty control-label robotoslabRegular\">Cantidad</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control robotoslabLight\" ng-model=\"vm.quantityEmbroideries\"></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Bordado\'\"><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary padding-btn pull-left robotoslabRegular\" type=\"submit\" ng-disabled=\"vm.embroideryType == \'\' || vm.createBlock\" ng-click=\"vm.addEmbroidery()\">Añadir Bordado</button></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Serigrafía\'\"><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.serigraphyBackground\" ng-change=\"vm.changeSerigraphyBackground()\" ng-options=\"option for option in vm.serigraphyBackgrounds\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Fondo --</option></select></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.serigraphyInk\" ng-change=\"vm.changeSerigraphyInks()\" ng-options=\"option for option in vm.serigraphyInks\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Numero de Tintas --</option></select></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.serigraphyType\" ng-change=\"vm.changeSerigraphyType()\" ng-options=\"option for option in vm.serigraphyTypes\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar tipo --</option></select></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Serigrafía\'\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 margin-top-qty control-label robotoslabRegular\">Cantidad</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control robotoslabLight\" ng-model=\"vm.quantitySerigraphys\"></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Serigrafía\'\"><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary padding-btn pull-left robotoslabRegular\" type=\"submit\" ng-disabled=\"vm.serigraphyType == \'\' || vm.createBlock\" ng-click=\"vm.addSerigraphy()\">Añadir Sergirafía</button></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Transfer\'\"><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.transferBackground\" ng-change=\"vm.changeTransferBackground()\" ng-options=\"option for option in vm.transferBackgrounds\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Fondo --</option></select></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.transferSize\" ng-change=\"vm.changeTransferSize()\" ng-options=\"option for option in vm.transferSizes\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Tamaño --</option></select></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Transfer\'\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 margin-top-qty control-label robotoslabRegular\">Cantidad</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control robotoslabLight\" ng-model=\"vm.quantityTransfers\"></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Transfer\'\"><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary padding-btn pull-left robotoslabRegular\" type=\"submit\" ng-disabled=\"vm.transferSize == \'\' || vm.createBlock\" ng-click=\"vm.addTransfer()\">Añadir Transfer</button></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Vinil\'\"><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.vinylColor\" ng-change=\"vm.changeVinylColor()\" ng-options=\"option for option in vm.vinylColors\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Color --</option></select></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.vinylNumberColor\" ng-change=\"vm.changeVinylNumberColor()\" ng-options=\"option for option in vm.vinylNumberColors\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Número Colores --</option></select></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.vinylSize\" ng-change=\"vm.changeVinylSize()\" ng-options=\"option for option in vm.vinylSizes\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Tamaño --</option></select></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Vinil\'\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 margin-top-qty control-label robotoslabRegular\">Cantidad</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control robotoslabLight\" ng-model=\"vm.quantityVinyls\"></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Vinil\'\"><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary padding-btn pull-left robotoslabRegular\" type=\"submit\" ng-disabled=\"vm.vinylSize == \'\' || vm.createBlock\" ng-click=\"vm.addVinyl()\">Añadir Vinil</button></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Sublimación\'\"><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.sublimationSize\" ng-change=\"vm.changeSublimationSize()\" ng-options=\"option for option in vm.sublimationSizes\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Tamaño --</option></select></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Sublimación\'\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 margin-top-qty control-label robotoslabRegular\">Cantidad</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control robotoslabLight\" ng-model=\"vm.quantitySublimations\"></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Sublimación\'\"><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary padding-btn pull-left robotoslabRegular\" type=\"submit\" ng-disabled=\"vm.sublimationSize == \'\' || vm.createBlock\" ng-click=\"vm.addSublimation()\">Añadir Sublimación</button></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Laser\'\"><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.laserSize\" ng-change=\"vm.changeLaserSize()\" ng-options=\"option for option in vm.laserSizes\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Tamaño --</option></select></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Laser\'\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 margin-top-qty control-label robotoslabRegular\">Cantidad</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control robotoslabLight\" ng-model=\"vm.quantityLasers\"></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Laser\'\"><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary padding-btn pull-left robotoslabRegular\" type=\"submit\" ng-disabled=\"vm.laserSize == \'\' || vm.createBlock\" ng-click=\"vm.addLaser()\">Añadir Laser</button></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Confección\'\"><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.confectionType\" ng-change=\"vm.changeConfectionType()\" ng-options=\"option for option in vm.confectionTypes\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Tamaño --</option></select></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Confección\'\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 margin-top-qty control-label robotoslabRegular\">Cantidad</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control robotoslabLight\" ng-model=\"vm.quantityConfections\"></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Confección\'\"><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary padding-btn pull-left robotoslabRegular\" type=\"submit\" ng-disabled=\"vm.confectionType == \'\' || vm.createBlock\" ng-click=\"vm.addConfection()\">Añadir Confección</button></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Promocionales\'\"><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.promotionalName\" ng-change=\"vm.changePromotionalName()\" ng-options=\"option for option in vm.promotionalNames\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Nombre --</option></select></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.promotionalBrand\" ng-change=\"vm.changePromotionalBrand()\" ng-options=\"option for option in vm.promotionalBrands\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Marca --</option></select></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><select class=\"form-control\" ng-model=\"vm.promotionalModel\" ng-change=\"vm.changePromotionalModel()\" ng-options=\"option for option in vm.promotionalModels\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar Modelo --</option></select></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Promocionales\'\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label robotoslabRegular\" style=\"padding-top: 8px; !important;\">Cantidad</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control robotoslabLight\" ng-model=\"vm.quantityPromotionals\"></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary padding-btn pull-left robotoslabRegular\" type=\"submit\" ng-disabled=\"vm.createBlock\" ng-click=\"vm.addExtra()\">Extras</button></div></div></div></div><div class=\"row row-button\" ng-show=\"vm.optionWith == \'Promocionales\'\"><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary padding-btn pull-left robotoslabRegular\" type=\"submit\" ng-disabled=\"vm.promotionalModel == \'\' || vm.createBlock\" ng-click=\"vm.addPromotional()\">Añadir Promocional</button></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row row-button\"><div class=\"col-sm-12\"><h3><center>Lista de Extras</center></h3><div class=\"hr-line-dashed\"></div><div class=\"slimScrollDiv\" style=\"position: relative; overflow: hidden; width: auto; height: 100%;\" ng-if=\"vm.totalItems.length != 0\"><div class=\"full-height-scroll\" style=\"overflow: hidden; width: auto; height: 100%;\"><div class=\"table-responsive no-margin\"><table class=\"table table-striped table-hover\"><thead><tr><th classhowmessages=\"robotoslabRegular\">Cantidad</th><th class=\"robotoslabRegular\">Descripción</th><th class=\"robotoslabRegular\">Precio Unitario</th><th class=\"robotoslabRegular\">Precio Recomendado</th><th class=\"robotoslabRegular\">Precio</th><th class=\"robotoslabRegular\"></th></tr></thead><tbody><tr ng-repeat=\"item in vm.totalItems track by $index\"><td class=\"robotoslabLight\">{{ item.quantity }}</td><td class=\"robotoslabLight\">{{ item.description }}</td><td class=\"robotoslabLight\">{{ item.price | currency }}</td><td class=\"robotoslabLight\">{{ item.priceTotal | currency }}</td><td class=\"robotoslabLight\"><input type=\"number\" class=\"form-control robotoslabLight\" ng-change=\"vm.calculateTotalPrice()\" ng-model=\"item.priceToChange\"></td><td class=\"robotoslabLight\"><button ng-click=\"vm.deleteItem($index)\" class=\"btn btn-cancel padding-btn pull-right robotoslabRegular\" type=\"submit\">Borrar</button></td></tr><tr><td class=\"robotoslabLight\"></td><td class=\"robotoslabLight\"></td><td class=\"robotoslabLight\"></td><td class=\"robotoslabLight\">SubTotal</td><td class=\"robotoslabLight\">{{ vm.subTotalCotization | currency }}</td><td class=\"robotoslabLight\"></td></tr><tr><td class=\"robotoslabLight\"></td><td class=\"robotoslabLight\"></td><td class=\"robotoslabLight\"></td><td class=\"robotoslabLight\">Iva</td><td class=\"robotoslabLight\">{{ vm.ivaCotization | currency }}</td><td class=\"robotoslabLight\"></td></tr><tr><td class=\"robotoslabLight\"></td><td class=\"robotoslabLight\"></td><td class=\"robotoslabLight\"></td><td class=\"robotoslabLight\">Total</td><td class=\"robotoslabLight\">{{ vm.totalCotization | currency }}</td><td class=\"robotoslabLight\"></td></tr></tbody></table></div></div><div class=\"slimScrollBar\" style=\"width: 7px; position: absolute; top: 0px; opacity: 0.4; display: none; border-radius: 7px; z-index: 99; right: 1px; height: 365.112px; background: rgb(0, 0, 0);\"></div><div class=\"slimScrollRail\" style=\"width: 7px; height: 100%; position: absolute; top: 0px; display: none; border-radius: 7px; opacity: 0.2; z-index: 90; right: 1px; background: rgb(51, 51, 51);\"></div></div><h3 ng-if=\"vm.totalItems.length == 0\"><center>Aún no tienes extras</center></h3></div></div></div><div class=\"modal-footer mails\"><div><button type=\"button\" class=\"btn btn-w-primary footer-buttons gravityBook\" ng-click=\"vm.addExtras()\">Agregar</button> <button type=\"button\" class=\"btn btn-white footer-buttons gravityBook\" ng-click=\"vm.cancel()\">Cancelar</button></div></div>");
$templateCache.put("app/components/common/directives/googlePlaces/googlePlaces.html","<div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label robotoslabRegular\">Latitud</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control robotoslabLight\" placeholder=\"0.0\" focus-me=\"true\" ng-model=\"config.latNumber\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': config.latNumber == undefined && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label robotoslabRegular\">Longuitud</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control robotoslabLight\" placeholder=\"0.0\" ng-model=\"config.lngNumber\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': config.lngNumber == undefined && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label robotoslabRegular\">Ubicación</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control gravityBook\" g-places-autocomplete=\"\" force-selection=\"true\" ng-model=\"config.place\" placeholder=\"Ubicación\"></div></div></div><div class=\"col-sm-6\"><ng-map center=\"[{{config.lat}}, {{config.lng}}]\" zoom=\"{{config.zoom}}\"><marker ng-repeat=\"p in config.positions\" position=\"{{p}}\"></marker></ng-map></div>");
$templateCache.put("app/components/common/directives/filterBy/filterBy.html","<div class=\"filter-by col-lg-3 col-md-4 col-sm-12 col-xs-12 pull-right hide-list padding-search-filter\" id=\"filter-by\" style=\"margin: auto; height: auto\" ng-if=\"config.paginationFor!=0 || config.searchedItems\"><select class=\"form-control\" ng-change=\"vm.selectFilter()\" ng-model=\"vm.itemSelected\" ng-options=\"item.order as item.name for item in config.collection\"><option disabled=\"\" selected=\"\" value=\"\">-- Filtrar por --</option></select></div>");
$templateCache.put("app/components/common/directives/googlePlacesDrawing/googlePlacesDrawing.html","<div class=\"google-places-drawing col-sm-12\"><div class=\"col-sm-6\"><div class=\"row input-map\"><div class=\"form-group input-height\"><label class=\"col-sm-3 control-label robotoslabRegular\">Latitud</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control robotoslabLight\" placeholder=\"0.0\" focus-me=\"true\" ng-disabled=\"!config.flagUpdate\" ng-model=\"vm.lat\" ng-keypress=\"vm.enterFunction($event)\"></div></div><div class=\"form-group input-height\"><label class=\"col-sm-3 control-label robotoslabRegular\">Longuitud</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control robotoslabLight\" placeholder=\"0.0\" ng-disabled=\"!config.flagUpdate\" ng-model=\"vm.lng\" ng-keypress=\"vm.enterFunction($event)\"></div></div><div class=\"form-group input-height\"><label class=\"col-sm-3 control-label robotoslabRegular\">Ubicación</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control gravityBook\" g-places-autocomplete=\"\" force-selection=\"true\" ng-model=\"vm.place\" placeholder=\"Ubicación\" ng-disabled=\"!config.flagUpdate\"></div></div><div class=\"form-group input-height\"><div class=\"col-sm-12\"><button class=\"btn btn-w-primary pull-right\" type=\"submit\" ng-click=\"vm.resetMap()\" ng-disabled=\"!config.updateFlag\">Reiniciar</button></div></div></div></div><div class=\"col-sm-6\"><div class=\"row row-map\"><div id=\"mapRubaDirective\"></div></div></div></div>");
$templateCache.put("app/components/common/directives/indicatorWidget/indicatorWidget.html","<div class=\"col-lg-4 col-sm-6 col-xs-12\" ng-click=\"vm.goTo()\"><div class=\"indicator-widget widget style1 wiz-details\" ng-style=\"vm.style\" ng-mouseenter=\"vm.hoverIn()\" ng-mouseleave=\"vm.hoverOut()\"><div class=\"row\"><div class=\"col-xs-12 height-number\"><h3 ng-if=\"config.quantity!=undefined\" class=\"font-bold pull-right wiz-number-size\">{{config.quantity}}</h3><h2 ng-if=\"config.quantity==undefined\" class=\"font-bold pull-right wiz-number-size\"></h2></div><div class=\"col-xs-12\"><center><i class=\"fa {{config.icon}} wiz-icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-xs-12 wiz-title\"><center><pre class=\"wiz-title-font word-widget robotoslabBold\"> {{config.title}} </pre></center></div></div></div></div>");
$templateCache.put("app/components/common/directives/indicatorWidget/titleWidget.html","<div class=\"ibox-content section-title\"><div class=\"row\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><i class=\"fa {{icon}} icon-font\" aria-hidden=\"true\"></i></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white robotoslabBold\">{{title}}</h2></div><div ng-show=\"addButton\" class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-w-m btn-border-radius btn-w-primary pull-right robotoslabRegular\" ng-click=\"whenClickAdd()\"><i class=\"fa {{iconButton}} plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{buttonName}}</button></div></div></div>");
$templateCache.put("app/components/common/directives/indicatorWidget3/indicatorWidget3.html","<div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\" ng-click=\"vm.goTo()\"><div class=\"indicator-widget-3 widget style1 wiz-details\" ng-style=\"vm.style\" ng-mouseenter=\"vm.hoverIn()\" ng-mouseleave=\"vm.hoverOut()\"><div class=\"row\"><div class=\"col-xs-12 height-number\"><h3 ng-if=\"config.quantity!=undefined\" class=\"font-bold pull-right wiz-number-size\">{{config.quantity}}</h3><h2 ng-if=\"config.quantity==undefined\" class=\"font-bold pull-right wiz-number-size\"></h2></div><div class=\"col-xs-12\"><center><i class=\"fa {{config.icon}} wiz-icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-xs-12 wiz-title\"><center><pre class=\"wiz-title-font word-widget robotoslabBold\"> {{config.title}} </pre></center></div></div></div></div>");
$templateCache.put("app/components/common/directives/listModel/listModel.html","<div class=\"list-model\"><div class=\"ibox-content ibox-padding-search-filter\"><div class=\"row row-width-margin\"><div class=\"col-lg-9 col-md-8 col-sm-12 col-xs-12 padding-search-filter\" ng-show=\"config.paginationFor!=0 || config.searchedItems\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control robotoslabRegular hide-list\" placeholder=\"{{config.somePlaceholder}}\" ng-model=\"config.itemsText\" ng-keypress=\"vm.enterFunction($event)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary robotoslabRegular hide-list\" ng-click=\"vm.searchText(config.itemsText)\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div><div class=\"filter-by col-lg-3 col-md-4 col-sm-12 col-xs-12 pull-right hide-list padding-search-filter\" id=\"filter-by\" style=\"margin: auto; height: auto\" ng-show=\"config.paginationFor!=0 || config.searchedItems\"><select class=\"form-control\" ng-change=\"vm.filterList()\" ng-model=\"vm.itemSelected\" ng-options=\"item.order as item.name for item in config.collection\"><option disabled=\"\" selected=\"\" value=\"\">-- Filtrar por --</option></select></div></div></div><div class=\"ibox-content ibox-padding-table hide-list\"><h2 ng-show=\"config.paginationFor==0 && !config.searchedItems\"><center>No tienes nada aún</center></h2><h2 ng-show=\"config.paginationFor==0 && config.searchedItems\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"config.paginationFor!=0\"><div class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\" style=\"margin: 0\"><thead class=\"border-none\"><tr role=\"row\" class=\"border-none\"><th class=\"sorting border-none robotoslabBold\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" ng-repeat=\"title in config.titlesList track by $index\" ng-style=\"title.style\">{{title.name}}</th></tr></thead><tbody class=\"border-none\"><tr class=\"gradeA odd border-none\" role=\"row\" ng-repeat=\"itemList in config.itemsList track by $index\"><td class=\"robotoslabLight border-none\" ng-repeat=\"item in itemList track by $index\"><div ng-show=\"!item.buttonFlag && !item.styleFlag\" ng-style=\"item.styleRow\">{{item.name}}</div><div ng-show=\"!item.buttonFlag && item.styleFlag && item.style==\'currency\'\">{{item.name | currency}}</div><div ng-show=\"!item.buttonFlag && item.styleFlag && item.style==\'date\'\">{{item.name | date}}</div><div ng-show=\"item.buttonFlag\" ng-style=\"item.styleRow\"><button class=\"btn btn-w-primary btn-border-radius robotoslabBold\" ng-show=\"item.buttonColor==\'btn-shipment-bale-to\'\" ng-click=\"config.baleShipments($parent.$index);\">{{item.name}}</button> <button class=\"btn btn-w-primary btn-border-radius robotoslabBold\" ng-show=\"item.buttonColor==\'btn-shipment-client\'\" ng-click=\"config.clientShipments($parent.$index);\">{{item.name}}</button> <button class=\"btn btn-w-primary btn-border-radius robotoslabBold\" ng-show=\"item.buttonColor==\'btn-shipment-client-details\'\" ng-click=\"config.clientShipmentDetails($parent.$index);\">{{item.name}}</button> <button class=\"btn btn-w-primary btn-border-radius robotoslabBold\" ng-show=\"item.buttonColor==\'btn-shipment-trucker\'\" ng-click=\"config.truckerShipment($parent.$index);\">{{item.name}}</button> <button type=\"button\" class=\"btn {{item.buttonColor}} btn-border-radius robotoslabBold\" ng-show=\"item.buttonColor==\'btn-w-primary\'\" ng-click=\"config.editModule($parent.$index);\">{{item.name}}</button> <button class=\"btn btn-cancel robotoslabBold\" ng-show=\"item.buttonColor==\'btn-cancel\'\" ng-click=\"config.deleteModule($parent.$index);\">{{item.name}}</button></div></td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"config.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"config.pageSelected\" ng-change=\"vm.changePage(config.pageSelected)\" ng-options=\"page for page in config.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div><div class=\"ibox-content ibox-padding-table hide-cards\"><h2 ng-show=\"config.paginationFor==0\"><center>No tienes nada aún</center></h2><div class=\"row row-style\" ng-repeat=\"itemList in config.itemsList track by $index\" ng-show=\"config.paginationFor!=0\"><div ng-repeat=\"item in itemList track by $index\" class=\"col-xs-12 no-padding\"><div class=\"row row-width-margin\"><div ng-show=\"!item.buttonFlag\" class=\"col-xs-12\"><div class=\"row\"><div class=\"col-sm-6 col-xs-6\"><h4 class=\"robotoslabRegular\">{{config.titlesList[$index].name}} :</h4></div><div class=\"col-sm-6 col-xs-6\"><h4 class=\"robotoslabBold\" ng-show=\"!item.buttonFlag && !item.styleFlag\" ng-style=\"item.styleRow\">{{item.name}}</h4><h4 class=\"robotoslabBold\" ng-show=\"!item.buttonFlag && item.styleFlag && item.style==\'currency\'\">{{item.name | currency}}</h4><h4 class=\"robotoslabBold\" ng-show=\"!item.buttonFlag && item.styleFlag && item.style==\'date\'\">{{item.name | date}}</h4></div></div></div><div ng-show=\"item.buttonFlag\" class=\"col-xs-12\"><center><button class=\"btn {{item.buttonColor}} btn-block pull-right robotoslabBold\" ng-show=\"item.buttonColor!=\'btn-cancel\'\" ng-click=\"config.editModule($parent.$index);\">{{item.name}}</button> <button class=\"btn btn-block btn-cancel robotoslabBold pull-right\" ng-show=\"item.buttonColor==\'btn-cancel\'\" ng-click=\"config.deleteModule($parent.$index);\">{{item.name}}</button></center></div></div></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"config.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"config.pageSelected\" ng-change=\"vm.changePage(config.pageSelected)\" ng-options=\"page for page in config.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div><br><br></div>");
$templateCache.put("app/components/common/directives/printPDF/printPDF.html","<div class=\"print-pdf ibox-content section-title\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" aria-label=\"Close\" style=\"font-size:40px;\"><span aria-hidden=\"true\">&times;</span></button><h2 class=\"modal-title gravityBold\"><strong>PDF de Embarque</strong></h2></div><div class=\"row row-width-margin\"><div class=\"col-xs-12\" ng-style=\"{\'height\': vm.windowHeight}\"><iframe class=\"preview-pane\" id=\"pdfName\" name=\"pdfName\" type=\"application/pdf\" width=\"100%\" height=\"100%\" frameborder=\"0\" style=\"position:relative;z-index:999\" src=\"{{vm.pdf | trustUrl}}\"></iframe></div></div><div class=\"modal-footer\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-w-primary padding-btn margin-button robotoslabRegular\" ng-click=\"vm.print()\">Imprimir</button> <button type=\"button\" class=\"btn btn-w-primary padding-btn margin-button robotoslabRegular\" ng-click=\"vm.save()\">Guardar</button> <button type=\"button\" class=\"btn btn-white gravityBook\" ng-click=\"vm.cancel()\">Cerrar</button></div></div></div>");
$templateCache.put("app/components/common/directives/searchList/searchList.html","<div class=\"col-lg-9 col-md-8 col-sm-12 col-xs-12 padding-search-filter\" ng-show=\"paginationFor!=0 || searchedItems\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control robotoslabRegular hide-list\" placeholder=\"{{somePlaceholder}}\" ng-model=\"itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary robotoslabRegular hide-list\" ng-click=\"whenClick()\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div>");
$templateCache.put("app/components/common/directives/showMessage/showMessage.html","<div class=\"show-message\"><div class=\"no-authorize\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 padding-search-filter\"><center><h2 class=\"font-message\"><strong>No tienes ninguna marca dada de alta</strong></h2></center></div></div></div></div>");
$templateCache.put("app/components/common/directives/titleModel/titleModel.html","<div class=\"title-model ibox-content section-title\" ng-style=\"config.style\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa {{config.icon}} icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white robotoslabBold\">{{config.title}}</h2></div><div ng-show=\"config.addButton\" class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-border-radius pull-right robotoslabRegular\" ng-click=\"vm.addItemDirective()\" ng-style=\"vm.style\" ng-mouseenter=\"vm.hoverIn()\" ng-mouseleave=\"vm.hoverOut()\"><i class=\"fa {{config.iconButton}} plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{config.buttonName}}</button></div></div></div>");
$templateCache.put("app/components/common/directives/titleWidget/titleWidget.html","<div class=\"ibox-content section-title\" ng-style=\"config.style\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><i class=\"fa {{config.icon}} icon-font\" aria-hidden=\"true\"></i></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white robotoslabBold\">{{config.title}}</h2></div><div ng-show=\"config.addButton\" class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-border-radius pull-right robotoslabRegular\" ng-click=\"vm.addItemDirective()\" ng-style=\"vm.style\" ng-mouseenter=\"vm.hoverIn()\" ng-mouseleave=\"vm.hoverOut()\"><i class=\"fa {{config.iconButton}} plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{config.buttonName}}</button></div></div></div>");
$templateCache.put("app/main/admin/admins/all/all.html","<div ng-controller=\"AllAdminsAdminController as vm\" class=\"all-admins-admin\"><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center><div class=\"row\" style=\"width: 100%; margin: 0 0 10px 0;\" ng-show=\"!vm.spinnerFlag\"><div class=\"col-xs-12\" style=\"background-color: white; padding: 15px 15px 15px 15px;\"><h2 style=\"margin-top: 10px;color: #313639;font-size: 25px;font-weight: bold;\">Administradores <button class=\"btn btn-info btn-circle btn-add-activity btn-outline pull-right\" type=\"button\" style=\"margin: 3px;\" ng-click=\"vm.create()\"><i class=\"fa fa-plus\"></i></button> <span class=\"pull-right\" style=\"font-size: 18px;padding-right: 10px;padding-top: 8px;\">Nuevo administrador</span></h2></div></div><div class=\"ibox-content ibox-padding-search-filter\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control\" placeholder=\"Buscar por nombre del administrador\" ng-keypress=\"vm.enterFunction($event)\" ng-model=\"vm.itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary\" ng-click=\"vm.searchText(vm.itemsText)\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div></div></div><div class=\"ibox-content-list\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Rol</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Usuario</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Estado</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Lugar</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{$index+1}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><i class=\"fa fa-check\" style=\"color: green\" ng-if=\"item.fullEdit\"></i> <i class=\"fa fa-minus\" style=\"color: red\" ng-if=\"!item.fullEdit\"></i></td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.fullName}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.company.name}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.role}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.username}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.state}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.location}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.editModule($index);\">Editar</button></td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button class=\"btn btn-cancel\" ng-click=\"vm.deleteModule($index);\">Eliminar</button></td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div></div>");
$templateCache.put("app/main/admin/admins/admin/admin.html","<div ng-controller=\"AdminAdminsAdminController as vm\" class=\"admin-admins-admin\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><div class=\"title-model ibox-content section-title\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-user icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-10 col-md-10 col-sm-8 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{\'Detalle del Administrador\'}} <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.changeToUser()\">Convertir a usuario</button></h2></div></div></div><div class=\"ibox-content forum-container\"><div class=\"form-horizontal\"><h3 class=\"\">Información</h3><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Control</label><div class=\"col-sm-9\"><input type=\"checkbox\" value=\"option1\" id=\"inlineCheckbox3\" class=\"changeCheckButton pull-left\" ng-model=\"vm.user.fullEdit\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Nombre</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Nombre\" focus-me=\"true\" ng-model=\"vm.user.fullName\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.user.fullName == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Usuario</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Usuario para ingresar\" ng-model=\"vm.user.username\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.user.username == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\" ng-if=\"vm.flag\"><label class=\"col-sm-3 control-label\">Password</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Tu contraseña\" ng-model=\"vm.user.password\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.user.password == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\" ng-if=\"!vm.flag\"><label class=\"col-sm-3 control-label\">Cambiar contraseña</label><div class=\"col-sm-9\"><input type=\"checkbox\" value=\"option1\" id=\"inlineCheckbox1\" class=\"changeCheckButton pull-left\" ng-model=\"vm.flagg.changePassword\"></div></div><div class=\"form-group\" ng-if=\"!vm.flag && vm.flagg.changePassword\"><label class=\"col-sm-3 control-label\">Nueva Contraseña</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Nueva contraseña\" ng-model=\"vm.newPassword\" ng-keypress=\"vm.enterFunction($event)\"></div></div></div></div><div class=\"hr-line-dashed\"></div><h3 class=\"\">Rol</h3><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Rol</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.user.role\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Estado</label><div class=\"col-sm-9\"><select class=\"form-control\" ng-model=\"vm.user.state\" ng-change=\"vm.selectState()\" ng-options=\"state for state in vm.states\" ng-class=\"{\'error-input-form\': vm.user.state == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Lugar</label><div class=\"col-sm-9\"><select class=\"form-control\" ng-disabled=\"!vm.stateFlag\" ng-model=\"vm.user.location\" ng-options=\"location for location in vm.locations\" ng-class=\"{\'error-input-form\': vm.user.location == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\" ng-if=\"!vm.flag\">Actualizar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.create()\" ng-if=\"vm.flag\" ng-disabled=\"vm.createBlock\">Crear</button></div></div></div></div></div>");
$templateCache.put("app/main/admin/clients/all/all.html","<div ng-controller=\"ClientsAllController as vm\" class=\"clients-all\"><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center><div class=\"title-model ibox-content section-title\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-user-friends icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{vm.title}}</h2></div><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-w-title btn-border-radius pull-right\" style=\"margin-bottom: 5px;\" ng-click=\"vm.create()\"><i class=\"fa fa-plus plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{vm.titleButtonCreate}}</button></div></div></div><div class=\"ibox-content ibox-padding-search-filter\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control\" placeholder=\"Buscar por nombre de la empresa\" ng-keypress=\"vm.enterFunction($event)\" ng-model=\"vm.itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary\" ng-click=\"vm.searchText(vm.itemsText)\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div></div></div><div class=\"ibox-content-list\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Email</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Telefono</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.name}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.company.name}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.email}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.telephone}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.editModule($index);\">Editar</button></td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button class=\"btn btn-cancel\" ng-click=\"vm.deleteModule($index);\">Eliminar</button></td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div></div>");
$templateCache.put("app/main/admin/clients/client/client.html","<div ng-controller=\"ClientsClientController as vm\" class=\"clients-client\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><title-model data-config=\"vm.configTitle\"></title-model><div class=\"ibox-content forum-container\"><div class=\"form-horizontal\"><h2 class=\"\">Información Contacto</h2><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Nombre</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" focus-me=\"true\" ng-model=\"vm.client.name\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.client.name == undefined && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.client.email\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.client.email == undefined && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Telefono</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.client.telephone\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.client.telephone == undefined && vm.errorFlag == true}\"></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\" ng-if=\"!vm.flag\">Actualizar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.create()\" ng-if=\"vm.flag\" ng-disabled=\"vm.createBlock\">Crear</button></div></div></div></div></div>");
$templateCache.put("app/main/admin/colors/all/all.html","<div ng-controller=\"ColorsAllController as vm\" class=\"colors-all\"><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center><div class=\"title-model ibox-content section-title\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-palette icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{vm.title}}</h2></div><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-w-title btn-border-radius pull-right\" style=\"margin-bottom: 5px;\" ng-click=\"vm.create()\"><i class=\"fa fa-plus plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{vm.titleButtonCreate}}</button></div></div></div><div class=\"ibox-content ibox-padding-search-filter\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control\" placeholder=\"Buscar por nombre del usuario\" ng-keypress=\"vm.enterFunction($event)\" ng-model=\"vm.itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary\" ng-click=\"vm.searchText(vm.itemsText)\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div></div></div><div class=\"ibox-content-list\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{($index+1)+((vm.pageSelected-1)*50)}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.name}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.editModule($index);\">Editar</button></td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button class=\"btn btn-cancel\" ng-click=\"vm.deleteModule($index);\">Eliminar</button></td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div></div>");
$templateCache.put("app/main/admin/colors/color/color.html","<div ng-controller=\"ColorsColorController as vm\" class=\"color\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><title-model data-config=\"vm.configTitle\"></title-model><div class=\"ibox-content forum-container\"><div class=\"form-horizontal\"><h3 class=\"\">Información</h3><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Nombre</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Nombre\" focus-me=\"true\" ng-model=\"vm.color.name\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.color.name == \'\' && vm.errorFlag == true}\"></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\" ng-if=\"!vm.flag\">Actualizar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.create()\" ng-if=\"vm.flag\" ng-disabled=\"vm.createBlock\">Crear</button></div></div></div></div></div>");
$templateCache.put("app/main/admin/places/places/places.html","<div ng-controller=\"PlacesPlacesController as vm\" class=\"places-places-admin\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><title-model data-config=\"vm.configTitle\"></title-model><div class=\"ibox-content forum-container\"><div class=\"form-horizontal\"><h3 class=\"\">Estado</h3><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Nombre</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Nombre\" focus-me=\"true\" ng-model=\"vm.state.name\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.state.name == \'\' && vm.errorFlag == true}\"></div></div></div></div><div class=\"hr-line-dashed\"></div><h3 class=\"\">Lugares</h3><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Nombre</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Nombre\" focus-me=\"true\" ng-model=\"vm.placeToAdd\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.placeToAdd == \'\' && vm.errorFlag == true}\"></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/main/admin/places/all/all.html","<div ng-controller=\"AllPlacesAdminController as vm\" class=\"all-places-admin\"><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center><div class=\"title-model ibox-content section-title\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-map-pin icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{\'Estados\'}}</h2></div><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-w-title btn-border-radius pull-right\" style=\"margin-bottom: 5px;\" ng-click=\"vm.create()\"><i class=\"fa fa-plus plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{vm.titleButtonCreate}}</button></div></div></div><div class=\"ibox-content-list\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2><center>Etapa en desarrollo</center></h2></div></div></div>");
$templateCache.put("app/main/admin/roles/all/all.html","<div ng-controller=\"RolesAllController as vm\" class=\"roles-all\"><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center><div class=\"title-model ibox-content section-title\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-users icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{vm.title}}</h2></div><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-w-title btn-border-radius pull-right\" style=\"margin-bottom: 5px;\" ng-click=\"vm.create()\"><i class=\"fa fa-plus plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{vm.titleButtonCreate}}</button></div></div></div><div class=\"ibox-content ibox-padding-search-filter\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control\" placeholder=\"Buscar por nombre del rol\" ng-keypress=\"vm.enterFunction($event)\" ng-model=\"vm.itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary\" ng-click=\"vm.searchText(vm.itemsText)\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div></div></div><div class=\"ibox-content-list\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.name}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.editModule($index);\">Editar</button></td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div></div>");
$templateCache.put("app/main/admin/roles/role/role.html","<div ng-controller=\"RolesRoleController as vm\" class=\"role\"><title-model data-config=\"vm.configTitle\"></title-model><div class=\"ibox-content forum-container\"><div class=\"form-horizontal\"><h2 class=\"\">Información</h2><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Nombre</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Nombre\" ng-model=\"vm.role.name\"></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\" ng-if=\"!vm.flag\">Actualizar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.create()\" ng-if=\"vm.flag\" ng-disabled=\"vm.createBlock\">Crear</button></div></div></div></div></div>");
$templateCache.put("app/main/admin/registers/all/all.html","<div ng-controller=\"RegistersAllController as vm\" class=\"registers-all\"><div class=\"title-model ibox-content section-title\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-car-side icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{\'Placas Normales\'}}</h2></div><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-w-title btn-border-radius pull-right\" style=\"margin-bottom: 5px; width: 100%;\" ng-click=\"vm.create()\"><i class=\"fa fa-plus plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{\'Crear registro\'}}</button> <button type=\"button\" class=\"btn btn-w-title btn-border-radius pull-right\" style=\"margin-bottom: 5px; width: 100%;\" ng-if=\"vm.fullEditFlag\" ng-click=\"vm.exportExcel()\"><i class=\"fa fa-file-excel-o plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{\'Exportar\'}}</button></div></div></div><div class=\"row all-round\" style=\"width: 100%; margin: 0 0 10px 0;\"><div class=\"col-xs-12\" style=\"background-color: white; padding: 10px 5px 5px 5px;\"><div class=\"form-group\"><div class=\"col-sm-3\"><label>{{\'Estados\'}}</label><select class=\"form-control\" ng-model=\"vm.stateOption\" ng-change=\"vm.changeState()\" ng-options=\"state for state in vm.states\"></select></div><div class=\"col-sm-3\"><label>{{\'Lugares\'}}</label><select class=\"form-control\" ng-model=\"vm.placeOption\" ng-change=\"vm.changePlace()\" ng-options=\"place for place in vm.places\"></select></div><div class=\"col-sm-3\"><label>{{\'Trabajador\'}}</label><select class=\"form-control\" ng-model=\"vm.userOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"user.fullName for user in vm.users track by user.fullName\"></select></div><div class=\"col-sm-3\"><label>{{\'Marca\'}}</label><select class=\"form-control\" ng-model=\"vm.brandOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"brand.name for brand in vm.brands track by brand.name\"></select></div></div></div><div class=\"col-xs-12\" style=\"background-color: white; padding: 5px 5px 10px 5px;\"><div class=\"form-group\"><div class=\"col-sm-3\"><label>{{\'Tipo\'}}</label><select class=\"form-control\" ng-model=\"vm.typeCarOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"typeCar.name for typeCar in vm.typeCars track by typeCar.name\"></select></div><div class=\"col-sm-3\"><label>{{\'Baja\'}}</label><select class=\"form-control\" ng-model=\"vm.statesBlockOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"statesBlock for statesBlock in vm.statesBlocks\"></select></div><div class=\"col-sm-3\"><label class=\"font-13\" style=\"width: 100%;\">{{\'Fecha Inicio\'}}</label> <input type=\"date\" id=\"day1\" name=\"day1\" style=\"width: 100%; height: 34px;\" ng-model=\"vm.tempDate1\"></div><div class=\"col-sm-3\"><label class=\"font-13\" style=\"width: 100%;\">{{\'Fecha Fin\'}}</label> <input type=\"date\" id=\"day2\" name=\"day2\" style=\"width: 100%; height: 34px;\" ng-model=\"vm.tempDate2\"></div><div class=\"col-sm-2\"><label>{{\'Límite\'}}</label><select class=\"form-control\" ng-model=\"vm.limitSelect\" ng-change=\"vm.changeLimit()\" ng-options=\"limit for limit in vm.limits\"></select></div></div></div></div><div class=\"ibox-content ibox-padding-search-filter\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control\" placeholder=\"Buscar por VIN, nombre del cliente y/o placa\" ng-model=\"vm.itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary\" ng-click=\"vm.getDatesFilter()\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div></div></div><div class=\"ibox-content-list-2\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\" ng-if=\"vm.fullEditFlag\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\" ng-if=\"vm.fullEditFlag\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Póliza</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Archivos</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Placas</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Tipo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Trabajador</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Estado</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Lugar</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Telefono</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Marca</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Linea</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Modelo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Tipo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">VIN</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Registro</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Vigencia</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha de Baja</th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{($index+1)+((vm.pageSelected-1)*vm.limit)}}</td><td class=\"t validity-register-green\" style=\"border: none; font-size: 15px;\" ng-if=\"!item.isExpired\"><center>VIGENTE</center></td><td class=\"t validity-register-yellow\" style=\"border: none; font-size: 15px;\" ng-if=\"item.isExpired\"><center>VENCIDO</center></td><td class=\"t\" style=\"border: none; font-size: 15px;\" ng-if=\"item.status\"></td><td class=\"t status-register-red\" style=\"border: none; font-size: 15px;\" ng-if=\"!item.status\"><center>BAJA</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.seeRegister($index);\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status\" ng-click=\"vm.editModule($index);\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status && !item.isNewFormat\" ng-click=\"vm.pdfPrint1(item);\"><i class=\"fa fa-print\" aria-hidden=\"true\"></i></button> <button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status && item.isNewFormat\" ng-click=\"vm.pdfPrintNewCert(item);\"><i class=\"fa fa-print\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"vm.fullEditFlag\"><button class=\"btn btn-cancel\" ng-if=\"item.status\" ng-click=\"vm.banModule($index);\"><i class=\"fa fa-ban\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"vm.fullEditFlag\"><button class=\"btn btn-cancel\" ng-click=\"vm.deleteModule($index);\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"item.policyNumber != \'\'\"><center>{{item.policyNumber}}</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"item.policyNumber == \'\'\"><center>{{\'---\'}}</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><center>{{item.files.length}}</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.createdAt | date}} {{\' - \'}} {{item.createdAt | date: \'shortTime\'}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{\'MEC- \' + item.plates}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><span ng-if=\"item.typeRegister == \'car\'\">{{\'Vehículo\'}}</span> <span ng-if=\"item.typeRegister == \'moto\'\">{{\'Motocicleta\'}}</span></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.appUser.fullName}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.registerLocationState}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.registerLocationPlace}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.fullName + \' \'+ item.lastNameFather + \' \'+ item.lastNameMother}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.telephone}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.brand}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.line}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.model}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.type}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.vin}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.dateRegister | date}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.dateValidity | date}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.banDate | date}}</td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center></div>");
$templateCache.put("app/main/admin/registers/register/register.html","<div ng-controller=\"RegisterRegistersAdminController as vm\" class=\"register-registers-admin\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><div class=\"title-model ibox-content section-title\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-car-side icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white robotoslabBold\">{{\'Detalle del Registro\' }}</h2></div></div></div><div class=\"ibox-content\"><div class=\"form-horizontal\"><h3 class=\"h-title-blue\">Datos del afiliado</h3><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nombre(s)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" focus-me=\"true\" ng-model=\"vm.register.fullName\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.fullName == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Apellido Paterno</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.lastNameFather\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.lastNameFather == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Apellido Materno</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.lastNameMother\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.lastNameMother == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Teléfono</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.telephone\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.telephone == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">RFC</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.rfc\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.rfc == \'\' && vm.errorFlag == true}\"></div></div></div></div><h3 class=\"h-title-blue\">Domicilio</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Calle y numero exterior e interior</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.direction\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.direction == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Colonia</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.colony\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.colony == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Código Postal</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.postalCode\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.postalCode == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Población</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.population\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.population == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Municipio</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.municipality\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.municipality == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.state\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.state == \'\' && vm.errorFlag == true}\"></div></div></div></div><h3 class=\"h-title-blue\">Credenciales</h3><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">No. Credencial de Elector</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.credentialCard\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.credentialCard == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Tipo de Licencia de Conducir</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.licenseType\" ng-options=\"licenseType for licenseType in vm.licenseTypes\" ng-disabled=\"!vm.flagUpdate || vm.typeRegisterFlag || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.licenseType == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de Licencia de Conducir</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.licenseNumber\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.licenseNumber == \'\' && vm.errorFlag == true}\"></div></div></div></div><h3 class=\"h-title-blue\">Vehiculo</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Tipo de Registro</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-change=\"vm.typeRegisterCarOrMoto()\" ng-model=\"vm.typeRegister\" ng-options=\"typeRegister for typeRegister in vm.typeRegisters\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.typeRegister == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Marca</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.brand\" ng-options=\"brand.name as brand.name for brand in vm.brands\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.brand == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Tipo</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-if=\"!vm.typeRegisterFlag\" ng-model=\"vm.register.type\" ng-options=\"type.name as type.name for type in vm.typeCars\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.type == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-if=\"vm.typeRegisterFlag\" ng-model=\"vm.register.type\" readonly=\"\"></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Linea</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.line\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.line == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Modelo</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.model\" ng-options=\"date for date in vm.dates track by date\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.model == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Color</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.color\" ng-options=\"color.name as color.name for color in vm.colors\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.color == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de serie (VIN)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.vin\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.vin == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Cilindros</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.cylinders\" ng-options=\"cylinder for cylinder in vm.cylinders track by cylinder\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.cylinders == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Puertas</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.doors\" ng-options=\"door for door in vm.doors track by door\" ng-disabled=\"!vm.flagUpdate || vm.typeRegisterFlag || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.doors == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de placas</label> <label class=\"col-sm-2 control-label\">MEC-</label><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.plates\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"vm.blockMEC || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.plates == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Póliza</label><div class=\"col-sm-8\"><input type=\"checkbox\" value=\"option1\" id=\"inlineCheckbox1\" class=\"changeCheckButton pull-left\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-model=\"vm.register.hasPolicy\"></div></div><div class=\"form-group\" ng-if=\"vm.register.hasPolicy\"><label class=\"col-sm-4 control-label\">Número</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-model=\"vm.register.policyNumber\"></div></div></div></div><h3 class=\"h-title-blue\">Registro</h3><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Lugar de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.registerLocationPlace\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.registerLocationState\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de Registro</label><div class=\"col-sm-8\"><datepicker date-format=\"dd-MM-yyyy\" selector=\"form-control\"><div class=\"input-group\"><input class=\"form-control\" ng-model=\"vm.initialDate\" ng-change=\"vm.changeInitialDate()\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.initialDate == \'\' && vm.errorFlag == true}\" placeholder=\"Elegir fecha\"> <span class=\"input-group-addon\" style=\"cursor: pointer\"><i class=\"fa fa-lg fa-calendar\"></i></span></div></datepicker></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Vigencia Documentos</label> <label class=\"col-sm-8\" style=\"padding-top: 7px;\">{{vm.register.dateValidity | date}}</label></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion 1</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.obervations\"></div></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion 2</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.sugestion1\" ng-options=\"licenseType for licenseType in vm.sugestions\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.sugestion == \'\' && vm.errorFlag == true}\"></select></div></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion del capturista</label><div class=\"col-sm-8\"><textarea class=\"form-control\" ng-model=\"vm.register.finalObservations\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\">\r\n                </textarea></div></div></div></div><h3 class=\"h-title-blue\" ng-if=\"!vm.flag\">Archivos</h3><div class=\"row\" style=\"margin: auto; width: 100%;\" ng-if=\"!vm.flag\"><div class=\"col-sm-6\" ng-if=\"vm.flagUpdate\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nombre del documento</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"Escribe el nombre del doc\" ng-model=\"vm.documentType\"></div></div></div><div class=\"col-sm-12\" ng-if=\"vm.flagUpdate\"><div class=\"form-group\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-3 row-height\"><button type=\"button\" class=\"btn btn-w-primary gravityBook\" ngf-select=\"vm.addFile($files)\" ngf-multiple=\"false\" ngf-max-size=\"20MB\" ng-click=\"vm.bla()\">Adjuntar archivo</button></div><div class=\"col-lg-5 col-md-4 col-sm-8 col-xs-9 row-height\"><h4 ng-if=\"vm.fileToAdd.name == \'\'\">No hay archivo seleccionado</h4><h4 ng-if=\"vm.fileToAdd.name != \'\'\"><a target=\"_blank\" ng-href=\"https://container-buzonslagricola.s3.amazonaws.com/{{vm.fileToAdd.url}}\" class=\"opensans_regular\">{{vm.fileToAdd.name + \' ( \' + vm.sizeFile + \' MB) \' }}</a></h4></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.flagUpdate\"><button class=\"btn btn-w-primary padding-btn btn-block\" type=\"submit\" ng-click=\"vm.addFileToArray()\" ng-disabled=\"vm.createBlockUpload\"><span ng-show=\"!vm.createBlockUpload\">Añadir documento<i class=\"fa fa-file-upload\" style=\"margin-left: 7px;\"></i></span> <span ng-show=\"vm.createBlockUpload\">{{\'Añadiendo \' + vm.progressFile + \' %\'}} <i class=\"fa fa-spinner\" style=\"margin-left: 15px;\"></i></span></button></div><div class=\"col-sm-12\" style=\"padding-top: 15px;padding-bottom: 10px;\"><h3 ng-show=\"vm.register.files.length==0\">Aun no tienes archivos en este registro</h3><h3 ng-show=\"vm.register.files.length!=0\">Listado de Documentos</h3><div class=\"table-responsive no-margin\" ng-show=\"vm.register.files.length!=0\"><div id=\"DataTables_Table_01_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_01\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\" ng-if=\"vm.fullEditFlag && vm.flagUpdate\"></th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"file in vm.register.files track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{file.dateUpload | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><a target=\"_blank\" ng-href=\"https://container-conapafa.s3.amazonaws.com/{{file.url}}\" class=\"opensans_regular\">{{file.name}}</a></td><td class=\"t\" style=\"border: none; font-size: 15px;\" ng-if=\"vm.fullEditFlag && vm.flagUpdate\"><button class=\"btn btn-cancel padding-btn\" type=\"submit\" ng-click=\"vm.deleteCheck($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div></div></div></div><h3 class=\"h-title-blue\" ng-if=\"!vm.flag\">Renovaciones</h3><div class=\"row\" ng-if=\"!vm.flag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Creador Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.appUser.fullName\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.appUser.location\"></div></div></div><div class=\"col-sm-12\" style=\"padding-top: 15px;\"><h3 ng-show=\"vm.renovations.length==0\">Aun no tienes renovaciones en este registro</h3><h3 ng-show=\"vm.renovations.length!=0\">Listado de Renovaciones de Documentos</h3><div class=\"table-responsive no-margin\" ng-show=\"vm.renovations.length!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Trabajador</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Creación</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Documentos Anterior</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Renovación</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nueva vigencia</th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"renovation in vm.renovations track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.appUser.fullName}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.createdAt | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.dateValidityOld | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.date | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.dateValidity | date}}</td></tr></tbody></table></div></div></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\" ng-if=\"!vm.flag && vm.flagUpdate\">Actualizar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.checkCreate()\" ng-if=\"vm.flag && !vm.createBlock\">Crear</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" disabled=\"\" ng-if=\"vm.flag && vm.createBlock\">Creando <i class=\"fa fa-spinner\" aria-hidden=\"true\"></i></button></div></div></div></div></div>");
$templateCache.put("app/main/admin/renovations/renovation/renovation.html","<div ng-controller=\"RenovationRenovationsAdminController as vm\" class=\"register-registers-admin\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><div class=\"title-model ibox-content section-title\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-car-side icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white robotoslabBold\">{{\'Creación de la Placa A-B\' }}</h2></div></div></div><div class=\"ibox-content\"><div class=\"form-horizontal\"><h3 class=\"h-title-blue\">Datos del afiliado</h3><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nombre(s)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" focus-me=\"true\" ng-model=\"vm.register.fullName\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.fullName == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Apellido Paterno</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.lastNameFather\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.lastNameFather == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Apellido Materno</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.lastNameMother\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.lastNameMother == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Teléfono</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.telephone\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.telephone == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">RFC</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.rfc\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.rfc == \'\' && vm.errorFlag == true}\"></div></div></div></div><h3 class=\"h-title-blue\">Domicilio</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Calle y numero exterior e interior</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.direction\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.direction == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Colonia</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.colony\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.colony == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Código Postal</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.postalCode\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.postalCode == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Población</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.population\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.population == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Municipio</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.municipality\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.municipality == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.state\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.state == \'\' && vm.errorFlag == true}\"></div></div></div></div><h3 class=\"h-title-blue\">Credenciales</h3><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">No. Credencial de Elector</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.credentialCard\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.credentialCard == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Tipo de Licencia de Conducir</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.licenseType\" ng-options=\"licenseType for licenseType in vm.licenseTypes\" ng-disabled=\"!vm.flagUpdate || vm.typeRegisterFlag || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.licenseType == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de Licencia de Conducir</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.licenseNumber\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.licenseNumber == \'\' && vm.errorFlag == true}\"></div></div></div></div><h3 class=\"h-title-blue\">Vehiculo</h3><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Tipo de Registro</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-change=\"vm.typeRegisterCarOrMoto()\" ng-model=\"vm.typeRegister\" ng-options=\"typeRegister for typeRegister in vm.typeRegisters\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.typeRegister == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Marca</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.brand\" ng-options=\"brand.name as brand.name for brand in vm.brands\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.brand == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Tipo</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-if=\"!vm.typeRegisterFlag\" ng-model=\"vm.register.type\" ng-options=\"type.name as type.name for type in vm.typeCars\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.type == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-if=\"vm.typeRegisterFlag\" ng-model=\"vm.register.type\" readonly=\"\"></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Linea</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.line\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.line == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Modelo</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.model\" ng-options=\"date for date in vm.dates track by date\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.model == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Color</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.color\" ng-options=\"color.name as color.name for color in vm.colors\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.color == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de serie (VIN)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.vin\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.vin == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Cilindros</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.cylinders\" ng-options=\"cylinder for cylinder in vm.cylinders track by cylinder\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.cylinders == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Puertas</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.doors\" ng-options=\"door for door in vm.doors track by door\" ng-disabled=\"!vm.flagUpdate || vm.typeRegisterFlag || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.doors == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de placas</label> <label class=\"col-sm-2 control-label\">MEC-</label><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.plates\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"vm.blockMEC || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.plates == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Póliza</label><div class=\"col-sm-8\"><input type=\"checkbox\" value=\"option1\" id=\"inlineCheckbox1\" class=\"changeCheckButton pull-left\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-model=\"vm.register.hasPolicy\"></div></div><div class=\"form-group\" ng-if=\"vm.register.hasPolicy\"><label class=\"col-sm-4 control-label\">Número</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-model=\"vm.register.policyNumber\"></div></div></div></div><h3 class=\"h-title-blue\">Registro</h3><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Lugar de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.registerLocationPlace\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.registerLocationState\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de Registro</label><div class=\"col-sm-8\"><datepicker date-format=\"dd-MM-yyyy\" selector=\"form-control\"><div class=\"input-group\"><input class=\"form-control\" ng-model=\"vm.initialDate\" ng-change=\"vm.changeInitialDate()\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.initialDate == \'\' && vm.errorFlag == true}\" placeholder=\"Elegir fecha\"> <span class=\"input-group-addon\" style=\"cursor: pointer\"><i class=\"fa fa-lg fa-calendar\"></i></span></div></datepicker></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Vigencia Documentos</label> <label class=\"col-sm-8\" style=\"padding-top: 7px;\">{{vm.register.dateValidity | date}}</label></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion 1</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.obervations\"></div></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion 2</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.sugestion1\" ng-options=\"licenseType for licenseType in vm.sugestions\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.sugestion == \'\' && vm.errorFlag == true}\"></select></div></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion del capturista</label><div class=\"col-sm-8\"><textarea class=\"form-control\" ng-model=\"vm.register.finalObservations\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\">\r\n                </textarea></div></div></div></div><h3 class=\"h-title-blue\" ng-if=\"!vm.flag\">Archivos</h3><div class=\"row\" style=\"margin: auto; width: 100%;\" ng-if=\"!vm.flag\"><div class=\"col-sm-6\" ng-if=\"vm.flagUpdate\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nombre del documento</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"Escribe el nombre del doc\" ng-model=\"vm.documentType\"></div></div></div><div class=\"col-sm-12\" ng-if=\"vm.flagUpdate\"><div class=\"form-group\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-3 row-height\"><button type=\"button\" class=\"btn btn-w-primary gravityBook\" ngf-select=\"vm.addFile($files)\" ngf-multiple=\"false\" ngf-max-size=\"20MB\" ng-click=\"vm.bla()\">Adjuntar archivo</button></div><div class=\"col-lg-5 col-md-4 col-sm-8 col-xs-9 row-height\"><h4 ng-if=\"vm.fileToAdd.name == \'\'\">No hay archivo seleccionado</h4><h4 ng-if=\"vm.fileToAdd.name != \'\'\"><a target=\"_blank\" ng-href=\"https://container-buzonslagricola.s3.amazonaws.com/{{vm.fileToAdd.url}}\" class=\"opensans_regular\">{{vm.fileToAdd.name + \' ( \' + vm.sizeFile + \' MB) \' }}</a></h4></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.flagUpdate\"><button class=\"btn btn-w-primary padding-btn btn-block\" type=\"submit\" ng-click=\"vm.addFileToArray()\" ng-disabled=\"vm.createBlockUpload\"><span ng-show=\"!vm.createBlockUpload\">Añadir documento<i class=\"fa fa-file-upload\" style=\"margin-left: 7px;\"></i></span> <span ng-show=\"vm.createBlockUpload\">{{\'Añadiendo \' + vm.progressFile + \' %\'}} <i class=\"fa fa-spinner\" style=\"margin-left: 15px;\"></i></span></button></div><div class=\"col-sm-12\" style=\"padding-top: 15px;padding-bottom: 10px;\"><h3 ng-show=\"vm.register.files.length==0\">Aun no tienes archivos en este registro</h3><h3 ng-show=\"vm.register.files.length!=0\">Listado de Documentos</h3><div class=\"table-responsive no-margin\" ng-show=\"vm.register.files.length!=0\"><div id=\"DataTables_Table_01_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_01\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\" ng-if=\"vm.fullEditFlag && vm.flagUpdate\"></th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"file in vm.register.files track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{file.dateUpload | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><a target=\"_blank\" ng-href=\"https://container-conapafa.s3.amazonaws.com/{{file.url}}\" class=\"opensans_regular\">{{file.name}}</a></td><td class=\"t\" style=\"border: none; font-size: 15px;\" ng-if=\"vm.fullEditFlag && vm.flagUpdate\"><button class=\"btn btn-cancel padding-btn\" type=\"submit\" ng-click=\"vm.deleteCheck($index)\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div></div></div></div><h3 class=\"h-title-blue\" ng-if=\"!vm.flag\">Renovaciones</h3><div class=\"row\" ng-if=\"!vm.flag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Creador Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.appUser.fullName\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.appUser.location\"></div></div></div><div class=\"col-sm-12\" style=\"padding-top: 15px;\"><h3 ng-show=\"vm.renovations.length==0\">Aun no tienes renovaciones en este registro</h3><h3 ng-show=\"vm.renovations.length!=0\">Listado de Renovaciones de Documentos</h3><div class=\"table-responsive no-margin\" ng-show=\"vm.renovations.length!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Trabajador</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Creación</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Documentos Anterior</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Renovación</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nueva vigencia</th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"renovation in vm.renovations track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.appUser.fullName}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.createdAt | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.dateValidityOld | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.date | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.dateValidity | date}}</td></tr></tbody></table></div></div></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\" ng-if=\"!vm.flag && vm.flagUpdate\">Actualizar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.checkCreate()\" ng-if=\"vm.flag && !vm.createBlock\">Crear</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" disabled=\"\" ng-if=\"vm.flag && vm.createBlock\">Creando <i class=\"fa fa-spinner\" aria-hidden=\"true\"></i></button></div></div></div></div></div>");
$templateCache.put("app/main/admin/brands/all/all.html","<div ng-controller=\"BrandsAllController as vm\" class=\"brands-all\"><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center><div class=\"title-model ibox-content section-title\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-car icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{vm.title}}</h2></div><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-w-title btn-border-radius pull-right\" style=\"margin-bottom: 5px;\" ng-click=\"vm.create()\"><i class=\"fa fa-plus plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{vm.titleButtonCreate}}</button></div></div></div><div class=\"ibox-content ibox-padding-search-filter\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control\" placeholder=\"Buscar por nombre del usuario\" ng-keypress=\"vm.enterFunction($event)\" ng-model=\"vm.itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary\" ng-click=\"vm.searchText(vm.itemsText)\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div></div></div><div class=\"ibox-content-list\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{($index+1)+((vm.pageSelected-1)*50)}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.name}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.editModule($index);\">Editar</button></td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button class=\"btn btn-cancel\" ng-click=\"vm.deleteModule($index);\">Eliminar</button></td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div></div>");
$templateCache.put("app/main/admin/renovations/all/all.html","<div ng-controller=\"RenovationsAllController as vm\" class=\"registers-all\"><div class=\"title-model ibox-content section-title\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-car-side icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{\'Placas A-B\'}}</h2></div></div></div><div class=\"row all-round\" style=\"width: 100%; margin: 0 0 10px 0;\"><div class=\"col-xs-12\" style=\"background-color: white; padding: 10px 5px 5px 5px;\"><div class=\"form-group\"><div class=\"col-sm-3\"><label>{{\'Estados\'}}</label><select class=\"form-control\" ng-model=\"vm.stateOption\" ng-change=\"vm.changeState()\" ng-options=\"state for state in vm.states\"></select></div><div class=\"col-sm-3\"><label>{{\'Lugares\'}}</label><select class=\"form-control\" ng-model=\"vm.placeOption\" ng-change=\"vm.changePlace()\" ng-options=\"place for place in vm.places\"></select></div><div class=\"col-sm-3\"><label>{{\'Trabajador\'}}</label><select class=\"form-control\" ng-model=\"vm.userOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"user.fullName for user in vm.users track by user.fullName\"></select></div><div class=\"col-sm-3\"><label>{{\'Marca\'}}</label><select class=\"form-control\" ng-model=\"vm.brandOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"brand.name for brand in vm.brands track by brand.name\"></select></div></div></div><div class=\"col-xs-12\" style=\"background-color: white; padding: 5px 5px 10px 5px;\"><div class=\"form-group\"><div class=\"col-sm-3\"><label>{{\'Tipo\'}}</label><select class=\"form-control\" ng-model=\"vm.typeCarOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"typeCar.name for typeCar in vm.typeCars track by typeCar.name\"></select></div><div class=\"col-sm-3\"><label>{{\'Baja\'}}</label><select class=\"form-control\" ng-model=\"vm.statesBlockOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"statesBlock for statesBlock in vm.statesBlocks\"></select></div><div class=\"col-sm-3\"><label class=\"font-13\" style=\"width: 100%;\">{{\'Fecha Inicio\'}}</label> <input type=\"date\" id=\"day1\" name=\"day1\" style=\"width: 100%; height: 34px;\" ng-model=\"vm.tempDate1\"></div><div class=\"col-sm-3\"><label class=\"font-13\" style=\"width: 100%;\">{{\'Fecha Fin\'}}</label> <input type=\"date\" id=\"day2\" name=\"day2\" style=\"width: 100%; height: 34px;\" ng-model=\"vm.tempDate2\"></div><div class=\"col-sm-2\"><label>{{\'Límite\'}}</label><select class=\"form-control\" ng-model=\"vm.limitSelect\" ng-change=\"vm.changeLimit()\" ng-options=\"limit for limit in vm.limits\"></select></div></div></div></div><div class=\"ibox-content ibox-padding-search-filter\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control\" placeholder=\"Buscar por VIN, nombre del cliente y/o placa\" ng-model=\"vm.itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary\" ng-click=\"vm.getDatesFilter()\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div></div></div><div class=\"ibox-content-list-2\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\" ng-if=\"vm.fullEditFlag\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\" ng-if=\"vm.fullEditFlag\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Póliza</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Archivos</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Placas</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Tipo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Trabajador</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Estado</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Lugar</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Telefono</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Marca</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Linea</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Modelo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Tipo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">VIN</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Registro</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Vigencia</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha de Baja</th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{($index+1)+((vm.pageSelected-1)*vm.limit)}}</td><td class=\"t validity-register-green\" style=\"border: none; font-size: 15px;\" ng-if=\"!item.isExpired\"><center>VIGENTE</center></td><td class=\"t validity-register-yellow\" style=\"border: none; font-size: 15px;\" ng-if=\"item.isExpired\"><center>VENCIDO</center></td><td class=\"t\" style=\"border: none; font-size: 15px;\" ng-if=\"item.status\"></td><td class=\"t status-register-red\" style=\"border: none; font-size: 15px;\" ng-if=\"!item.status\"><center>BAJA</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.seeRegister($index);\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status\" ng-click=\"vm.editModule($index);\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status && !item.isNewFormat\" ng-click=\"vm.pdfPrint1(item);\"><i class=\"fa fa-print\" aria-hidden=\"true\"></i></button> <button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status && item.isNewFormat\" ng-click=\"vm.pdfPrintNewCert(item);\"><i class=\"fa fa-print\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"vm.fullEditFlag\"><button class=\"btn btn-cancel\" ng-if=\"item.status\" ng-click=\"vm.banModule($index);\"><i class=\"fa fa-ban\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"vm.fullEditFlag\"><button class=\"btn btn-cancel\" ng-click=\"vm.deleteModule($index);\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"item.policyNumber != \'\'\"><center>{{item.policyNumber}}</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"item.policyNumber == \'\'\"><center>{{\'---\'}}</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><center>{{item.files.length}}</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.createdAt | date}} {{\' - \'}} {{item.createdAt | date: \'shortTime\'}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{\'MEC- \' + item.plates}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><span ng-if=\"item.typeRegister == \'car\'\">{{\'Vehículo\'}}</span> <span ng-if=\"item.typeRegister == \'moto\'\">{{\'Motocicleta\'}}</span></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.appUser.fullName}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.registerLocationState}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.registerLocationPlace}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.fullName + \' \'+ item.lastNameFather + \' \'+ item.lastNameMother}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.telephone}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.brand}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.line}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.model}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.type}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.vin}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.dateRegister | date}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.dateValidity | date}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.banDate | date}}</td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center></div>");
$templateCache.put("app/main/admin/brands/brand/brand.html","<div ng-controller=\"BrandsBrandController as vm\" class=\"brand\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><title-model data-config=\"vm.configTitle\"></title-model><div class=\"ibox-content forum-container\"><div class=\"form-horizontal\"><h3 class=\"\">Información</h3><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Nombre</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Nombre\" focus-me=\"true\" ng-model=\"vm.brand.name\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.brand.name == \'\' && vm.errorFlag == true}\"></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\" ng-if=\"!vm.flag\">Actualizar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.create()\" ng-if=\"vm.flag\" ng-disabled=\"vm.createBlock\">Crear</button></div></div></div></div></div>");
$templateCache.put("app/main/admin/users/all/all.html","<div ng-controller=\"UsersAllController as vm\" class=\"users-all\"><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center><div class=\"title-model ibox-content section-title\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-users icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{vm.title}}</h2></div><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-w-title btn-border-radius pull-right\" style=\"margin-bottom: 5px;\" ng-click=\"vm.create()\"><i class=\"fa fa-plus plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{vm.titleButtonCreate}}</button></div></div></div><div class=\"ibox-content ibox-padding-search-filter\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control\" placeholder=\"Buscar por nombre del usuario\" ng-keypress=\"vm.enterFunction($event)\" ng-model=\"vm.itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary\" ng-click=\"vm.searchText(vm.itemsText)\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div></div></div><div class=\"ibox-content-list\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Rol</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Usuario</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Estado</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Lugar</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{$index+1}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.fullName}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.company.name}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.role}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.username}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.state}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.location}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.editModule($index);\">Editar</button></td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button class=\"btn btn-cancel\" ng-click=\"vm.deleteModule($index);\">Eliminar</button></td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div></div>");
$templateCache.put("app/main/admin/users/user/user.html","<div ng-controller=\"UserUsersAdminController as vm\" class=\"user-users-admin\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><div class=\"title-model ibox-content section-title\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-user icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{\'Detalle del Usuario\'}} <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.changeToAdmin()\">Convertir a admin</button></h2></div></div></div><div class=\"ibox-content forum-container\"><div class=\"form-horizontal\"><h3 class=\"\">Información</h3><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Nombre</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Nombre\" focus-me=\"true\" ng-model=\"vm.user.fullName\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.user.fullName == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Usuario</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Usuario para ingresar\" ng-model=\"vm.user.username\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.user.username == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\" ng-if=\"vm.flag\"><label class=\"col-sm-3 control-label\">Password</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Tu contraseña\" ng-model=\"vm.user.password\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.user.password == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\" ng-if=\"!vm.flag\"><label class=\"col-sm-3 control-label\">Cambiar contraseña</label><div class=\"col-sm-9\"><input type=\"checkbox\" value=\"option1\" id=\"inlineCheckbox1\" class=\"changeCheckButton pull-left\" ng-model=\"vm.flagg.changePassword\"></div></div><div class=\"form-group\" ng-if=\"!vm.flag && vm.flagg.changePassword\"><label class=\"col-sm-3 control-label\">Nueva Contraseña</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Nueva contraseña\" ng-model=\"vm.newPassword\" ng-keypress=\"vm.enterFunction($event)\"></div></div></div></div><div class=\"hr-line-dashed\"></div><h3 class=\"\">Rol</h3><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Rol</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.user.role\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Estado</label><div class=\"col-sm-9\"><select class=\"form-control\" ng-model=\"vm.user.state\" ng-change=\"vm.selectState()\" ng-options=\"state for state in vm.states\" ng-class=\"{\'error-input-form\': vm.user.state == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Lugar</label><div class=\"col-sm-9\"><select class=\"form-control\" ng-disabled=\"!vm.stateFlag\" ng-model=\"vm.user.location\" ng-options=\"location for location in vm.locations\" ng-class=\"{\'error-input-form\': vm.user.location == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\" ng-if=\"!vm.flag\">Actualizar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.create()\" ng-if=\"vm.flag\" ng-disabled=\"vm.createBlock\">Crear</button></div></div></div></div></div>");
$templateCache.put("app/main/admin/vendors/all/all.html","<div ng-controller=\"VendorsAllController as vm\" class=\"registers-all\"><div class=\"title-model ibox-content section-title\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-car-side icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{\'Placas Vendedores\'}}</h2></div></div></div><div class=\"row all-round\" style=\"width: 100%; margin: 0 0 10px 0;\"><div class=\"col-xs-12\" style=\"background-color: white; padding: 10px 5px 5px 5px;\"><div class=\"form-group\"><div class=\"col-sm-3\"><label>{{\'Estados\'}}</label><select class=\"form-control\" ng-model=\"vm.stateOption\" ng-change=\"vm.changeState()\" ng-options=\"state for state in vm.states\"></select></div><div class=\"col-sm-3\"><label>{{\'Lugares\'}}</label><select class=\"form-control\" ng-model=\"vm.placeOption\" ng-change=\"vm.changePlace()\" ng-options=\"place for place in vm.places\"></select></div><div class=\"col-sm-3\"><label>{{\'Trabajador\'}}</label><select class=\"form-control\" ng-model=\"vm.userOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"user.fullName for user in vm.users track by user.fullName\"></select></div><div class=\"col-sm-3\"><label>{{\'Marca\'}}</label><select class=\"form-control\" ng-model=\"vm.brandOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"brand.name for brand in vm.brands track by brand.name\"></select></div></div></div><div class=\"col-xs-12\" style=\"background-color: white; padding: 5px 5px 10px 5px;\"><div class=\"form-group\"><div class=\"col-sm-3\"><label>{{\'Tipo\'}}</label><select class=\"form-control\" ng-model=\"vm.typeCarOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"typeCar.name for typeCar in vm.typeCars track by typeCar.name\"></select></div><div class=\"col-sm-3\"><label>{{\'Baja\'}}</label><select class=\"form-control\" ng-model=\"vm.statesBlockOption\" ng-change=\"vm.filterWhereRegisters()\" ng-options=\"statesBlock for statesBlock in vm.statesBlocks\"></select></div><div class=\"col-sm-3\"><label class=\"font-13\" style=\"width: 100%;\">{{\'Fecha Inicio\'}}</label> <input type=\"date\" id=\"day1\" name=\"day1\" style=\"width: 100%; height: 34px;\" ng-model=\"vm.tempDate1\"></div><div class=\"col-sm-3\"><label class=\"font-13\" style=\"width: 100%;\">{{\'Fecha Fin\'}}</label> <input type=\"date\" id=\"day2\" name=\"day2\" style=\"width: 100%; height: 34px;\" ng-model=\"vm.tempDate2\"></div><div class=\"col-sm-2\"><label>{{\'Límite\'}}</label><select class=\"form-control\" ng-model=\"vm.limitSelect\" ng-change=\"vm.changeLimit()\" ng-options=\"limit for limit in vm.limits\"></select></div></div></div></div><div class=\"ibox-content ibox-padding-search-filter\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control\" placeholder=\"Buscar por VIN, nombre del cliente y/o placa\" ng-model=\"vm.itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary\" ng-click=\"vm.getDatesFilter()\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div></div></div><div class=\"ibox-content-list-2\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\" ng-if=\"vm.fullEditFlag\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\" ng-if=\"vm.fullEditFlag\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Póliza</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Archivos</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Placas</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Tipo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Trabajador</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Estado</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Lugar</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Telefono</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Marca</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Linea</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Modelo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Tipo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">VIN</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Registro</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Vigencia</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha de Baja</th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{($index+1)+((vm.pageSelected-1)*vm.limit)}}</td><td class=\"t validity-register-green\" style=\"border: none; font-size: 15px;\" ng-if=\"!item.isExpired\"><center>VIGENTE</center></td><td class=\"t validity-register-yellow\" style=\"border: none; font-size: 15px;\" ng-if=\"item.isExpired\"><center>VENCIDO</center></td><td class=\"t\" style=\"border: none; font-size: 15px;\" ng-if=\"item.status\"></td><td class=\"t status-register-red\" style=\"border: none; font-size: 15px;\" ng-if=\"!item.status\"><center>BAJA</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.seeRegister($index);\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status\" ng-click=\"vm.editModule($index);\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status && !item.isNewFormat\" ng-click=\"vm.pdfPrint1(item);\"><i class=\"fa fa-print\" aria-hidden=\"true\"></i></button> <button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status && item.isNewFormat\" ng-click=\"vm.pdfPrintNewCert(item);\"><i class=\"fa fa-print\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"vm.fullEditFlag\"><button class=\"btn btn-cancel\" ng-if=\"item.status\" ng-click=\"vm.banModule($index);\"><i class=\"fa fa-ban\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"vm.fullEditFlag\"><button class=\"btn btn-cancel\" ng-click=\"vm.deleteModule($index);\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"item.policyNumber != \'\'\"><center>{{item.policyNumber}}</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\" ng-if=\"item.policyNumber == \'\'\"><center>{{\'---\'}}</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><center>{{item.files.length}}</center></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.createdAt | date}} {{\' - \'}} {{item.createdAt | date: \'shortTime\'}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{\'MEC- \' + item.plates}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\"><span ng-if=\"item.typeRegister == \'car\'\">{{\'Vehículo\'}}</span> <span ng-if=\"item.typeRegister == \'moto\'\">{{\'Motocicleta\'}}</span></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.appUser.fullName}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.registerLocationState}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.registerLocationPlace}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.fullName + \' \'+ item.lastNameFather + \' \'+ item.lastNameMother}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.telephone}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.brand}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.line}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.model}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.type}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.vin}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.dateRegister | date}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.dateValidity | date}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\" ng-class=\"{\'error-input-form\': !item.status == true}\">{{item.banDate | date}}</td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center></div>");
$templateCache.put("app/main/admin/types/all/all.html","<div ng-controller=\"TypeCarsAllController as vm\" class=\"typeCars-all\"><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center><div class=\"title-model ibox-content section-title\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-car icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{vm.title}}</h2></div><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-w-title btn-border-radius pull-right\" style=\"margin-bottom: 5px;\" ng-click=\"vm.create()\"><i class=\"fa fa-plus plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{vm.titleButtonCreate}}</button></div></div></div><div class=\"ibox-content ibox-padding-search-filter\" ng-show=\"!vm.spinnerFlag\"><div class=\"row row-width-margin\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"input-group\"><input type=\"text\" class=\"input form-control\" placeholder=\"Buscar por nombre del usuario\" ng-keypress=\"vm.enterFunction($event)\" ng-model=\"vm.itemsText\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-w-primary\" ng-click=\"vm.searchText(vm.itemsText)\"><i class=\"fa fa-search\"></i> Buscar</button></span></div></div></div></div><div class=\"ibox-content-list\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{($index+1)+((vm.pageSelected-1)*50)}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{item.name}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.editModule($index);\">Editar</button></td><td class=\"t\" style=\"border: none; font-size: 15px;\"><button class=\"btn btn-cancel\" ng-click=\"vm.deleteModule($index);\">Eliminar</button></td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div></div>");
$templateCache.put("app/main/admin/vendors/vendor/vendor.html","<div ng-controller=\"VendorVendorsAdminController as vm\" class=\"register-registers-admin\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><div class=\"title-model ibox-content section-title\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-car-side icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white robotoslabBold\">{{\'Placas de Vendedores\'}}</h2></div></div></div><div class=\"ibox-content forum-container\"><div class=\"form-horizontal\"><h3 ng-hide=\"vm.flagHide\">Buscador de Placas MEC:</h3><div class=\"hr-line-dashed\" ng-hide=\"vm.flagHide\"></div><div class=\"row\" style=\"display: flex;\" ng-hide=\"vm.flagHide\"><h2 style=\"margin-right: 15px\">MEC-</h2><input type=\"text\" class=\"form-control\" style=\"width: auto; height: auto;\" placeholder=\"Escribir placas\" ng-model=\"vm.plates\"> <button class=\"btn btn-md btn-w-primary\" ng-click=\"vm.searchPlates(vm.plates, 1)\"><i class=\"fa fa-search\"></i></button></div><div class=\"hr-line-dashed\" ng-if=\"vm.platesFlag\"></div><h3 ng-if=\"vm.platesFlag\">Información del vehiculo:</h3><div class=\"hr-line-dashed\" ng-if=\"!vm.registerFlag && vm.platesFlag\"></div><h4 ng-if=\"!vm.registerFlag && vm.platesFlag\">No existe ese número de placa</h4><div class=\"hr-line-dashed\" ng-if=\"vm.registerFlag && vm.platesFlag\"></div><h3 ng-if=\"vm.registerFlag && vm.platesFlag\">Datos del afiliado</h3><div class=\"row\" ng-if=\"vm.registerFlag && vm.platesFlag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nombre(s)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.fullName\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Apellido Paterno</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.lastNameFather\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Apellido Materno</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.lastNameMother\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Teléfono</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.telephone\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">RFC</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.rfc\"></div></div></div></div><div class=\"hr-line-dashed\" ng-if=\"vm.registerFlag && vm.platesFlag\"></div><h3 ng-if=\"vm.registerFlag && vm.platesFlag\">Domicilio</h3><div class=\"row\" ng-if=\"vm.registerFlag && vm.platesFlag\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Calle y numero exterior e interior</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.direction\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Colonia</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.colony\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Código Postal</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.postalCode\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Población</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.population\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Municipio</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.municipality\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.state\"></div></div></div></div><div class=\"hr-line-dashed\" ng-if=\"vm.registerFlag && vm.platesFlag\"></div><h3 ng-if=\"vm.registerFlag && vm.platesFlag\">Credenciales</h3><div class=\"row\" ng-if=\"vm.registerFlag && vm.platesFlag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">No. Credencial de Elector</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.credentialCard\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Tipo de Licencia de Conducir</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.licenseType\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de Licencia de Conducir</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.licenseNumber\"></div></div></div></div><div class=\"hr-line-dashed\" ng-if=\"vm.registerFlag && vm.platesFlag\"></div><h3 ng-if=\"vm.registerFlag && vm.platesFlag\">Vehiculo</h3><div class=\"row\" ng-if=\"vm.registerFlag && vm.platesFlag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Marca</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.brand\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Tipo</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.type\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Linea</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.line\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Modelo</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.model\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Color</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.color\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de serie (VIN)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.vin\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Cilindros</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.cylinders\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Puertas</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.doors\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de placas</label> <label class=\"col-sm-2 control-label\">MEC-</label><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.plates\"></div></div></div></div><div class=\"hr-line-dashed\" ng-if=\"vm.registerFlag && vm.platesFlag\"></div><h3 ng-if=\"vm.registerFlag && vm.platesFlag\">Registro</h3><div class=\"row\" ng-if=\"vm.registerFlag && vm.platesFlag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Lugar de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.registerLocationPlace\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.registerLocationState\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de Registro</label><div class=\"col-sm-8\"><label class=\"col-sm-8\" style=\"padding-top: 7px;\">{{vm.register.dateRegister | date}}</label></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Vigencia Documentos</label> <label class=\"col-sm-8\" style=\"padding-top: 7px;\">{{vm.register.dateValidity | date}}</label></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Sugerencia</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.sugestion\"></div></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion 1</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.obervations\"></div></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion 2</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" readonly=\"\" ng-model=\"vm.register.sugestion1\"></div></div></div></div><div class=\"hr-line-dashed\" ng-if=\"vm.registerFlag && vm.platesFlag\"></div><div class=\"row\" ng-if=\"vm.registerFlag && vm.platesFlag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha Renovación</label><div class=\"col-sm-8\"><label class=\"col-sm-8\" style=\"padding-top: 7px;\" ng-hide=\"!vm.flagHide\">{{vm.renovation.date | date}}</label><datepicker date-format=\"dd-MM-yyyy\" selector=\"form-control\" ng-hide=\"vm.flagHide\"><div class=\"input-group\"><input class=\"form-control\" ng-model=\"vm.initialDate\" ng-change=\"vm.changeInitialDate()\" ng-class=\"{\'error-input-form\': vm.initialDate == \'\' && vm.errorFlag == true}\" placeholder=\"Elegir fecha\"> <span class=\"input-group-addon\" style=\"cursor: pointer\"><i class=\"fa fa-lg fa-calendar\"></i></span></div></datepicker></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nueva Vigencia Documentos</label> <label class=\"col-sm-8\" style=\"padding-top: 7px;\">{{vm.renovation.dateValidity | date}}</label></div></div></div><div class=\"hr-line-dashed\" ng-if=\"vm.registerFlag && vm.platesFlag\"></div><div class=\"form-group\" ng-if=\"vm.registerFlag && vm.platesFlag\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.create()\" ng-hide=\"vm.flagHide\" ng-disabled=\"vm.createBlock\">Crear</button></div></div></div></div></div>");
$templateCache.put("app/main/admin/types/type/type.html","<div ng-controller=\"TypeCarsTypeCarController as vm\" class=\"typeCar\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><title-model data-config=\"vm.configTitle\"></title-model><div class=\"ibox-content forum-container\"><div class=\"form-horizontal\"><h3 class=\"\">Información</h3><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Nombre</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"Nombre\" focus-me=\"true\" ng-model=\"vm.typeCar.name\" ng-keypress=\"vm.enterFunction($event)\" ng-class=\"{\'error-input-form\': vm.typeCar.name == \'\' && vm.errorFlag == true}\"></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\" ng-if=\"!vm.flag\">Actualizar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.create()\" ng-if=\"vm.flag\" ng-disabled=\"vm.createBlock\">Crear</button></div></div></div></div></div>");
$templateCache.put("app/main/worker/registers/all/all.html","<div ng-controller=\"AllRegistersWorkerController as vm\" class=\"all-registers-worker\"><div class=\"title-model ibox-content section-title\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-car-side icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white\">{{\'Registros de Placas\'}}</h2></div><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-w-title btn-border-radius pull-right\" style=\"margin-bottom: 5px; width: 100%;\" ng-click=\"vm.create()\"><i class=\"fa fa-plus plus-icon\" aria-hidden=\"true\"></i> &nbsp; {{\'Crear registro\'}}</button></div></div></div><div class=\"ibox-content-list-2\" ng-show=\"!vm.spinnerFlag\"><div class=\"row-list hide-list\"><h2 ng-show=\"vm.paginationFor==0 && !vm.withText\"><center>No tienes nada aún</center></h2><h2 ng-show=\"vm.paginationFor==0 && vm.withText\"><center>No se encontró nada con ese criterio</center></h2><div class=\"table-responsive no-margin\" ng-show=\"vm.paginationFor!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\"></th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Placas</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Tipo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Trabajador</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Estado</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Lugar</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Telefono</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Marca</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Linea</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Modelo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Tipo</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">VIN</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Registro</th><th class=\"sorting upCase\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Vigencia</th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items track by $index\" style=\"border: none\"><td class=\"t upCase\" style=\"border: none; font-size: 15px;\"><i class=\"fa fa-circle\" style=\"color: green\" ng-if=\"item.status\"></i> <i class=\"fa fa-circle\" style=\"color: red\" ng-if=\"!item.status\"></i></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-click=\"vm.seeRegister($index);\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\"><button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status && !item.isNewFormat\" ng-click=\"vm.pdfPrint1(item);\"><i class=\"fa fa-print\" aria-hidden=\"true\"></i></button> <button type=\"button\" class=\"btn btn-w-primary btn-border-radius\" ng-if=\"item.status && item.isNewFormat\" ng-click=\"vm.pdfPrintNewCert(item);\"><i class=\"fa fa-print\" aria-hidden=\"true\"></i></button></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.createdAt | date}} {{\' - \'}} {{item.createdAt | date: \'shortTime\'}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{\'MEC- \' + item.plates}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\"><span ng-if=\"item.typeRegister == \'car\'\">{{\'Vehículo\'}}</span> <span ng-if=\"item.typeRegister == \'moto\'\">{{\'Motocicleta\'}}</span></td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.appUser.fullName}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.registerLocationState}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.registerLocationPlace}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.fullName + \' \'+ item.lastNameFather + \' \'+ item.lastNameMother}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.telephone}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.brand}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.line}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.model}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.type}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.vin}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.dateRegister | date}}</td><td class=\"t upCase\" style=\"border: none; font-size: 15px;\">{{item.dateValidity | date}}</td></tr></tbody></table></div></div><div class=\"dataTables_paginate paging_simple_numbers\" ng-show=\"vm.paginationFor!=0\"><ul class=\"pagination padding-pagination\"><li class=\"paginate_button previous\" ng-click=\"vm.changeLeft()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-left arrow-margin\" aria-hidden=\"true\"></i></a></li><li class=\"paginate_button\"><a aria-controls=\"DataTables_Table_0\" class=\"select-pagination-padding\"><select class=\"form-control page-options\" ng-model=\"vm.pageSelected\" ng-change=\"vm.changePage(vm.pageSelected)\" ng-options=\"page for page in vm.paginationOptions\"></select></a></li><li class=\"paginate_button next\" ng-click=\"vm.changeRight()\"><a aria-controls=\"DataTables_Table_0\" class=\"arrow-height\"><i class=\"fa fa-arrow-right arrow-margin\" aria-hidden=\"true\"></i></a></li></ul></div></div></div><center ng-show=\"vm.spinnerFlag\"><div class=\"loader\"></div></center></div>");
$templateCache.put("app/main/worker/registers/register/register.html","<div ng-controller=\"RegisterRegistersWorkerController as vm\" class=\"register-registers-worker\"><div class=\"col-sm-12\" style=\"padding: 0; margin: 10px 0;\"><button class=\"btn btn-w-primary padding-btn\" type=\"submit\" ng-click=\"vm.cancel()\">Regresar</button></div><div class=\"title-model ibox-content section-title\"><div class=\"row row-width-margin\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4 section-heigth-title section-icon\"><center><i class=\"fa fa-car-side icon-font\" aria-hidden=\"true\"></i></center></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-8 section-heigth-title\"><h2 class=\"title-style w-white robotoslabBold\">{{\'Detalle del Registro\' }}</h2></div></div></div><div class=\"ibox-content\"><div class=\"form-horizontal\"><h2 class=\"h-title-blue\">Datos del afiliado</h2><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nombre(s)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" focus-me=\"true\" ng-model=\"vm.register.fullName\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.fullName == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Apellido Paterno</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.lastNameFather\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.lastNameFather == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Apellido Materno</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.lastNameMother\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.lastNameMother == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Teléfono</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.telephone\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.telephone == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">RFC</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.rfc\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.rfc == \'\' && vm.errorFlag == true}\"></div></div></div></div><h2 class=\"h-title-blue\">Domicilio</h2><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Calle y numero exterior e interior</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.direction\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.direction == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Colonia</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.colony\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.colony == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Código Postal</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.postalCode\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.postalCode == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Población</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.population\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.population == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Municipio</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.municipality\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.municipality == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.state\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.state == \'\' && vm.errorFlag == true}\"></div></div></div></div><h2 class=\"h-title-blue\">Credenciales</h2><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">No. Credencial de Elector</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.credentialCard\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.credentialCard == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Tipo de Licencia de Conducir</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.licenseType\" ng-options=\"licenseType for licenseType in vm.licenseTypes\" ng-disabled=\"!vm.flagUpdate || vm.typeRegisterFlag\" ng-class=\"{\'error-input-form\': vm.register.licenseType == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de Licencia de Conducir</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.licenseNumber\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.licenseNumber == \'\' && vm.errorFlag == true}\"></div></div></div></div><h2 class=\"h-title-blue\">Vehiculo</h2><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Tipo de Registro</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-change=\"vm.typeRegisterCarOrMoto()\" ng-model=\"vm.typeRegister\" ng-options=\"typeRegister for typeRegister in vm.typeRegisters\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.typeRegister == \'\' && vm.errorFlag == true}\"></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Marca</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.brand\" ng-options=\"brand.name as brand.name for brand in vm.brands\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.brand == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Tipo</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-if=\"!vm.typeRegisterFlag\" ng-model=\"vm.register.type\" ng-options=\"type.name as type.name for type in vm.typeCars\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.type == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-if=\"vm.typeRegisterFlag\" ng-model=\"vm.register.type\" readonly=\"\"></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Linea</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.line\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.line == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Modelo</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.model\" ng-options=\"date for date in vm.dates track by date\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.model == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Color</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.color\" ng-options=\"color.name as color.name for color in vm.colors\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.color == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de serie (VIN)</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.vin\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.vin == \'\' && vm.errorFlag == true}\"></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Cilindros</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.cylinders\" ng-options=\"cylinder for cylinder in vm.cylinders track by cylinder\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.cylinders == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Puertas</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.doors\" ng-options=\"door for door in vm.doors track by door\" ng-disabled=\"!vm.flagUpdate || vm.typeRegisterFlag || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.doors == \'\' && vm.errorFlag == true}\"><option disabled=\"\" selected=\"\" value=\"\">-- Seleccionar --</option></select></div></div></div><div class=\"col-sm-6\" ng-if=\"vm.typeRegister != \'\'\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Numero de placas</label> <label class=\"col-sm-2 control-label\">MEC-</label><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-model=\"vm.register.plates\" ng-keypress=\"vm.enterFunction($event)\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.plates == \'\' && vm.errorFlag == true}\"></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Póliza</label><div class=\"col-sm-8\"><input type=\"checkbox\" value=\"option1\" id=\"inlineCheckbox1\" class=\"changeCheckButton pull-left\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-model=\"vm.register.hasPolicy\"></div></div><div class=\"form-group\" ng-if=\"vm.register.hasPolicy\"><label class=\"col-sm-4 control-label\">Número</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-model=\"vm.register.policyNumber\"></div></div></div></div><h2 class=\"h-title-blue\">Registro</h2><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Lugar de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.registerLocationPlace\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.registerLocationState\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Fecha de Registro</label> <label class=\"col-sm-8\" style=\"padding-top: 7px;\">{{vm.register.dateRegister | date}}</label></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Vigencia Documentos</label> <label class=\"col-sm-8\" style=\"padding-top: 7px;\">{{vm.register.dateValidity | date}}</label></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion 1</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.obervations\"></div></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion 2</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"vm.register.sugestion1\" ng-options=\"licenseType for licenseType in vm.sugestions\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\" ng-class=\"{\'error-input-form\': vm.register.sugestion == \'\' && vm.errorFlag == true}\"></select></div></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Observacion del capturista</label><div class=\"col-sm-8\"><textarea class=\"form-control\" ng-model=\"vm.register.finalObservations\" ng-disabled=\"!vm.flagUpdate || vm.createBlock\">\r\n                </textarea></div></div></div></div><h3 class=\"h-title-blue\" ng-if=\"!vm.flag\">Archivos</h3><div class=\"row\" style=\"margin: auto; width: 100%;\" ng-if=\"!vm.flag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nombre del documento</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"Escribe el nombre del doc\" ng-model=\"vm.documentType\"></div></div></div><div class=\"col-sm-12\"><div class=\"form-group\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-3 row-height\"><button type=\"button\" class=\"btn btn-w-primary gravityBook\" ngf-select=\"vm.addFile($files)\" ngf-multiple=\"false\" ngf-pattern=\"\'image/*,application/*\'\" ngf-max-size=\"20MB\" ng-click=\"vm.bla()\">Adjuntar archivo</button></div><div class=\"col-lg-5 col-md-4 col-sm-8 col-xs-9 row-height\"><h4 ng-if=\"vm.fileToAdd.name == \'\'\">No hay archivo seleccionado</h4><h4 ng-if=\"vm.fileToAdd.name != \'\'\"><a target=\"_blank\" ng-href=\"https://container-buzonslagricola.s3.amazonaws.com/{{vm.fileToAdd.url}}\" class=\"opensans_regular\">{{vm.fileToAdd.name + \' ( \' + vm.sizeFile + \' MB) \' }}</a></h4></div></div></div><div class=\"col-sm-6\"><button class=\"btn btn-w-primary padding-btn btn-block\" type=\"submit\" ng-click=\"vm.addFileToArray()\" ng-disabled=\"vm.createBlockUpload || vm.createBlock\"><span ng-show=\"!vm.createBlockUpload\">Añadir documento<i class=\"fa fa-file-upload\" style=\"margin-left: 7px;\"></i></span> <span ng-show=\"vm.createBlockUpload\">{{\'Añadiendo \' + vm.progressFile + \' %\'}} <i class=\"fa fa-spinner\" style=\"margin-left: 15px;\"></i></span></button></div><div class=\"col-sm-12\" style=\"padding-top: 15px;padding-bottom: 10px;\"><h3 ng-show=\"vm.register.files.length==0\">Aun no tienes archivos en este registro</h3><h3 ng-show=\"vm.register.files.length!=0\">Listado de Documentos</h3><div class=\"table-responsive no-margin\" ng-show=\"vm.register.files.length!=0\"><div id=\"DataTables_Table_01_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_01\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nombre</th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"file in vm.register.files track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{file.dateUpload | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\"><a target=\"_blank\" ng-href=\"https://container-conapafa.s3.amazonaws.com/{{file.url}}\" class=\"opensans_regular\">{{file.name}}</a></td></tr></tbody></table></div></div></div></div><h3 class=\"h-title-blue\" ng-if=\"!vm.flag\">Renovaciones</h3><div class=\"row\" ng-if=\"!vm.flag\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Creador Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.appUser.fullName\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Estado de Registro</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control t\" placeholder=\"\" readonly=\"\" ng-model=\"vm.register.appUser.location\"></div></div></div><div class=\"col-sm-12\" style=\"padding-top: 15px;\"><h3 ng-show=\"vm.renovations.length==0\">Aun no tienes renovaciones en este registro</h3><h3 ng-show=\"vm.renovations.length!=0\">Listado de Renovaciones de Documentos</h3><div class=\"table-responsive no-margin\" ng-show=\"vm.renovations.length!=0\"><div id=\"DataTables_Table_0_wrapper\" class=\"dataTables_wrapper form-inline dt-bootstrap no-padding\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable dtr-inline no-margin\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead style=\"border: none\"><tr role=\"row\" style=\"border: none\"><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Trabajador</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Creación</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Documentos Anterior</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Fecha Renovación</th><th class=\"sorting\" tabindex=\"0\" rowspan=\"1\" colspan=\"1\" style=\"border: none\">Nueva vigencia</th></tr></thead><tbody style=\"border: none\"><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"renovation in vm.renovations track by $index\" style=\"border: none\"><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.appUser.fullName}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.createdAt | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.dateValidityOld | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.date | date}}</td><td class=\"t\" style=\"border: none; font-size: 15px;\">{{renovation.dateValidity | date}}</td></tr></tbody></table></div></div></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><button class=\"btn btn-white padding-btn pull-right\" type=\"submit\" ng-click=\"vm.cancel()\">Cancelar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.update()\" ng-if=\"!vm.flag && vm.flagUpdate\">Actualizar</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" ng-click=\"vm.checkCreate()\" ng-if=\"vm.flag && !vm.createBlock\">Crear</button> <button class=\"btn btn-w-primary padding-btn pull-right\" type=\"submit\" disabled=\"\" ng-if=\"vm.flag && vm.createBlock\">Creando <i class=\"fa fa-spinner\" aria-hidden=\"true\"></i></button></div></div></div></div></div>");}]);